/* eslint-disable no-unused-vars, no-sparse-arrays, no-useless-escape */
import { useState, useEffect, useRef, useCallback } from "react";
import { createClient } from "@supabase/supabase-js";
import RedesignApp, { TOKENS as REDESIGN_TOKENS } from "./Redesign";

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_KEY
);

// ── Rebook Modal ──────────────────────────────────────────────────────────────
function RebookModal({quote, onConfirm, onClose}){
  const [date, setDate] = useState(todayStr());
  return(
    <div onClick={e=>{if(e.target===e.currentTarget)onClose();}} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.88)",zIndex:900,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
      <div style={{background:"#0d1f0d",border:"1px solid rgba(124,252,0,0.2)",borderTop:"2px solid rgba(124,252,0,0.3)",borderRadius:"20px 20px 0 0",padding:"24px 24px 40px",width:"100%",maxWidth:430,animation:"fadeUp 0.2s ease"}}>
        <div style={{width:36,height:4,background:"rgba(255,255,255,0.15)",borderRadius:2,margin:"0 auto 20px"}}/>
        <div style={{color:"#7CFC00",fontSize:10,fontFamily:"monospace",letterSpacing:"0.12em",marginBottom:6}}>REBOOK JOB</div>
        <div style={{color:"#fff",fontSize:18,fontWeight:700,marginBottom:4}}>{quote.customerName}</div>
        <div style={{color:"rgba(255,255,255,0.35)",fontSize:12,fontFamily:"monospace",marginBottom:20}}>{quote.address}</div>
        <div style={{marginBottom:20}}>
          <div style={{color:"rgba(255,255,255,0.4)",fontSize:10,fontFamily:"monospace",letterSpacing:"0.1em",marginBottom:8}}>SELECT DATE</div>
          <input
            type="date"
            value={date}
            min={todayStr()}
            onChange={e=>setDate(e.target.value)}
            style={{width:"100%",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(124,252,0,0.3)",borderRadius:10,padding:"13px 14px",color:"#fff",fontSize:15,fontFamily:"monospace",outline:"none",colorScheme:"dark"}}
          />
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          <button onClick={()=>onConfirm(date)} style={{width:"100%",background:"#7CFC00",color:"#000",border:"none",borderRadius:10,padding:"15px",fontSize:13,fontFamily:"monospace",fontWeight:700,cursor:"pointer",letterSpacing:"0.05em"}}>
            ↺ REBOOK FOR {new Date(date+"T12:00:00").toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric"})}
          </button>
          <button onClick={onClose} style={{width:"100%",background:"none",border:"1px solid rgba(255,255,255,0.1)",borderRadius:10,padding:"12px",fontSize:13,fontFamily:"monospace",color:"rgba(255,255,255,0.4)",cursor:"pointer"}}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

// ── Password Reset Modal ──────────────────────────────────────────────────────
function PasswordResetModal({onDone}){
  const [password,setPassword]=useState("");
  const [confirm,setConfirm]=useState("");
  const [saving,setSaving]=useState(false);
  const [done,setDone]=useState(false);
  const [error,setError]=useState("");

  const handle=async()=>{
    if(password.length<6){setError("Password must be at least 6 characters");return;}
    if(password!==confirm){setError("Passwords don't match");return;}
    setSaving(true);
    const{error:err}=await supabase.auth.updateUser({password});
    setSaving(false);
    if(err){setError(err.message);return;}
    setDone(true);
    setTimeout(()=>onDone(),1800);
  };

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.95)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:"#0a180a",border:"1px solid rgba(124,252,0,0.25)",borderRadius:20,padding:"32px 24px",maxWidth:360,width:"100%",textAlign:"center"}}>
        {done?(
          <>
            <div style={{fontSize:40,marginBottom:12}}>✅</div>
            <div style={{color:"#7CFC00",fontSize:16,fontFamily:"monospace",fontWeight:700,marginBottom:8}}>PASSWORD UPDATED</div>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:13,fontFamily:"monospace"}}>Signing you in…</div>
          </>
        ):(
          <>
            <div style={{fontSize:32,marginBottom:12}}>🔑</div>
            <div style={{color:"#fff",fontSize:18,fontWeight:700,marginBottom:4}}>Set New Password</div>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:13,fontFamily:"monospace",marginBottom:24}}>Choose a new password for your account</div>
            <div style={{display:"flex",flexDirection:"column",gap:12,textAlign:"left",marginBottom:16}}>
              <div>
                <div style={{color:"#7CFC00",fontSize:10,fontFamily:"monospace",letterSpacing:"0.1em",marginBottom:5}}>NEW PASSWORD</div>
                <input type="password" value={password} onChange={e=>{setPassword(e.target.value);setError("");}} placeholder="Min. 6 characters" style={{width:"100%",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.15)",borderRadius:10,padding:"12px 14px",color:"#fff",fontSize:14,fontFamily:"monospace",outline:"none"}}/>
              </div>
              <div>
                <div style={{color:"#7CFC00",fontSize:10,fontFamily:"monospace",letterSpacing:"0.1em",marginBottom:5}}>CONFIRM PASSWORD</div>
                <input type="password" value={confirm} onChange={e=>{setConfirm(e.target.value);setError("");}} placeholder="Re-enter password" style={{width:"100%",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.15)",borderRadius:10,padding:"12px 14px",color:"#fff",fontSize:14,fontFamily:"monospace",outline:"none"}}/>
              </div>
            </div>
            {error&&<div style={{color:"#ff6b6b",fontSize:12,fontFamily:"monospace",marginBottom:12}}>{error}</div>}
            <button onClick={handle} disabled={saving||!password||!confirm} style={{width:"100%",background:password&&confirm&&!saving?"#7CFC00":"rgba(124,252,0,0.15)",color:password&&confirm&&!saving?"#000":"rgba(255,255,255,0.3)",border:"none",borderRadius:10,padding:"15px",fontSize:14,fontFamily:"monospace",fontWeight:700,cursor:password&&confirm?"pointer":"default"}}>
              {saving?"UPDATING…":"SET PASSWORD →"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

// ── PWA Install Modal ─────────────────────────────────────────────────────────
function PWAInstallModal({onClose}){
  const isIOS=/iphone|ipad|ipod/i.test(navigator.userAgent);
  const [activeTab,setActiveTab]=useState(isIOS?"iphone":"samsung");

  const Step=({num,icon,text})=>(
    <div style={{display:"flex",gap:12,alignItems:"flex-start",marginBottom:16}}>
      <div style={{minWidth:26,height:26,borderRadius:"50%",background:"rgba(124,252,0,0.15)",border:"1px solid rgba(124,252,0,0.35)",display:"flex",alignItems:"center",justifyContent:"center",color:"#7CFC00",fontSize:11,fontFamily:"monospace",fontWeight:700,flexShrink:0}}>{num}</div>
      <div style={{flex:1,display:"flex",alignItems:"flex-start",gap:8}}>
        <span style={{fontSize:18,lineHeight:1.5}}>{icon}</span>
        <span style={{color:"rgba(255,255,255,0.8)",fontSize:13,fontFamily:"monospace",lineHeight:1.6}}>{text}</span>
      </div>
    </div>
  );

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.88)",zIndex:900,display:"flex",alignItems:"flex-end",justifyContent:"center"}} onClick={e=>{if(e.target===e.currentTarget)onClose();}}>
      <div style={{background:"#0d1f0d",border:"1px solid rgba(124,252,0,0.2)",borderTop:"2px solid rgba(124,252,0,0.3)",borderRadius:"20px 20px 0 0",padding:"24px 24px 40px",width:"100%",maxWidth:480,maxHeight:"88vh",overflowY:"auto"}}>
        {/* Handle bar */}
        <div style={{width:36,height:4,background:"rgba(255,255,255,0.15)",borderRadius:2,margin:"0 auto 20px"}}/>

        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:16}}>
          <div>
            <div style={{color:"#7CFC00",fontSize:10,fontFamily:"monospace",letterSpacing:"0.12em",marginBottom:5}}>ADD TO HOME SCREEN</div>
            <div style={{color:"#fff",fontSize:20,fontWeight:700,lineHeight:1.2}}>Install LAWN.Quote</div>
          </div>
          <button onClick={onClose} style={{background:"rgba(255,255,255,0.07)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"7px 12px",color:"rgba(255,255,255,0.45)",fontSize:13,cursor:"pointer",flexShrink:0,marginLeft:12}}>✕</button>
        </div>

        <div style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",marginBottom:20,lineHeight:1.7}}>
          Add LAWN.Quote to your home screen for instant access — it opens full-screen like a native app with no browser bar.
        </div>

        {/* Device tabs */}
        <div style={{display:"flex",gap:8,marginBottom:22}}>
          {[{id:"iphone",label:"📱 iPhone"},{id:"samsung",label:"🤖 Android"}].map(t=>(
            <button key={t.id} onClick={()=>setActiveTab(t.id)} style={{flex:1,padding:"11px 8px",borderRadius:10,border:`1px solid ${activeTab===t.id?"rgba(124,252,0,0.4)":"rgba(255,255,255,0.1)"}`,background:activeTab===t.id?"rgba(124,252,0,0.1)":"rgba(255,255,255,0.03)",color:activeTab===t.id?"#7CFC00":"rgba(255,255,255,0.35)",fontSize:13,fontFamily:"monospace",fontWeight:700,cursor:"pointer",transition:"all 0.18s"}}>
              {t.label}
            </button>
          ))}
        </div>

        {activeTab==="iphone"&&(
          <div>
            <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:12,padding:"18px 16px",marginBottom:14}}>
              <div style={{color:"rgba(255,255,255,0.25)",fontSize:10,fontFamily:"monospace",letterSpacing:"0.1em",marginBottom:16}}>REQUIRES SAFARI (not Chrome or Firefox)</div>
              <Step num="1" icon="🌐" text='Open this page in Safari. If you opened from a link, tap the "..." menu → "Open in Safari".'>
              </Step>
              <Step num="2" icon="⬆️" text='Tap the Share button at the bottom center of Safari (a box with an upward arrow).'>
              </Step>
              <Step num="3" icon="➕" text='Scroll down in the share sheet and tap "Add to Home Screen".'>
              </Step>
              <Step num="4" icon="✅" text='Optionally rename it, then tap "Add" in the top-right. Done — find LAWN.Quote on your home screen!'>
              </Step>
            </div>
            <div style={{background:"rgba(124,252,0,0.04)",border:"1px solid rgba(124,252,0,0.1)",borderRadius:10,padding:"11px 14px",display:"flex",gap:8,alignItems:"flex-start"}}>
              <span style={{color:"#7CFC00",fontSize:12,fontFamily:"monospace",fontWeight:700,flexShrink:0}}>💡</span>
              <span style={{color:"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace",lineHeight:1.6}}>If the Share button is hidden, scroll to the top of the page first — it will reappear in the Safari toolbar.</span>
            </div>
          </div>
        )}

        {activeTab==="samsung"&&(
          <div>
            <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:12,padding:"18px 16px",marginBottom:14}}>
              <div style={{color:"rgba(255,255,255,0.25)",fontSize:10,fontFamily:"monospace",letterSpacing:"0.1em",marginBottom:16}}>CHROME OR SAMSUNG INTERNET</div>
              <Step num="1" icon="🌐" text="Open this page in Chrome or Samsung Internet on your Android device.">
              </Step>
              <Step num="2" icon="⋮" text='Tap the three-dot menu (⋮) in the top-right corner of the browser.'>
              </Step>
              <Step num="3" icon="➕" text='Tap "Add to Home screen". On Samsung Internet choose "Add page to" → "Home screen".'>
              </Step>
              <Step num="4" icon="✅" text='Tap "Add" on the dialog. LAWN.Quote will appear on your home screen like a regular app.'>
              </Step>
            </div>
            <div style={{background:"rgba(124,252,0,0.04)",border:"1px solid rgba(124,252,0,0.1)",borderRadius:10,padding:"11px 14px",display:"flex",gap:8,alignItems:"flex-start"}}>
              <span style={{color:"#7CFC00",fontSize:12,fontFamily:"monospace",fontWeight:700,flexShrink:0}}>💡</span>
              <span style={{color:"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace",lineHeight:1.6}}>Chrome may also show an "Install app" banner at the bottom automatically — just tap it to install in one step.</span>
            </div>
          </div>
        )}

        <button onClick={onClose} style={{width:"100%",marginTop:22,background:"#7CFC00",color:"#000",border:"none",borderRadius:10,padding:"15px",fontSize:13,fontFamily:"monospace",fontWeight:700,cursor:"pointer",letterSpacing:"0.05em"}}>
          GOT IT
        </button>
      </div>
    </div>
  );
}

// ── Onboarding Checklist ──────────────────────────────────────────────────────
function OnboardingChecklist({profile,customers,quotes,onNavigate}){
  const [dismissed,setDismissed]=useState(()=>!!localStorage.getItem('onboarding_done'));

  const step1=!!(profile?.company&&profile?.name);
  const step2=customers.length>0;
  const step3=quotes.length>0;
  const allDone=step1&&step2&&step3;

  // Auto-dismiss and save when all steps complete
  const prevAllDone=useRef(allDone);
  useEffect(()=>{
    if(allDone&&!prevAllDone.current){
      localStorage.setItem('onboarding_done','1');
      setTimeout(()=>setDismissed(true),1200);
    }
    prevAllDone.current=allDone;
  },[allDone]);

  if(dismissed) return null;

  const steps=[
    {label:"Add your company info",  sub:"Name, phone, and company",           done:step1, action:()=>onNavigate('account','profile')},
    {label:"Add your first client",  sub:"Go to Clients → tap +",              done:step2, action:()=>onNavigate('customers')},
    {label:"Create your first quote",sub:"Tap the ✦ Quote tab below",          done:step3, action:()=>onNavigate('newquote')},
  ];
  const completedCount=steps.filter(s=>s.done).length;

  return(
    <div style={{background:"rgba(124,252,0,0.05)",border:"1px solid rgba(124,252,0,0.2)",borderRadius:14,padding:"16px",marginBottom:14,animation:"fadeUp 0.3s ease"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
        <div>
          <div style={{color:"#7CFC00",fontSize:11,fontFamily:"monospace",fontWeight:700,letterSpacing:"0.08em"}}>🌿 GET STARTED</div>
          <div style={{color:"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace",marginTop:3}}>{completedCount} of 3 steps complete</div>
        </div>
        <button onClick={()=>{localStorage.setItem('onboarding_done','1');setDismissed(true);}} style={{background:"none",border:"none",color:"rgba(255,255,255,0.25)",cursor:"pointer",fontSize:16,padding:"2px 4px"}}>✕</button>
      </div>
      {/* Progress bar */}
      <div style={{height:3,background:"rgba(255,255,255,0.08)",borderRadius:99,overflow:"hidden",marginBottom:12}}>
        <div style={{height:"100%",background:"#7CFC00",width:(completedCount/3*100)+"%",borderRadius:99,transition:"width 0.5s"}}/>
      </div>
      {/* Steps */}
      <div style={{display:"flex",flexDirection:"column",gap:8}}>
        {steps.map((s,i)=>(
          <button key={i} onClick={s.done?undefined:s.action} disabled={s.done} style={{display:"flex",alignItems:"center",gap:12,background:s.done?"rgba(124,252,0,0.04)":"rgba(255,255,255,0.03)",border:"1px solid "+(s.done?"rgba(124,252,0,0.15)":"rgba(255,255,255,0.07)"),borderRadius:10,padding:"10px 12px",cursor:s.done?"default":"pointer",textAlign:"left",width:"100%",transition:"all 0.15s"}}>
            <div style={{width:22,height:22,borderRadius:"50%",background:s.done?"#7CFC00":"rgba(255,255,255,0.06)",border:"2px solid "+(s.done?"#7CFC00":"rgba(255,255,255,0.15)"),display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,transition:"all 0.3s"}}>
              {!s.done&&<span style={{color:"rgba(255,255,255,0.25)",fontSize:10,fontFamily:"monospace"}}>{i+1}</span>}
            </div>
            <div style={{flex:1}}>
              <div style={{color:s.done?"rgba(255,255,255,0.35)":"rgba(255,255,255,0.8)",fontSize:13,fontFamily:"monospace",fontWeight:700,textDecoration:s.done?"line-through":"none"}}>{s.label}</div>
              {!s.done&&<div style={{color:"rgba(255,255,255,0.3)",fontSize:11,fontFamily:"monospace",marginTop:1}}>{s.sub}</div>}
            </div>
            {!s.done&&<span style={{color:"rgba(124,252,0,0.5)",fontSize:13}}>→</span>}
          </button>
        ))}
      </div>
    </div>
  );
}

// ── Paywall Modal ─────────────────────────────────────────────────────────────
function PaywallModal({onUpgrade,onSignOut}){
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.95)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:"#0a180a",border:"1px solid rgba(255,68,68,0.3)",borderRadius:20,padding:"36px 28px",maxWidth:360,width:"100%",textAlign:"center",animation:"fadeUp 0.3s ease"}}>
        <div style={{fontSize:40,marginBottom:16}}>⏰</div>
        <div style={{color:"#ff6b6b",fontSize:18,fontFamily:"monospace",fontWeight:700,marginBottom:8}}>TRIAL EXPIRED</div>
        <div style={{color:"rgba(255,255,255,0.55)",fontSize:13,fontFamily:"monospace",lineHeight:1.7,marginBottom:24}}>
          Your 14-day free trial has ended. Upgrade to LAWN.Quote Pro to keep access to all your quotes, clients, invoices, and schedule.
        </div>

        {/* Feature reminder */}
        <div style={{background:"rgba(124,252,0,0.05)",border:"1px solid rgba(124,252,0,0.15)",borderRadius:12,padding:"14px 16px",marginBottom:20,textAlign:"left"}}>
          <div style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontFamily:"monospace",letterSpacing:"0.08em",marginBottom:8}}>WHAT YOU GET FOR $10/MO</div>
          {["Unlimited quotes & clients","Satellite measurement","Schedule & route optimization","Invoicing & payments","All features, always"].map(f=>(
            <div key={f} style={{display:"flex",gap:8,marginBottom:5}}>
              <span style={{color:"#7CFC00",fontSize:12}}>✓</span>
              <span style={{color:"rgba(255,255,255,0.6)",fontSize:12,fontFamily:"monospace"}}>{f}</span>
            </div>
          ))}
        </div>

        <button onClick={onUpgrade} style={{width:"100%",background:"#7CFC00",color:"#000",border:"none",borderRadius:10,padding:"15px",fontSize:14,fontFamily:"monospace",fontWeight:700,cursor:"pointer",marginBottom:10}}>
          🚀 UPGRADE FOR $10/MO →
        </button>
        <button onClick={onSignOut} style={{width:"100%",background:"none",border:"1px solid rgba(255,255,255,0.1)",borderRadius:10,padding:"11px",fontSize:12,fontFamily:"monospace",color:"rgba(255,255,255,0.35)",cursor:"pointer"}}>
          Sign out
        </button>
      </div>
    </div>
  );
}

// ─── Constants ────────────────────────────────────────────────────────────────
// ── Grass / Lawn Services (sqft-based) ──────────────────────────────────────
const SERVICES = [
  { id:"mow",    label:"Mow & Edge",        basePrice:45, perSqft:0.0045, unit:"sqft" },
  { id:"fert",   label:"Fertilization",     basePrice:35, perSqft:0.0035, unit:"sqft" },
  { id:"aerate", label:"Core Aeration",     basePrice:75, perSqft:0.0060, unit:"sqft" },
  { id:"seed",   label:"Overseeding",       basePrice:55, perSqft:0.0080, unit:"sqft" },
  { id:"weed",   label:"Weed Control",      basePrice:35, perSqft:0.0025, unit:"sqft" },
  { id:"leaf",   label:"Leaf Removal",      basePrice:65, perSqft:0.0055, unit:"sqft" },
  { id:"trim",   label:"Shrub Trimming",    basePrice:55, perSqft:0.0020, unit:"sqft" },
  { id:"detatch",label:"Dethatching",       basePrice:80, perSqft:0.0070, unit:"sqft" },
  { id:"lime",   label:"Lime Application",  basePrice:40, perSqft:0.0020, unit:"sqft" }];

// ── Landscaping Services (bed sqft-based, labor + material) ─────────────────
const LANDSCAPE_SERVICES = [
  { id:"mulch",   label:"Mulch Install (2in)",  laborPerSqft:0.65, matPerSqft:0.55, unit:"sqft", notes:"3cu ft/10sqft" },,
  { id:"mulch3",  label:"Mulch Install (3in)",  laborPerSqft:0.65, matPerSqft:0.80, unit:"sqft", notes:"3cu ft/7sqft" },,
  { id:"bedge",   label:"Bed Edging & Cleanup", laborPerSqft:0.45, matPerSqft:0,    unit:"sqft", notes:"~$1.50/linear ft" },,
  { id:"weedctrl",label:"Weed Control",         laborPerSqft:0.20, matPerSqft:0.08, unit:"sqft", notes:"incl. herbicide" },,
  { id:"preemerg",label:"Pre-emergent",         laborPerSqft:0.15, matPerSqft:0.10, unit:"sqft", notes:"seasonal app" },,
  { id:"fabric",  label:"Landscape Fabric",     laborPerSqft:0.35, matPerSqft:0.25, unit:"sqft", notes:"incl. pins" },,
  { id:"rock",    label:"Rock / Gravel (2in)",  laborPerSqft:0.85, matPerSqft:1.20, unit:"sqft", notes:"river rock avg" },,
  { id:"rock3",   label:"Rock / Gravel (3in)",  laborPerSqft:0.85, matPerSqft:1.75, unit:"sqft", notes:"deeper coverage" },,
  { id:"pavers",  label:"Paver Install",        laborPerSqft:8.50, matPerSqft:5.50, unit:"sqft", notes:"excl. base prep" },,
  { id:"groundcv",label:"Groundcover Planting", laborPerSqft:0.90, matPerSqft:0.85, unit:"sqft", notes:"2in plugs avg" },,
  { id:"shrub",   label:"Shrub Planting",       laborPerSqft:0,    matPerSqft:0,    unit:"each", laborEach:45, matEach:35, notes:"5-gal container avg" },,
  { id:"flower",  label:"Annual Flowers",       laborPerSqft:0,    matPerSqft:0,    unit:"each", laborEach:8,  matEach:6,  notes:"4in pot avg" },,
  { id:"topsoil", label:"Topsoil / Topdress",   laborPerSqft:0.40, matPerSqft:0.55, unit:"sqft", notes:"1in depth" },];
const MATERIALS = [
  { id:1, name:"Bermuda Grass Sod (pallet)", unit:"pallet",   price:189, store:"Lowe's",      margin:0.22 },
  { id:2, name:"Scott's Turf Builder",       unit:"40lb bag", price:34,  store:"Home Depot",  margin:0.18 },
  { id:3, name:"Pre-emergent Weed Control",  unit:"12lb bag", price:29,  store:"Lowe's",      margin:0.2  },
  { id:4, name:"Lawn Edging (20ft roll)",    unit:"roll",     price:22,  store:"Home Depot",  margin:0.25 },
  { id:5, name:"Fertilizer 16-4-8 (50lb)",  unit:"bag",      price:48,  store:"Lowe's",      margin:0.2  },
  { id:6, name:"Mulch (2cu ft bag)",         unit:"bag",      price:6.5, store:"Home Depot",  margin:0.3  }];
// ── Holiday Lighting ─────────────────────────────────────────────────────────
// Legacy constants kept for displaying old saved quotes
const HOLIDAY_SERVICE_PLANS = [
  { id:"hl_install",          label:"Install Only",                laborPerLinFt:2.50, laborPerItem:8.00,  storageFee:0  },
  { id:"hl_install_takedown", label:"Install + Takedown",          laborPerLinFt:3.75, laborPerItem:12.00, storageFee:0  },
  { id:"hl_full_service",     label:"Install + Takedown + Storage",laborPerLinFt:4.50, laborPerItem:15.00, storageFee:75 },
];
const HOLIDAY_MATERIALS = [
  { id:"hl_c9",     name:"C9 LED Strand (25ft)",   unit:"strand", price:28,  margin:0.35 },
  { id:"hl_mini",   name:"Mini LED Strand (100ct)", unit:"strand", price:18,  margin:0.35 },
  { id:"hl_wreath", name:"Wreath (24in)",           unit:"each",   price:35,  margin:0.30 },
  { id:"hl_garland",name:"Garland (9ft)",           unit:"each",   price:22,  margin:0.30 },
  { id:"hl_stake",  name:"Pathway Stake Light",     unit:"each",   price:8,   margin:0.40 },
  { id:"hl_clip",   name:"Gutter Clips (50ct)",     unit:"bag",    price:9,   margin:0.25 },
  { id:"hl_timer",  name:"Outlet Timer",            unit:"each",   price:18,  margin:0.30 },
];
// New simple per-unit pricing model
const HOLIDAY_ITEMS = [
  { id:"hli_c9",       label:"C9 Lights",          unit:"ft",  pricePerUnit:3.50 },
  { id:"hli_mini",     label:"Mini/Twinkle Lights", unit:"ft",  pricePerUnit:2.50 },
  { id:"hli_garland",  label:"Garland",             unit:"ft",  pricePerUnit:4.00 },
  { id:"hli_treewrap", label:"Tree Wrap",           unit:"ft",  pricePerUnit:3.00 },
  { id:"hli_roofline", label:"Roofline/Eave",       unit:"ft",  pricePerUnit:2.00 },
  { id:"hli_wreath",   label:"Wreath",              unit:"ea",  pricePerUnit:65.00 },
  { id:"hli_stake",    label:"Pathway Stake",       unit:"ea",  pricePerUnit:12.00 },
];
const HOLIDAY_SVC_OPTIONS = [
  { id:"install_only",    label:"Install Only",                  takedownPct:0,  storageFee:0  },
  { id:"install_takedown",label:"Install + Takedown",            takedownPct:40, storageFee:0  },
  { id:"full_service",    label:"Install + Takedown + Storage",  takedownPct:40, storageFee:75 },
];

// ── Default (recommended) rate settings ──────────────────────────────────────
const DEFAULT_RATE_SETTINGS = {
  services: Object.fromEntries(SERVICES.map(s=>[s.id,{basePrice:s.basePrice,perSqft:s.perSqft}])),
  landscapeServices: Object.fromEntries(LANDSCAPE_SERVICES.filter(s=>s&&s.id).map(s=>[s.id,{laborPerSqft:s.laborPerSqft||0,matPerSqft:s.matPerSqft||0,laborEach:s.laborEach||0,matEach:s.matEach||0}])),
  materials: Object.fromEntries(MATERIALS.map(m=>[String(m.id),{price:m.price,margin:m.margin}])),
  holidayItems: Object.fromEntries(HOLIDAY_ITEMS.map(i=>[i.id,{pricePerUnit:i.pricePerUnit}])),
};
const mergeRateSettings = (saved) => ({
  services: {...DEFAULT_RATE_SETTINGS.services, ...(saved?.services||{})},
  landscapeServices: {...DEFAULT_RATE_SETTINGS.landscapeServices, ...(saved?.landscapeServices||{})},
  materials: {...DEFAULT_RATE_SETTINGS.materials, ...(saved?.materials||{})},
  holidayItems: {...DEFAULT_RATE_SETTINGS.holidayItems, ...(saved?.holidayItems||{})},
});

const calcHolidayPrice = (m, planId, rateSettings) => {
  const plan = HOLIDAY_SERVICE_PLANS.find(p => p.id === planId);
  if (!plan) return 0;
  const r = rateSettings?.holidayPlans?.[planId] || plan;
  const linFt = (m.rooflineFt||0) + (m.gutterFt||0) + (m.garlandFt||0);
  const items  = (m.wreathCount||0) + (m.stakeCount||0) + (m.doorCount||0) + (m.windowCount||0);
  return Math.round(((r.laborPerLinFt * linFt) + (r.laborPerItem * items) + r.storageFee) * 100) / 100;
};

const RECURRING_OPTIONS = [
  { id:"once",     label:"One-time",  perYear:1  },
  { id:"weekly",   label:"Weekly",    perYear:52 },
  { id:"biweekly", label:"Bi-weekly", perYear:26 },
  { id:"monthly",  label:"Monthly",   perYear:12 }];
const PAYMENT_METHODS = ["Cash","Check","Venmo","Zelle","CashApp","ACH Transfer","Credit Card","Debit Card","Other"];
const PIPELINE_STAGES = ["Lead","Quoted","Accepted","Scheduled","Completed","Declined"];
const STAGE_COLORS    = { Lead:"#888",Quoted:"#7CFC00",Accepted:"var(--lq-blue)",Scheduled:"#ffaa00",Completed:"#00ff99",Declined:"#ff4444" };
const PROPERTY_TYPES  = ["Residential","Commercial","HOA","Other"];

// ─── Helpers ──────────────────────────────────────────────────────────────────
const genId    = () => `${Date.now()}-${Math.random().toString(36).slice(2,6).toUpperCase()}`;
const qNum     = () => `LQ-${Math.floor(Math.random()*9000+1000)}`;
const todayStr = () => new Date().toISOString().split("T")[0];
const fmtDate  = iso => new Date(iso+"T12:00:00").toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"});
const daysSince= iso => Math.floor((Date.now()-new Date(iso+"T12:00:00"))/86400000);

// Check if user has active access (must be after daysSince)
const hasAccess = (profile) => {
  if(!profile) return false;
  if(profile.plan==="pro") return true;
  if(profile.plan==="cancelled") return false;
  // trial_start is null until first quote is saved — full access until then
  if(!profile.trial_start) return true;
  const daysUsed = daysSince(profile.trial_start);
  console.log("[Paywall] plan:", profile.plan, "trial_start:", profile.trial_start, "days_used:", daysUsed, "blocked:", daysUsed > 14);
  return daysUsed <= 14;
};
const addDays  = (iso,n) => { const d=new Date(iso+"T12:00:00"); d.setDate(d.getDate()+n); return d.toISOString().split("T")[0]; };
const nextDue  = (last,rec) => { const m={weekly:7,biweekly:14,monthly:30}; return m[rec]?addDays(last,m[rec]):null; };

const rowToQuote = r => {
  // Normalize services: lawn-quote writes `services`, portal writes `line_items`
  // Fall back to line_items so portal-created quotes display properly here
  const rawSvcs = r.services && r.services.length > 0 ? r.services : [];
  const lineItemsAsSvcs = (r.line_items && r.line_items.length > 0 && rawSvcs.length === 0)
    ? r.line_items.map(l=>({id:l.name,label:l.name,basePrice:parseFloat(l.price)||0,perSqft:0,isPortalItem:true}))
    : [];
  return {
    id:r.id, quoteNum:r.quote_num, stage:r.stage, createdAt:r.created_at,
    customerId:r.customer_id, customerName:r.customer_name, customerPhone:r.customer_phone,
    address:r.address, sqft:r.sqft, services:[...rawSvcs,...lineItemsAsSvcs], materials:r.materials||[],
    subtotal:r.subtotal, discAmt:r.disc_amt, taxAmt:r.tax_amt, total:r.total,
    taxRate:r.tax_rate, discount:r.discount, recurring:r.recurring,
    payment:r.payment, notes:r.notes, photoCount:r.photo_count, annualVal:r.annual_val,
    photos:r.photos||[], shareToken:r.share_token||r.quote_token||null,
    quoteCategory:        r.quote_category        || 'lawn',
    holidayMeasurements:  r.holiday_measurements  || {},
    depositAmount:        r.deposit_amount        || 0,
    depositPaid:          r.deposit_paid          || false,
    depositStripeLink:    r.deposit_stripe_link   || null,
    preferredInstallDate: r.preferred_install_date || null,
    preferredTakedownDate:r.preferred_takedown_date|| null,
  };
};
const rowToCustomer = r => ({
  id:r.id, name:r.name, phone:r.phone, email:r.email,
  address:r.address, propertyType:r.property_type, notes:r.notes, createdAt:r.created_at,
  recurringActive:     r.recurring_active,
  recurringFrequency:  r.recurring_frequency,
  recurringDay:        r.recurring_day,
  recurringStart:      r.recurring_start,
  recurringServices:   r.recurring_services,
  recurringDuration:          r.recurring_duration,
  recurringCustomDays:        r.recurring_custom_days,
  recurringEnd:               r.recurring_end,
  recurringTemplateQuoteId:   r.recurring_template_quote_id,
  recurringPrice:             r.recurring_price ?? null,
});


const rowToInvoice = r => ({
  id:r.id, invoiceNum:r.invoice_num, status:r.status, createdAt:r.created_at,
  customerId:r.customer_id, customerName:r.customer_name,
  customerPhone:r.customer_phone, customerEmail:r.customer_email,
  quoteId:r.quote_id, lineItems:r.line_items||[],
  subtotal:r.subtotal, discAmt:r.disc_amt, taxAmt:r.tax_amt, total:r.total,
  terms:r.terms, dueDate:r.due_date, paidDate:r.paid_date,
  paymentMethod:r.payment_method, notes:r.notes,
});
const iNum = () => `INV-${Math.floor(Math.random()*9000+1000)}`;
const calcDueDate = (terms, from=todayStr()) => {
  if(terms==="due_receipt") return from;
  if(terms==="net7")  return addDays(from,7);
  if(terms==="net30") return addDays(from,30);
  return from; // custom — caller sets manually
};
const isOverdue = inv => inv.status!=="Paid" && inv.dueDate && daysSince(inv.dueDate) > 0;

// ─── Google Maps ──────────────────────────────────────────────────────────────
function useGoogleReady() {
  const [ready,setReady]=useState(()=>!!(window.google?.maps?.places));
  useEffect(()=>{
    if(ready) return;
    const id=setInterval(()=>{ if(window.google?.maps?.places){setReady(true);clearInterval(id);} },150);
    return ()=>clearInterval(id);
  },[ready]);
  return ready;
}
const computeSqft = polygon =>
  Math.round(window.google.maps.geometry.spherical.computeArea(polygon.getPath())*10.7639);

// ─── Shared UI ────────────────────────────────────────────────────────────────
const S = {
  label:   {color:"var(--lq-accent)",fontFamily:"monospace",fontSize:10,letterSpacing:"0.12em",textTransform:"uppercase",marginBottom:6},
  heading: {fontSize:22,fontWeight:700,color:"var(--lq-text)",margin:0,lineHeight:1.2},
  sub:     {color:"var(--lq-text3)",fontSize:12,marginTop:5,fontFamily:"monospace"},
  card:    {background:"var(--lq-card)",border:"1px solid var(--lq-card-border)",borderRadius:12,padding:"14px 16px"},
  divider: {height:1,background:"var(--lq-divider)",margin:"4px 0"},
  mapBadge:{position:"absolute",bottom:10,left:10,background:"rgba(0,0,0,0.78)",borderRadius:6,padding:"4px 9px",color:"var(--lq-accent)",fontSize:10,fontFamily:"monospace",border:"1px solid rgba(124,252,0,0.25)"},
};
const btn=(active,variant="primary")=>{
  const v={
    primary:{bg:active?"#7CFC00":"rgba(124,252,0,0.12)",color:active?"#000":"rgba(255,255,255,0.25)"},
    ghost:  {bg:"rgba(255,255,255,0.05)",color:"rgba(255,255,255,0.55)"},
    blue:   {bg:active?"rgba(0,207,255,0.15)":"rgba(255,255,255,0.04)",color:active?"var(--lq-blue)":"rgba(255,255,255,0.3)"},
    danger: {bg:"rgba(255,68,68,0.1)",color:"#ff6b6b"},
  }[variant];
  return {background:v.bg,color:v.color,border:`1px solid ${active?(variant==="primary"?"rgba(124,252,0,0.4)":variant==="blue"?"rgba(0,207,255,0.3)":variant==="danger"?"rgba(255,68,68,0.35)":"rgba(255,255,255,0.1)"):"rgba(255,255,255,0.08)"}`,borderRadius:10,padding:"12px 16px",fontSize:13,fontWeight:700,fontFamily:"monospace",cursor:active?"pointer":"default",transition:"all 0.2s",width:"100%",display:"flex",alignItems:"center",justifyContent:"center",gap:6};
};

function Field({label,value,onChange,placeholder,type="text",required,rows,error}){
  const [focused,setFocused]=useState(false);
  const style={background:"rgba(255,255,255,0.06)",border:`1px solid ${error?"rgba(255,68,68,0.5)":focused?"rgba(124,252,0,0.45)":"rgba(255,255,255,0.1)"}`,borderRadius:10,padding:"11px 13px",color:"#fff",fontSize:13,fontFamily:"monospace",width:"100%",outline:"none",transition:"border-color 0.2s"};
  return(
    <div>
      <div style={S.label}>{label}{required&&<span style={{color:"#7CFC00"}}> *</span>}</div>
      {rows?<textarea value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder} rows={rows} onFocus={()=>setFocused(true)} onBlur={()=>setFocused(false)} style={{...style,resize:"vertical",lineHeight:1.5}}/>
           :<input type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder} onFocus={()=>setFocused(true)} onBlur={()=>setFocused(false)} style={style}/>}
      {error&&<div style={{color:"#ff6b6b",fontSize:11,fontFamily:"monospace",marginTop:4}}>{error}</div>}
    </div>
  );
}

function Tag({label,color}){
  return <span style={{background:`${color}18`,border:`1px solid ${color}44`,borderRadius:6,padding:"2px 8px",color,fontSize:10,fontFamily:"monospace",whiteSpace:"nowrap"}}>{label}</span>;
}

function StagePill({stage,onChange}){
  const [open,setOpen]=useState(false);
  const btnRef=useRef(null);
  const [dropUp,setDropUp]=useState(false);
  const color=STAGE_COLORS[stage]||"#888";

  const handleOpen=()=>{
    if(btnRef.current){
      const rect=btnRef.current.getBoundingClientRect();
      const spaceBelow=window.innerHeight-rect.bottom;
      // Open upward if less than 220px below
      setDropUp(spaceBelow<220);
    }
    setOpen(o=>!o);
  };

  return(
    <div style={{position:"relative",display:"inline-block"}}>
      {/* Backdrop to close */}
      {open&&<div onClick={()=>setOpen(false)} style={{position:"fixed",inset:0,zIndex:98}}/>}
      <button ref={btnRef} onClick={handleOpen} style={{background:`${color}18`,border:`1px solid ${color}44`,borderRadius:8,padding:"5px 10px",color:stage==="Lead"?"#555555":color,fontSize:11,fontFamily:"monospace",cursor:"pointer",fontWeight:700,position:"relative",zIndex:99}}>
        {stage} {open?"▴":"▾"}
      </button>
      {open&&(
        <div style={{
          position:"absolute",
          [dropUp?"bottom":"top"]:dropUp?"calc(100% + 4px)":"calc(100% + 4px)",
          left:0,
          background:"#0f1f0f",
          border:"1px solid rgba(255,255,255,0.15)",
          borderRadius:10,
          overflow:"hidden",
          zIndex:200,
          minWidth:140,
          boxShadow:"0 8px 32px rgba(0,0,0,0.6)",
        }}>
          {PIPELINE_STAGES.map(s=>(
            <button key={s} onClick={()=>{onChange(s);setOpen(false);}} style={{display:"flex",alignItems:"center",gap:8,width:"100%",padding:"10px 14px",background:s===stage?"rgba(255,255,255,0.07)":"none",border:"none",borderBottom:"1px solid rgba(255,255,255,0.04)",color:STAGE_COLORS[s]||"#888",fontSize:12,fontFamily:"monospace",cursor:"pointer",textAlign:"left"}}>
              <div style={{width:7,height:7,borderRadius:"50%",background:STAGE_COLORS[s]||"#888",flexShrink:0}}/>
              {s}
              {s===stage&&<span style={{marginLeft:"auto",fontSize:10}}>✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function ConfirmModal({message,onConfirm,onCancel,confirmLabel="DELETE",danger=true}){
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.8)",zIndex:500,display:"flex",alignItems:"center",justifyContent:"center",padding:"20px"}}>
      <div style={{background:"#0f1f0f",border:"1px solid rgba(255,255,255,0.12)",borderRadius:16,padding:"24px",maxWidth:340,width:"100%",animation:"fadeUp 0.2s ease"}}>
        <div style={{color:"#fff",fontSize:15,fontFamily:"monospace",fontWeight:700,marginBottom:8}}>Are you sure?</div>
        <div style={{color:"rgba(255,255,255,0.5)",fontSize:13,fontFamily:"monospace",lineHeight:1.6,marginBottom:20}}>{message}</div>
        <div style={{display:"flex",gap:10}}>
          <button onClick={onCancel} style={{...btn(true,"ghost"),flex:1}}>CANCEL</button>
          <button onClick={onConfirm} style={{...btn(true,danger?"danger":"primary"),flex:1}}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}

function Toast({message,type="success"}){
  return(
    <div style={{position:"fixed",top:20,left:"50%",transform:"translateX(-50%)",background:type==="success"?"rgba(124,252,0,0.15)":"rgba(255,68,68,0.15)",border:`1px solid ${type==="success"?"rgba(124,252,0,0.4)":"rgba(255,68,68,0.4)"}`,borderRadius:10,padding:"10px 18px",color:type==="success"?"#7CFC00":"#ff6b6b",fontFamily:"monospace",fontSize:13,fontWeight:700,zIndex:600,whiteSpace:"nowrap",animation:"fadeUp 0.2s ease"}}>
      {type==="success"?"✓":"✕"} {message}
    </div>
  );
}

function useToast(){
  const [toast,setToast]=useState(null);
  const show=(message,type="success")=>{
    setToast({message,type});
    setTimeout(()=>setToast(null),2500);
  };
  return [toast,show];
}

// ─── Auth ─────────────────────────────────────────────────────────────────────
function AuthLogo(){
  return(
    <div style={{textAlign:"center",marginBottom:32}}>
      <div style={{display:"inline-flex",alignItems:"center",gap:10,marginBottom:12}}>
        <div style={{width:36,height:36,borderRadius:10,background:"rgba(124,252,0,0.15)",border:"2px solid rgba(124,252,0,0.4)",display:"flex",alignItems:"center",justifyContent:"center"}}><span style={{fontSize:18}}>🌿</span></div>
        <span style={{color:"#7CFC00",fontFamily:"monospace",fontSize:20,fontWeight:700,letterSpacing:"0.1em"}}>LAWN·QUOTE</span>
      </div>
      <div style={{color:"rgba(255,255,255,0.3)",fontFamily:"monospace",fontSize:11,letterSpacing:"0.08em"}}>BUILT FOR THE TRUCK</div>
    </div>
  );
}

function AuthInput({label,type="text",value,onChange,placeholder,error}){
  const [show,setShow]=useState(false);
  const [focused,setFocused]=useState(false);
  const isPass=type==="password";
  return(
    <div>
      <div style={{color:"rgba(255,255,255,0.45)",fontSize:11,fontFamily:"monospace",letterSpacing:"0.08em",marginBottom:6}}>{label}</div>
      <div style={{position:"relative"}}>
        <input type={isPass?(show?"text":"password"):type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder} onFocus={()=>setFocused(true)} onBlur={()=>setFocused(false)}
          style={{width:"100%",background:"rgba(255,255,255,0.06)",border:`1px solid ${error?"rgba(255,68,68,0.5)":focused?"rgba(124,252,0,0.5)":"rgba(255,255,255,0.12)"}`,borderRadius:12,padding:isPass?"12px 44px 12px 14px":"12px 14px",color:"#fff",fontSize:14,fontFamily:"monospace",outline:"none",transition:"border-color 0.2s",boxSizing:"border-box"}}/>
        {isPass&&<button onClick={()=>setShow(s=>!s)} style={{position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:"rgba(255,255,255,0.35)",cursor:"pointer",fontSize:14,padding:0}}>{show?"🙈":"👁"}</button>}
      </div>
      {error&&<div style={{color:"#ff6b6b",fontSize:11,fontFamily:"monospace",marginTop:4}}>{error}</div>}
    </div>
  );
}

function LoginScreen({onNav,onDemo}){
  const [email,setEmail]=useState(""); const [password,setPassword]=useState("");
  const [loading,setLoading]=useState(false); const [error,setError]=useState("");
  const handle=async()=>{
    if(!email.trim()||password.length<6){setError("Enter your email and password");return;}
    setLoading(true);setError("");
    const{error:err}=await supabase.auth.signInWithPassword({email,password});
    setLoading(false);
    if(err)setError(err.message);
  };
  return(
    <div style={{display:"flex",flexDirection:"column",gap:20}}>
      <AuthLogo/>
      <div style={{textAlign:"center",marginBottom:4}}><h2 style={{...S.heading,fontSize:20,marginBottom:6}}>Welcome back</h2><p style={{color:"rgba(255,255,255,0.4)",fontSize:13,fontFamily:"monospace"}}>Sign in to your account</p></div>
      <AuthInput label="EMAIL ADDRESS" type="email" value={email} onChange={v=>{setEmail(v);setError("");}} placeholder="you@example.com"/>
      <AuthInput label="PASSWORD" type="password" value={password} onChange={v=>{setPassword(v);setError("");}} placeholder="••••••••"/>
      {error&&<div style={{background:"rgba(255,68,68,0.1)",border:"1px solid rgba(255,68,68,0.3)",borderRadius:8,padding:"10px 14px",color:"#ff6b6b",fontSize:12,fontFamily:"monospace"}}>{error}</div>}
      <button onClick={handle} disabled={loading} style={{...btn(!loading),background:loading?"rgba(124,252,0,0.2)":"#7CFC00",color:loading?"rgba(255,255,255,0.3)":"#000",border:"none",padding:"15px",fontSize:14}}>{loading?"SIGNING IN…":"SIGN IN →"}</button>
      <div style={{textAlign:"center"}}><span style={{color:"rgba(255,255,255,0.35)",fontSize:13,fontFamily:"monospace"}}>No account? </span><button onClick={()=>onNav("signup")} style={{background:"none",border:"none",color:"#7CFC00",fontSize:13,fontFamily:"monospace",cursor:"pointer",fontWeight:700}}>Start free trial</button></div>
      <div style={{textAlign:"center"}}><button onClick={()=>onNav("forgot")} style={{background:"none",border:"none",color:"rgba(255,255,255,0.3)",fontSize:12,fontFamily:"monospace",cursor:"pointer"}}>Forgot password?</button></div>
      {onDemo&&<div style={{borderTop:"1px solid rgba(255,255,255,0.07)",paddingTop:16,textAlign:"center"}}><button onClick={onDemo} style={{background:"none",border:"1px solid rgba(124,252,0,0.25)",borderRadius:9,color:"rgba(124,252,0,0.7)",fontSize:12,fontFamily:"monospace",cursor:"pointer",padding:"10px 20px",width:"100%"}}>👁 Try Demo — no account needed</button></div>}
    </div>
  );
}

function SignupScreen({onNav}){
  const [name,setName]=useState(""); const [company,setCompany]=useState("");
  const [email,setEmail]=useState(""); const [password,setPassword]=useState("");
  const [confirm,setConfirm]=useState(""); const [agreed,setAgreed]=useState(false);
  const [loading,setLoading]=useState(false); const [error,setError]=useState("");
  const strength=password.length===0?0:password.length<6?1:password.length<10?2:3;
  const strengthColor=["transparent","#ff4444","#ffaa00","#7CFC00"][strength];
  const handle=async()=>{
    if(!name.trim()){setError("Name is required");return;}
    if(!email.includes("@")){setError("Valid email required");return;}
    if(password.length<6){setError("Minimum 6 characters");return;}
    if(password!==confirm){setError("Passwords don't match");return;}
    if(!agreed){setError("Please agree to the terms");return;}
    setLoading(true);setError("");
    const{error:err,data}=await supabase.auth.signUp({email,password,options:{data:{name,company}}});
    setLoading(false);
    if(err){setError(err.message);return;}
    // Add to Loops for marketing emails
    try{
      await fetch('/api/add-to-loops',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({
          email,
          firstName:name.split(' ')[0],
          lastName:name.split(' ').slice(1).join(' ')||'',
          source:'app-signup',
        })
      });
    }catch(e){console.log('Loops error:',e);}
    // Account created — redirect to Stripe checkout
    try{
      const res=await fetch("/api/create-checkout",{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({
          email,
          priceId:"price_1TXn5FFOsREr3krA0wgTAXmV",
        }),
      });
      const{url,error:stripeErr}=await res.json();
      if(stripeErr) throw new Error(stripeErr);
      window.location.href=url;
    }catch(e){
      console.error("Stripe redirect error:",e);
      // Account created even if Stripe fails — let them in
      onNav("login");
    }
  };
  return(
    <div style={{display:"flex",flexDirection:"column",gap:18}}>
      <AuthLogo/>
      <div style={{background:"rgba(124,252,0,0.08)",border:"1px solid rgba(124,252,0,0.25)",borderRadius:12,padding:"12px 16px",textAlign:"center"}}>
        <div style={{color:"#7CFC00",fontFamily:"monospace",fontSize:13,fontWeight:700}}>🎉 14-DAY FREE TRIAL</div>
        <div style={{color:"rgba(255,255,255,0.45)",fontSize:11,fontFamily:"monospace",marginTop:3}}>Enter your card · no charge for 14 days · $10/mo after</div>
      </div>
      <AuthInput label="YOUR NAME" value={name} onChange={v=>{setName(v);setError("");}} placeholder="Jane Smith"/>
      <AuthInput label="COMPANY (OPTIONAL)" value={company} onChange={setCompany} placeholder="ABC Lawn Care"/>
      <AuthInput label="EMAIL ADDRESS" type="email" value={email} onChange={v=>{setEmail(v);setError("");}} placeholder="you@example.com"/>
      <AuthInput label="PASSWORD" type="password" value={password} onChange={v=>{setPassword(v);setError("");}} placeholder="Min. 6 characters"/>
      {password.length>0&&<div style={{marginTop:-10}}><div style={{display:"flex",gap:4,marginBottom:4}}>{[1,2,3].map(i=><div key={i} style={{flex:1,height:3,borderRadius:99,background:strength>=i?strengthColor:"rgba(255,255,255,0.1)",transition:"background 0.3s"}}/>)}</div><div style={{color:strengthColor,fontSize:10,fontFamily:"monospace"}}>{"Weak Fair Strong".split(" ")[strength-1]||""}</div></div>}
      <AuthInput label="CONFIRM PASSWORD" type="password" value={confirm} onChange={v=>{setConfirm(v);setError("");}} placeholder="Re-enter password"/>
      <button onClick={()=>setAgreed(a=>!a)} style={{display:"flex",alignItems:"flex-start",gap:10,background:"none",border:"none",cursor:"pointer",padding:0,textAlign:"left"}}>
        <div style={{width:18,height:18,borderRadius:5,background:agreed?"#7CFC00":"rgba(255,255,255,0.08)",border:`2px solid ${agreed?"#7CFC00":"rgba(255,255,255,0.2)"}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>{agreed&&<span style={{fontSize:10,color:"#000",fontWeight:900}}>✓</span>}</div>
        <span style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",lineHeight:1.5}}>I agree to the Terms of Service and Privacy Policy</span>
      </button>
      {error&&<div style={{background:"rgba(255,68,68,0.1)",border:"1px solid rgba(255,68,68,0.3)",borderRadius:8,padding:"10px 14px",color:"#ff6b6b",fontSize:12,fontFamily:"monospace"}}>{error}</div>}
      <button onClick={handle} disabled={loading} style={{...btn(!loading),background:loading?"rgba(124,252,0,0.2)":"#7CFC00",color:loading?"rgba(255,255,255,0.3)":"#000",border:"none",padding:"15px",fontSize:14}}>{loading?"CREATING ACCOUNT…":"START FREE TRIAL →"}</button>
      <div style={{textAlign:"center"}}><span style={{color:"rgba(255,255,255,0.35)",fontSize:13,fontFamily:"monospace"}}>Already have an account? </span><button onClick={()=>onNav("login")} style={{background:"none",border:"none",color:"#7CFC00",fontSize:13,fontFamily:"monospace",cursor:"pointer",fontWeight:700}}>Sign in</button></div>
    </div>
  );
}

function ForgotScreen({onNav}){
  const [email,setEmail]=useState(""); const [sent,setSent]=useState(false);
  const [loading,setLoading]=useState(false); const [error,setError]=useState("");
  const handle=async()=>{
    if(!email.includes("@")){setError("Enter a valid email");return;}
    setLoading(true);
    const{error:err}=await supabase.auth.resetPasswordForEmail(email,{redirectTo:window.location.origin});
    setLoading(false);
    if(err){setError(err.message);return;}
    setSent(true);
  };
  return(
    <div style={{display:"flex",flexDirection:"column",gap:20}}>
      <AuthLogo/>
      {!sent?(<>
        <div style={{textAlign:"center"}}><h2 style={{...S.heading,fontSize:20,marginBottom:6}}>Reset password</h2><p style={{color:"rgba(255,255,255,0.4)",fontSize:13,fontFamily:"monospace"}}>We'll send a reset link to your email</p></div>
        <AuthInput label="EMAIL ADDRESS" type="email" value={email} onChange={v=>{setEmail(v);setError("");}} placeholder="you@example.com"/>
        {error&&<div style={{color:"#ff6b6b",fontSize:12,fontFamily:"monospace"}}>{error}</div>}
        <button onClick={handle} disabled={loading||!email.includes("@")} style={{...btn(email.includes("@")&&!loading),background:email.includes("@")&&!loading?"#7CFC00":"rgba(124,252,0,0.15)",color:email.includes("@")&&!loading?"#000":"rgba(255,255,255,0.3)",border:"none",padding:"15px",fontSize:14}}>{loading?"SENDING…":"SEND RESET LINK →"}</button>
      </>):(
        <div style={{textAlign:"center",padding:"20px 0"}}>
          <div style={{fontSize:36,marginBottom:16}}>📬</div>
          <div style={{color:"#7CFC00",fontSize:16,fontWeight:700,fontFamily:"monospace",marginBottom:8}}>Check your email</div>
          <div style={{color:"rgba(255,255,255,0.45)",fontSize:13,fontFamily:"monospace",lineHeight:1.6}}>Reset link sent to<br/><span style={{color:"#fff"}}>{email}</span></div>
        </div>
      )}
      <button onClick={()=>onNav("login")} style={{background:"none",border:"none",color:"rgba(255,255,255,0.35)",fontSize:13,fontFamily:"monospace",cursor:"pointer"}}>← Back to sign in</button>
    </div>
  );
}

// ─── Trial Banner ─────────────────────────────────────────────────────────────
function TrialBanner({profile}){
  const [dismissed,setDismissed]=useState(false);
  if(dismissed) return null;
  return(
    <div style={{background:"var(--lq-card)",border:"1px solid var(--lq-card-border)",borderRadius:10,padding:"9px 14px",display:"flex",alignItems:"center",gap:10,marginBottom:16}}>
      <span style={{fontSize:14}}>🌿</span>
      <div style={{flex:1}}>
        <div style={{color:"var(--lq-accent)",fontSize:11,fontFamily:"monospace",fontWeight:700}}>14-DAY FREE TRIAL</div>
        <div style={{color:"var(--lq-text3)",fontSize:10,fontFamily:"monospace",marginTop:1}}>14 days free · then $10/mo · cancel anytime</div>
      </div>
      <button onClick={()=>setDismissed(true)} style={{background:"none",border:"none",color:"var(--lq-text3)",cursor:"pointer",fontSize:14,padding:"2px 4px"}}>✕</button>
    </div>
  );
}

// ─── Nav ──────────────────────────────────────────────────────────────────────
function NavBar({screen,setScreen,onNav}){
  const items=[
    {id:"newquote", icon:"✦",  label:"Quote"},
    {id:"schedule", icon:"📅", label:"Schedule"},
    {id:"invoices", icon:"🧾", label:"Invoices"},
    {id:"customers",icon:"👥", label:"Clients"},
    {id:"pipeline", icon:"📊", label:"Pipeline"}];
  return(
    <div style={{position:"fixed",bottom:0,left:0,right:0,background:"var(--lq-nav)",borderTop:"1px solid var(--lq-nav-border)",display:"flex",justifyContent:"space-around",padding:"10px 0 18px",zIndex:200}}>
      {items.map(item=>{
        const active=screen===item.id;
        return <button key={item.id} onClick={()=>onNav(item.id)} style={{background:"none",border:"none",cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:3,flex:1}}>
          <span style={{fontSize:16,filter:active?"none":"grayscale(1) opacity(0.4)"}}>{item.icon}</span>
          <span style={{fontSize:9,fontFamily:"monospace",color:active?"var(--lq-accent)":"var(--lq-inactive)",letterSpacing:"0.06em"}}>{item.label.toUpperCase()}</span>
        </button>;
      })}
      {/* Quote in progress indicator */}
      {screen!=="newquote"&&false&&<div style={{position:"absolute",top:-6,left:"10%",width:8,height:8,borderRadius:"50%",background:"#7CFC00"}}/>}
    </div>
  );
}

// ─── Dashboard ────────────────────────────────────────────────────────────────

function DashboardStrip({quotes,customers,invoices,jobs=[]}){
  const [modal,setModal] = useState(null);

  // ── Time tracking metrics ─────────────────────────────────────────────────
  const completedJobs = jobs.filter(j=>j.status==="Completed"&&j.duration>0);
  const avgActual = completedJobs.length ? Math.round(completedJobs.reduce((a,j)=>a+(j.duration||0),0)/completedJobs.length) : 0;
  const scheduledJobs = jobs.filter(j=>j.status==="Scheduled"&&j.duration>0);
  const avgEstimate = scheduledJobs.length ? Math.round(scheduledJobs.reduce((a,j)=>a+(j.duration||0),0)/scheduledJobs.length) : 60;
  const last10 = [...completedJobs].sort((a,b)=>(b.scheduledDate||"").localeCompare(a.scheduledDate||"")).slice(0,30).reverse();
  const clientTimeMap = {};
  completedJobs.forEach(j=>{
    if(!j.customerName) return;
    if(!clientTimeMap[j.customerName]) clientTimeMap[j.customerName]={name:j.customerName,total:0,count:0};
    clientTimeMap[j.customerName].total+=j.duration||0;
    clientTimeMap[j.customerName].count++;
  });
  const clientTimes = Object.values(clientTimeMap).map(c=>({...c,avg:Math.round(c.total/c.count)})).sort((a,b)=>b.avg-a.avg).slice(0,8);

  // ── Date helpers ──────────────────────────────────────────────────────────
  const now        = new Date();
  const thisYM     = now.toISOString().slice(0,7);
  const lastMonthD = new Date(now.getFullYear(), now.getMonth()-1, 1);
  const lastYM     = lastMonthD.toISOString().slice(0,7);

  const inMonth = (q,ym) => (q.createdAt||"").startsWith(ym);

  // ── Core metrics ──────────────────────────────────────────────────────────
  const accepted     = quotes.filter(q=>q.stage==="Accepted"||q.stage==="Completed");
  const revenue      = accepted.reduce((a,q)=>a+(q.total||0),0);
  const openQ        = quotes.filter(q=>q.stage==="Quoted");
  const overdue      = openQ.filter(q=>daysSince(q.createdAt)>=2);

  const thisMonthQ   = quotes.filter(q=>inMonth(q,thisYM));
  const lastMonthQ   = quotes.filter(q=>inMonth(q,lastYM));
  const monthRev     = thisMonthQ.filter(q=>q.stage==="Accepted"||q.stage==="Completed").reduce((a,q)=>a+(q.total||0),0);
  const lastMonthRev = lastMonthQ.filter(q=>q.stage==="Accepted"||q.stage==="Completed").reduce((a,q)=>a+(q.total||0),0);

  const pct = (cur,prev) => prev===0 ? null : Math.round(((cur-prev)/prev)*100);
  const revPct    = pct(monthRev, lastMonthRev);
  const clientPct = null; // static for now

  // ── Service breakdown ─────────────────────────────────────────────────────
  const svcMap = {};
  accepted.forEach(q=>(q.services||[]).forEach(s=>{
    if(!s||!s.label) return;
    if(!svcMap[s.label]) svcMap[s.label]={label:s.label,revenue:0,count:0};
    const price=(s.basePrice||0)+(s.perSqft||0)*(q.sqft||0);
    svcMap[s.label].revenue+=price; svcMap[s.label].count++;
  }));
  const topServices = Object.values(svcMap).sort((a,b)=>b.revenue-a.revenue).slice(0,6);

  // ── Top clients ───────────────────────────────────────────────────────────
  const clientMap = {};
  accepted.forEach(q=>{
    if(!q.customerName) return;
    if(!clientMap[q.customerName]) clientMap[q.customerName]={name:q.customerName,phone:q.customerPhone,revenue:0,jobs:0};
    clientMap[q.customerName].revenue+=q.total||0;
    clientMap[q.customerName].jobs++;
  });
  const topClients = Object.values(clientMap).sort((a,b)=>b.revenue-a.revenue).slice(0,6);

  // ── Overdue invoices ──────────────────────────────────────────────────────
  const overdueInv = (invoices||[]).filter(i=>isOverdue(i));

  // ── Today ─────────────────────────────────────────────────────────────────
  const todayDate = todayStr();
  const scheduledToday = quotes.filter(q=>q.stage==="Scheduled"&&q.scheduledDate===todayDate);
  const overdueInvoiceAmt = overdueInv.reduce((a,i)=>a+(i.total||0),0);
  const followUpNeeded = quotes.filter(q=>q.stage==="Quoted"&&daysSince(q.createdAt)>=2);
  const uninvoicedCompleted = quotes.filter(q=>q.stage==="Completed"&&!(invoices||[]).find(i=>i.quoteId===q.id));

  // ── Recommendations ───────────────────────────────────────────────────────
  const recommendations = [];
  if(overdue.length>0) recommendations.push({icon:"⏰",text:"Follow up on "+overdue.length+" quote"+(overdue.length>1?"s":"")+" — clients who get a follow-up text within 48hrs convert 3× more.",color:"#ffaa00"});
  if(revPct!==null&&revPct<0) recommendations.push({icon:"📉",text:"Revenue is down "+Math.abs(revPct)+"% vs last month. Consider running a seasonal promo or reaching out to dormant clients.",color:"#ff6b6b"});
  if(topServices[0]) recommendations.push({icon:"💡",text:topServices[0].label+" is your top earner ($"+topServices[0].revenue.toFixed(0)+" total). Upsell it on every job this month.",color:"#7CFC00"});
  if(topClients[0]&&topClients[0].jobs===1) recommendations.push({icon:"🔄",text:topClients[0].name+" has only booked once but spent $"+topClients[0].revenue.toFixed(0)+". Offer them a recurring discount to lock in repeat business.",color:"var(--lq-blue)"});
  if(overdueInv.length>0) recommendations.push({icon:"🧾",text:"$"+(overdueInv.reduce((a,i)=>a+(i.total||0),0).toFixed(0))+" in overdue invoices. Send reminders today — payment rates drop significantly after 30 days.",color:"#ff6b6b"});
  const avgJob = accepted.length?revenue/accepted.length:0;
  if(avgJob>0&&avgJob<200) recommendations.push({icon:"💰",text:"Your average job is $"+avgJob.toFixed(0)+". Adding one upsell service per visit (mulch, edging, weed control) could push it past $250+.",color:"#7CFC00"});

  // ── Action items for today ────────────────────────────────────────────────
  const todayActions = [];
  if(uninvoicedCompleted.length>0) todayActions.push({icon:"🧾",label:"Invoice ready",value:uninvoicedCompleted.length+" job"+(uninvoicedCompleted.length!==1?"s":""),color:"#7CFC00",action:"invoices"});
  if(overdueInv.length>0) todayActions.push({icon:"⚠️",label:"Overdue invoices",value:"$"+overdueInvoiceAmt.toFixed(0),color:"#ff6b6b",action:"invoices"});
  if(followUpNeeded.length>0) todayActions.push({icon:"⏰",label:"Follow up",value:followUpNeeded.length+" quote"+(followUpNeeded.length!==1?"s":""),color:"#ffaa00",action:"pipeline"});

  // ── Stat cards ────────────────────────────────────────────────────────────
  const stats = [
    { id:"revenue",  label:"Revenue",  value:"$"+revenue.toLocaleString(), pct:revPct,    alert:false },
    { id:"month",    label:"This Mo",  value:"$"+monthRev.toFixed(0),      pct:revPct,    alert:false },
    { id:"open",     label:"Open",     value:openQ.length+"",              pct:null,      alert:overdue.length>0 },
    { id:"clients",  label:"Clients",  value:customers.length+"",          pct:clientPct, alert:false }];

  const PctBadge = ({pct}) => {
    if(pct===null) return null;
    const up=pct>=0;
    return <div style={{fontSize:9,fontFamily:"monospace",color:up?"#00ff99":"#ff6b6b",marginTop:2}}>{up?"▲":"▼"}{Math.abs(pct)}% vs last mo</div>;
  };

  // ── Modal content ─────────────────────────────────────────────────────────
  const renderModal = () => {
    if(!modal) return null;
    const close = () => setModal(null);

    const Section = ({title,children}) => (
      <div style={{marginBottom:18}}>
        <div style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontFamily:"monospace",letterSpacing:"0.1em",marginBottom:8}}>{title}</div>
        {children}
      </div>
    );

    const Bar = ({label,value,max,color="#7CFC00",sub}) => (
      <div style={{marginBottom:8}}>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
          <span style={{color:"rgba(255,255,255,0.7)",fontSize:12,fontFamily:"monospace"}}>{label}</span>
          <span style={{color,fontSize:12,fontFamily:"monospace",fontWeight:700}}>{value}</span>
        </div>
        <div style={{height:4,background:"rgba(255,255,255,0.08)",borderRadius:99,overflow:"hidden"}}>
          <div style={{height:"100%",background:color,width:max>0?Math.round((parseFloat(value.replace(/[^0-9.]/g,""))/max)*100)+"%":"0%",borderRadius:99,transition:"width 0.5s"}}/>
        </div>
        {sub&&<div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace",marginTop:2}}>{sub}</div>}
      </div>
    );

    let title="", content=null;

    if(modal==="revenue"||modal==="month"){
      title = modal==="revenue" ? "Total Revenue" : "This Month";
      const maxSvc = topServices[0]?.revenue||1;
      const maxClient = topClients[0]?.revenue||1;
      content = (<>
        <Section title="MONTH OVER MONTH">
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:12}}>
            {[["This Month","$"+monthRev.toFixed(0),revPct],["Last Month","$"+lastMonthRev.toFixed(0),null]].map(([l,v,p])=>(
              <div key={l} style={{background:"rgba(255,255,255,0.04)",borderRadius:10,padding:"12px",textAlign:"center"}}>
                <div style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontFamily:"monospace",marginBottom:4}}>{l.toUpperCase()}</div>
                <div style={{color:"#7CFC00",fontSize:18,fontWeight:700,fontFamily:"monospace"}}>{v}</div>
                {p!==null&&<div style={{color:p>=0?"#00ff99":"#ff6b6b",fontSize:10,fontFamily:"monospace",marginTop:2}}>{p>=0?"▲":"▼"}{Math.abs(p)}%</div>}
              </div>
            ))}
          </div>
        </Section>
        <Section title="TOP SERVICES BY REVENUE">
          {topServices.length===0?<div style={{color:"rgba(255,255,255,0.25)",fontSize:12,fontFamily:"monospace"}}>No accepted quotes yet</div>
          :topServices.map(s=><Bar key={s.label} label={s.label} value={"$"+s.revenue.toFixed(0)} max={maxSvc} sub={s.count+" job"+(s.count!==1?"s":"")}/>)}
        </Section>
        <Section title="TOP CLIENTS BY REVENUE">
          {topClients.length===0?<div style={{color:"rgba(255,255,255,0.25)",fontSize:12,fontFamily:"monospace"}}>No clients yet</div>
          :topClients.map(c=><Bar key={c.name} label={c.name} value={"$"+c.revenue.toFixed(0)} max={maxClient} color="var(--lq-blue)" sub={c.jobs+" job"+(c.jobs!==1?"s":"")}/>)}
        </Section>
      </>);
    }

    if(modal==="open"){
      title = "Open Quotes";
      const overdueQ = openQ.filter(q=>daysSince(q.createdAt)>=2);
      const freshQ   = openQ.filter(q=>daysSince(q.createdAt)<2);
      content = (<>
        <Section title="SUMMARY">
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:12}}>
            {[["Total Open",openQ.length,"#7CFC00"],["Need Follow-up",overdueQ.length,"#ffaa00"]].map(([l,v,c])=>(
              <div key={l} style={{background:"rgba(255,255,255,0.04)",borderRadius:10,padding:"12px",textAlign:"center"}}>
                <div style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontFamily:"monospace",marginBottom:4}}>{l.toUpperCase()}</div>
                <div style={{color:c,fontSize:22,fontWeight:700,fontFamily:"monospace"}}>{v}</div>
              </div>
            ))}
          </div>
        </Section>
        {overdueQ.length>0&&<Section title={"OVERDUE — "+overdueQ.length+" NEED FOLLOW-UP"}>
          {overdueQ.map(q=>(
            <div key={q.id} style={{background:"rgba(255,170,0,0.07)",border:"1px solid rgba(255,170,0,0.2)",borderRadius:10,padding:"11px 13px",marginBottom:8}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                <div>
                  <div style={{color:"#fff",fontSize:13,fontFamily:"monospace",fontWeight:700}}>{q.customerName}</div>
                  <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace",marginTop:1}}>Sent {daysSince(q.createdAt)}d ago · ${q.total?.toFixed(0)}</div>
                </div>
                <a href={"sms:"+q.customerPhone} style={{background:"rgba(255,170,0,0.15)",border:"1px solid rgba(255,170,0,0.3)",borderRadius:8,padding:"5px 10px",color:"#ffaa00",fontSize:11,fontFamily:"monospace",textDecoration:"none"}}>💬 TEXT</a>
              </div>
            </div>
          ))}
        </Section>}
        {freshQ.length>0&&<Section title="RECENTLY SENT">
          {freshQ.map(q=>(
            <div key={q.id} style={{...S.card,marginBottom:6}}>
              <div style={{display:"flex",justifyContent:"space-between"}}>
                <div><div style={{color:"#fff",fontSize:13,fontFamily:"monospace"}}>{q.customerName}</div><div style={{color:"rgba(255,255,255,0.3)",fontSize:11,fontFamily:"monospace",marginTop:1}}>Sent {daysSince(q.createdAt)}d ago</div></div>
                <div style={{color:"#7CFC00",fontSize:14,fontWeight:700}}>${q.total?.toFixed(0)}</div>
              </div>
            </div>
          ))}
        </Section>}
      </>);
    }

    if(modal==="clients"){
      title = "Clients";
      const maxRev = topClients[0]?.revenue||1;
      const recurring = customers.filter(c=>c.recurringActive===true);
      const newThisMonth = customers.filter(c=>(c.createdAt||"").startsWith(thisYM));
      content = (<>
        <Section title="OVERVIEW">
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:12}}>
            {[["Total",customers.length,"#7CFC00"],["Recurring",recurring.length,"var(--lq-blue)"],["New Mo",newThisMonth.length,"#7CFC00"]].map(([l,v,c])=>(
              <div key={l} style={{background:"rgba(255,255,255,0.04)",borderRadius:10,padding:"10px 6px",textAlign:"center"}}>
                <div style={{color:"rgba(255,255,255,0.35)",fontSize:9,fontFamily:"monospace",marginBottom:3}}>{l.toUpperCase()}</div>
                <div style={{color:c,fontSize:18,fontWeight:700,fontFamily:"monospace"}}>{v}</div>
              </div>
            ))}
          </div>
        </Section>
        <Section title="TOP CLIENTS BY REVENUE">
          {topClients.length===0?<div style={{color:"rgba(255,255,255,0.25)",fontSize:12,fontFamily:"monospace"}}>No data yet</div>
          :topClients.map(c=>(
            <div key={c.name} style={{marginBottom:8}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:3}}>
                <span style={{color:"rgba(255,255,255,0.7)",fontSize:12,fontFamily:"monospace"}}>{c.name}</span>
                <div style={{display:"flex",gap:8,alignItems:"center"}}>
                  <span style={{color:"var(--lq-blue)",fontSize:12,fontFamily:"monospace",fontWeight:700}}>${c.revenue.toFixed(0)}</span>
                  <a href={"sms:"+c.phone} style={{background:"rgba(124,252,0,0.08)",border:"1px solid rgba(124,252,0,0.2)",borderRadius:6,padding:"3px 8px",color:"#7CFC00",fontSize:10,fontFamily:"monospace",textDecoration:"none"}}>💬</a>
                </div>
              </div>
              <div style={{height:4,background:"rgba(255,255,255,0.08)",borderRadius:99,overflow:"hidden"}}>
                <div style={{height:"100%",background:"var(--lq-blue)",width:Math.round((c.revenue/maxRev)*100)+"%",borderRadius:99}}/>
              </div>
              <div style={{color:"rgba(255,255,255,0.25)",fontSize:10,fontFamily:"monospace",marginTop:1}}>{c.jobs} job{c.jobs!==1?"s":""}</div>
            </div>
          ))}
        </Section>
      </>);
    }

    if(modal==="time"){
      title="Time Tracking";
      const maxBar = last10.length ? Math.max(...last10.map(j=>j.duration||0), avgEstimate) : 60;
      content=(<>
        <Section title="AVERAGES">
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:4}}>
            {[["Avg Estimated",avgEstimate+" min","#ffaa00"],["Avg Actual",avgActual?" "+avgActual+" min":"No data","#7CFC00"]].map(([l,v,c])=>(
              <div key={l} style={{background:"rgba(255,255,255,0.04)",borderRadius:10,padding:"12px",textAlign:"center"}}>
                <div style={{color:"rgba(255,255,255,0.35)",fontSize:9,fontFamily:"monospace",marginBottom:4}}>{l.toUpperCase()}</div>
                <div style={{color:c,fontSize:18,fontWeight:700,fontFamily:"monospace"}}>{v}</div>
              </div>
            ))}
          </div>
          {avgActual>0&&avgEstimate>0&&(
            <div style={{background:avgActual>avgEstimate?"rgba(255,68,68,0.06)":"rgba(124,252,0,0.06)",border:`1px solid ${avgActual>avgEstimate?"rgba(255,68,68,0.2)":"rgba(124,252,0,0.2)"}`,borderRadius:8,padding:"8px 12px",textAlign:"center",marginTop:8}}>
              <span style={{color:avgActual>avgEstimate?"#ff6b6b":"#7CFC00",fontSize:12,fontFamily:"monospace",fontWeight:700}}>{avgActual>avgEstimate?"⚠️ Running "+( avgActual-avgEstimate)+" min over estimate on average":"✅ Running "+(avgEstimate-avgActual)+" min under estimate on average"}</span>
            </div>
          )}
        </Section>
        {last10.length>0&&(
          <Section title={`LAST ${last10.length} COMPLETED JOBS`}>
            {last10.map((j,i)=>(
              <div key={j.id||i} style={{marginBottom:10}}>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
                  <span style={{color:"rgba(255,255,255,0.65)",fontSize:11,fontFamily:"monospace",maxWidth:"65%",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{j.customerName}</span>
                  <span style={{color:"#7CFC00",fontSize:11,fontFamily:"monospace",fontWeight:700}}>{j.duration} min</span>
                </div>
                <div style={{position:"relative",height:8,background:"rgba(255,255,255,0.06)",borderRadius:99,overflow:"visible"}}>
                  <div style={{height:"100%",background:j.duration>avgEstimate?"rgba(255,107,107,0.7)":"#7CFC00",width:Math.round((j.duration/maxBar)*100)+"%",borderRadius:99,transition:"width 0.4s"}}/>
                  {avgEstimate>0&&<div style={{position:"absolute",top:-2,bottom:-2,width:2,background:"rgba(255,170,0,0.7)",left:Math.round((avgEstimate/maxBar)*100)+"%",borderRadius:1}}/>}
                </div>
                <div style={{color:"rgba(255,255,255,0.2)",fontSize:9,fontFamily:"monospace",marginTop:2}}>{j.scheduledDate}</div>
              </div>
            ))}
            <div style={{display:"flex",alignItems:"center",gap:6,marginTop:4}}>
              <div style={{width:12,height:2,background:"rgba(255,170,0,0.7)",borderRadius:1}}/>
              <span style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace"}}>Avg estimate ({avgEstimate} min)</span>
            </div>
          </Section>
        )}
        {clientTimes.length>0&&(
          <Section title="AVG DURATION BY CLIENT">
            {clientTimes.map(c=>(
              <div key={c.name} style={{marginBottom:8}}>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
                  <span style={{color:"rgba(255,255,255,0.7)",fontSize:12,fontFamily:"monospace"}}>{c.name}</span>
                  <span style={{color:c.avg>avgEstimate?"#ff6b6b":"#7CFC00",fontSize:12,fontFamily:"monospace",fontWeight:700}}>{c.avg} min</span>
                </div>
                <div style={{height:4,background:"rgba(255,255,255,0.08)",borderRadius:99,overflow:"hidden"}}>
                  <div style={{height:"100%",background:c.avg>avgEstimate?"rgba(255,107,107,0.6)":"rgba(124,252,0,0.7)",width:Math.round((c.avg/(clientTimes[0].avg||1))*100)+"%",borderRadius:99}}/>
                </div>
                <div style={{color:"rgba(255,255,255,0.25)",fontSize:10,fontFamily:"monospace",marginTop:1}}>{c.count} job{c.count!==1?"s":""}</div>
              </div>
            ))}
          </Section>
        )}
        {completedJobs.length===0&&<div style={{color:"rgba(255,255,255,0.3)",fontSize:13,fontFamily:"monospace",textAlign:"center",padding:"24px 0"}}>No completed jobs with timer data yet.<br/>Use the job timer in Schedule to track time.</div>}
      </>);
    }

    return(
      <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",zIndex:400,display:"flex",alignItems:"flex-end",justifyContent:"center"}} onClick={close}>
        <div onClick={e=>e.stopPropagation()} style={{background:"#0a180a",border:"1px solid rgba(124,252,0,0.2)",borderRadius:"16px 16px 0 0",width:"100%",maxWidth:430,maxHeight:"80vh",display:"flex",flexDirection:"column",animation:"fadeUp 0.25s ease"}}>
          {/* Modal header */}
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"18px 20px 12px",borderBottom:"1px solid rgba(255,255,255,0.07)",flexShrink:0}}>
            <div style={{color:"#fff",fontSize:16,fontFamily:"monospace",fontWeight:700}}>{title}</div>
            <button onClick={close} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",cursor:"pointer",fontSize:18}}>✕</button>
          </div>
          {/* Scrollable content */}
          <div style={{overflowY:"auto",padding:"16px 20px 32px",flex:1}}>
            {content}
            {/* Recommendations */}
            {recommendations.length>0&&(
              <div>
                <div style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontFamily:"monospace",letterSpacing:"0.1em",marginBottom:8}}>RECOMMENDATIONS</div>
                {recommendations.map((r,i)=>(
                  <div key={i} style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.07)",borderLeft:"3px solid "+r.color,borderRadius:"0 10px 10px 0",padding:"10px 13px",marginBottom:8,display:"flex",gap:10}}>
                    <span style={{fontSize:16,flexShrink:0}}>{r.icon}</span>
                    <span style={{color:"rgba(255,255,255,0.6)",fontSize:12,fontFamily:"monospace",lineHeight:1.6}}>{r.text}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return(
    <>
      {renderModal()}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:6,marginBottom:6}}>
        {stats.map(s=>(
          <button key={s.id} onClick={()=>setModal(s.id)} style={{background:s.alert?"rgba(255,170,0,0.08)":"rgba(255,255,255,0.04)",border:"1px solid "+(s.alert?"rgba(255,170,0,0.25)":"rgba(255,255,255,0.07)"),borderRadius:10,padding:"8px 6px",textAlign:"center",cursor:"pointer",transition:"all 0.15s"}}>
            <div style={{color:s.alert?"#ffaa00":"#7CFC00",fontSize:12,fontWeight:700,fontFamily:"monospace",lineHeight:1}}>{s.value}</div>
            <PctBadge pct={s.pct}/>
            <div style={{color:"rgba(255,255,255,0.3)",fontSize:9,fontFamily:"monospace",marginTop:s.pct!==null?2:3,letterSpacing:"0.06em"}}>{s.label.toUpperCase()}</div>
          </button>
        ))}
      </div>
      <button onClick={()=>setModal("time")} style={{width:"100%",background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.07)",borderRadius:10,padding:"8px 12px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",marginBottom:14}}>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <span style={{fontSize:14}}>⏱</span>
          <span style={{color:"var(--lq-text2)",fontSize:11,fontFamily:"monospace",fontWeight:700}}>TIME TRACKING</span>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          {avgActual>0&&<span style={{color:avgActual>avgEstimate?"#ff6b6b":"#7CFC00",fontSize:11,fontFamily:"monospace",fontWeight:700}}>{avgActual} min avg</span>}
          <span style={{color:"rgba(255,255,255,0.2)",fontSize:11}}>→</span>
        </div>
      </button>
    </>
  );
}

// eslint-disable-next-line no-unused-vars
function Dashboard({quotes,customers}){
  const [metrics,setMetrics]=useState({mrrTotal:0,mrrAnnual:0,activeRecurringCount:0,nextWeekJobs:[]});

  useEffect(()=>{
    const fetchMetrics=async()=>{
      try{
        const session=await supabase.auth.getSession();
        if(!session.data.session) return;
        const res=await fetch('/api/recurring-service?action=metrics',{headers:{'x-user-id':session.data.session.user.id}});
        if(res.ok){const data=await res.json();setMetrics(data.metrics||{});}
      }catch(e){console.log('Metrics fetch error:',e);}
    };
    fetchMetrics();
  },[]);

  const accepted  = quotes.filter(q=>q.stage==="Completed"||q.stage==="Accepted");
  const revenue   = accepted.reduce((a,q)=>a+(q.total||0),0);
  const thisMonth = quotes.filter(q=>q.createdAt?.startsWith(todayStr().slice(0,7)));
  const openQ     = quotes.filter(q=>q.stage==="Quoted");
  const overdue   = openQ.filter(q=>daysSince(q.createdAt)>=2);
  const recurring = quotes.filter(q=>q.recurring!=="once"&&q.stage==="Accepted");
  const annualRun = recurring.reduce((a,q)=>{const r=RECURRING_OPTIONS.find(r=>r.id===q.recurring);return a+(q.total||0)*(r?.perYear||1);},0);
  const stats=[
    {label:"Total Revenue",  value:`$${revenue.toLocaleString()}`,   sub:"accepted + completed"},
    {label:"This Month",     value:`${thisMonth.length} quotes`,      sub:`$${thisMonth.reduce((a,q)=>a+(q.total||0),0).toFixed(0)} pipeline`},
    {label:"Open Quotes",    value:openQ.length,                      sub:`${overdue.length} need follow-up`,alert:overdue.length>0},
    {label:"MRR",value:`$${Math.round(metrics.mrrTotal).toLocaleString()}`,sub:`$${Math.round(metrics.mrrAnnual).toLocaleString()}/yr`},
    {label:"Recurring",value:metrics.activeRecurringCount,sub:`${metrics.activeRecurringCount} active services`},
    {label:"Avg Job Value",  value:accepted.length?`$${(revenue/accepted.length).toFixed(0)}`:"$—",sub:"accepted jobs"}];
  return(
    <div style={{display:"flex",flexDirection:"column",gap:16}}>
      <div><p style={S.label}>Overview</p><h2 style={S.heading}>Dashboard</h2><p style={S.sub}>{todayStr()}</p></div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
        {stats.map(stat=>(
          <div key={stat.label} style={{...S.card,borderColor:stat.alert?"rgba(255,170,0,0.3)":"rgba(255,255,255,0.08)"}}>
            <div style={{color:"rgba(255,255,255,0.35)",fontSize:9,fontFamily:"monospace",letterSpacing:"0.1em",marginBottom:4}}>{stat.label.toUpperCase()}</div>
            <div style={{color:stat.alert?"#ffaa00":"#7CFC00",fontSize:20,fontWeight:700,fontFamily:"monospace"}}>{stat.value}</div>
            <div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace",marginTop:3}}>{stat.sub}</div>
          </div>
        ))}
      </div>
      {overdue.length>0&&(
        <div style={{background:"rgba(255,170,0,0.06)",border:"1px solid rgba(255,170,0,0.25)",borderRadius:12,padding:"14px 16px"}}>
          <div style={{color:"#ffaa00",fontSize:11,fontFamily:"monospace",fontWeight:700,marginBottom:10}}>⏰ FOLLOW-UP NEEDED</div>
          {overdue.map(q=>(
            <div key={q.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:"1px solid rgba(255,255,255,0.05)"}}>
              <div><div style={{color:"#fff",fontSize:13,fontFamily:"monospace"}}>{q.customerName}</div><div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace"}}>Sent {daysSince(q.createdAt)}d ago · ${q.total?.toFixed(0)}</div></div>
              <a href={`sms:${q.customerPhone}`} style={{background:"rgba(255,170,0,0.15)",border:"1px solid rgba(255,170,0,0.3)",borderRadius:8,padding:"6px 12px",color:"#ffaa00",fontSize:11,fontFamily:"monospace",textDecoration:"none"}}>💬 TEXT</a>
            </div>
          ))}
        </div>
      )}
      {recurring.length>0&&(
        <div style={{...S.card}}>
          <div style={{color:"rgba(255,255,255,0.4)",fontSize:10,fontFamily:"monospace",letterSpacing:"0.1em",marginBottom:10}}>RECURRING JOBS — NEXT DUE</div>
          {recurring.slice(0,5).map(q=>{
            const due=nextDue(q.createdAt,q.recurring);
            const daysUntil=due?-daysSince(due):null;
            return(
              <div key={q.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:"1px solid rgba(255,255,255,0.04)"}}>
                <div><div style={{color:"#fff",fontSize:13,fontFamily:"monospace"}}>{q.customerName}</div><div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace"}}>{RECURRING_OPTIONS.find(r=>r.id===q.recurring)?.label} · ${q.total?.toFixed(0)}</div></div>
                <div style={{textAlign:"right"}}>
                  <div style={{color:daysUntil!==null&&daysUntil<=3?"#ffaa00":"#7CFC00",fontSize:12,fontFamily:"monospace",fontWeight:700}}>{daysUntil!==null?(daysUntil<=0?"DUE NOW":`${daysUntil}d`):"—"}</div>
                  {due&&<div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace"}}>{fmtDate(due)}</div>}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ─── Pipeline ─────────────────────────────────────────────────────────────────

function QuoteDetail({quote,onBack,onUpdateStage,onDelete,onDuplicate,onCreateInvoice,onEditQuote,onLogApplication}){
  const [confirm,    setConfirm]    = useState(false);
  const [toast,      showToast]     = useToast();
  const [tab,        setTab]        = useState("detail");
  const [lightbox,   setLightbox]   = useState(null);
  const [smsCopied,  setSmsCopied]  = useState(false);
  const [shareToken, setShareToken] = useState(quote.shareToken||null);
  const [shareCopied,setShareCopied]= useState(false);
  const recurInfo = RECURRING_OPTIONS.find(r=>r.id===quote.recurring);

  const handleShare=async()=>{
    let token=shareToken;
    if(!token){
      token=Array.from(crypto.getRandomValues(new Uint8Array(16))).map(b=>b.toString(16).padStart(2,'0')).join('');
      await supabase.from('quotes').update({share_token:token}).eq('id',quote.id);
      setShareToken(token);
    }
    const url=`${window.location.origin}/q/${token}`;
    try{await navigator.clipboard.writeText(url);}catch(e){}
    setShareCopied(true);
    setTimeout(()=>setShareCopied(false),3000);
    showToast('Share link copied to clipboard');
  };

  const buildQuoteSMS=()=>{
    const firstName=quote.customerName?.split(" ")[0]||quote.customerName||"there";
    const svcs=(quote.services||[]).map(s=>{
      const price=(s.basePrice||0)+(s.perSqft||0)*(quote.sqft||0);
      return`  • ${s.label} — $${price.toFixed(0)}`;
    }).join("\n");
    const annualVal=recurInfo&&quote.recurring!=="once"?Math.round((quote.total||0)*recurInfo.perYear):0;
    return`Hi ${firstName}! 🌿 Here's your lawn estimate:\n\n📍 ${quote.address}${quote.sqft?`\n📐 ${quote.sqft.toLocaleString()} sqft`:""}\n\nServices:\n${svcs}${quote.discAmt>0?`\n\n💚 Discount: -$${quote.discAmt?.toFixed(0)}`:""}${quote.taxAmt>0?`\n🧾 Tax: $${quote.taxAmt?.toFixed(0)}`:""}\n\n💰 Total: $${quote.total?.toFixed(0)}${recurInfo&&quote.recurring!=="once"?` (${recurInfo.label})`:""}${annualVal?`\n📅 Annual value: $${annualVal.toLocaleString()}/yr`:""}\n\nQuote #${quote.quoteNum} · Valid 7 days\n\nReply YES to book! 📞`;
  };

  return(
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      {toast&&<Toast message={toast.message} type={toast.type||"success"}/>}
      {confirm&&<ConfirmModal message={"Delete quote #"+quote.quoteNum+"? This cannot be undone."} onConfirm={async()=>{await onDelete(quote.id);onBack();}} onCancel={()=>setConfirm(false)}/>}

      {/* Lightbox */}
      {lightbox!==null&&(
        <div onClick={()=>setLightbox(null)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.95)",zIndex:600,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <img src={lightbox} alt="" style={{maxWidth:"100%",maxHeight:"90vh",borderRadius:10,objectFit:"contain"}}/>
          <button onClick={()=>setLightbox(null)} style={{position:"absolute",top:20,right:20,background:"rgba(255,255,255,0.1)",border:"none",color:"#fff",borderRadius:"50%",width:36,height:36,fontSize:18,cursor:"pointer"}}>✕</button>
        </div>
      )}

      {/* Header */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <button onClick={onBack} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12,cursor:"pointer",padding:0}}>← PIPELINE</button>
        <div style={{display:"flex",gap:6}}>
          <button onClick={()=>onEditQuote(quote)} style={{background:"rgba(124,252,0,0.08)",border:"1px solid rgba(124,252,0,0.25)",borderRadius:8,padding:"6px 10px",color:"#7CFC00",fontSize:11,fontFamily:"monospace",cursor:"pointer"}}>✎ EDIT</button>
          <button onClick={async()=>{await onDuplicate(quote);showToast("Quote duplicated");}} style={{background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"6px 10px",color:"rgba(255,255,255,0.5)",fontSize:11,fontFamily:"monospace",cursor:"pointer"}}>⎘ DUP</button>
          <button onClick={()=>setConfirm(true)} style={{background:"rgba(255,68,68,0.08)",border:"1px solid rgba(255,68,68,0.2)",borderRadius:8,padding:"6px 10px",color:"#ff6b6b",fontSize:11,fontFamily:"monospace",cursor:"pointer"}}>🗑</button>
        </div>
      </div>

      {/* Quote header card */}
      <div style={{background:"linear-gradient(160deg,#0f1f0f,#0a150a)",border:"1px solid rgba(124,252,0,0.25)",borderRadius:16,overflow:"hidden"}}>
        <div style={{background:"#7CFC00",padding:"14px 18px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{fontSize:17,fontWeight:700,color:"#000"}}>LAWN ESTIMATE</div>
            <div style={{fontFamily:"monospace",fontSize:11,color:"rgba(0,0,0,0.55)"}}>#{quote.quoteNum} · {fmtDate(quote.createdAt)}</div>
          </div>
          <div style={{textAlign:"right"}}>
            <div style={{fontSize:26,fontWeight:700,color:"#000"}}>${quote.total?.toFixed(0)}</div>
            <div style={{fontFamily:"monospace",fontSize:10,color:"rgba(0,0,0,0.55)"}}>TOTAL</div>
          </div>
        </div>
        <div style={{padding:"14px 18px",display:"flex",flexDirection:"column",gap:10}}>
          <div><div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace",marginBottom:2}}>CLIENT</div>
            <div style={{color:"#fff",fontSize:14,fontFamily:"monospace",fontWeight:700}}>{quote.customerName}</div>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace"}}>{quote.customerPhone}</div>
          </div>
          <div><div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace",marginBottom:2}}>PROPERTY</div>
            <div style={{color:"rgba(255,255,255,0.7)",fontSize:13,fontFamily:"monospace"}}>{quote.address}</div>
            <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace",marginTop:2}}>{quote.sqft?.toLocaleString()} sq ft</div>
          </div>
        </div>
      </div>

      {/* Tabs: Detail / Photos */}
      <div style={{display:"flex",background:"rgba(255,255,255,0.05)",borderRadius:10,padding:3,gap:2}}>
        {[["detail","Details"],["photos","Photos"+(quote.photos?.length>0?" ("+quote.photos.length+")":"")]].map(([v,l])=>(
          <button key={v} onClick={()=>setTab(v)} style={{flex:1,padding:"8px",background:tab===v?"#7CFC00":"none",color:tab===v?"#000":"rgba(255,255,255,0.45)",border:"none",borderRadius:8,cursor:"pointer",fontSize:11,fontWeight:700,fontFamily:"monospace",transition:"all 0.2s"}}>{l.toUpperCase()}</button>
        ))}
      </div>

      {/* Detail tab */}
      {tab==="detail"&&(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {quote.services?.length>0&&(
            <div style={{...S.card}}>
              <div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace",marginBottom:8}}>SERVICES</div>
              {quote.services.map(s=>{
                const price=(s.basePrice||0)+(s.perSqft||0)*(quote.sqft||0);
                return <div key={s.id} style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:"1px solid rgba(255,255,255,0.04)"}}>
                  <span style={{color:"rgba(255,255,255,0.75)",fontSize:13,fontFamily:"monospace"}}>{s.label}</span>
                  <span style={{color:"#7CFC00",fontSize:13}}>${price.toFixed(0)}</span>
                </div>;
              })}
              {quote.discAmt>0&&<div style={{display:"flex",justifyContent:"space-between",marginTop:6}}><span style={{color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12}}>Discount</span><span style={{color:"var(--lq-blue)",fontFamily:"monospace",fontSize:12}}>-${quote.discAmt?.toFixed(0)}</span></div>}
              {quote.taxAmt>0&&<div style={{display:"flex",justifyContent:"space-between"}}><span style={{color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12}}>Tax</span><span style={{color:"rgba(255,255,255,0.5)",fontFamily:"monospace",fontSize:12}}>${quote.taxAmt?.toFixed(0)}</span></div>}
              <div style={{display:"flex",justifyContent:"space-between",marginTop:8,paddingTop:8,borderTop:"1px solid rgba(124,252,0,0.15)"}}>
                <span style={{color:"rgba(255,255,255,0.55)",fontFamily:"monospace",fontSize:13}}>TOTAL</span>
                <span style={{color:"#7CFC00",fontSize:18,fontWeight:700}}>${quote.total?.toFixed(0)}</span>
              </div>
              {quote.recurring!=="once"&&recurInfo&&<div style={{display:"flex",justifyContent:"space-between",marginTop:4}}><span style={{color:"rgba(255,255,255,0.3)",fontFamily:"monospace",fontSize:11}}>{recurInfo.label}</span><span style={{color:"rgba(124,252,0,0.6)",fontFamily:"monospace",fontSize:11}}>${(quote.total*recurInfo.perYear).toLocaleString()}/yr</span></div>}
            </div>
          )}
          {quote.notes&&<div style={{...S.card}}><div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace",marginBottom:4}}>NOTES</div><div style={{color:"rgba(255,255,255,0.6)",fontSize:13,fontFamily:"monospace",lineHeight:1.5}}>{quote.notes}</div></div>}
          <div style={{...S.card}}>
            <div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace",marginBottom:8}}>STAGE</div>
            <StagePill stage={quote.stage} onChange={s=>onUpdateStage(quote.id,s)}/>
          </div>
          {(()=>{const hasPhone=quote.customerPhone&&quote.customerPhone.replace(/\D/g,"").length>=7&&!quote.customerPhone.includes("000-0000");return hasPhone?(<button onClick={()=>{const t=buildQuoteSMS();try{navigator.clipboard?.writeText(t);}catch(e){}setSmsCopied(true);setTimeout(()=>setSmsCopied(false),2000);window.location.href="sms:"+quote.customerPhone;showToast("Quote text copied");}} style={{...btn(true),background:smsCopied?"rgba(124,252,0,0.2)":"#7CFC00",color:smsCopied?"#7CFC00":"#000",border:"none"}}>📱 {smsCopied?"✓ COPIED — PASTE IN SMS":"SEND QUOTE TEXT"}</button>):(<div style={{background:"rgba(255,170,0,0.07)",border:"1px solid rgba(255,170,0,0.2)",borderRadius:10,padding:"11px 14px",color:"#ffaa00",fontSize:12,fontFamily:"monospace",textAlign:"center"}}>⚠️ No phone number — add one to this client to send a text</div>);})()}
          <div style={{display:"flex",gap:8}}>
            <a href={"tel:"+quote.customerPhone} style={{flex:1,...btn(true,"ghost"),textDecoration:"none",textAlign:"center"}}>📞 CALL</a>
            <a href={"sms:"+quote.customerPhone} style={{flex:1,...btn(true,"ghost"),textDecoration:"none",textAlign:"center",color:"rgba(255,255,255,0.4)"}}>💬 BLANK TEXT</a>
          </div>
          <button onClick={()=>onCreateInvoice(quote)} style={{...btn(true),background:"rgba(0,207,255,0.12)",border:"1px solid rgba(0,207,255,0.35)",color:"var(--lq-blue)"}}>🧾 CREATE INVOICE</button>
          <button onClick={handleShare} style={{...btn(true),background:shareCopied?"rgba(124,252,0,0.15)":"rgba(124,252,0,0.08)",border:"1px solid rgba(124,252,0,0.3)",color:"#7CFC00"}}>🔗 {shareCopied?"LINK COPIED!":"SHARE QUOTE"}</button>
          <button onClick={()=>onLogApplication?.(quote)} style={{...btn(true,"ghost"),borderColor:"rgba(0,207,255,0.2)",color:"var(--lq-blue)"}}>🧪 LOG APPLICATION</button>
        </div>
      )}

      {/* Photos tab */}
      {tab==="photos"&&(
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          {(!quote.photos||quote.photos.length===0)?(
            <div style={{...S.card,textAlign:"center",padding:"32px 16px"}}>
              <div style={{fontSize:32,marginBottom:8}}>📷</div>
              <div style={{color:"rgba(255,255,255,0.35)",fontFamily:"monospace",fontSize:12}}>No photos attached to this quote</div>
              <div style={{color:"rgba(255,255,255,0.2)",fontFamily:"monospace",fontSize:11,marginTop:4}}>Photos can be added when creating a quote</div>
            </div>
          ):(
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
              {quote.photos.map((p,i)=>(
                <div key={i} onClick={()=>setLightbox(p)} style={{aspectRatio:"4/3",borderRadius:10,overflow:"hidden",cursor:"pointer",border:"1px solid rgba(255,255,255,0.1)"}}>
                  <img src={p} alt={"Photo "+(i+1)} style={{width:"100%",height:"100%",objectFit:"cover"}}/>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}


function QuoteEditForm({quote,onSave,onBack}){
  const [rates,setRates]=useState(()=>{
    const r={};
    (quote.services||[]).forEach(s=>{ r[s.id]={basePrice:s.basePrice||s.basePrice||0,perSqft:s.perSqft||0,label:s.label}; });
    // Fill in any services not on the quote
    SERVICES.filter(s=>s&&s.id).forEach(s=>{ if(!r[s.id]) r[s.id]={basePrice:s.basePrice||0,perSqft:s.perSqft||0,label:s.label}; });
    return r;
  });
  const [selSvc,setSelSvc]=useState(()=>(quote.services||[]).map(s=>s.id));
  const [notes,setNotes]=useState(quote.notes||"");
  const [saving,setSaving]=useState(false);
  const [editRates,setEditRates]=useState(false);

  const svcPrice=id=>rates[id].basePrice+(rates[id].perSqft||0)*(quote.sqft||0);
  const total=selSvc.reduce((a,id)=>a+svcPrice(id),0);
  const updateRate=(id,field,val)=>{const n=parseFloat(val);if(!isNaN(n)&&n>=0)setRates(r=>({...r,[id]:{...r[id],[field]:n}}));};

  const handleSave=async()=>{
    setSaving(true);
    const updatedServices=selSvc.map(id=>({
      id, label:rates[id].label,
      basePrice:rates[id].basePrice,
      perSqft:rates[id].perSqft||0,
    }));
    const subtotal=total;
    const discAmt=quote.discAmt||0;
    const taxAmt=(subtotal-discAmt)*((quote.taxRate||0)/100);
    const newTotal=subtotal-discAmt+taxAmt;
    await onSave(quote.id,{services:updatedServices,subtotal,total:newTotal,notes});
    setSaving(false);
  };

  const rateInp={background:"rgba(255,255,255,0.07)",border:"1px solid rgba(124,252,0,0.25)",borderRadius:6,padding:"4px 7px",color:"#fff",fontSize:12,fontFamily:"monospace",width:72,textAlign:"right",outline:"none"};

  return(
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div><p style={S.label}>Edit Quote</p><h2 style={S.heading}>{quote.customerName}</h2><p style={S.sub}>#{quote.quoteNum} · {quote.sqft?.toLocaleString()} sqft</p></div>
        <button onClick={onBack} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12,cursor:"pointer"}}>✕ CANCEL</button>
      </div>

      <div style={{display:"flex",flexDirection:"column",gap:8}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
          <div style={S.label}>Services & Pricing</div>
          <button onClick={()=>setEditRates(e=>!e)} style={{background:editRates?"rgba(124,252,0,0.1)":"rgba(255,255,255,0.04)",color:editRates?"#7CFC00":"rgba(255,255,255,0.4)",border:`1px solid ${editRates?"rgba(124,252,0,0.25)":"rgba(255,255,255,0.08)"}`,borderRadius:8,padding:"5px 11px",fontSize:10,cursor:"pointer",fontFamily:"monospace"}}>
            {editRates?"✓ DONE":"⚙ EDIT RATES"}
          </button>
        </div>

        {SERVICES.map(s=>{
          const on=selSvc.includes(s.id);
          const price=svcPrice(s.id);
          return(
            <div key={s.id} style={{background:on?"rgba(124,252,0,0.07)":"rgba(255,255,255,0.03)",border:`1px solid ${on?"rgba(124,252,0,0.25)":"rgba(255,255,255,0.06)"}`,borderRadius:12,padding:"11px 13px",transition:"all 0.15s"}}>
              <div style={{display:"flex",alignItems:"center",gap:10}}>
                <button onClick={()=>setSelSvc(p=>p.includes(s.id)?p.filter(x=>x!==s.id):[...p,s.id])} style={{width:20,height:20,borderRadius:5,flexShrink:0,background:on?"#7CFC00":"rgba(255,255,255,0.08)",border:`2px solid ${on?"#7CFC00":"rgba(255,255,255,0.15)"}`,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
                  {on&&<span style={{fontSize:10,color:"#000",fontWeight:900}}>✓</span>}
                </button>
                <div style={{flex:1,color:"#fff",fontSize:13,fontFamily:"monospace"}}>{s.label}</div>
                <div style={{color:on?"#7CFC00":"rgba(255,255,255,0.3)",fontSize:14,fontWeight:700}}>${price.toFixed(0)}</div>
              </div>
              {editRates&&<div style={{marginTop:8,paddingTop:8,borderTop:"1px solid rgba(255,255,255,0.05)",display:"flex",gap:10,alignItems:"flex-end"}}>
                <div style={{flex:1}}><div style={{color:"rgba(255,255,255,0.3)",fontSize:9,fontFamily:"monospace",marginBottom:3}}>BASE ($)</div><input type="number" min="0" value={rates[s.id].basePrice} onChange={e=>updateRate(s.id,"basePrice",e.target.value)} style={rateInp}/></div>
                <div style={{flex:1}}><div style={{color:"rgba(255,255,255,0.3)",fontSize:9,fontFamily:"monospace",marginBottom:3}}>/ SQFT ($)</div><input type="number" min="0" step="0.001" value={rates[s.id].perSqft} onChange={e=>updateRate(s.id,"perSqft",e.target.value)} style={rateInp}/></div>
                <div style={{color:"#7CFC00",fontSize:13,fontWeight:700,fontFamily:"monospace",paddingBottom:4}}>${price.toFixed(0)}</div>
              </div>}
            </div>
          );
        })}
      </div>

      <Field label="Notes" value={notes} onChange={setNotes} placeholder="Property notes, special instructions…" rows={2}/>

      <div style={{background:"rgba(124,252,0,0.05)",border:"1px solid rgba(124,252,0,0.18)",borderRadius:12,padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <span style={{color:"rgba(255,255,255,0.55)",fontFamily:"monospace",fontSize:12}}>NEW TOTAL</span>
        <span style={{color:"#7CFC00",fontSize:20,fontWeight:700}}>${total.toFixed(0)}</span>
      </div>

      <button onClick={handleSave} disabled={saving} style={{...btn(true),background:"#7CFC00",color:"#000",border:"none"}}>
        {saving?"SAVING…":"SAVE CHANGES"}
      </button>
    </div>
  );
}

function Pipeline({quotes,onUpdateStage,onDeleteQuote,onDuplicateQuote,onSelectQuote,onScheduleFromQuote}){
  const [filter,setFilter]=useState("All");
  const [confirm,setConfirm]=useState(null);
  const [toast,showToast]=useToast();
  const filtered=filter==="All"?quotes:quotes.filter(q=>q.stage===filter);
  const stageCount=s=>quotes.filter(q=>q.stage===s).length;

  const handleDelete=async id=>{
    await onDeleteQuote(id);
    setConfirm(null);
    showToast("Quote deleted");
  };
  const handleDuplicate=async q=>{
    await onDuplicateQuote(q);
    showToast("Quote duplicated");
  };
  const handleMarkSent=async q=>{
    if(q.stage==="Lead"||q.stage==="Draft") await onUpdateStage(q.id,"Quoted");
    showToast("Marked as Sent");
  };

  return(
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      {toast&&<Toast message={toast.message} type={toast.type}/>}
      {confirm&&<ConfirmModal message={`Delete quote #${confirm.quoteNum} for ${confirm.customerName}? This cannot be undone.`} onConfirm={()=>handleDelete(confirm.id)} onCancel={()=>setConfirm(null)}/>}
      <div><p style={S.label}>Sales Pipeline</p><h2 style={S.heading}>All Quotes</h2><p style={S.sub}>{quotes.length} total · {quotes.filter(q=>q.stage==="Accepted"||q.stage==="Completed").length} won</p></div>
      <div style={{display:"flex",gap:6,overflowX:"auto",paddingBottom:4}}>
        {["All",...PIPELINE_STAGES].map(s=>(
          <button key={s} onClick={()=>setFilter(s)} style={{flexShrink:0,padding:"6px 11px",background:filter===s?`${STAGE_COLORS[s]||"#7CFC00"}18`:"rgba(255,255,255,0.04)",border:`1px solid ${filter===s?(STAGE_COLORS[s]||"#7CFC00")+"44":"rgba(255,255,255,0.08)"}`,borderRadius:8,color:filter===s?(STAGE_COLORS[s]||"#7CFC00"):"rgba(255,255,255,0.4)",fontSize:10,fontFamily:"monospace",cursor:"pointer",whiteSpace:"nowrap"}}>
            {s.toUpperCase()} {s!=="All"&&<span style={{opacity:0.6}}>({stageCount(s)})</span>}
          </button>
        ))}
      </div>
      {filtered.length===0?(
        <div style={{...S.card,textAlign:"center",padding:"32px 16px"}}><div style={{fontSize:28,marginBottom:8}}>📋</div><div style={{color:"rgba(255,255,255,0.35)",fontFamily:"monospace",fontSize:12}}>No quotes yet</div></div>
      ):(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {filtered.map(q=>{
            const overdue=q.stage==="Quoted"&&daysSince(q.createdAt)>=2;
            const isDraft=q.stage==="Lead";
            return(
              <div key={q.id} style={{...S.card,borderColor:overdue?"rgba(255,170,0,0.3)":"rgba(255,255,255,0.08)"}}>
                <div onClick={()=>onSelectQuote(q)} style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8,cursor:"pointer"}}>
                  <div style={{flex:1,marginRight:10}}>
                    <div style={{color:"#fff",fontSize:14,fontFamily:"monospace",fontWeight:700}}>{q.customerName}</div>
                    <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace",marginTop:2}}>{q.address}</div>
                    <div style={{color:"rgba(255,255,255,0.25)",fontSize:10,fontFamily:"monospace",marginTop:2}}>#{q.quoteNum} · {fmtDate(q.createdAt)} · {q.sqft?.toLocaleString()} sqft · tap to view</div>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <div style={{color:"#7CFC00",fontSize:16,fontWeight:700}}>${q.total?.toFixed(0)}</div>
                    {q.recurring!=="once"&&<div style={{color:"rgba(124,252,0,0.5)",fontSize:10,fontFamily:"monospace"}}>{RECURRING_OPTIONS.find(r=>r.id===q.recurring)?.label}</div>}
                  </div>
                </div>
                <div style={{display:"flex",flexWrap:"wrap",gap:4,marginBottom:10}}>
                  {q.services?.slice(0,3).map(s=><Tag key={s.id} label={s.label} color="#7CFC00"/>)}
                  {overdue&&<Tag label="⏰ FOLLOW UP" color="#ffaa00"/>}
                  {q.customerName==="Door Hanger Lead"&&<Tag label="🚪 Add Contact Info" color="#ffaa00"/>}
                  {q.notes&&<Tag label="📝 Notes" color="#888"/>}
                </div>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:8}}>
                  <StagePill stage={q.stage} onChange={stage=>onUpdateStage(q.id,stage)}/>
                  <div style={{display:"flex",gap:6}}>
                    {isDraft&&<button onClick={()=>handleMarkSent(q)} style={{background:"rgba(124,252,0,0.08)",border:"1px solid rgba(124,252,0,0.2)",borderRadius:7,padding:"5px 9px",color:"#7CFC00",fontSize:10,fontFamily:"monospace",cursor:"pointer",whiteSpace:"nowrap"}}>📤 SEND</button>}
                    <button onClick={()=>handleDuplicate(q)} style={{background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:7,padding:"5px 9px",color:"rgba(255,255,255,0.5)",fontSize:10,fontFamily:"monospace",cursor:"pointer"}}>⎘ DUP</button>
                    <a href={`sms:${q.customerPhone}`} style={{background:"rgba(124,252,0,0.07)",border:"1px solid rgba(124,252,0,0.15)",borderRadius:7,padding:"5px 9px",color:"#7CFC00",fontSize:10,fontFamily:"monospace",textDecoration:"none"}}>💬</a>
                    <button onClick={()=>setConfirm(q)} style={{background:"rgba(255,68,68,0.08)",border:"1px solid rgba(255,68,68,0.2)",borderRadius:7,padding:"5px 9px",color:"#ff6b6b",fontSize:10,fontFamily:"monospace",cursor:"pointer"}}>🗑</button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ─── Customers ────────────────────────────────────────────────────────────────

// ─── Customer Import ──────────────────────────────────────────────────────────

// Jobber's known export column names
const JOBBER_MAP = {
  name:         ["client name","name","full name","contact name","client"],
  phone:        ["phone","phone number","mobile","cell","primary phone","work phone"],
  email:        ["email","email address","e-mail","primary email"],
  address:      ["billing address","address","street address","property address","service address"],
  propertyType: ["type","client type","property type","account type"],
  notes:        ["notes","internal notes","client notes","comments"],
};

function fuzzyMatch(header, fieldCandidates) {
  const h = header.toLowerCase().trim();
  for (const candidate of fieldCandidates) {
    if (h.includes(candidate) || candidate.includes(h)) return true;
  }
  return false;
}

function detectColumns(headers) {
  const mapping = {};
  headers.forEach((h, i) => {
    for (const [field, candidates] of Object.entries(JOBBER_MAP)) {
      if (!mapping[field] && fuzzyMatch(h, candidates)) {
        mapping[field] = i;
      }
    }
  });
  return mapping;
}

function parseCSV(text) {
  const lines = text.trim().split(/\r?\n/);
  if (lines.length < 2) return { headers: [], rows: [] };
  const parseRow = line => {
    const cols = []; let cur = ""; let inQ = false;
    for (let i = 0; i < line.length; i++) {
      const c = line[i];
      if (c === '"') { inQ = !inQ; }
      else if (c === "," && !inQ) { cols.push(cur.trim()); cur = ""; }
      else cur += c;
    }
    cols.push(cur.trim());
    return cols;
  };
  const headers = parseRow(lines[0]).map(h => h.replace(/^"|"$/g,""));
  const rows = lines.slice(1).map(l => parseRow(l).map(c => c.replace(/^"|"$/g,"")));
  return { headers, rows };
}

function fmtImportPhone(v) {
  if (!v) return "";
  const d = (v+"").replace(/\D/g,"").slice(0,10);
  if (d.length >= 7) return `(${d.slice(0,3)}) ${d.slice(3,6)}-${d.slice(6)}`;
  if (d.length >= 4) return `(${d.slice(0,3)}) ${d.slice(3)}`;
  return d;
}

function ImportCustomers({ onImport, onBack, existingCount }) {
  const fileRef    = useRef(null);
  const [stage,    setStage]    = useState("upload");   // upload | mapping | preview | importing | done
  const [headers,  setHeaders]  = useState([]);
  const [rows,     setRows]     = useState([]);
  const [colMap,   setColMap]   = useState({});
  const [preview,  setPreview]  = useState([]);
  const [progress, setProgress] = useState(0);
  const [result,   setResult]   = useState(null);

  const handleFile = async e => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      let parsedHeaders = [], parsedRows = [];

      if (file.name.endsWith(".csv")) {
        const text = await file.text();
        const { headers: h, rows: r } = parseCSV(text);
        parsedHeaders = h; parsedRows = r;
      } else {
        // XLSX: load SheetJS dynamically
        if (!window.XLSX) {
          await new Promise((res, rej) => {
            const s = document.createElement("script");
            s.src = "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js";
            s.onload = res; s.onerror = rej;
            document.head.appendChild(s);
          });
        }
        const buf = await file.arrayBuffer();
        const wb  = window.XLSX.read(buf, { type:"array" });
        const ws  = wb.Sheets[wb.SheetNames[0]];
        const data = window.XLSX.utils.sheet_to_json(ws, { header:1, defval:"" });
        parsedHeaders = (data[0]||[]).map(h => String(h));
        parsedRows    = data.slice(1).map(r => parsedHeaders.map((_,i) => String(r[i]||"")));
      }

      // Filter out completely empty rows
      parsedRows = parsedRows.filter(r => r.some(c => c.trim()));

      const detected = detectColumns(parsedHeaders);
      setHeaders(parsedHeaders);
      setRows(parsedRows);
      setColMap(detected);
      setStage("mapping");
    } catch(err) {
      alert("Could not read file. Make sure it's a .csv or .xlsx file.");
    }
  };

  const buildPreview = () => {
    const prev = rows.slice(0,3).map(r => ({
      name:  colMap.name  !== undefined ? r[colMap.name]  : "",
      phone: colMap.phone !== undefined ? fmtImportPhone(r[colMap.phone]) : "",
      email: colMap.email !== undefined ? r[colMap.email] : "",
      address:      colMap.address      !== undefined ? r[colMap.address]      : "",
      propertyType: colMap.propertyType !== undefined ? r[colMap.propertyType] : "",
      notes:        colMap.notes        !== undefined ? r[colMap.notes]        : "",
    }));
    setPreview(prev);
    setStage("preview");
  };

  const runImport = async () => {
    setStage("importing");
    setProgress(0);
    const customers = rows
      .map(r => ({
        id:           genId(),
        name:         colMap.name  !== undefined ? r[colMap.name]?.trim()  : "",
        phone:        colMap.phone !== undefined ? fmtImportPhone(r[colMap.phone]) : "",
        email:        colMap.email !== undefined ? r[colMap.email]?.trim() : "",
        address:      colMap.address      !== undefined ? r[colMap.address]?.trim()      : "",
        propertyType: colMap.propertyType !== undefined ? r[colMap.propertyType]?.trim() : "Residential",
        notes:        colMap.notes        !== undefined ? r[colMap.notes]?.trim()        : "",
        createdAt:    todayStr(),
      }))
      .filter(c => c.name.length > 0);

    let imported = 0; let skipped = 0;
    const BATCH = 20;
    for (let i = 0; i < customers.length; i += BATCH) {
      const batch = customers.slice(i, i + BATCH);
      try {
        await onImport(batch);
        imported += batch.length;
      } catch {
        skipped += batch.length;
      }
      setProgress(Math.round(((i + BATCH) / customers.length) * 100));
      await new Promise(r => setTimeout(r, 50));
    }
    setResult({ imported, skipped, total: customers.length });
    setStage("done");
  };

  const APP_FIELDS = ["name","phone","email","address","propertyType","notes"];
  const FIELD_LABELS = { name:"Name", phone:"Phone", email:"Email", address:"Address", propertyType:"Property Type", notes:"Notes" };

  return (
    <div style={{display:"flex",flexDirection:"column",gap:18}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div><p style={S.label}>Import Clients</p><h2 style={S.heading}>Import from File</h2></div>
        <button onClick={onBack} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12,cursor:"pointer"}}>✕ CANCEL</button>
      </div>

      {/* ── Upload ── */}
      {stage==="upload" && (
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <div style={{background:"rgba(124,252,0,0.05)",border:"1px solid rgba(124,252,0,0.2)",borderRadius:12,padding:"16px"}}>
            <div style={{color:"#7CFC00",fontSize:12,fontFamily:"monospace",fontWeight:700,marginBottom:6}}>📥 SUPPORTED FORMATS</div>
            <div style={{display:"flex",flexDirection:"column",gap:4}}>
              {["• Jobber CSV export (auto-detected)","• Any .csv or .xlsx spreadsheet","• Columns auto-mapped by name"].map(t=>(
                <div key={t} style={{color:"rgba(255,255,255,0.5)",fontSize:12,fontFamily:"monospace"}}>{t}</div>
              ))}
            </div>
          </div>

          <div style={{background:"rgba(0,207,255,0.05)",border:"1px solid rgba(0,207,255,0.15)",borderRadius:12,padding:"12px 16px"}}>
            <div style={{color:"var(--lq-blue)",fontSize:11,fontFamily:"monospace",fontWeight:700,marginBottom:4}}>HOW TO EXPORT FROM JOBBER</div>
            <div style={{color:"rgba(255,255,255,0.45)",fontSize:11,fontFamily:"monospace",lineHeight:1.7}}>
              Jobber &rarr; Clients &rarr; &#8226;&#8226;&#8226; menu &rarr; Export Clients &rarr; Download CSV
            </div>
          </div>

          <input ref={fileRef} type="file" accept=".csv,.xlsx,.xls" onChange={handleFile} style={{display:"none"}}/>
          <button onClick={()=>fileRef.current.click()} style={{...btn(true),background:"#7CFC00",color:"#000",border:"none",padding:"16px",fontSize:15}}>
            📂 CHOOSE FILE (.CSV OR .XLSX)
          </button>
          {existingCount>0&&<div style={{color:"rgba(255,255,255,0.25)",fontSize:11,fontFamily:"monospace",textAlign:"center"}}>{existingCount} existing clients · duplicates will be added as new entries</div>}
        </div>
      )}

      {/* ── Column Mapping ── */}
      {stage==="mapping" && (
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <div style={{...S.card,borderColor:"rgba(124,252,0,0.15)"}}>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:10,fontFamily:"monospace",marginBottom:4}}>FILE DETECTED</div>
            <div style={{color:"#fff",fontSize:13,fontFamily:"monospace"}}>{rows.length} rows · {headers.length} columns</div>
            <div style={{color:"rgba(124,252,0,0.6)",fontSize:11,fontFamily:"monospace",marginTop:2}}>
              {Object.keys(colMap).length} fields auto-matched
            </div>
          </div>

          <div style={{color:"rgba(255,255,255,0.4)",fontSize:10,fontFamily:"monospace",letterSpacing:"0.1em"}}>COLUMN MAPPING — tap to change</div>

          {APP_FIELDS.map(field => (
            <div key={field} style={{display:"flex",alignItems:"center",gap:12,...S.card}}>
              <div style={{flex:"0 0 100px",color:"#7CFC00",fontSize:12,fontFamily:"monospace",fontWeight:700}}>{FIELD_LABELS[field]}</div>
              <div style={{color:"rgba(255,255,255,0.2)",fontSize:12}}>→</div>
              <select
                value={colMap[field]!==undefined ? colMap[field] : ""}
                onChange={e=>setColMap(m=>({...m,[field]:e.target.value===""?undefined:parseInt(e.target.value)}))}
                style={{flex:1,background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.12)",borderRadius:8,padding:"8px 10px",color:"#fff",fontSize:12,fontFamily:"monospace",outline:"none"}}
              >
                <option value="">— skip —</option>
                {headers.map((h,i)=><option key={i} value={i}>{h}</option>)}
              </select>
            </div>
          ))}

          {!colMap.name && (
            <div style={{background:"rgba(255,170,0,0.08)",border:"1px solid rgba(255,170,0,0.3)",borderRadius:10,padding:"10px 14px",color:"#ffaa00",fontSize:12,fontFamily:"monospace"}}>
              ⚠ Name column is required — please map it above
            </div>
          )}

          <button onClick={buildPreview} disabled={colMap.name===undefined} style={{...btn(colMap.name!==undefined),background:colMap.name!==undefined?"#7CFC00":"rgba(124,252,0,0.15)",color:colMap.name!==undefined?"#000":"rgba(255,255,255,0.3)",border:"none"}}>
            PREVIEW IMPORT →
          </button>
        </div>
      )}

      {/* ── Preview ── */}
      {stage==="preview" && (
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <div style={{...S.card,borderColor:"rgba(124,252,0,0.2)"}}>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:10,fontFamily:"monospace",marginBottom:8}}>PREVIEW — FIRST 3 ROWS</div>
            {preview.map((c,i)=>(
              <div key={i} style={{padding:"10px 0",borderBottom:i<preview.length-1?"1px solid rgba(255,255,255,0.06)":"none"}}>
                <div style={{color:"#fff",fontSize:13,fontFamily:"monospace",fontWeight:700}}>{c.name||"—"}</div>
                <div style={{color:"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace",marginTop:2}}>{[c.phone,c.email].filter(Boolean).join(" · ")||"No contact info"}</div>
                {c.address&&<div style={{color:"rgba(255,255,255,0.3)",fontSize:11,fontFamily:"monospace",marginTop:1}}>📍 {c.address}</div>}
              </div>
            ))}
          </div>

          <div style={{background:"rgba(124,252,0,0.06)",border:"1px solid rgba(124,252,0,0.2)",borderRadius:12,padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{color:"rgba(255,255,255,0.5)",fontFamily:"monospace",fontSize:12}}>READY TO IMPORT</span>
            <span style={{color:"#7CFC00",fontFamily:"monospace",fontSize:16,fontWeight:700}}>{rows.filter(r=>r[colMap.name]?.trim()).length} clients</span>
          </div>

          <button onClick={runImport} style={{...btn(true),background:"#7CFC00",color:"#000",border:"none",padding:"15px",fontSize:14}}>
            ⬆ IMPORT ALL CLIENTS
          </button>
          <button onClick={()=>setStage("mapping")} style={{background:"none",border:"none",color:"rgba(255,255,255,0.3)",fontSize:12,fontFamily:"monospace",cursor:"pointer"}}>← BACK TO MAPPING</button>
        </div>
      )}

      {/* ── Importing ── */}
      {stage==="importing" && (
        <div style={{display:"flex",flexDirection:"column",gap:20,alignItems:"center",padding:"20px 0"}}>
          <div style={{fontSize:36}}>⬆</div>
          <div style={{color:"#7CFC00",fontFamily:"monospace",fontSize:14,fontWeight:700}}>IMPORTING CLIENTS…</div>
          <div style={{width:"100%",height:6,background:"rgba(255,255,255,0.08)",borderRadius:99,overflow:"hidden"}}>
            <div style={{height:"100%",background:"#7CFC00",width:`${progress}%`,borderRadius:99,transition:"width 0.3s"}}/>
          </div>
          <div style={{color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12}}>{progress}% complete</div>
        </div>
      )}

      {/* ── Done ── */}
      {stage==="done" && result && (
        <div style={{display:"flex",flexDirection:"column",gap:16,alignItems:"center",padding:"10px 0"}}>
          <div style={{fontSize:42}}>✅</div>
          <div style={{color:"#7CFC00",fontSize:20,fontWeight:700,fontFamily:"monospace"}}>Import Complete!</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,width:"100%"}}>
            <div style={{...S.card,textAlign:"center",borderColor:"rgba(124,252,0,0.2)"}}>
              <div style={{color:"#7CFC00",fontSize:28,fontWeight:700,fontFamily:"monospace"}}>{result.imported}</div>
              <div style={{color:"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace",marginTop:2}}>IMPORTED</div>
            </div>
            {result.skipped>0&&(
              <div style={{...S.card,textAlign:"center",borderColor:"rgba(255,170,0,0.2)"}}>
                <div style={{color:"#ffaa00",fontSize:28,fontWeight:700,fontFamily:"monospace"}}>{result.skipped}</div>
                <div style={{color:"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace",marginTop:2}}>SKIPPED</div>
              </div>
            )}
          </div>
          <div style={{color:"rgba(255,255,255,0.35)",fontSize:12,fontFamily:"monospace",textAlign:"center"}}>
            Your clients are ready to quote
          </div>
          <button onClick={onBack} style={{...btn(true),background:"#7CFC00",color:"#000",border:"none",width:"100%"}}>VIEW CLIENTS →</button>
        </div>
      )}
    </div>
  );
}

function AddCustomerForm({onSave,onBack}){
  const [name,setName]=useState("");
  const [phone,setPhone]=useState("");
  const [email,setEmail]=useState("");
  const [address,setAddress]=useState("");
  const [propertyType,setPropertyType]=useState("Residential");
  const [notes,setNotes]=useState("");
  const [saving,setSaving]=useState(false);
  const valid=name.trim()&&phone.replace(/\D/g,"").length>=10;
  const fmt=v=>{const d=v.replace(/\D/g,"").slice(0,10);if(d.length>=7)return`(${d.slice(0,3)}) ${d.slice(3,6)}-${d.slice(6)}`;if(d.length>=4)return`(${d.slice(0,3)}) ${d.slice(3)}`;if(d.length)return`(${d}`;return"";};
  const handle=async()=>{
    if(!valid)return;
    setSaving(true);
    await onSave({id:genId(),name,phone,email,address,propertyType,notes,createdAt:todayStr()});
    setSaving(false);
  };
  return(
    <div style={{display:"flex",flexDirection:"column",gap:16}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div><p style={S.label}>New Client</p><h2 style={S.heading}>Add Client</h2></div>
        <button onClick={onBack} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12,cursor:"pointer"}}>✕ CANCEL</button>
      </div>
      <Field label="Full Name" value={name} onChange={setName} placeholder="Jane Smith" required/>
      <Field label="Phone Number" value={phone} onChange={v=>setPhone(fmt(v))} placeholder="(555) 867-5309" required/>
      <Field label="Email (optional)" value={email} onChange={setEmail} placeholder="jane@email.com" type="email"/>
      <Field label="Property Address (optional)" value={address} onChange={setAddress} placeholder="123 Main St, Nashville TN"/>
      <div>
        <div style={S.label}>Property Type</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
          {PROPERTY_TYPES.map(t=><button key={t} onClick={()=>setPropertyType(t)} style={{padding:"7px 13px",background:propertyType===t?"rgba(124,252,0,0.12)":"rgba(255,255,255,0.04)",border:`1px solid ${propertyType===t?"rgba(124,252,0,0.35)":"rgba(255,255,255,0.08)"}`,borderRadius:8,color:propertyType===t?"#7CFC00":"rgba(255,255,255,0.5)",fontSize:12,fontFamily:"monospace",cursor:"pointer"}}>{t}</button>)}
        </div>
      </div>
      <Field label="Notes (optional)" value={notes} onChange={setNotes} placeholder="Gate code, preferred schedule…" rows={2}/>
      <button onClick={handle} disabled={!valid||saving} style={{...btn(valid&&!saving),background:valid&&!saving?"#7CFC00":"rgba(124,252,0,0.15)",color:valid&&!saving?"#000":"rgba(255,255,255,0.3)",border:"none"}}>{saving?"SAVING…":"SAVE CLIENT →"}</button>
    </div>
  );
}

function Customers({customers,quotes,onSelect,onAdd,onImport}){
  const [search,setSearch]=useState("");
  console.log('Customers component rendered with', customers.length, 'customers');
  const filtered=customers.filter(c=>c.name.toLowerCase().includes(search.toLowerCase())||c.phone?.includes(search)||c.email?.toLowerCase().includes(search.toLowerCase()));
  return(
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
        <div><p style={S.label}>Client Management</p><h2 style={S.heading}>Clients</h2><p style={S.sub}>{customers.length} total</p></div>
        <div style={{display:"flex",gap:6,marginTop:4}}>
          <button onClick={onImport} style={{background:"rgba(0,207,255,0.1)",color:"var(--lq-blue)",border:"1px solid rgba(0,207,255,0.3)",borderRadius:10,padding:"10px 12px",fontSize:11,fontWeight:700,fontFamily:"monospace",cursor:"pointer",whiteSpace:"nowrap"}}>⬆ IMPORT</button>
          <button onClick={onAdd} style={{background:"#7CFC00",color:"#000",border:"none",borderRadius:10,padding:"10px 12px",fontSize:11,fontWeight:700,fontFamily:"monospace",cursor:"pointer",whiteSpace:"nowrap"}}>+ ADD</button>
        </div>
      </div>
      <div style={{background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:10,padding:"10px 13px",display:"flex",gap:8,alignItems:"center"}}>
        <span style={{color:"rgba(255,255,255,0.3)",fontSize:14}}>🔍</span>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search name, phone, email…" style={{background:"none",border:"none",outline:"none",color:"#fff",fontSize:13,flex:1,fontFamily:"monospace"}}/>
      </div>
      {filtered.length===0?(
        <div style={{...S.card,textAlign:"center",padding:"32px 16px"}}><div style={{fontSize:28,marginBottom:8}}>👥</div><div style={{color:"rgba(255,255,255,0.35)",fontFamily:"monospace",fontSize:12}}>{search?"No results":"No clients yet"}</div></div>
      ):(
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {filtered.map(c=>{
            const cQ=quotes.filter(q=>q.customerId===c.id);
            const spent=cQ.filter(q=>q.stage==="Accepted"||q.stage==="Completed").reduce((a,q)=>a+(q.total||0),0);
            const last=cQ.sort((a,b)=>b.createdAt.localeCompare(a.createdAt))[0];
            const hasRec=cQ.some(q=>q.recurring!=="once"&&(q.stage==="Accepted"||q.stage==="Scheduled"));
            return(
              <div key={c.id} onClick={()=>onSelect(c)} style={{...S.card,cursor:"pointer"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                  <div style={{display:"flex",alignItems:"center",gap:10,flex:1}}>
                    <div style={{width:36,height:36,borderRadius:"50%",background:"rgba(124,252,0,0.15)",border:"1px solid rgba(124,252,0,0.3)",display:"flex",alignItems:"center",justifyContent:"center",color:"#7CFC00",fontSize:15,fontWeight:700,flexShrink:0}}>{c.name.charAt(0).toUpperCase()}</div>
                    <div>
                      <div style={{color:"#fff",fontSize:14,fontFamily:"monospace",fontWeight:700}}>{c.name}</div>
                      <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace"}}>{c.phone}</div>
                    </div>
                  </div>
                  <div style={{textAlign:"right"}}><div style={{color:"#7CFC00",fontSize:15,fontWeight:700}}>${spent.toFixed(0)}</div><div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace"}}>lifetime</div></div>
                </div>
                <div style={{display:"flex",gap:6,marginTop:10,flexWrap:"wrap"}}>
                  {c.propertyType&&<Tag label={c.propertyType} color="#888"/>}
                  <Tag label={`${cQ.length} quote${cQ.length!==1?"s":""}`} color="#888"/>
                  {hasRec&&<Tag label="🔄 Recurring" color="var(--lq-blue)"/>}
                  {last&&<Tag label={`Last: ${fmtDate(last.createdAt)}`} color="#888"/>}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}


function ClientHistoryTabs({cQ, invoices, onNewQuote, onSelectInvoice, onSelectQuote, onCreateMultiInvoice, onRebook}){
  const [tab,       setTab]       = useState("quotes");
  const [selecting, setSelecting] = useState(false);
  const [selected,  setSelected]  = useState(new Set());

  const cInv = invoices.filter(i=>
    cQ.some(q=>q.id===i.quoteId) ||
    cQ.some(q=>q.customerName===i.customerName)
  );

  const toggleSelect = (id) => {
    setSelected(s=>{ const n=new Set(s); n.has(id)?n.delete(id):n.add(id); return n; });
  };

  const selectedQuotes = cQ.filter(q=>selected.has(q.id));
  const selectedTotal  = selectedQuotes.reduce((a,q)=>a+(q.total||0),0);

  const handleCreateMulti = () => {
    if(selectedQuotes.length===0) return;
    onCreateMultiInvoice?.(selectedQuotes);
    setSelecting(false);
    setSelected(new Set());
  };

  return(
    <div style={{display:"flex",flexDirection:"column",gap:10}}>
      {/* Tab bar */}
      <div style={{display:"flex",background:"rgba(255,255,255,0.05)",borderRadius:10,padding:3,gap:2}}>
        {[["quotes","Quotes"+(cQ.length>0?" ("+cQ.length+")":"")],["invoices","Invoices"+(cInv.length>0?" ("+cInv.length+")":"")]].map(([v,l])=>(
          <button key={v} onClick={()=>{setTab(v);setSelecting(false);setSelected(new Set());}} style={{flex:1,padding:"8px",background:tab===v?"#7CFC00":"none",color:tab===v?"#000":"rgba(255,255,255,0.45)",border:"none",borderRadius:8,cursor:"pointer",fontSize:11,fontWeight:700,fontFamily:"monospace",transition:"all 0.2s"}}>{l.toUpperCase()}</button>
        ))}
      </div>

      {/* Quotes tab */}
      {tab==="quotes"&&(
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {cQ.length===0?(
            <div style={{...S.card,textAlign:"center",padding:"28px 16px"}}>
              <div style={{fontSize:28,marginBottom:8}}>📋</div>
              <div style={{color:"rgba(255,255,255,0.35)",fontFamily:"monospace",fontSize:12,marginBottom:12}}>No quotes yet</div>
              <button onClick={onNewQuote} style={{background:"rgba(124,252,0,0.1)",border:"1px solid rgba(124,252,0,0.25)",borderRadius:10,padding:"10px 18px",color:"#7CFC00",fontSize:12,fontFamily:"monospace",cursor:"pointer"}}>+ CREATE FIRST QUOTE</button>
            </div>
          ):(
            <>
              {/* Multi-invoice toolbar */}
              <div style={{display:"flex",gap:6,alignItems:"center"}}>
                {!selecting?(
                  <button onClick={()=>setSelecting(true)} style={{background:"rgba(0,207,255,0.08)",border:"1px solid rgba(0,207,255,0.25)",borderRadius:9,padding:"7px 12px",color:"var(--lq-blue)",fontSize:11,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>☑ SELECT MULTIPLE</button>
                ):(
                  <>
                    <button onClick={()=>{setSelecting(false);setSelected(new Set());}} style={{background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:9,padding:"7px 12px",color:"rgba(255,255,255,0.5)",fontSize:11,fontFamily:"monospace",cursor:"pointer"}}>✕ CANCEL</button>
                    <button onClick={()=>setSelected(new Set(cQ.map(q=>q.id)))} style={{background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:9,padding:"7px 12px",color:"rgba(255,255,255,0.5)",fontSize:11,fontFamily:"monospace",cursor:"pointer"}}>SELECT ALL</button>
                  </>
                )}
              </div>

              {/* Quote cards */}
              {cQ.map(q=>{
                const isSel = selected.has(q.id);
                return(
                  <div key={q.id}
                    onClick={()=>selecting ? toggleSelect(q.id) : onSelectQuote&&onSelectQuote(q)}
                    style={{...S.card,cursor:"pointer",borderColor:isSel?"rgba(0,207,255,0.4)":"rgba(255,255,255,0.08)",background:isSel?"rgba(0,207,255,0.06)":"rgba(255,255,255,0.04)",transition:"all 0.15s"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:6}}>
                      <div style={{display:"flex",gap:10,alignItems:"flex-start"}}>
                        {selecting&&(
                          <div style={{width:20,height:20,borderRadius:5,background:isSel?"var(--lq-blue)":"rgba(255,255,255,0.08)",border:"2px solid "+(isSel?"var(--lq-blue)":"rgba(255,255,255,0.2)"),display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>
                            {isSel&&<span style={{fontSize:11,color:"#000",fontWeight:900}}>✓</span>}
                          </div>
                        )}
                        <div>
                          <div style={{color:"#fff",fontSize:13,fontFamily:"monospace",fontWeight:700}}>#{q.quoteNum}</div>
                          <div style={{color:"rgba(255,255,255,0.3)",fontSize:11,fontFamily:"monospace",marginTop:2}}>{fmtDate(q.createdAt)} · {q.sqft?.toLocaleString()} sqft</div>
                        </div>
                      </div>
                      <div style={{textAlign:"right"}}>
                        <div style={{color:"#7CFC00",fontSize:15,fontWeight:700}}>${q.total?.toFixed(0)}</div>
                        <Tag label={q.stage} color={STAGE_COLORS[q.stage]||"#888"}/>
                      </div>
                    </div>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                        {q.services?.slice(0,3).map(s=><Tag key={s.id} label={s.label} color="#7CFC00"/>)}
                        {q.recurring!=="once"&&<Tag label={RECURRING_OPTIONS.find(r=>r.id===q.recurring)?.label||""} color="var(--lq-blue)"/>}
                      </div>
                      {!selecting&&(
                        <div style={{display:"flex",gap:6,alignItems:"center"}}>
                          {(q.stage==="Completed"||q.stage==="Accepted")&&onRebook&&(
                            <button onClick={e=>{e.stopPropagation();onRebook(q);}} style={{background:"rgba(124,252,0,0.1)",border:"1px solid rgba(124,252,0,0.25)",borderRadius:7,padding:"4px 10px",color:"#7CFC00",fontSize:10,fontFamily:"monospace",fontWeight:700,cursor:"pointer",whiteSpace:"nowrap"}}>↺ REBOOK</button>
                          )}
                          <span style={{color:"rgba(255,255,255,0.2)",fontSize:11,fontFamily:"monospace"}}>→</span>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}

              {/* Multi-invoice action bar */}
              {selecting&&selected.size>0&&(
                <div style={{background:"rgba(0,207,255,0.08)",border:"1px solid rgba(0,207,255,0.3)",borderRadius:12,padding:"13px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div>
                    <div style={{color:"var(--lq-blue)",fontSize:13,fontFamily:"monospace",fontWeight:700}}>{selected.size} quote{selected.size!==1?"s":""} selected</div>
                    <div style={{color:"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace",marginTop:2}}>Total: ${selectedTotal.toFixed(0)}</div>
                  </div>
                  <button onClick={handleCreateMulti} style={{background:"var(--lq-blue)",color:"#000",border:"none",borderRadius:10,padding:"10px 16px",fontSize:12,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>🧾 CREATE INVOICE</button>
                </div>
              )}
            </>
          )}
        </div>
      )}

      {/* Invoices tab */}
      {tab==="invoices"&&(
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {cInv.length===0?(
            <div style={{...S.card,textAlign:"center",padding:"28px 16px"}}>
              <div style={{fontSize:28,marginBottom:8}}>🧾</div>
              <div style={{color:"rgba(255,255,255,0.35)",fontFamily:"monospace",fontSize:12}}>No invoices yet</div>
            </div>
          ):(
            cInv.map(inv=>{
              const sc=INV_STATUS_COLORS[isOverdue(inv)?"Overdue":inv.status]||"#888";
              const daysUntil=inv.dueDate?-daysSince(inv.dueDate):null;
              return(
                <div key={inv.id} onClick={()=>onSelectInvoice&&onSelectInvoice(inv)} style={{...S.card,borderColor:isOverdue(inv)?"rgba(255,68,68,0.25)":inv.status==="Paid"?"rgba(0,255,153,0.15)":"rgba(255,255,255,0.08)",cursor:"pointer"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:6}}>
                    <div>
                      <div style={{color:"#fff",fontSize:13,fontFamily:"monospace",fontWeight:700}}>#{inv.invoiceNum}</div>
                      <div style={{color:"rgba(255,255,255,0.3)",fontSize:11,fontFamily:"monospace",marginTop:2}}>{fmtDate(inv.createdAt)}</div>
                      {inv.dueDate&&inv.status!=="Paid"&&(
                        <div style={{color:isOverdue(inv)?"#ff6b6b":"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace",marginTop:1}}>
                          {isOverdue(inv)?"⚠ "+Math.abs(daysUntil)+"d overdue":daysUntil===0?"Due today":"Due in "+daysUntil+"d"}
                        </div>
                      )}
                      {inv.status==="Paid"&&inv.paidDate&&<div style={{color:"rgba(0,255,153,0.6)",fontSize:11,fontFamily:"monospace",marginTop:1}}>✓ Paid {fmtDate(inv.paidDate)}</div>}
                    </div>
                    <div style={{textAlign:"right"}}>
                      <div style={{color:"#7CFC00",fontSize:15,fontWeight:700}}>${inv.total?.toFixed(0)}</div>
                      <span style={{background:`${sc}18`,border:`1px solid ${sc}44`,borderRadius:6,padding:"2px 7px",color:sc,fontSize:10,fontFamily:"monospace"}}>{isOverdue(inv)?"Overdue":inv.status}</span>
                    </div>
                  </div>
                  <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                    {(inv.lineItems||[]).slice(0,3).map((li,i)=><Tag key={i} label={li.label||li.name||""} color="#888"/>)}
                  </div>
                </div>
              );
            })
          )}
        </div>
      )}
    </div>
  );
}

function CustomerProfile({customer,quotes,invoices,onBack,onNewQuote,onUpdate,onDelete,onScheduleRecurring,onSelectInvoice,onUpdateStage,onDeleteQuote,onDuplicateQuote,onCreateInvoice,onMarkPaid,onDeleteInvoice,onUpdateInvoice,onCreateMultiInvoice,onRebook}){
  const [editing,       setEditing]       = useState(false);
  const [recurringSetup,setRecurringSetup] = useState(false);
  const [viewingQuote,      setViewingQuote]      = useState(null);
  const [editingViewingQuote,setEditingViewingQuote] = useState(null);
  const [viewingInvoice,    setViewingInvoice]     = useState(null);
  const [form,setForm]=useState({name:customer.name,phone:customer.phone||"",email:customer.email||"",address:customer.address||"",propertyType:customer.propertyType||"Residential",notes:customer.notes||""});
  const [recurForm,setRecurForm] = useState({
    frequency:  customer.recurringFrequency  || "biweekly",
    dayOfWeek:  customer.recurringDay        || "1",       // 0=Sun…6=Sat
    startDate:  customer.recurringStart      || todayStr(),
    services:   customer.recurringServices   || "",
    duration:   customer.recurringDuration   || 60,
    active:     true, // always start active — user can toggle off
    templateQuoteId: customer.recurringTemplateQuoteId || "",
    price: customer.recurringPrice != null ? String(customer.recurringPrice) : "",
  });
  const [saving,setSaving]=useState(false);
  const [confirm,setConfirm]=useState(false);
  const [toast,showToast]=useToast();
  const cQ=quotes.filter(q=>q.customerId===customer.id).sort((a,b)=>b.createdAt.localeCompare(a.createdAt));
  const spent=cQ.filter(q=>q.stage==="Accepted"||q.stage==="Completed").reduce((a,q)=>a+(q.total||0),0);
  const rec=cQ.filter(q=>q.recurring!=="once"&&(q.stage==="Accepted"||q.stage==="Scheduled"));
  const isRecurring = customer.recurringActive===true && !!customer.recurringFrequency;
  // Balance owed = value of completed work minus payments received. Completed
  // recurring jobs that came through with $0 fall back to the client's recurring price.
  const _qVal=q=>(q.total&&q.total>0)?q.total:((q.recurring&&q.recurring!=="once"&&customer.recurringPrice)?Number(customer.recurringPrice):(q.total||0));
  const _cInv=(invoices||[]).filter(i=>i.customerId===customer.id||i.customerName===customer.name);
  const completedVal=cQ.filter(q=>q.stage==="Completed").reduce((a,q)=>a+_qVal(q),0);
  const paidVal=_cInv.filter(i=>i.status==="Paid").reduce((a,i)=>a+(i.total||0),0);
  const balanceOwed=Math.max(0,Math.round(completedVal-paidVal));

  const handleSave=async()=>{
    setSaving(true);
    await onUpdate(customer.id,form);
    setSaving(false);
    setEditing(false);
    showToast("Client updated");
  };

  const handleSaveRecurring=async()=>{
    setSaving(true);

    const addr = (form.address || customer.address || "").trim();
    const isActive = !!recurForm.active;

    if(isActive && !addr){
      showToast("Please add a property address to this client first","error");
      setSaving(false);
      return;
    }

    try{
      const session=await supabase.auth.getSession();
      if(!session.data.session){ showToast("Not authenticated","error"); setSaving(false); return; }

      if(isActive){
        // Call recurring-service API with create action
        const res=await fetch('/api/recurring-service',{
          method:'POST',
          headers:{'Content-Type':'application/json','x-user-id':session.data.session.user.id},
          body:JSON.stringify({
            action:'create',
            customerId:customer.id,
            frequency:recurForm.frequency,
            services:recurForm.services||"",
            price:Number(recurForm.price)||0,
            startDate:recurForm.startDate,
            endDate:recurForm.endDate||null,
            duration:Number(recurForm.duration)||60,
            customDays:parseInt(recurForm.customDays)||null,
            templateQuoteId:recurForm.templateQuoteId||null
          })
        });
        const result=await res.json();
        if(!res.ok){ showToast(result.error||"Failed to create recurring service","error"); setSaving(false); return; }
        showToast(`✅ Recurring service created! Generated ${result.jobsGenerated} jobs`);
      } else {
        // Pause recurring by calling recurring-service API
        const res=await fetch('/api/recurring-service',{
          method:'POST',
          headers:{'Content-Type':'application/json','x-user-id':session.data.session.user.id},
          body:JSON.stringify({customerId:customer.id,action:'pause'})
        });
        const result=await res.json();
        if(!res.ok){ showToast(result.error||"Failed to pause recurring service","error"); setSaving(false); return; }
        showToast("Schedule paused");
      }

      // Update local customer object via onUpdate
      const updates={
        recurringFrequency:        isActive?recurForm.frequency:null,
        recurringDay:              recurForm.dayOfWeek,
        recurringStart:            isActive?recurForm.startDate:null,
        recurringServices:         isActive?recurForm.services:null,
        recurringDuration:         Number(recurForm.duration)||60,
        recurringActive:           isActive,
        recurringTemplateQuoteId:  recurForm.templateQuoteId||null,
        recurringPrice:            isActive?(recurForm.price !== "" ? Number(recurForm.price) : null):null,
      };
      await onUpdate(customer.id, {...form, ...updates});
    } catch(err){
      console.error('Recurring service error:',err);
      showToast(err.message||"Error saving recurring service","error");
    }

    setSaving(false);
    setRecurringSetup(false);
  };

  if(editingViewingQuote) return(
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <button onClick={()=>setEditingViewingQuote(null)} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12,cursor:"pointer",textAlign:"left",padding:0}}>← {customer.name}</button>
      <QuoteEditForm quote={editingViewingQuote} onSave={async(id,updates)=>{if(onUpdateStage)await onUpdateStage?.(id,updates);setEditingViewingQuote(null);setViewingQuote(q=>q?{...q,...updates}:null);}} onBack={()=>{setEditingViewingQuote(null);}}/>
    </div>
  );

  if(viewingQuote) return(
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <button onClick={()=>setViewingQuote(null)} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12,cursor:"pointer",textAlign:"left",padding:0}}>← {customer.name}</button>
      <QuoteDetail quote={viewingQuote} onBack={()=>setViewingQuote(null)} onUpdateStage={async(id,s)=>{if(onUpdateStage)await onUpdateStage(id,s);setViewingQuote(q=>({...q,stage:s}));}} onDelete={async id=>{if(onDeleteQuote)await onDeleteQuote(id);setViewingQuote(null);}} onDuplicate={onDuplicateQuote||(()=>{})} onCreateInvoice={onCreateInvoice||(()=>{})} onEditQuote={q=>setEditingViewingQuote(q)} onLogApplication={()=>{}}/>
    </div>
  );

  if(viewingInvoice) return(
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <button onClick={()=>setViewingInvoice(null)} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12,cursor:"pointer",textAlign:"left",padding:0}}>← {customer.name}</button>
      <InvoiceDetail invoice={viewingInvoice} profile={null} session={null} customers={[customer]} onBack={()=>setViewingInvoice(null)} onMarkPaid={async(id,method)=>{if(onMarkPaid)await onMarkPaid(id,method);setViewingInvoice(i=>({...i,status:"Paid",paidDate:todayStr(),paymentMethod:method}));}} onDelete={async id=>{if(onDeleteInvoice)await onDeleteInvoice(id);setViewingInvoice(null);}} onUpdate={onUpdateInvoice||(()=>{})}/>
    </div>
  );

  return(
    <div style={{display:"flex",flexDirection:"column",gap:16}}>
      {toast&&<Toast message={toast.message}/>}
      {confirm&&<ConfirmModal message={`Delete ${customer.name}? This will also delete all their quotes.`} onConfirm={()=>{onDelete(customer.id);setConfirm(false);}} onCancel={()=>setConfirm(false)}/>}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <button onClick={onBack} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12,cursor:"pointer",padding:0}}>← CLIENTS</button>
        <div style={{display:"flex",gap:8}}>
          <button onClick={()=>setEditing(e=>!e)} style={{background:editing?"rgba(124,252,0,0.12)":"rgba(255,255,255,0.06)",border:`1px solid ${editing?"rgba(124,252,0,0.3)":"rgba(255,255,255,0.1)"}`,borderRadius:8,padding:"6px 12px",color:editing?"#7CFC00":"rgba(255,255,255,0.5)",fontSize:11,fontFamily:"monospace",cursor:"pointer"}}>{editing?"✕ CANCEL":"✎ EDIT"}</button>
          <button onClick={()=>setConfirm(true)} style={{background:"rgba(255,68,68,0.08)",border:"1px solid rgba(255,68,68,0.2)",borderRadius:8,padding:"6px 12px",color:"#ff6b6b",fontSize:11,fontFamily:"monospace",cursor:"pointer"}}>🗑 DELETE</button>
        </div>
      </div>

      {editing?(
        <div style={{...S.card,borderColor:"rgba(124,252,0,0.15)",display:"flex",flexDirection:"column",gap:14}}>
          <div style={{...S.label,marginBottom:0}}>Edit Client Info</div>
          <Field label="Name" value={form.name} onChange={v=>setForm(f=>({...f,name:v}))} placeholder="Jane Smith" required/>
          <Field label="Phone" value={form.phone} onChange={v=>setForm(f=>({...f,phone:v}))} placeholder="(555) 867-5309"/>
          <Field label="Email" value={form.email} onChange={v=>setForm(f=>({...f,email:v}))} placeholder="jane@email.com" type="email"/>
          <Field label="Property Address" value={form.address} onChange={v=>setForm(f=>({...f,address:v}))} placeholder="123 Main St, Nashville TN"/>
          <div>
            <div style={S.label}>Property Type</div>
            <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
              {PROPERTY_TYPES.map(t=><button key={t} onClick={()=>setForm(f=>({...f,propertyType:t}))} style={{padding:"7px 13px",background:form.propertyType===t?"rgba(124,252,0,0.12)":"rgba(255,255,255,0.04)",border:`1px solid ${form.propertyType===t?"rgba(124,252,0,0.35)":"rgba(255,255,255,0.08)"}`,borderRadius:8,color:form.propertyType===t?"#7CFC00":"rgba(255,255,255,0.5)",fontSize:12,fontFamily:"monospace",cursor:"pointer"}}>{t}</button>)}
            </div>
          </div>
          <Field label="Client Notes" value={form.notes} onChange={v=>setForm(f=>({...f,notes:v}))} placeholder="Gate code, preferred schedule, special requests…" rows={3}/>
          <button onClick={handleSave} disabled={saving} style={{...btn(true),background:"#7CFC00",color:"#000",border:"none"}}>{saving?"SAVING…":"SAVE CHANGES"}</button>
        </div>
      ):(
        <div style={{...S.card,borderColor:"rgba(124,252,0,0.15)"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
            <div style={{display:"flex",alignItems:"center",gap:12}}>
              <div style={{width:48,height:48,borderRadius:"50%",background:"rgba(124,252,0,0.15)",border:"2px solid rgba(124,252,0,0.3)",display:"flex",alignItems:"center",justifyContent:"center",color:"#7CFC00",fontSize:20,fontWeight:700}}>{customer.name.charAt(0).toUpperCase()}</div>
              <div>
                <div style={{color:"#fff",fontSize:16,fontWeight:700,fontFamily:"monospace"}}>{customer.name}</div>
                <div style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace"}}>{customer.phone}</div>
                {customer.email&&<div style={{color:"rgba(255,255,255,0.3)",fontSize:11,fontFamily:"monospace"}}>{customer.email}</div>}
                {customer.address&&<div style={{color:"rgba(255,255,255,0.25)",fontSize:11,fontFamily:"monospace",marginTop:2}}>📍 {customer.address}</div>}
              </div>
            </div>
            <div style={{textAlign:"right"}}><div style={{color:"#7CFC00",fontSize:18,fontWeight:700}}>${spent.toFixed(0)}</div><div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace"}}>lifetime</div></div>
          </div>
          {customer.notes&&<div style={{marginTop:12,padding:"10px 0",borderTop:"1px solid rgba(255,255,255,0.06)",color:"rgba(255,255,255,0.45)",fontSize:12,fontFamily:"monospace",lineHeight:1.5}}>📝 {customer.notes}</div>}
          <div style={{display:"flex",gap:8,marginTop:14}}>
            <a href={`tel:${customer.phone}`} style={{flex:1,background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"9px",textAlign:"center",color:"rgba(255,255,255,0.6)",fontSize:12,fontFamily:"monospace",textDecoration:"none"}}>📞 CALL</a>
            <a href={`sms:${customer.phone}`} style={{flex:1,background:"rgba(124,252,0,0.07)",border:"1px solid rgba(124,252,0,0.2)",borderRadius:8,padding:"9px",textAlign:"center",color:"#7CFC00",fontSize:12,fontFamily:"monospace",textDecoration:"none"}}>💬 TEXT</a>
            {customer.email&&<a href={`mailto:${customer.email}`} style={{flex:1,background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"9px",textAlign:"center",color:"rgba(255,255,255,0.6)",fontSize:12,fontFamily:"monospace",textDecoration:"none"}}>✉️ EMAIL</a>}
          </div>
        </div>
      )}

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:8}}>
        {[
          {l:"QUOTES",v:cQ.length,c:"#7CFC00"},
          {l:"RECURRING",v:rec.length,c:"#7CFC00"},
          {l:"AVG JOB",v:cQ.length?`$${(spent/Math.max(cQ.filter(q=>q.stage==="Accepted"||q.stage==="Completed").length,1)).toFixed(0)}`:"$—",c:"#7CFC00"},
          {l:"BALANCE",v:`$${balanceOwed}`,c:balanceOwed>0?"#ffaa00":"#7CFC00"},
        ].map(({l,v,c})=>(
          <div key={l} style={{background:l==="BALANCE"&&balanceOwed>0?"rgba(255,170,0,0.07)":"rgba(124,252,0,0.05)",border:`1px solid ${l==="BALANCE"&&balanceOwed>0?"rgba(255,170,0,0.2)":"rgba(124,252,0,0.1)"}`,borderRadius:10,padding:"10px 6px",textAlign:"center"}}>
            <div style={{color:"rgba(255,255,255,0.3)",fontSize:9,fontFamily:"monospace"}}>{l}</div>
            <div style={{color:c,fontSize:15,fontWeight:700,marginTop:3,fontFamily:"monospace"}}>{v}</div>
          </div>
        ))}
      </div>

      {/* ── Recurring Schedule Setup ── */}
      {!recurringSetup?(
        <button onClick={()=>setRecurringSetup(true)} style={{display:"flex",alignItems:"center",gap:10,background:isRecurring?"rgba(0,207,255,0.08)":"rgba(255,255,255,0.04)",border:`1px solid ${isRecurring?"rgba(0,207,255,0.3)":"rgba(255,255,255,0.1)"}`,borderRadius:12,padding:"13px 16px",cursor:"pointer",width:"100%",textAlign:"left",transition:"all 0.2s"}}>
          <span style={{fontSize:20}}>🔄</span>
          <div style={{flex:1}}>
            <div style={{color:isRecurring?"var(--lq-blue)":"rgba(255,255,255,0.6)",fontSize:13,fontFamily:"monospace",fontWeight:700}}>{isRecurring?"RECURRING SCHEDULE ACTIVE":"SET UP RECURRING SCHEDULE"}</div>
            <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace",marginTop:2}}>
              {isRecurring
                ? (customer.recurringFrequency==="custom"?"Every "+(customer.recurringCustomDays||7)+" days":(RECURRING_OPTIONS.find(r=>r.id===customer.recurringFrequency)?.label||"Scheduled"))+" · "+["Sun","Mon","Tue","Wed","Thu","Fri","Sat"][parseInt(customer.recurringDay||"1")]+"s · auto-added to schedule"
                : "Tap to schedule this client weekly, bi-weekly, or monthly"}
            </div>
          </div>
          <span style={{color:"rgba(255,255,255,0.3)",fontSize:14}}>→</span>
        </button>
      ):(
        <div style={{...S.card,borderColor:"rgba(0,207,255,0.2)",display:"flex",flexDirection:"column",gap:14}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{color:"var(--lq-blue)",fontSize:13,fontFamily:"monospace",fontWeight:700}}>🔄 RECURRING SCHEDULE</div>
            <button onClick={()=>setRecurringSetup(false)} style={{background:"none",border:"none",color:"rgba(255,255,255,0.3)",cursor:"pointer",fontSize:14}}>✕</button>
          </div>

          {/* Active toggle */}
          <button onClick={()=>setRecurForm(f=>({...f,active:!f.active}))} style={{display:"flex",alignItems:"center",gap:10,background:"none",border:"none",cursor:"pointer",padding:0,textAlign:"left"}}>
            <div style={{width:42,height:24,borderRadius:99,background:recurForm.active?"#7CFC00":"rgba(255,255,255,0.15)",position:"relative",transition:"background 0.2s",flexShrink:0}}>
              <div style={{width:20,height:20,borderRadius:"50%",background:"#fff",position:"absolute",top:2,left:recurForm.active?20:2,transition:"left 0.2s",boxShadow:"0 1px 4px rgba(0,0,0,0.3)"}}/>
            </div>
            <span style={{color:recurForm.active?"#7CFC00":"rgba(255,255,255,0.4)",fontSize:13,fontFamily:"monospace",fontWeight:700}}>{recurForm.active?"ACTIVE":"PAUSED"}</span>
          </button>

          {/* Frequency */}
          <div>
            <div style={S.label}>Frequency</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
              {[["weekly","Weekly","Every 7 days"],["biweekly","Bi-weekly","Every 14 days"],["monthly","Monthly","Every 30 days"],["custom","Custom","Set your own"]].map(([v,l,sub])=>(
                <button key={v} onClick={()=>setRecurForm(f=>({...f,frequency:v}))} style={{padding:"10px 8px",background:recurForm.frequency===v?"rgba(0,207,255,0.12)":"rgba(255,255,255,0.04)",border:"1px solid "+(recurForm.frequency===v?"rgba(0,207,255,0.4)":"rgba(255,255,255,0.08)"),borderRadius:9,cursor:"pointer",textAlign:"center"}}>
                  <div style={{color:recurForm.frequency===v?"var(--lq-blue)":"rgba(255,255,255,0.6)",fontSize:12,fontFamily:"monospace",fontWeight:recurForm.frequency===v?700:400}}>{l}</div>
                  <div style={{color:"rgba(255,255,255,0.25)",fontSize:9,fontFamily:"monospace",marginTop:2}}>{sub}</div>
                </button>
              ))}
            </div>
            {recurForm.frequency==="custom"&&(
              <div style={{marginTop:8,display:"flex",alignItems:"center",gap:10,background:"rgba(0,207,255,0.06)",border:"1px solid rgba(0,207,255,0.2)",borderRadius:9,padding:"10px 14px"}}>
                <span style={{color:"rgba(255,255,255,0.5)",fontSize:12,fontFamily:"monospace"}}>Every</span>
                <input
                  type="text" inputMode="numeric" pattern="[0-9]*"
                  value={recurForm.customDays||""}
                  onChange={e=>{const v=e.target.value.replace(/[^0-9]/g,'');setRecurForm(f=>({...f,customDays:v}));}}
                  onBlur={e=>{const v=parseInt(e.target.value)||7;setRecurForm(f=>({...f,customDays:v}));}}
                  style={{width:64,background:"rgba(255,255,255,0.08)",border:"1px solid rgba(0,207,255,0.3)",borderRadius:7,padding:"7px 10px",color:"var(--lq-blue)",fontSize:16,fontFamily:"monospace",fontWeight:700,outline:"none",textAlign:"center"}}
                />
                <span style={{color:"rgba(255,255,255,0.5)",fontSize:12,fontFamily:"monospace"}}>days</span>
                <span style={{color:"rgba(255,255,255,0.25)",fontSize:11,fontFamily:"monospace",marginLeft:"auto"}}>
                  ~{recurForm.customDays&&recurForm.customDays>0?Math.round(365/(recurForm.customDays||7)):0}x/yr
                </span>
              </div>
            )}
          </div>

          {/* Day of week */}
          <div>
            <div style={S.label}>Preferred Day</div>
            <div style={{display:"flex",gap:5,overflowX:"auto",paddingBottom:2}}>
              {["Sun","Mon","Tue","Wed","Thu","Fri","Sat"].map((d,i)=>(
                <button key={i} onClick={()=>setRecurForm(f=>({...f,dayOfWeek:String(i)}))} style={{flexShrink:0,width:40,padding:"8px 0",background:recurForm.dayOfWeek===String(i)?"rgba(0,207,255,0.12)":"rgba(255,255,255,0.04)",border:`1px solid ${recurForm.dayOfWeek===String(i)?"rgba(0,207,255,0.4)":"rgba(255,255,255,0.08)"}`,borderRadius:9,cursor:"pointer",color:recurForm.dayOfWeek===String(i)?"var(--lq-blue)":"rgba(255,255,255,0.5)",fontSize:11,fontFamily:"monospace",fontWeight:recurForm.dayOfWeek===String(i)?700:400}}>{d}</button>
              ))}
            </div>
          </div>

          {/* Start + End date */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            <div>
              <div style={S.label}>Start Date</div>
              <input type="date" value={recurForm.startDate} onChange={e=>setRecurForm(f=>({...f,startDate:e.target.value}))} style={{width:"100%",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"9px 10px",color:"#fff",fontSize:12,fontFamily:"monospace",outline:"none"}}/>
            </div>
            <div>
              <div style={S.label}>End Date <span style={{color:"rgba(255,255,255,0.25)",fontSize:9}}>(optional)</span></div>
              <input type="date" value={recurForm.endDate||""} min={recurForm.startDate} onChange={e=>setRecurForm(f=>({...f,endDate:e.target.value}))} style={{width:"100%",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"9px 10px",color:"#fff",fontSize:12,fontFamily:"monospace",outline:"none"}}/>
            </div>
          </div>
          {/* Duration */}
          <div>
            <div style={S.label}>Duration (min)</div>
            <input type="text" inputMode="numeric" pattern="[0-9]*" value={recurForm.duration||""} onChange={e=>{const v=e.target.value.replace(/[^0-9]/g,'');setRecurForm(f=>({...f,duration:v}));}} onBlur={e=>{const v=parseInt(e.target.value)||60;setRecurForm(f=>({...f,duration:v}));}} style={{width:"100%",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"9px 10px",color:"#fff",fontSize:12,fontFamily:"monospace",outline:"none"}}/>
          </div>

          {/* Price per visit */}
          <div>
            <div style={S.label}>Price per visit ($) <span style={{color:"rgba(255,255,255,0.25)",fontSize:9}}>(overrides template quote)</span></div>
            <input type="text" inputMode="decimal" value={recurForm.price} onChange={e=>{const v=e.target.value.replace(/[^0-9.]/g,'');setRecurForm(f=>({...f,price:v}));}} placeholder="e.g. 85" style={{width:"100%",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"9px 10px",color:"#fff",fontSize:12,fontFamily:"monospace",outline:"none"}}/>
          </div>

          {/* Services note */}
          <div>
            <div style={S.label}>Services (optional note)</div>
            <input value={recurForm.services} onChange={e=>setRecurForm(f=>({...f,services:e.target.value}))} placeholder="Mow & Edge, Fertilization…" style={{width:"100%",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"9px 10px",color:"#fff",fontSize:12,fontFamily:"monospace",outline:"none"}}/>
          </div>

          {/* Quote template picker */}
          <div>
            <div style={S.label}>Quote Template <span style={{color:"rgba(255,255,255,0.25)",fontSize:9}}>(used for invoicing)</span></div>
            {cQ.filter(q=>q.stage!=="Declined").length===0?(
              <div style={{background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:8,padding:"10px 12px",color:"rgba(255,255,255,0.3)",fontSize:12,fontFamily:"monospace"}}>
                No quotes yet — create a quote for this client first
              </div>
            ):(
              <select
                value={recurForm.templateQuoteId||""}
                onChange={e=>setRecurForm(f=>({...f,templateQuoteId:e.target.value}))}
                style={{width:"100%",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"9px 10px",color:recurForm.templateQuoteId?"#fff":"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",outline:"none"}}
              >
                <option value="">— Select a quote template —</option>
                {cQ.filter(q=>q.stage!=="Declined").map(q=>(
                  <option key={q.id} value={q.id}>
                    #{q.quoteNum} · {q.stage} · ${q.total?.toFixed(0)||"0"} · {fmtDate(q.createdAt)}
                  </option>
                ))}
              </select>
            )}
            {recurForm.templateQuoteId&&(()=>{
              const tq=cQ.find(q=>q.id===recurForm.templateQuoteId);
              return tq?(
                <div style={{marginTop:6,background:"rgba(124,252,0,0.05)",border:"1px solid rgba(124,252,0,0.15)",borderRadius:8,padding:"8px 12px"}}>
                  <div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace",marginBottom:4}}>SERVICES IN THIS QUOTE</div>
                  {(tq.services||[]).filter(s=>s.name||s.label).map((s,i)=>(
                    <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"3px 0"}}>
                      <span style={{color:"rgba(255,255,255,0.6)",fontSize:11,fontFamily:"monospace"}}>{s.name||s.label}</span>
                      <span style={{color:"#7CFC00",fontSize:11,fontFamily:"monospace"}}>${(s.price||0).toFixed(0)}</span>
                    </div>
                  ))}
                  <div style={{borderTop:"1px solid rgba(124,252,0,0.1)",marginTop:6,paddingTop:6,display:"flex",justifyContent:"space-between"}}>
                    <span style={{color:"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace"}}>TOTAL</span>
                    <span style={{color:"#7CFC00",fontSize:13,fontWeight:700,fontFamily:"monospace"}}>${tq.total?.toFixed(0)||"0"}</span>
                  </div>
                </div>
              ):null;
            })()}
          </div>

          <div style={{background:"rgba(0,207,255,0.05)",border:"1px solid rgba(0,207,255,0.15)",borderRadius:8,padding:"10px 12px",color:"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace",lineHeight:1.6}}>
            📅 {recurForm.active?"Generates jobs":"Will generate jobs"} from {fmtDate(recurForm.startDate)}{recurForm.endDate?" through "+fmtDate(recurForm.endDate):" onwards (no end date)"}
          </div>

          <button onClick={handleSaveRecurring} disabled={saving} style={{...btn(true),background:"var(--lq-blue)",color:"#000",border:"none"}}>
            {saving?"SAVING…":"SAVE RECURRING SCHEDULE"}
          </button>
        </div>
      )}

      <button onClick={()=>onNewQuote(customer)} style={{...btn(true),background:"#7CFC00",color:"#000",border:"none"}}>+ NEW QUOTE FOR {customer.name.split(" ")[0].toUpperCase()}</button>

      {/* Quote + Invoice tabs */}
      <ClientHistoryTabs cQ={cQ} invoices={invoices} onNewQuote={()=>onNewQuote(customer)} onSelectInvoice={inv=>setViewingInvoice(inv)} onSelectQuote={q=>setViewingQuote(q)} onCreateMultiInvoice={onCreateMultiInvoice} onRebook={onRebook}/>
    </div>
  );
}


// ─── Account Dropdown ─────────────────────────────────────────────────────────
function AccountDropdown({profile,session,onNavigate,onSignOut,onClose}){
  return(
    <>
      {/* Backdrop */}
      <div onClick={onClose} style={{position:"fixed",inset:0,zIndex:299}}/>
      {/* Dropdown */}
      <div style={{position:"absolute",top:"100%",right:0,marginTop:6,background:"#0a180a",border:"1px solid rgba(124,252,0,0.2)",borderRadius:12,overflow:"hidden",zIndex:300,minWidth:200,boxShadow:"0 8px 32px rgba(0,0,0,0.6)"}}>
        {/* User info */}
        <div style={{padding:"12px 16px",borderBottom:"1px solid rgba(255,255,255,0.07)"}}>
          <div style={{color:"#fff",fontSize:13,fontFamily:"monospace",fontWeight:700}}>{profile?.name||"No name"}</div>
          <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace",marginTop:2}}>{session?.user?.email}</div>
          {profile?.company&&<div style={{color:"rgba(124,252,0,0.6)",fontSize:11,fontFamily:"monospace",marginTop:2}}>{profile.company}</div>}
        </div>
        {/* Menu items */}
        {[
          {icon:"👤",label:"Profile & Company",  tab:"profile"},
          {icon:"💳",label:"Subscription",       tab:"subscription"},
          {icon:"🔑",label:"Change Password",    tab:"password"},
          {icon:"⬇",label:"Export Data",        tab:"export"}].map(item=>(
          <button key={item.tab} onClick={()=>{onNavigate(item.tab);onClose();}} style={{display:"flex",alignItems:"center",gap:10,width:"100%",padding:"11px 16px",background:"none",border:"none",color:"rgba(255,255,255,0.7)",fontSize:13,fontFamily:"monospace",cursor:"pointer",borderBottom:"1px solid rgba(255,255,255,0.05)",textAlign:"left"}}>
            <span style={{fontSize:15}}>{item.icon}</span>{item.label}
          </button>
        ))}
        <button onClick={onSignOut} style={{display:"flex",alignItems:"center",gap:10,width:"100%",padding:"11px 16px",background:"none",border:"none",color:"#ff6b6b",fontSize:13,fontFamily:"monospace",cursor:"pointer",textAlign:"left"}}>
          <span style={{fontSize:15}}>🚪</span>Sign Out
        </button>
      </div>
    </>
  );
}

// ─── Schedule ─────────────────────────────────────────────────────────────────
const DAYS_SHORT  = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
const MONTH_NAMES = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const JOB_STATUS_COLORS = {Scheduled:"#7CFC00",Completed:"#00ff99",Skipped:"#888",Rescheduled:"#ffaa00"};

function getWeekDates(anchor){
  const d=new Date(anchor+"T12:00:00");
  const day=d.getDay();
  return Array.from({length:7},(_,i)=>{
    const dt=new Date(d);dt.setDate(d.getDate()-day+i);
    return dt.toISOString().split("T")[0];
  });
}

function nearestNeighborRoute(jobs){
  if(jobs.length<=1) return jobs;
  const withCoords=jobs.filter(j=>j.lat&&j.lng);
  const noCoords=jobs.filter(j=>!j.lat||!j.lng);
  if(withCoords.length===0) return jobs;
  const dist=(a,b)=>Math.sqrt(Math.pow((a.lat-b.lat)*69,2)+Math.pow((a.lng-b.lng)*55,2));
  const route=[withCoords[0]];
  const remaining=[...withCoords.slice(1)];
  while(remaining.length>0){
    const last=route[route.length-1];
    let nearestIdx=0;
    let nearestDist=dist(last,remaining[0]);
    remaining.forEach((j,i)=>{const d2=dist(last,j);if(d2<nearestDist){nearestDist=d2;nearestIdx=i;}});
    route.push(remaining.splice(nearestIdx,1)[0]);
  }
  return [...route,...noCoords];
}


function ScheduleMap({jobs,googleReady,selDate,optimized}){
  const mapDivRef = useRef(null);
  const mapRef    = useRef(null);
  const markersRef= useRef([]);
  const infoRef   = useRef(null);

  // Geocode an address and return {lat,lng}
  const geocode = (address) => new Promise(resolve=>{
    if(!window.google?.maps) return resolve(null);
    const gc = new window.google.maps.Geocoder();
    gc.geocode({address},(results,status)=>{
      if(status==="OK"&&results[0]){
        resolve({lat:results[0].geometry.location.lat(),lng:results[0].geometry.location.lng()});
      } else resolve(null);
    });
  });

  // Init map once
  useEffect(()=>{
    if(!googleReady||mapRef.current||!mapDivRef.current) return;
    mapRef.current = new window.google.maps.Map(mapDivRef.current,{
      center:{lat:36.17,lng:-86.78}, zoom:11,
      mapTypeId:"roadmap",
      disableDefaultUI:false,
      zoomControl:true,
      streetViewControl:false,
      mapTypeControl:false,
      fullscreenControl:true,
    });
    infoRef.current = new window.google.maps.InfoWindow();
  },[googleReady]);

  // Plot markers whenever jobs or date changes
  useEffect(()=>{
    if(!mapRef.current||!window.google?.maps) return;
    // Clear old markers
    markersRef.current.forEach(m=>m.setMap(null));
    markersRef.current=[];
    if(infoRef.current) infoRef.current.close();

    const jobsWithAddr = jobs.filter(j=>j.address);
    if(jobsWithAddr.length===0) return;

    const bounds = new window.google.maps.LatLngBounds();
    let placed = 0;

    jobsWithAddr.forEach(async(job,idx)=>{
      // Use stored lat/lng if available, otherwise geocode
      let pos = job.lat&&job.lng ? {lat:parseFloat(job.lat),lng:parseFloat(job.lng)} : await geocode(job.address);
      if(!pos) return;
      bounds.extend(pos);
      placed++;

      const statusColors = {
        Scheduled:"#7CFC00", Completed:"#00ff99",
        Skipped:"#888888",   Rescheduled:"#ffaa00",
      };
      const color = statusColors[job.status]||"#7CFC00";

      // Numbered SVG pin
      const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 32 40">
        <path d="M16 0C7.16 0 0 7.16 0 16c0 10 16 24 16 24S32 26 32 16C32 7.16 24.84 0 16 0z" fill="${color}"/>
        <circle cx="16" cy="16" r="10" fill="white"/>
        <text x="16" y="21" font-family="monospace" font-size="11" font-weight="bold" fill="#000" text-anchor="middle">${idx+1}</text>
      </svg>`;

      const marker = new window.google.maps.Marker({
        position:pos, map:mapRef.current,
        icon:{url:"data:image/svg+xml;charset=UTF-8,"+encodeURIComponent(svg), scaledSize:new window.google.maps.Size(32,40), anchor:new window.google.maps.Point(16,40)},
        title:job.customerName,
        zIndex:idx+1,
      });
      markersRef.current.push(marker);

      marker.addListener("click",()=>{
        if(!infoRef.current) return;
        infoRef.current.setContent(
          "<div style='font-family:monospace;padding:6px 4px;min-width:160px'>"
          +"<div style='font-weight:700;font-size:13px;margin-bottom:3px'>"+job.customerName+"</div>"
          +"<div style='font-size:11px;color:#555;margin-bottom:3px'>"+job.address+"</div>"
          +(job.scheduledTime?"<div style='font-size:11px;color:#555'>🕐 "+job.scheduledTime+"</div>":"")
          +(job.services?"<div style='font-size:10px;color:#777;margin-top:3px'>"+(Array.isArray(job.services)?job.services.map(s=>s.label||s.name||"").filter(Boolean).join(", "):job.services)+"</div>":"")
          +"<div style='margin-top:5px;display:inline-block;padding:2px 7px;border-radius:4px;font-size:10px;font-weight:700;background:"+(job.status==="Completed"?"#d4fce8":job.status==="Skipped"?"#eee":"#d4f7d4")+";color:#333'>"+job.status+"</div>"
          +"</div>"
        );
        infoRef.current.open(mapRef.current,marker);
      });

      // Fit bounds after all markers placed
      if(placed===jobsWithAddr.length&&placed>0){
        if(placed===1) mapRef.current.setCenter(pos);
        else mapRef.current.fitBounds(bounds,{top:40,right:20,bottom:20,left:20});
      }
    });
  },[jobs,googleReady]);

  return(
    <div style={{borderRadius:12,overflow:"hidden",border:"1px solid rgba(124,252,0,0.2)",position:"relative"}}>
      <div ref={mapDivRef} style={{width:"100%",height:280}}/>
      {!googleReady&&(
        <div style={{position:"absolute",inset:0,background:"#0d1f0d",display:"flex",alignItems:"center",justifyContent:"center"}}>
          <span style={{color:"#7CFC00",fontFamily:"monospace",fontSize:12}}>LOADING MAP…</span>
        </div>
      )}
      {jobs.length===0&&googleReady&&(
        <div style={{position:"absolute",inset:0,background:"rgba(5,14,5,0.75)",display:"flex",alignItems:"center",justifyContent:"center"}}>
          <span style={{color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12}}>No jobs to show</span>
        </div>
      )}
      <div style={{position:"absolute",bottom:8,left:8,background:"rgba(0,0,0,0.7)",borderRadius:6,padding:"4px 8px",color:"#7CFC00",fontSize:10,fontFamily:"monospace",border:"1px solid rgba(124,252,0,0.2)"}}>
        {jobs.filter(j=>j.address).length} STOPS · {optimized?"OPTIMIZED":"ORIGINAL ORDER"}
      </div>
    </div>
  );
}

// ─── Job timer notifications (service-worker backed) ───────────────────────────
const TIMER_LS_KEY="lq_active_timers";
const notifyOK=()=>typeof window!=="undefined"&&"serviceWorker"in navigator&&"Notification"in window;
const fmtClock=ms=>{const d=new Date(ms);const h=((d.getHours()+11)%12)+1;const m=String(d.getMinutes()).padStart(2,"0");return h+":"+m+(d.getHours()<12?"a":"p");};
async function showTimerNotification(job,startMs){
  if(!notifyOK()||Notification.permission!=="granted") return;
  try{
    const reg=await navigator.serviceWorker.ready;
    await reg.showNotification("⏱ Timing — "+(job.customerName||"Job"),{
      body:"Started "+fmtClock(startMs)+" · tap Stop when you finish",
      tag:"timer-"+job.id,
      data:{jobId:job.id},
      requireInteraction:true,
      silent:true,
      actions:[{action:"stop",title:"⏹ Stop job"},{action:"open",title:"Open"}],
    });
  }catch(e){}
}
async function clearTimerNotification(jobId){
  if(!notifyOK()) return;
  try{
    const reg=await navigator.serviceWorker.ready;
    (await reg.getNotifications({tag:"timer-"+jobId})).forEach(n=>n.close());
  }catch(e){}
}

// ── Calendar export helpers ───────────────────────────────────────────────
// Turn a job into an Apple (.ics) or Google Calendar event. Times are written
// as "floating" local time (no timezone) so the event lands at the scheduled
// clock time on whatever device imports it.
function _calPad2(n){return String(n).padStart(2,"0");}
function _calStartEnd(job){
  const d=job.scheduledDate||todayStr();
  const t=job.scheduledTime||"08:00";
  let h=8,m=0;
  const mm=/(\d{1,2}):(\d{2})\s*(AM|PM)?/i.exec(t);
  if(mm){ h=+mm[1]; m=+mm[2]; const ap=mm[3]&&mm[3].toUpperCase(); if(ap==="PM"&&h<12)h+=12; if(ap==="AM"&&h===12)h=0; }
  const start=new Date(`${d}T${_calPad2(h)}:${_calPad2(m)}:00`);
  const durMin=Number(job.duration)>0?Number(job.duration):60;
  const end=new Date(start.getTime()+durMin*60000);
  return {start,end};
}
function _calLocal(dt){
  return dt.getFullYear()+_calPad2(dt.getMonth()+1)+_calPad2(dt.getDate())+"T"+_calPad2(dt.getHours())+_calPad2(dt.getMinutes())+"00";
}
function _calMeta(job){
  const svc=Array.isArray(job.services)?job.services.map(s=>s.label||s.name||"").filter(Boolean).join(", "):(job.services||"");
  const title=(job.customerName?job.customerName+" — ":"")+"Lawn service";
  const details=[svc&&("Services: "+svc), job.notes&&("Notes: "+job.notes)].filter(Boolean).join("\n");
  return {title,details,location:job.address||""};
}
function jobToGoogleCalUrl(job){
  const {start,end}=_calStartEnd(job);
  const {title,details,location}=_calMeta(job);
  const p=new URLSearchParams({action:"TEMPLATE",text:title,dates:_calLocal(start)+"/"+_calLocal(end),details,location});
  return "https://calendar.google.com/calendar/render?"+p.toString();
}
function downloadJobIcs(job){
  const {start,end}=_calStartEnd(job);
  const {title,details,location}=_calMeta(job);
  const esc=s=>String(s||"").replace(/([,;\\])/g,"\\$1").replace(/\r?\n/g,"\\n");
  const ics=["BEGIN:VCALENDAR","VERSION:2.0","PRODID:-//LAWN.Quote//Schedule//EN","CALSCALE:GREGORIAN","BEGIN:VEVENT",
    "UID:lawnquote-"+(job.id||Date.now())+"@lawn-quote.app","DTSTAMP:"+_calLocal(new Date()),
    "DTSTART:"+_calLocal(start),"DTEND:"+_calLocal(end),
    "SUMMARY:"+esc(title),"DESCRIPTION:"+esc(details),"LOCATION:"+esc(location),
    "END:VEVENT","END:VCALENDAR"].join("\r\n");
  const blob=new Blob([ics],{type:"text/calendar;charset=utf-8"});
  const url=URL.createObjectURL(blob);
  const a=document.createElement("a");
  a.href=url;
  a.download=((job.customerName||"job").replace(/[^a-z0-9]+/gi,"-").toLowerCase()||"job")+".ics";
  document.body.appendChild(a);
  a.click();
  setTimeout(()=>{try{document.body.removeChild(a);URL.revokeObjectURL(url);}catch(e){}},1500);
}

function ScheduleScreen({quotes,jobs,customers=[],onAddJob,onUpdateJob,onDeleteJob,onCompleteJob,googleReady}){
  // viewMode removed — week strip always visible
  const [anchorDate, setAnchorDate] = useState(todayStr());
  const [selDate,    setSelDate]    = useState(todayStr());
  const [showAdd,    setShowAdd]    = useState(false);
  const [routeMode,  setRouteMode]  = useState(false);
  const [optimized,  setOptimized]  = useState(false);
  const [showMapPicker, setShowMapPicker] = useState(false);
  const [showMap,    setShowMap]    = useState(false);
  const [liftedJob,    setLiftedJob]    = useState(null);
  const [selectedJob,  setSelectedJob]  = useState(null);
  const _draggedRef    = useRef(false);
  const longPressTimer = useRef(null);
  const [toast,      showToast]     = useToast();
  const schedMapRef  = useRef(null);
  const _schedMapDiv  = useRef(null);
  const _markersRef   = useRef([]);
  const [dragId,     setDragId]     = useState(null);
  const [dragOverId, setDragOverId] = useState(null);
  const [localJobs,  setLocalJobs]  = useState(null);
  const _touchStartY  = useRef(0);
  const _touchJobId   = useRef(null);
  // Restore running timers from localStorage so they survive reload / app-switch.
  const [activeTimers,setActiveTimers] = useState(()=>{
    try{
      const saved=JSON.parse(localStorage.getItem(TIMER_LS_KEY)||"{}");
      const out={};
      Object.keys(saved).forEach(id=>{
        const t=saved[id];
        if(t&&t.running&&t.startMs) out[id]={running:true,startMs:t.startMs,elapsed:Math.floor((Date.now()-t.startMs)/1000)};
      });
      return out;
    }catch(e){ return {}; }
  });
  const _timerRef = useRef({});

  const weekDates = getWeekDates(anchorDate);

  // Persist running timers (startMs only — elapsed is derived).
  useEffect(()=>{
    try{
      const slim={};
      Object.keys(activeTimers).forEach(id=>{ if(activeTimers[id]?.running) slim[id]={running:true,startMs:activeTimers[id].startMs}; });
      localStorage.setItem(TIMER_LS_KEY,JSON.stringify(slim));
    }catch(e){}
  },[activeTimers]);

  // Live timer tick every second
  useEffect(()=>{
    const interval = setInterval(()=>{
      setActiveTimers(prev=>{
        const updated={...prev};
        let changed=false;
        Object.keys(updated).forEach(id=>{
          if(updated[id].running){
            updated[id]={...updated[id],elapsed:Math.floor((Date.now()-updated[id].startMs)/1000)};
            changed=true;
          }
        });
        return changed?updated:prev;
      });
    },1000);
    return()=>clearInterval(interval);
  },[]);

  // Refresh the notification label periodically + when returning to foreground.
  useEffect(()=>{
    const refresh=()=>{ Object.keys(activeTimers).forEach(id=>{ if(activeTimers[id]?.running){ const job=jobs.find(j=>j.id===id); if(job) showTimerNotification(job,activeTimers[id].startMs); } }); };
    const iv=setInterval(refresh,60000);
    document.addEventListener("visibilitychange",refresh);
    return()=>{clearInterval(iv);document.removeEventListener("visibilitychange",refresh);};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[activeTimers,jobs]);

  const startTimer = async(job) => {
    const jobId=typeof job==="string"?job:job.id;
    const jobObj=typeof job==="string"?(jobs.find(j=>j.id===job)||{id:job}):job;
    const startMs=Date.now();
    setActiveTimers(prev=>({...prev,[jobId]:{running:true,startMs,elapsed:0}}));
    if(notifyOK()){
      try{
        let perm=Notification.permission;
        if(perm==="default") perm=await Notification.requestPermission();
        if(perm==="granted") showTimerNotification(jobObj,startMs);
      }catch(e){}
    }
  };

  const stopTimer = async(job) => {
    const t = activeTimers[job.id];
    if(!t) return;
    const mins = Math.max(1, Math.round(t.elapsed/60));
    setActiveTimers(prev=>{const n={...prev};delete n[job.id];return n;});
    clearTimerNotification(job.id);
    await onCompleteJob({...job, actualDuration:mins});
    showToast("Job done — "+mins+" min logged");
  };

  // Stop button tapped inside the system notification → finish the job here.
  useEffect(()=>{
    if(!("serviceWorker"in navigator)) return;
    const handler=e=>{
      const{type,jobId}=e.data||{};
      if(type==="timer-stop"){ const job=jobs.find(j=>j.id===jobId); if(job) stopTimer(job); }
    };
    navigator.serviceWorker.addEventListener("message",handler);
    return()=>navigator.serviceWorker.removeEventListener("message",handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[jobs,activeTimers]);

  // Stop requested while app was closed (?stopJob=) — apply once jobs load.
  useEffect(()=>{
    const sj=new URLSearchParams(window.location.search).get("stopJob");
    if(!sj) return;
    const job=jobs.find(j=>j.id===sj);
    if(job&&activeTimers[sj]){ stopTimer(job); const u=new URL(window.location.href); u.searchParams.delete("stopJob"); window.history.replaceState({},"",u); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[jobs]);

  const fmtElapsed = (secs) => {
    const h=Math.floor(secs/3600);
    const m=Math.floor((secs%3600)/60);
    const s=secs%60;
    if(h>0) return h+"h "+String(m).padStart(2,"0")+"m";
    return String(m).padStart(2,"0")+":"+String(s).padStart(2,"0");
  };

  // Merge accepted quotes + manual jobs for a date
  const getJobsForDate = (date) => {
    // Only show manually scheduled jobs — no auto-population from quotes
    // to prevent duplicates when the same job is added manually
    return jobs
      .filter(j=>j.scheduledDate===date)
      .sort((a,b)=>(a.scheduledTime||"23:59").localeCompare(b.scheduledTime||"23:59"));
  };

  const selJobs      = getJobsForDate(selDate);
  const routeJobs    = optimized ? nearestNeighborRoute(selJobs) : selJobs;
  const jobCountForDate = (d) => getJobsForDate(d).length;

  const openInMaps = (app) => {
    const waypoints = routeJobs.filter(j=>j.address);
    if(waypoints.length===0) return;
    if(app==='google'){
      const parts=waypoints.map(j=>encodeURIComponent(j.address)).join('/');
      window.open(`https://www.google.com/maps/dir/${parts}`);
    } else {
      if(waypoints.length===1){
        window.open(`https://maps.apple.com/?q=${encodeURIComponent(waypoints[0].address)}`);
      } else {
        const origin=encodeURIComponent(waypoints[0].address);
        const dest=encodeURIComponent(waypoints[waypoints.length-1].address);
        const stops=waypoints.slice(1,-1).map(j=>encodeURIComponent(j.address)).join('&saddr=');
        window.open(`https://maps.apple.com/?saddr=${origin}${stops?'&saddr='+stops:''}&daddr=${dest}&dirflg=d`);
      }
    }
    setShowMapPicker(false);
  };

  const prevWeek=()=>{const d=new Date(anchorDate+"T12:00:00");d.setDate(d.getDate()-7);setAnchorDate(d.toISOString().split("T")[0]);};
  const nextWeek=()=>{const d=new Date(anchorDate+"T12:00:00");d.setDate(d.getDate()+7);setAnchorDate(d.toISOString().split("T")[0]);};

  const selDateObj = new Date(selDate+"T12:00:00");
  const selLabel   = DAYS_SHORT[selDateObj.getDay()]+", "+MONTH_NAMES[selDateObj.getMonth()]+" "+selDateObj.getDate();

  return(
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      {toast&&<Toast message={toast.message} type={toast.type||"success"}/>}

      {/* Header */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
        <div><p style={S.label}>Schedule</p><h2 style={S.heading}>My Schedule</h2></div>
        <div style={{display:"flex",gap:6,marginTop:4}}>
          <button onClick={()=>setShowMap(m=>!m)} style={{background:showMap?"rgba(124,252,0,0.12)":"rgba(255,255,255,0.05)",border:"1px solid "+(showMap?"rgba(124,252,0,0.3)":"rgba(255,255,255,0.1)"),borderRadius:9,padding:"8px 11px",color:showMap?"#7CFC00":"rgba(255,255,255,0.5)",fontSize:11,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>🗺 MAP</button>
          <button onClick={()=>setRouteMode(r=>!r)} style={{background:routeMode?"rgba(0,207,255,0.12)":"rgba(255,255,255,0.05)",border:`1px solid ${routeMode?"rgba(0,207,255,0.3)":"rgba(255,255,255,0.1)"}`,borderRadius:9,padding:"8px 11px",color:routeMode?"var(--lq-blue)":"rgba(255,255,255,0.5)",fontSize:11,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>📋 ROUTE</button>
          <button onClick={()=>setShowAdd(true)} style={{background:"#7CFC00",color:"#000",border:"none",borderRadius:9,padding:"8px 11px",fontSize:11,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>+ ADD JOB</button>
        </div>
      </div>

      {/* Week strip — always visible */}
      <div style={{display:"flex",flexDirection:"column",gap:8}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <button onClick={prevWeek} style={{background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"6px 10px",color:"rgba(255,255,255,0.5)",fontSize:13,cursor:"pointer"}}>‹</button>
          <span style={{color:"rgba(255,255,255,0.5)",fontFamily:"monospace",fontSize:12}}>{MONTH_NAMES[new Date(weekDates[0]+"T12:00:00").getMonth()]} {new Date(weekDates[0]+"T12:00:00").getFullYear()}</span>
          <button onClick={nextWeek} style={{background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"6px 10px",color:"rgba(255,255,255,0.5)",fontSize:13,cursor:"pointer"}}>›</button>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:4}}>
          {weekDates.map(d=>{
            const isToday=d===todayStr();
            const isSel=d===selDate;
            const count=jobCountForDate(d);
            const dayObj=new Date(d+"T12:00:00");
            return(
              <button key={d}
                onClick={()=>{
                  if(liftedJob){
                    // Drop the lifted job on this day
                    onUpdateJob(liftedJob.id,{scheduledDate:d,status:"Scheduled"});
                    showToast("Moved to "+fmtDate(d));
                    setLiftedJob(null);
                    setSelDate(d);
                    setAnchorDate(d);
                  } else {
                    setSelDate(d);
                  }
                }}
                style={{
                  background: liftedJob ? (isSel?"#ffaa00":"rgba(255,170,0,0.15)") : isSel?"#7CFC00":isToday?"rgba(124,252,0,0.1)":"rgba(255,255,255,0.04)",
                  border:`1px solid ${liftedJob?"rgba(255,170,0,0.5)":isSel?"#7CFC00":isToday?"rgba(124,252,0,0.3)":"rgba(255,255,255,0.08)"}`,
                  borderRadius:10,padding:"10px 4px",cursor:liftedJob?"copy":"pointer",
                  display:"flex",flexDirection:"column",alignItems:"center",gap:3,
                  transition:"all 0.15s",
                  transform:liftedJob&&!isSel?"scale(1.05)":"scale(1)",
                }}>
                <span style={{fontSize:9,fontFamily:"monospace",color:liftedJob?"#ffaa00":isSel?"#000":isToday?"#7CFC00":"rgba(255,255,255,0.4)",fontWeight:700}}>{DAYS_SHORT[dayObj.getDay()].toUpperCase()}</span>
                <span style={{fontSize:15,fontWeight:700,color:liftedJob&&!isSel?"#ffaa00":isSel?"#000":"#fff"}}>{dayObj.getDate()}</span>
                {liftedJob&&<div style={{width:18,height:18,borderRadius:"50%",background:"rgba(255,170,0,0.3)",display:"flex",alignItems:"center",justifyContent:"center"}}><span style={{fontSize:12,color:"#ffaa00"}}>↓</span></div>}
                {!liftedJob&&count>0&&<div style={{width:18,height:18,borderRadius:"50%",background:isSel?"rgba(0,0,0,0.2)":"rgba(124,252,0,0.15)",display:"flex",alignItems:"center",justifyContent:"center"}}><span style={{fontSize:9,color:isSel?"#000":"#7CFC00",fontFamily:"monospace",fontWeight:700}}>{count}</span></div>}
              </button>
            );
          })}
        </div>
      </div>

      {/* Lifted job banner */}
      {liftedJob&&(
        <div style={{background:"rgba(255,170,0,0.1)",border:"1px solid rgba(255,170,0,0.35)",borderRadius:10,padding:"10px 14px",display:"flex",alignItems:"center",gap:10,animation:"pulse 1s ease infinite"}}>
          <span style={{fontSize:16}}>✋</span>
          <div style={{flex:1}}>
            <div style={{color:"#ffaa00",fontSize:12,fontFamily:"monospace",fontWeight:700}}>{liftedJob.customerName} — tap a day above to move</div>
            <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace",marginTop:1}}>Currently {fmtDate(liftedJob.scheduledDate)}</div>
          </div>
          <button onClick={()=>setLiftedJob(null)} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",cursor:"pointer",fontSize:16}}>✕</button>
        </div>
      )}

      {/* Selected day header */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <div style={{color:"#fff",fontSize:15,fontFamily:"monospace",fontWeight:700}}>{selLabel}</div>
          <div style={{color:"rgba(255,255,255,0.35)",fontSize:12,fontFamily:"monospace"}}>{selJobs.length} job{selJobs.length!==1?"s":""} scheduled</div>
        </div>
        <div style={{display:"flex",gap:6}}>
          <button onClick={()=>{const d=new Date(selDate+"T12:00:00");d.setDate(d.getDate()-1);const nd=d.toISOString().split("T")[0];setSelDate(nd);if(!weekDates.includes(nd))setAnchorDate(nd);}} style={{background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"6px 10px",color:"rgba(255,255,255,0.5)",fontSize:13,cursor:"pointer"}}>‹</button>
          <button onClick={()=>{const d=new Date(selDate+"T12:00:00");d.setDate(d.getDate()+1);const nd=d.toISOString().split("T")[0];setSelDate(nd);if(!weekDates.includes(nd))setAnchorDate(nd);}} style={{background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"6px 10px",color:"rgba(255,255,255,0.5)",fontSize:13,cursor:"pointer"}}>›</button>
        </div>
      </div>

      {/* Job Map */}
      {showMap&&(
        <ScheduleMap
          jobs={routeMode?routeJobs:selJobs}
          googleReady={googleReady}
          selDate={selDate}
          optimized={optimized}
        />
      )}

      {/* Route controls */}
      {routeMode&&selJobs.length>0&&(
        <div style={{background:"rgba(0,207,255,0.06)",border:"1px solid rgba(0,207,255,0.2)",borderRadius:12,padding:"12px 14px",display:"flex",gap:10,alignItems:"center"}}>
          <div style={{flex:1}}>
            <div style={{color:"var(--lq-blue)",fontSize:12,fontFamily:"monospace",fontWeight:700}}>ROUTE MODE</div>
            <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace",marginTop:2}}>{routeJobs.length} stops · {optimized?"optimized by proximity":"original order"}</div>
          </div>
          <button onClick={()=>setOptimized(o=>!o)} style={{background:optimized?"rgba(0,207,255,0.15)":"rgba(255,255,255,0.06)",border:`1px solid ${optimized?"rgba(0,207,255,0.4)":"rgba(255,255,255,0.12)"}`,borderRadius:8,padding:"7px 11px",color:optimized?"var(--lq-blue)":"rgba(255,255,255,0.5)",fontSize:11,fontFamily:"monospace",fontWeight:700,cursor:"pointer",whiteSpace:"nowrap"}}>
            ⚡ {optimized?"OPTIMIZED":"OPTIMIZE"}
          </button>
          <button onClick={()=>setShowMapPicker(true)} style={{background:"#7CFC00",color:"#000",border:"none",borderRadius:8,padding:"7px 11px",fontSize:11,fontFamily:"monospace",fontWeight:700,cursor:"pointer",whiteSpace:"nowrap"}}>🗺 OPEN</button>
        </div>
      )}

      {/* Map app picker */}
      {showMapPicker&&(
        <div onClick={()=>setShowMapPicker(false)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:500,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
          <div onClick={e=>e.stopPropagation()} style={{background:"#0d1f0d",border:"1px solid rgba(124,252,0,0.2)",borderRadius:"16px 16px 0 0",padding:"20px 20px 36px",width:"100%",maxWidth:430,animation:"fadeUp 0.2s ease"}}>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:10,fontFamily:"monospace",letterSpacing:"0.1em",marginBottom:16,textAlign:"center"}}>OPEN ROUTE IN</div>
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              <button onClick={()=>openInMaps('google')} style={{display:"flex",alignItems:"center",gap:14,background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:12,padding:"14px 16px",cursor:"pointer",width:"100%"}}>
                <span style={{fontSize:24}}>🗺</span>
                <div style={{textAlign:"left"}}>
                  <div style={{color:"#fff",fontFamily:"monospace",fontSize:14,fontWeight:700}}>Google Maps</div>
                  <div style={{color:"rgba(255,255,255,0.35)",fontFamily:"monospace",fontSize:11,marginTop:2}}>Works on iPhone & Android</div>
                </div>
              </button>
              <button onClick={()=>openInMaps('apple')} style={{display:"flex",alignItems:"center",gap:14,background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:12,padding:"14px 16px",cursor:"pointer",width:"100%"}}>
                <span style={{fontSize:24}}>🍎</span>
                <div style={{textAlign:"left"}}>
                  <div style={{color:"#fff",fontFamily:"monospace",fontSize:14,fontWeight:700}}>Apple Maps</div>
                  <div style={{color:"rgba(255,255,255,0.35)",fontFamily:"monospace",fontSize:11,marginTop:2}}>iPhone only</div>
                </div>
              </button>
            </div>
            <button onClick={()=>setShowMapPicker(false)} style={{width:"100%",marginTop:14,background:"none",border:"1px solid rgba(255,255,255,0.1)",borderRadius:10,padding:"12px",color:"rgba(255,255,255,0.4)",fontSize:13,fontFamily:"monospace",cursor:"pointer"}}>Cancel</button>
          </div>
        </div>
      )}

      {/* Job list */}
      {selJobs.length===0?(
        <div style={{...S.card,textAlign:"center",padding:"32px 16px"}}>
          <div style={{fontSize:28,marginBottom:8}}>📅</div>
          <div style={{color:"rgba(255,255,255,0.35)",fontFamily:"monospace",fontSize:12}}>No jobs scheduled for {selLabel}</div>
          <button onClick={()=>setShowAdd(true)} style={{marginTop:12,background:"rgba(124,252,0,0.1)",border:"1px solid rgba(124,252,0,0.25)",borderRadius:10,padding:"10px 18px",color:"#7CFC00",fontSize:12,fontFamily:"monospace",cursor:"pointer"}}>+ ADD JOB</button>
        </div>
      ):(
        <>
        {dragId&&<div style={{color:"rgba(255,255,255,0.3)",fontSize:11,fontFamily:"monospace",textAlign:"center",marginBottom:4}}>☰ Drag to reorder</div>}
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {(localJobs||(routeMode?routeJobs:selJobs)).map((job,idx)=>{
            const isDragging  = dragId===job.id;
            const isDragOver  = dragOverId===job.id;
            const sc=JOB_STATUS_COLORS[job.status]||"#888";
            return(
              <div key={job.id} className="lqr-jobcard"
                onTouchStart={e=>{
                  if(routeMode) return;
                  longPressTimer.current=setTimeout(()=>{
                    setLiftedJob(job);
                    // Haptic feedback on iOS
                    if(navigator.vibrate) navigator.vibrate(40);
                  },500);
                }}
                onTouchEnd={()=>clearTimeout(longPressTimer.current)}
                onTouchMove={()=>clearTimeout(longPressTimer.current)}
                onMouseDown={e=>{
                  if(routeMode) return;
                  longPressTimer.current=setTimeout(()=>setLiftedJob(job),600);
                }}
                onMouseUp={()=>clearTimeout(longPressTimer.current)}
                onMouseLeave={()=>clearTimeout(longPressTimer.current)}
                draggable={!routeMode}
                onClick={()=>{ if(_draggedRef.current){_draggedRef.current=false;return;} if(liftedJob){setLiftedJob(null);return;} setSelectedJob(job); }}
                onDragStart={()=>{_draggedRef.current=true;setDragId(job.id);}}
                onDragEnd={async()=>{
                  if(localJobs){
                    // Save new order as scheduledTime offsets
                    const base=new Date(selDate+"T08:00:00");
                    await Promise.all(localJobs.map((j,i)=>{
                      const t=new Date(base.getTime()+i*60*60*1000);
                      const hh=String(t.getHours()).padStart(2,"0");
                      const mm=String(t.getMinutes()).padStart(2,"0");
                      return onUpdateJob(j.id,{scheduledTime:hh+":"+mm});
                    }));
                  }
                  setDragId(null);setDragOverId(null);setLocalJobs(null);
                }}
                onDragOver={e=>{e.preventDefault();if(dragId&&dragId!==job.id){
                  setDragOverId(job.id);
                  setLocalJobs(prev=>{
                    const list=[...(prev||(routeMode?routeJobs:selJobs))];
                    const fromIdx=list.findIndex(j=>j.id===dragId);
                    const toIdx=list.findIndex(j=>j.id===job.id);
                    if(fromIdx<0||toIdx<0) return prev;
                    const [moved]=list.splice(fromIdx,1);
                    list.splice(toIdx,0,moved);
                    return list;
                  });
                }}}
                onDragLeave={()=>setDragOverId(null)}
                style={{...S.card,
                  borderColor:liftedJob?.id===job.id?"rgba(255,170,0,0.6)":isDragOver?"rgba(124,252,0,0.5)":job.status==="Completed"?"rgba(0,255,153,0.2)":job.status==="Skipped"?"rgba(136,136,136,0.2)":"rgba(255,255,255,0.08)",
                  opacity:isDragging?0.4:1,
                  transform:liftedJob?.id===job.id?"scale(1.02) translateY(-2px)":isDragOver?"scale(1.01)":"scale(1)",
                  background:liftedJob?.id===job.id?"rgba(255,170,0,0.08)":undefined,
                  boxShadow:liftedJob?.id===job.id?"0 8px 24px rgba(255,170,0,0.2)":undefined,
                  transition:"all 0.2s",
                  cursor:routeMode?"default":liftedJob?.id===job.id?"grabbing":"grab",
                }}>
                <div style={{display:"flex",gap:10,alignItems:"flex-start"}}>
                  {!routeMode&&<div style={{display:"flex",flexDirection:"column",gap:2,justifyContent:"center",paddingTop:2,flexShrink:0,cursor:"grab",opacity:0.3}}>
                    <div style={{width:16,height:2,background:"#fff",borderRadius:1}}/>
                    <div style={{width:16,height:2,background:"#fff",borderRadius:1}}/>
                    <div style={{width:16,height:2,background:"#fff",borderRadius:1}}/>
                  </div>}
                  {routeMode&&<div style={{width:24,height:24,borderRadius:"50%",background:"rgba(0,207,255,0.15)",border:"1px solid rgba(0,207,255,0.3)",display:"flex",alignItems:"center",justifyContent:"center",color:"var(--lq-blue)",fontSize:11,fontFamily:"monospace",fontWeight:700,flexShrink:0}}>{idx+1}</div>}
                  <div style={{flex:1}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                      <div>
                        <div style={{color:"#fff",fontSize:14,fontFamily:"monospace",fontWeight:700}}>{job.customerName}</div>
                        <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace",marginTop:2}}>📍 {job.address}</div>
                        {job.scheduledTime&&<div style={{color:"rgba(255,255,255,0.3)",fontSize:11,fontFamily:"monospace",marginTop:1}}>🕐 {job.scheduledTime}</div>}
                        {job.services&&<div style={{color:"rgba(124,252,0,0.6)",fontSize:11,fontFamily:"monospace",marginTop:2}}>{Array.isArray(job.services)?job.services.map(s=>s.label||s.name||"").filter(Boolean).join(", "):job.services}</div>}
                      </div>
                      <span style={{background:`${sc}18`,border:`1px solid ${sc}44`,borderRadius:6,padding:"2px 7px",color:sc,fontSize:10,fontFamily:"monospace",whiteSpace:"nowrap",marginLeft:8}}>{job.status}</span>
                    </div>
                    {/* Timer display */}
                    {activeTimers[job.id]?.running&&(
                      <div style={{display:"flex",alignItems:"center",gap:8,marginTop:8,background:"rgba(124,252,0,0.08)",border:"1px solid rgba(124,252,0,0.25)",borderRadius:8,padding:"8px 12px"}}>
                        <div style={{width:8,height:8,borderRadius:"50%",background:"#7CFC00",boxShadow:"0 0 6px #7CFC00",animation:"pulse 1s ease infinite",flexShrink:0}}/>
                        <span style={{color:"#7CFC00",fontSize:18,fontFamily:"monospace",fontWeight:700,letterSpacing:"0.05em"}}>{fmtElapsed(activeTimers[job.id].elapsed)}</span>
                        <span style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontFamily:"monospace"}}>ON SITE</span>
                      </div>
                    )}

                    {/* Tap-to-open actions hint */}
                    <div style={{color:"rgba(255,255,255,0.25)",fontSize:10,fontFamily:"monospace",marginTop:8,textAlign:"right"}}>Tap for actions ›</div>

                  </div>
                </div>
              </div>
            );
          })}
        </div>
        </>
      )}

      {/* Add job modal */}
      {showAdd&&<AddJobModal selDate={selDate} customers={customers} quotes={quotes} onSave={async job=>{await onAddJob(job);setShowAdd(false);showToast("Job added");}} onClose={()=>setShowAdd(false)}/>}

      {/* Job actions modal */}
      {selectedJob&&(()=>{
        const job=jobs.find(j=>j.id===selectedJob.id)||selectedJob;
        const sc=JOB_STATUS_COLORS[job.status]||"#888";
        const running=activeTimers[job.id]?.running;
        const close=()=>setSelectedJob(null);
        const aStyle=(c,bg,bd)=>({display:"flex",alignItems:"center",gap:10,width:"100%",background:bg,border:"1px solid "+bd,borderRadius:11,padding:"14px 16px",color:c,fontSize:14,fontFamily:"monospace",fontWeight:700,cursor:"pointer",textDecoration:"none",boxSizing:"border-box"});
        return(
          <div onClick={close} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",backdropFilter:"blur(3px)",zIndex:1000,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
            <div onClick={e=>e.stopPropagation()} style={{width:"100%",maxWidth:480,background:"var(--lq-card,#15171a)",borderTopLeftRadius:20,borderTopRightRadius:20,border:"1px solid rgba(255,255,255,0.1)",borderBottom:"none",padding:"18px 18px calc(18px + env(safe-area-inset-bottom))",maxHeight:"85vh",overflowY:"auto"}}>
              <div style={{width:38,height:4,borderRadius:2,background:"rgba(255,255,255,0.2)",margin:"0 auto 16px"}}/>
              {/* Header */}
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:4}}>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{color:"#fff",fontSize:18,fontFamily:"monospace",fontWeight:700}}>{job.customerName}</div>
                  {job.address&&<div style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",marginTop:3}}>📍 {job.address}</div>}
                  {job.scheduledTime&&<div style={{color:"rgba(255,255,255,0.35)",fontSize:12,fontFamily:"monospace",marginTop:2}}>🕐 {job.scheduledTime}</div>}
                </div>
                <span style={{background:`${sc}18`,border:`1px solid ${sc}44`,borderRadius:6,padding:"3px 9px",color:sc,fontSize:11,fontFamily:"monospace",whiteSpace:"nowrap",marginLeft:8}}>{job.status}</span>
              </div>
              {running&&(
                <div style={{display:"flex",alignItems:"center",gap:8,margin:"14px 0 4px",background:"rgba(124,252,0,0.08)",border:"1px solid rgba(124,252,0,0.25)",borderRadius:10,padding:"10px 14px"}}>
                  <div style={{width:9,height:9,borderRadius:"50%",background:"#7CFC00",boxShadow:"0 0 6px #7CFC00",animation:"pulse 1s ease infinite",flexShrink:0}}/>
                  <span style={{color:"#7CFC00",fontSize:22,fontFamily:"monospace",fontWeight:700,letterSpacing:"0.05em"}}>{fmtElapsed(activeTimers[job.id].elapsed)}</span>
                  <span style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace"}}>ON SITE</span>
                </div>
              )}
              {/* Actions */}
              <div style={{display:"flex",flexDirection:"column",gap:9,marginTop:16}}>
                {job.status==="Completed"?(
                  <button onClick={()=>{onUpdateJob(job.id,{status:"Scheduled"});close();}} style={aStyle("#ffaa00","rgba(255,170,0,0.1)","rgba(255,170,0,0.3)")}>↩ Reopen job</button>
                ):running?(
                  <button onClick={()=>{stopTimer(job);close();}} style={aStyle("#00ff99","rgba(0,255,153,0.15)","rgba(0,255,153,0.5)")}>⏹ Stop &amp; complete</button>
                ):(
                  <>
                    <button onClick={()=>{startTimer(job);close();}} style={aStyle("#7CFC00","rgba(124,252,0,0.12)","rgba(124,252,0,0.4)")}>▶ Start job</button>
                    <button onClick={()=>{onCompleteJob(job);close();}} style={aStyle("#00ff99","rgba(0,255,153,0.08)","rgba(0,255,153,0.25)")}>✓ Mark done</button>
                    {job.status!=="Skipped"
                      ?<button onClick={()=>{onUpdateJob(job.id,{status:"Skipped"});close();}} style={aStyle("#aaa","rgba(136,136,136,0.1)","rgba(136,136,136,0.25)")}>✗ Skip job</button>
                      :<button onClick={()=>{onUpdateJob(job.id,{status:"Scheduled"});close();}} style={aStyle("#7CFC00","rgba(124,252,0,0.08)","rgba(124,252,0,0.25)")}>↩ Unskip</button>
                    }
                  </>
                )}
                {job.address&&<a href={"https://maps.apple.com/?q="+encodeURIComponent(job.address)} target="_blank" rel="noreferrer" style={aStyle("var(--lq-blue)","rgba(0,207,255,0.08)","rgba(0,207,255,0.25)")}>🗺 Directions</a>}
                <button onClick={()=>{downloadJobIcs(job);showToast("Opening Apple Calendar…");}} style={aStyle("#fff","rgba(255,255,255,0.06)","rgba(255,255,255,0.15)")}>📅 Add to Apple Calendar</button>
                <a href={jobToGoogleCalUrl(job)} target="_blank" rel="noreferrer" style={aStyle("#8ab4f8","rgba(138,180,248,0.1)","rgba(138,180,248,0.3)")}>📅 Add to Google Calendar</a>
                <button onClick={()=>{if(window.confirm("Delete this job?")){onDeleteJob(job.id);close();}}} style={aStyle("#ff6b6b","rgba(255,68,68,0.08)","rgba(255,68,68,0.2)")}>🗑 Delete job</button>
                <button onClick={close} style={aStyle("rgba(255,255,255,0.6)","rgba(255,255,255,0.05)","rgba(255,255,255,0.12)")}>Close</button>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
}

function AddJobModal({selDate,onSave,onClose,customers=[],quotes=[]}){
  const [search,   setSearch]   = useState("");
  const [selCust,  setSelCust]  = useState(null);
  const [selQuote, setSelQuote] = useState(null);
  const [date,     setDate]     = useState(selDate);
  const [time,     setTime]     = useState("08:00");
  const [dur,      setDur]      = useState(60);
  const [notes,    setNotes]    = useState("");
  const [saving,   setSaving]   = useState(false);
  const [showList, setShowList] = useState(false);

  const filtered = search.trim().length>0
    ? customers.filter(c=>
        c.name.toLowerCase().includes(search.toLowerCase()) ||
        (c.phone||"").includes(search) ||
        (c.address||"").toLowerCase().includes(search.toLowerCase())
      ).slice(0,6)
    : [];

  const clientQuotes = selCust
    ? quotes.filter(q=>q.customerId===selCust.id&&(q.stage==="Accepted"||q.stage==="Quoted"||q.stage==="Scheduled"))
    : [];

  const selectClient = (c) => {
    setSelCust(c);
    setSelQuote(null);
    setSearch(c.name);
    setShowList(false);
  };

  const clearClient = () => {
    setSelCust(null);
    setSelQuote(null);
    setSearch("");
    setShowList(false);
  };

  const selectQuote = (q) => {
    setSelQuote(q);
    // Pre-fill duration and notes from quote
    if(q.services&&q.services.length>0){
      setNotes(q.services.slice(0,3).map(s=>s.label).join(", "));
    }
  };

  const valid = (selCust||search.trim())&&(selCust?.address||search.trim());

  const handle = async() => {
    if(!valid) return;
    setSaving(true);
    await onSave({
      id:           genId(),
      customerId:   selCust?.id||null,
      quoteId:      selQuote?.id||null,
      customerName: selCust?.name||search.trim(),
      address:      selCust?.address||"",
      scheduledDate:date,
      scheduledTime:time,
      duration:     dur,
      notes,
      status:       "Scheduled",
      lat:null, lng:null,
      services:     selQuote?(selQuote.services||[]).slice(0,3).map(s=>s.label).join(", "):"",
    });
    setSaving(false);
  };

  const inp={background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"10px 12px",color:"#fff",fontSize:13,fontFamily:"monospace",outline:"none",width:"100%"};

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",zIndex:500,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
      <div style={{background:"#0a180a",border:"1px solid rgba(124,252,0,0.2)",borderRadius:"16px 16px 0 0",padding:"24px 20px 40px",width:"100%",maxWidth:430,animation:"fadeUp 0.25s ease"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
          <div style={{color:"#fff",fontSize:15,fontFamily:"monospace",fontWeight:700}}>Add Job</div>
          <button onClick={onClose} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",cursor:"pointer",fontSize:18}}>✕</button>
        </div>

        <div style={{display:"flex",flexDirection:"column",gap:12}}>

          {/* Client search */}
          <div style={{position:"relative"}}>
            <div style={S.label}>Client *</div>
            {selCust?(
              <div style={{display:"flex",alignItems:"center",gap:10,background:"rgba(124,252,0,0.07)",border:"1px solid rgba(124,252,0,0.25)",borderRadius:10,padding:"10px 13px"}}>
                <div style={{width:28,height:28,borderRadius:"50%",background:"rgba(124,252,0,0.15)",display:"flex",alignItems:"center",justifyContent:"center",color:"#7CFC00",fontSize:13,fontWeight:700,flexShrink:0}}>{selCust.name.charAt(0)}</div>
                <div style={{flex:1}}>
                  <div style={{color:"#fff",fontSize:13,fontFamily:"monospace",fontWeight:700}}>{selCust.name}</div>
                  {selCust.address&&<div style={{color:"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace",marginTop:1}}>📍 {selCust.address}</div>}
                  {selCust.phone&&<div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace"}}>{selCust.phone}</div>}
                </div>
                <button onClick={clearClient} style={{background:"none",border:"none",color:"rgba(255,255,255,0.3)",cursor:"pointer",fontSize:16}}>✕</button>
              </div>
            ):(
              <div>
                <div style={{position:"relative"}}>
                  <span style={{position:"absolute",left:12,top:"50%",transform:"translateY(-50%)",color:"rgba(255,255,255,0.3)",fontSize:14}}>🔍</span>
                  <input
                    value={search}
                    onChange={e=>{setSearch(e.target.value);setShowList(true);}}
                    onFocus={()=>setShowList(true)}
                    placeholder="Search clients by name, phone…"
                    style={{...inp,paddingLeft:36}}
                  />
                </div>
                {/* Dropdown results */}
                {showList&&filtered.length>0&&(
                  <div style={{position:"absolute",left:0,right:0,background:"#0a180a",border:"1px solid rgba(124,252,0,0.2)",borderRadius:10,marginTop:4,zIndex:100,overflow:"hidden",boxShadow:"0 8px 24px rgba(0,0,0,0.5)"}}>
                    {filtered.map(c=>(
                      <button key={c.id} onClick={()=>selectClient(c)} style={{display:"flex",alignItems:"center",gap:10,width:"100%",padding:"11px 14px",background:"none",border:"none",borderBottom:"1px solid rgba(255,255,255,0.05)",cursor:"pointer",textAlign:"left"}}>
                        <div style={{width:28,height:28,borderRadius:"50%",background:"rgba(124,252,0,0.12)",display:"flex",alignItems:"center",justifyContent:"center",color:"#7CFC00",fontSize:12,fontWeight:700,flexShrink:0}}>{c.name.charAt(0)}</div>
                        <div style={{flex:1}}>
                          <div style={{color:"#fff",fontSize:13,fontFamily:"monospace"}}>{c.name}</div>
                          <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace"}}>{[c.phone,c.address].filter(Boolean).join(" · ").slice(0,45)}</div>
                        </div>
                      </button>
                    ))}
                  </div>
                )}
                {showList&&search.trim()&&filtered.length===0&&(
                  <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:10,padding:"12px 14px",marginTop:4,color:"rgba(255,255,255,0.35)",fontSize:12,fontFamily:"monospace"}}>
                    No clients found — add them in the Clients tab first
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Quote selector — shows after client is picked */}
          {selCust&&(
            <div>
              <div style={S.label}>Quote (optional)</div>
              {clientQuotes.length===0?(
                <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.07)",borderRadius:8,padding:"10px 12px",color:"rgba(255,255,255,0.25)",fontSize:12,fontFamily:"monospace"}}>
                  No accepted quotes for this client
                </div>
              ):(
                <div style={{display:"flex",flexDirection:"column",gap:6}}>
                  {/* None option */}
                  <button onClick={()=>setSelQuote(null)} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 12px",background:!selQuote?"rgba(255,255,255,0.06)":"rgba(255,255,255,0.03)",border:"1px solid "+(!selQuote?"rgba(255,255,255,0.15)":"rgba(255,255,255,0.07)"),borderRadius:9,cursor:"pointer",textAlign:"left"}}>
                    <div style={{width:16,height:16,borderRadius:"50%",border:"2px solid "+(!selQuote?"#fff":"rgba(255,255,255,0.2)"),background:!selQuote?"#fff":"none",flexShrink:0}}/>
                    <span style={{color:"rgba(255,255,255,0.5)",fontSize:12,fontFamily:"monospace"}}>No specific quote</span>
                  </button>
                  {clientQuotes.map(q=>{
                    const isSel=selQuote?.id===q.id;
                    return(
                      <button key={q.id} onClick={()=>selectQuote(q)} style={{display:"flex",alignItems:"center",gap:10,padding:"11px 12px",background:isSel?"rgba(124,252,0,0.08)":"rgba(255,255,255,0.03)",border:"1px solid "+(isSel?"rgba(124,252,0,0.35)":"rgba(255,255,255,0.07)"),borderRadius:9,cursor:"pointer",textAlign:"left",width:"100%"}}>
                        <div style={{width:16,height:16,borderRadius:"50%",border:"2px solid "+(isSel?"#7CFC00":"rgba(255,255,255,0.2)"),background:isSel?"#7CFC00":"none",flexShrink:0}}/>
                        <div style={{flex:1}}>
                          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                            <span style={{color:"#fff",fontSize:13,fontFamily:"monospace",fontWeight:isSel?700:400}}>#{q.quoteNum}</span>
                            <span style={{color:"#7CFC00",fontSize:13,fontFamily:"monospace",fontWeight:700}}>${q.total?.toFixed(0)}</span>
                          </div>
                          <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace",marginTop:2}}>
                            {(q.services||[]).slice(0,3).map(s=>s.label).join(", ")||"No services"}
                          </div>
                          <div style={{marginTop:3}}>
                            <Tag label={q.stage} color={STAGE_COLORS[q.stage]||"#888"}/>
                          </div>
                        </div>
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {/* Date + Time */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            <div><div style={S.label}>Date</div><input type="date" value={date} onChange={e=>setDate(e.target.value)} style={inp}/></div>
            <div><div style={S.label}>Time</div><input type="time" value={time} onChange={e=>setTime(e.target.value)} style={inp}/></div>
          </div>

          {/* Duration */}
          <div>
            <div style={S.label}>Duration (mins)</div>
            <div style={{display:"flex",gap:6}}>
              {[30,60,90,120].map(d=>(
                <button key={d} onClick={()=>setDur(d)} style={{flex:1,padding:"9px 4px",background:dur===d?"rgba(124,252,0,0.12)":"rgba(255,255,255,0.04)",border:"1px solid "+(dur===d?"rgba(124,252,0,0.35)":"rgba(255,255,255,0.08)"),borderRadius:8,color:dur===d?"#7CFC00":"rgba(255,255,255,0.5)",fontSize:12,fontFamily:"monospace",cursor:"pointer"}}>{d}m</button>
              ))}
            </div>
          </div>

          {/* Notes */}
          <div><div style={S.label}>Notes</div><input value={notes} onChange={e=>setNotes(e.target.value)} placeholder="Gate code, access instructions…" style={inp}/></div>

          <button onClick={handle} disabled={!valid||saving} style={{...btn(!!valid&&!saving),background:valid&&!saving?"#7CFC00":"rgba(124,252,0,0.15)",color:valid&&!saving?"#000":"rgba(255,255,255,0.3)",border:"none",marginTop:4}}>
            {saving?"SAVING…":"SAVE JOB →"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Account & Settings ───────────────────────────────────────────────────────
function FeedbackWidget({profile,session}){
  const [showFeedback,setShowFeedback]=useState(false);
  const [fbMsg,setFbMsg]=useState("");
  const [fbSent,setFbSent]=useState(false);
  const [fbLoading,setFbLoading]=useState(false);
  return(
    <div style={{background:"rgba(0,207,255,0.06)",border:"1px solid rgba(0,207,255,0.2)",borderRadius:12,padding:"14px 16px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:showFeedback?12:0}}>
        <div style={{display:"flex",gap:10,alignItems:"center"}}>
          <span style={{fontSize:20}}>💬</span>
          <div>
            <div style={{color:"var(--lq-blue)",fontSize:12,fontFamily:"monospace",fontWeight:700}}>HELP US IMPROVE</div>
            {!showFeedback&&<div style={{color:"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace",marginTop:2}}>We respond within 24 hours</div>}
          </div>
        </div>
        {!fbSent&&<button onClick={()=>setShowFeedback(s=>!s)} style={{background:"rgba(0,207,255,0.1)",border:"1px solid rgba(0,207,255,0.3)",borderRadius:8,padding:"6px 12px",color:"var(--lq-blue)",fontSize:11,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>{showFeedback?"✕ CLOSE":"SEND FEEDBACK"}</button>}
      </div>
      {fbSent?(
        <div style={{color:"#00ff99",fontSize:12,fontFamily:"monospace",marginTop:4}}>✓ Feedback sent! We'll respond within 24 hours.</div>
      ):showFeedback&&(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          <textarea value={fbMsg} onChange={e=>setFbMsg(e.target.value)} placeholder="Tell us what would make LAWN.Quote better for your business…" rows={4} style={{width:"100%",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(0,207,255,0.2)",borderRadius:9,padding:"10px 12px",color:"#fff",fontSize:13,fontFamily:"monospace",outline:"none",resize:"vertical",lineHeight:1.5}}/>
          <button disabled={!fbMsg.trim()||fbLoading} onClick={async()=>{
            if(!fbMsg.trim()) return;
            setFbLoading(true);
            try{
              await fetch('/api/contact-form',{
                method:'POST',headers:{'Content-Type':'application/json'},
                body:JSON.stringify({name:profile?.name||'App User',email:session?.user?.email||'unknown',subject:'In-App Feedback',message:fbMsg})
              });
            }catch(e){}
            setFbLoading(false);setFbSent(true);setShowFeedback(false);
          }} style={{background:"var(--lq-blue)",color:"#000",border:"none",borderRadius:9,padding:"11px",fontSize:12,fontFamily:"monospace",fontWeight:700,cursor:fbMsg.trim()?"pointer":"default",opacity:fbMsg.trim()?1:0.5}}>
            {fbLoading?"SENDING…":"SEND FEEDBACK →"}
          </button>
        </div>
      )}
    </div>
  );
}

function TaxReportWidget({invoices,quotes,profile}){
  const methods=["All",...[...new Set((invoices||[]).filter(i=>i.paymentMethod).map(i=>i.paymentMethod))]];
  const [selMethod,setSelMethod]=useState("All");
  const now=new Date();
  const yr=now.getFullYear();
  const mo=String(now.getMonth()+1).padStart(2,"0");
  const lastMo=now.getMonth()===0?String(12):String(now.getMonth()).padStart(2,"0");
  const lastYr=now.getMonth()===0?yr-1:yr;

  const PERIODS=[
    {id:"this_month",   label:"This Month",   start:`${yr}-${mo}-01`,      end:todayStr()},
    {id:"last_month",   label:"Last Month",   start:`${lastYr}-${lastMo}-01`, end:`${lastYr}-${lastMo}-${new Date(lastYr,parseInt(lastMo),0).getDate()}`},
    {id:"q1",           label:"Q1",           start:`${yr}-01-01`,          end:`${yr}-03-31`},
    {id:"q2",           label:"Q2",           start:`${yr}-04-01`,          end:`${yr}-06-30`},
    {id:"q3",           label:"Q3",           start:`${yr}-07-01`,          end:`${yr}-09-30`},
    {id:"q4",           label:"Q4",           start:`${yr}-10-01`,          end:`${yr}-12-31`},
    {id:"this_year",    label:`${yr}`,        start:`${yr}-01-01`,          end:`${yr}-12-31`},
    {id:"last_year",    label:`${yr-1}`,      start:`${yr-1}-01-01`,        end:`${yr-1}-12-31`},
    {id:"custom",       label:"Custom",       start:"",                     end:""},
  ];
  const [selPeriod,setSelPeriod]=useState("this_year");
  const [customStart,setCustomStart]=useState(`${yr}-01-01`);
  const [customEnd,setCustomEnd]=useState(todayStr());

  const period=PERIODS.find(p=>p.id===selPeriod)||PERIODS[0];
  const start=selPeriod==="custom"?customStart:period.start;
  const end=selPeriod==="custom"?customEnd:period.end;

  const inRange=date=>date&&date>=start&&date<=end;

  const methodFiltered=selMethod==="All"?(invoices||[]):(invoices||[]).filter(i=>i.paymentMethod===selMethod);
  const paidInvoices=methodFiltered.filter(i=>i.status==="Paid"&&inRange(i.paidDate||i.createdAt));
  const totalRevenue=paidInvoices.reduce((a,i)=>a+(i.total||0),0);
  const numJobs=paidInvoices.length;
  const avgJobValue=numJobs?totalRevenue/numJobs:0;

  // Revenue by service from linked quotes
  const svcRevMap={};
  paidInvoices.forEach(inv=>{
    const q=(quotes||[]).find(q=>q.id===inv.quoteId);
    if(q){(q.services||[]).forEach(s=>{
      const lbl=s.label||s.name||"Other";
      const price=(s.basePrice||0)+(s.perSqft||0)*(q.sqft||0);
      svcRevMap[lbl]=(svcRevMap[lbl]||0)+price;
    });}
    else{(inv.lineItems||[]).forEach(l=>{if(l.label){svcRevMap[l.label]=(svcRevMap[l.label]||0)+((parseFloat(l.price)||0)*(parseFloat(l.qty)||1));}});}
  });
  const svcBreakdown=Object.entries(svcRevMap).sort((a,b)=>b[1]-a[1]);

  const downloadCSV=()=>{
    const co=profile?.company||"LAWN.Quote";
    const summaryRows=[
      ["TAX REPORT — "+co],["Period:",start+" to "+end],["Generated:",todayStr()],[""],
      ["SUMMARY"],["Total Revenue","$"+totalRevenue.toFixed(2)],["Number of Jobs",numJobs],["Average Job Value","$"+avgJobValue.toFixed(2)],[""],
      ["REVENUE BY SERVICE"],["Service","Revenue"],
      ...svcBreakdown.map(([l,v])=>[l,"$"+v.toFixed(2)]),[""],
      ["PAID INVOICES"],["Invoice #","Client","Date Paid","Amount","Payment Method"],
      ...paidInvoices.map(i=>[i.invoiceNum||"",i.customerName||"",i.paidDate||i.createdAt||"","$"+(i.total||0).toFixed(2),i.paymentMethod||""])
    ];
    const csv=summaryRows.map(r=>r.map(v=>`"${String(v).replace(/"/g,'""')}"`).join(",")).join("\n");
    const a=document.createElement("a");
    a.href="data:text/csv;charset=utf-8,"+encodeURIComponent(csv);
    a.download=`tax-report-${start}-to-${end}.csv`;
    a.click();
  };

  const printReport=()=>{
    const co=profile?.company||"LAWN.Quote";
    const svcRows=svcBreakdown.map(([l,v])=>`<tr><td>${l}</td><td style="text-align:right">$${v.toFixed(2)}</td></tr>`).join("");
    const invRows=paidInvoices.map(i=>`<tr><td>${i.invoiceNum||""}</td><td>${i.customerName||""}</td><td>${i.paidDate||i.createdAt||""}</td><td style="text-align:right">$${(i.total||0).toFixed(2)}</td><td>${i.paymentMethod||""}</td></tr>`).join("");
    const html=`<!DOCTYPE html><html><head><meta charset="utf-8"><title>Tax Report — ${co}</title>
    <style>body{font-family:Arial,sans-serif;max-width:750px;margin:40px auto;color:#111;font-size:13px;}
    h1{font-size:22px;margin-bottom:4px;}h2{font-size:15px;margin:24px 0 8px;border-bottom:2px solid #000;padding-bottom:4px;}
    .meta{color:#555;font-size:12px;margin-bottom:24px;}
    .summary{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;margin-bottom:24px;}
    .stat{border:1px solid #ddd;border-radius:6px;padding:14px;text-align:center;}
    .stat-val{font-size:22px;font-weight:700;color:#000;}
    .stat-lbl{font-size:11px;color:#666;margin-top:4px;text-transform:uppercase;}
    table{width:100%;border-collapse:collapse;font-size:12px;}
    th{background:#f5f5f5;text-align:left;padding:7px 10px;border-bottom:2px solid #ddd;}
    td{padding:6px 10px;border-bottom:1px solid #eee;}
    @media print{body{margin:20px;}}</style></head><body>
    <h1>${co} — Tax Report</h1>
    <div class="meta">Period: ${start} to ${end} &nbsp;|&nbsp; Generated: ${todayStr()}</div>
    <div class="summary">
      <div class="stat"><div class="stat-val">$${totalRevenue.toFixed(2)}</div><div class="stat-lbl">Total Revenue</div></div>
      <div class="stat"><div class="stat-val">${numJobs}</div><div class="stat-lbl">Jobs</div></div>
      <div class="stat"><div class="stat-val">$${avgJobValue.toFixed(2)}</div><div class="stat-lbl">Avg Job Value</div></div>
    </div>
    <h2>Revenue by Service</h2>
    <table><thead><tr><th>Service</th><th style="text-align:right">Revenue</th></tr></thead><tbody>${svcRows||'<tr><td colspan="2" style="color:#999">No service data</td></tr>'}</tbody></table>
    <h2>Paid Invoices</h2>
    <table><thead><tr><th>Invoice #</th><th>Client</th><th>Date Paid</th><th style="text-align:right">Amount</th><th>Method</th></tr></thead><tbody>${invRows||'<tr><td colspan="5" style="color:#999">No paid invoices in this period</td></tr>'}</tbody></table>
    <script>window.onload=()=>window.print();</script></body></html>`;
    const w=window.open("","_blank");
    w.document.write(html);
    w.document.close();
  };

  const exportAllInvoices=()=>{
    const filtered=selMethod==="All"?(invoices||[]):(invoices||[]).filter(i=>i.paymentMethod===selMethod);
    const headers=["Invoice #","Client","Total","Status","Payment Method","Paid Date","Due Date","Services","Date Created"];
    const rows=filtered.map(i=>[i.invoiceNum||"",i.customerName||"",(i.total||0).toFixed(2),i.status||"",i.paymentMethod||"",i.paidDate||"",i.dueDate||"",(i.lineItems||[]).map(l=>l.label||"").filter(Boolean).join("; "),i.createdAt||""]);
    const csv=[headers,...rows].map(r=>r.map(v=>`"${String(v).replace(/"/g,'""')}"`).join(",")).join("\n");
    const a=document.createElement("a");
    a.href="data:text/csv;charset=utf-8,"+encodeURIComponent(csv);
    a.download="lawnquote-invoices-"+(selMethod==="All"?"all":selMethod.toLowerCase().replace(/ /g,"-"))+"-"+todayStr()+".csv";
    a.click();
  };

  return(
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      {/* Payment method filter */}
      <div>
        <div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace",letterSpacing:"0.08em",marginBottom:6}}>PAYMENT METHOD</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
          {methods.map(m=>(
            <button key={m} onClick={()=>setSelMethod(m)} style={{padding:"5px 10px",background:selMethod===m?"rgba(0,255,153,0.12)":"rgba(255,255,255,0.04)",border:"1px solid "+(selMethod===m?"rgba(0,255,153,0.3)":"rgba(255,255,255,0.08)"),borderRadius:7,color:selMethod===m?"#00ff99":"rgba(255,255,255,0.5)",fontSize:11,fontFamily:"monospace",cursor:"pointer"}}>{m}</button>
          ))}
        </div>
      </div>
      <div style={{height:1,background:"rgba(255,255,255,0.07)"}}/>
      {/* Period selector */}
      <div>
        <div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace",letterSpacing:"0.08em",marginBottom:6}}>PERIOD</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
        {PERIODS.filter(p=>p.id!=="custom").map(p=>(
          <button key={p.id} onClick={()=>setSelPeriod(p.id)} style={{padding:"5px 10px",background:selPeriod===p.id?"rgba(124,252,0,0.12)":"rgba(255,255,255,0.04)",border:"1px solid "+(selPeriod===p.id?"rgba(124,252,0,0.3)":"rgba(255,255,255,0.08)"),borderRadius:7,color:selPeriod===p.id?"#7CFC00":"rgba(255,255,255,0.5)",fontSize:11,fontFamily:"monospace",cursor:"pointer"}}>{p.label}</button>
        ))}
        <button onClick={()=>setSelPeriod("custom")} style={{padding:"5px 10px",background:selPeriod==="custom"?"rgba(124,252,0,0.12)":"rgba(255,255,255,0.04)",border:"1px solid "+(selPeriod==="custom"?"rgba(124,252,0,0.3)":"rgba(255,255,255,0.08)"),borderRadius:7,color:selPeriod==="custom"?"#7CFC00":"rgba(255,255,255,0.5)",fontSize:11,fontFamily:"monospace",cursor:"pointer"}}>Custom</button>
      </div>
      </div>
      {selPeriod==="custom"&&(
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
          {[["From",customStart,setCustomStart],["To",customEnd,setCustomEnd]].map(([l,v,s])=>(
            <div key={l}>
              <div style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontFamily:"monospace",marginBottom:4}}>{l.toUpperCase()}</div>
              <input type="date" value={v} onChange={e=>s(e.target.value)} style={{width:"100%",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"8px 10px",color:"#fff",fontSize:12,fontFamily:"monospace",outline:"none",colorScheme:"dark"}}/>
            </div>
          ))}
        </div>
      )}
      {/* Summary stats */}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:6}}>
        {[["Revenue","$"+totalRevenue.toFixed(0),"#7CFC00"],["Jobs",numJobs,"var(--lq-blue)"],["Avg Value","$"+avgJobValue.toFixed(0),"#7CFC00"]].map(([l,v,c])=>(
          <div key={l} style={{background:"rgba(255,255,255,0.04)",borderRadius:8,padding:"10px 8px",textAlign:"center"}}>
            <div style={{color:c,fontSize:16,fontWeight:700,fontFamily:"monospace"}}>{v}</div>
            <div style={{color:"rgba(255,255,255,0.3)",fontSize:9,fontFamily:"monospace",marginTop:2}}>{l.toUpperCase()}</div>
          </div>
        ))}
      </div>
      {/* Service breakdown */}
      {svcBreakdown.length>0&&(
        <div style={{background:"rgba(255,255,255,0.02)",border:"1px solid rgba(255,255,255,0.06)",borderRadius:8,padding:"10px 12px"}}>
          <div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace",letterSpacing:"0.08em",marginBottom:8}}>TOP SERVICES</div>
          {svcBreakdown.slice(0,4).map(([l,v])=>(
            <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"3px 0",borderBottom:"1px solid rgba(255,255,255,0.04)"}}>
              <span style={{color:"rgba(255,255,255,0.6)",fontSize:12,fontFamily:"monospace"}}>{l}</span>
              <span style={{color:"#7CFC00",fontSize:12,fontFamily:"monospace",fontWeight:700}}>${v.toFixed(0)}</span>
            </div>
          ))}
        </div>
      )}
      {paidInvoices.length===0&&<div style={{color:"rgba(255,255,255,0.3)",fontSize:12,fontFamily:"monospace",textAlign:"center",padding:"8px 0"}}>No paid invoices in this period</div>}
      <div style={{display:"flex",gap:8}}>
        <button onClick={downloadCSV} style={{flex:1,...btn(true),background:"rgba(124,252,0,0.1)",color:"#7CFC00",borderColor:"rgba(124,252,0,0.25)"}}>⬇ TAX CSV</button>
        <button onClick={printReport} style={{flex:1,...btn(true),background:"rgba(0,207,255,0.08)",color:"var(--lq-blue)",borderColor:"rgba(0,207,255,0.25)"}}>🖨 PRINT</button>
      </div>
      <button onClick={exportAllInvoices} style={{...btn(true),background:"rgba(0,255,153,0.08)",color:"#00ff99",borderColor:"rgba(0,255,153,0.25)"}}>
        ⬇ EXPORT {selMethod.toUpperCase()} INVOICES CSV
      </button>
    </div>
  );
}

function InvoiceExportWidget({invoices}){
  const methods=["All",...[...new Set(invoices.filter(i=>i.paymentMethod).map(i=>i.paymentMethod))]];
  const [selMethod,setSelMethod]=useState("All");
  const filtered=selMethod==="All"?invoices:invoices.filter(i=>i.paymentMethod===selMethod);
  const totalPaid=filtered.filter(i=>i.status==="Paid").reduce((a,i)=>a+(i.total||0),0);
  return(
    <div style={{display:"flex",flexDirection:"column",gap:10}}>
      <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
        {methods.map(m=>(
          <button key={m} onClick={()=>setSelMethod(m)} style={{padding:"5px 10px",background:selMethod===m?"rgba(0,255,153,0.12)":"rgba(255,255,255,0.04)",border:"1px solid "+(selMethod===m?"rgba(0,255,153,0.3)":"rgba(255,255,255,0.08)"),borderRadius:7,color:selMethod===m?"#00ff99":"rgba(255,255,255,0.5)",fontSize:11,fontFamily:"monospace",cursor:"pointer"}}>{m}</button>
        ))}
      </div>
      <div style={{display:"flex",justifyContent:"space-between",background:"rgba(0,255,153,0.05)",border:"1px solid rgba(0,255,153,0.1)",borderRadius:8,padding:"8px 12px"}}>
        <span style={{color:"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace"}}>{filtered.length} invoices</span>
        <span style={{color:"#00ff99",fontSize:13,fontWeight:700,fontFamily:"monospace"}}>${totalPaid.toFixed(2)} paid</span>
      </div>
      <button onClick={()=>{
        const headers=["Invoice #","Client","Total","Status","Payment Method","Paid Date","Due Date","Services","Date Created"];
        const rows=filtered.map(i=>[
          i.invoiceNum||"",i.customerName||"",
          (i.total||0).toFixed(2),i.status||"",
          i.paymentMethod||"",i.paidDate||"",i.dueDate||"",
          (i.lineItems||[]).map(l=>l.label||"").filter(Boolean).join("; "),
          i.createdAt||""
        ]);
        const csv=[headers,...rows].map(r=>r.map(v=>`"${String(v).replace(/"/g,'""')}"`).join(",")).join("\n");
        const a=document.createElement("a");
        a.href="data:text/csv;charset=utf-8,"+encodeURIComponent(csv);
        a.download="lawnquote-invoices-"+(selMethod==="All"?"all":selMethod.toLowerCase().replace(/ /g,"-"))+"-"+todayStr()+".csv";
        a.click();
      }} style={{...btn(true),background:"rgba(0,255,153,0.08)",color:"#00ff99",borderColor:"rgba(0,255,153,0.25)"}}>
        ⬇ EXPORT {selMethod.toUpperCase()} INVOICES CSV
      </button>
    </div>
  );
}

function RatesSettingsTab({rateSettings, onSave}){
  const [local, setLocal] = useState(()=>mergeRateSettings(rateSettings));
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [section, setSection] = useState("services");

  useEffect(()=>{ setLocal(mergeRateSettings(rateSettings)); },[rateSettings]);

  const upSvc=(id,field,val)=>{
    const n=parseFloat(val);
    if(isNaN(n)||n<0) return;
    setLocal(l=>({...l,services:{...l.services,[id]:{...l.services[id],[field]:n}}}));
  };
  const upLs=(id,field,val)=>{
    const n=parseFloat(val);
    if(isNaN(n)||n<0) return;
    setLocal(l=>({...l,landscapeServices:{...l.landscapeServices,[id]:{...l.landscapeServices[id],[field]:n}}}));
  };
  const upMat=(id,field,val)=>{
    const n=parseFloat(val);
    if(isNaN(n)||n<0) return;
    setLocal(l=>({...l,materials:{...l.materials,[id]:{...l.materials[id],[field]:n}}}));
  };
  const upHlItem=(id,val)=>{
    const n=parseFloat(val);
    if(isNaN(n)||n<0) return;
    setLocal(l=>({...l,holidayItems:{...l.holidayItems,[id]:{pricePerUnit:n}}}));
  };
  const resetSection=()=>{ setLocal(l=>({...l,[sectionKey]:DEFAULT_RATE_SETTINGS[sectionKey]})); };
  const sectionKey={services:"services",landscape:"landscapeServices",materials:"materials",holiday:"holidayItems"}[section]||"services";

  const handleSave=async()=>{
    setSaving(true);
    await onSave(local);
    setSaving(false);
    setSaved(true);
    setTimeout(()=>setSaved(false),2000);
  };

  const inp={background:"rgba(255,255,255,0.07)",border:"1px solid rgba(255,255,255,0.12)",borderRadius:7,padding:"7px 9px",color:"#fff",fontSize:12,fontFamily:"monospace",outline:"none",width:"100%"};
  const recBadge=(cur,def)=>{
    const same=Math.abs(Number(cur)-Number(def))<0.0001;
    return same ? null : <span style={{fontSize:9,fontFamily:"monospace",color:"rgba(255,170,0,0.7)",marginLeft:4}}>rec: {def}</span>;
  };
  const sections=[["services","Lawn Svcs"],["landscape","Landscape"],["materials","Materials"],["holiday","Holiday"]];

  return(
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <div style={{background:"rgba(124,252,0,0.06)",border:"1px solid rgba(124,252,0,0.15)",borderRadius:10,padding:"11px 14px"}}>
        <div style={{color:"#7CFC00",fontSize:10,fontFamily:"monospace",fontWeight:700,marginBottom:3}}>RATE SETTINGS</div>
        <div style={{color:"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace",lineHeight:1.5}}>These become your defaults on every new quote. You can still adjust per-quote. Recommended values shown in orange.</div>
      </div>

      {/* Section tabs */}
      <div style={{display:"flex",gap:2,flexWrap:"wrap"}}>
        {sections.map(([v,l])=>(
          <button key={v} onClick={()=>setSection(v)} style={{padding:"7px 10px",background:section===v?"rgba(124,252,0,0.12)":"rgba(255,255,255,0.04)",color:section===v?"#7CFC00":"rgba(255,255,255,0.4)",border:`1px solid ${section===v?"rgba(124,252,0,0.3)":"rgba(255,255,255,0.08)"}`,borderRadius:8,cursor:"pointer",fontSize:10,fontFamily:"monospace",fontWeight:700}}>{l.toUpperCase()}</button>
        ))}
      </div>

      {/* Lawn Services */}
      {section==="services"&&(
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {SERVICES.map(s=>{
            const cur=local.services[s.id]||{};
            const def=DEFAULT_RATE_SETTINGS.services[s.id];
            return(
              <div key={s.id} style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:10,padding:"11px 13px"}}>
                <div style={{color:"#fff",fontSize:12,fontFamily:"monospace",fontWeight:700,marginBottom:8}}>{s.label}</div>
                <div style={{display:"flex",gap:10}}>
                  <div style={{flex:1}}>
                    <div style={{color:"rgba(255,255,255,0.35)",fontSize:9,fontFamily:"monospace",marginBottom:4}}>BASE PRICE ($){recBadge(cur.basePrice,def.basePrice)}</div>
                    <input type="number" min="0" step="1" value={cur.basePrice} onChange={e=>upSvc(s.id,"basePrice",e.target.value)} style={inp}/>
                  </div>
                  <div style={{flex:1}}>
                    <div style={{color:"rgba(255,255,255,0.35)",fontSize:9,fontFamily:"monospace",marginBottom:4}}>PER SQFT ($){recBadge(cur.perSqft,def.perSqft)}</div>
                    <input type="number" min="0" step="0.0001" value={cur.perSqft} onChange={e=>upSvc(s.id,"perSqft",e.target.value)} style={inp}/>
                  </div>
                  <div style={{display:"flex",alignItems:"flex-end",paddingBottom:2}}>
                    <button title="Reset to recommended" onClick={()=>setLocal(l=>({...l,services:{...l.services,[s.id]:{...def}}}))} style={{background:"none",border:"1px solid rgba(255,255,255,0.1)",borderRadius:6,padding:"6px 8px",color:"rgba(255,255,255,0.3)",fontSize:10,cursor:"pointer",fontFamily:"monospace"}}>↺</button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Landscape Services */}
      {section==="landscape"&&(
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {LANDSCAPE_SERVICES.filter(s=>s&&s.id).map(s=>{
            const cur=local.landscapeServices[s.id]||{};
            const def=DEFAULT_RATE_SETTINGS.landscapeServices[s.id]||{};
            const isEach=s.unit==="each";
            return(
              <div key={s.id} style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:10,padding:"11px 13px"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                  <div style={{color:"#fff",fontSize:12,fontFamily:"monospace",fontWeight:700}}>{s.label}</div>
                  <button title="Reset to recommended" onClick={()=>setLocal(l=>({...l,landscapeServices:{...l.landscapeServices,[s.id]:{...def}}}))} style={{background:"none",border:"1px solid rgba(255,255,255,0.1)",borderRadius:6,padding:"4px 7px",color:"rgba(255,255,255,0.3)",fontSize:10,cursor:"pointer",fontFamily:"monospace"}}>↺</button>
                </div>
                <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                  {isEach?(
                    <>
                      <div style={{flex:1,minWidth:80}}>
                        <div style={{color:"rgba(255,255,255,0.35)",fontSize:9,fontFamily:"monospace",marginBottom:4}}>LABOR/EA ($){recBadge(cur.laborEach,def.laborEach)}</div>
                        <input type="number" min="0" step="0.01" value={cur.laborEach||0} onChange={e=>upLs(s.id,"laborEach",e.target.value)} style={inp}/>
                      </div>
                      <div style={{flex:1,minWidth:80}}>
                        <div style={{color:"rgba(255,255,255,0.35)",fontSize:9,fontFamily:"monospace",marginBottom:4}}>MAT/EA ($){recBadge(cur.matEach,def.matEach)}</div>
                        <input type="number" min="0" step="0.01" value={cur.matEach||0} onChange={e=>upLs(s.id,"matEach",e.target.value)} style={inp}/>
                      </div>
                    </>
                  ):(
                    <>
                      <div style={{flex:1,minWidth:80}}>
                        <div style={{color:"rgba(255,255,255,0.35)",fontSize:9,fontFamily:"monospace",marginBottom:4}}>LABOR/SQFT ($){recBadge(cur.laborPerSqft,def.laborPerSqft)}</div>
                        <input type="number" min="0" step="0.01" value={cur.laborPerSqft||0} onChange={e=>upLs(s.id,"laborPerSqft",e.target.value)} style={inp}/>
                      </div>
                      <div style={{flex:1,minWidth:80}}>
                        <div style={{color:"rgba(255,255,255,0.35)",fontSize:9,fontFamily:"monospace",marginBottom:4}}>MAT/SQFT ($){recBadge(cur.matPerSqft,def.matPerSqft)}</div>
                        <input type="number" min="0" step="0.01" value={cur.matPerSqft||0} onChange={e=>upLs(s.id,"matPerSqft",e.target.value)} style={inp}/>
                      </div>
                    </>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Materials */}
      {section==="materials"&&(
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {MATERIALS.map(m=>{
            const cur=local.materials[String(m.id)]||{};
            const def=DEFAULT_RATE_SETTINGS.materials[String(m.id)];
            return(
              <div key={m.id} style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:10,padding:"11px 13px"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                  <div>
                    <div style={{color:"#fff",fontSize:12,fontFamily:"monospace",fontWeight:700}}>{m.name}</div>
                    <div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace"}}>{m.store} · {m.unit}</div>
                  </div>
                  <button title="Reset to recommended" onClick={()=>setLocal(l=>({...l,materials:{...l.materials,[String(m.id)]:{...def}}}))} style={{background:"none",border:"1px solid rgba(255,255,255,0.1)",borderRadius:6,padding:"4px 7px",color:"rgba(255,255,255,0.3)",fontSize:10,cursor:"pointer",fontFamily:"monospace"}}>↺</button>
                </div>
                <div style={{display:"flex",gap:10}}>
                  <div style={{flex:1}}>
                    <div style={{color:"rgba(255,255,255,0.35)",fontSize:9,fontFamily:"monospace",marginBottom:4}}>COST PRICE ($){recBadge(cur.price,def.price)}</div>
                    <input type="number" min="0" step="0.01" value={cur.price} onChange={e=>upMat(String(m.id),"price",e.target.value)} style={inp}/>
                  </div>
                  <div style={{flex:1}}>
                    <div style={{color:"rgba(255,255,255,0.35)",fontSize:9,fontFamily:"monospace",marginBottom:4}}>MARGIN (%){recBadge((cur.margin*100).toFixed(0),(def.margin*100).toFixed(0))}</div>
                    <input type="number" min="0" max="200" step="1" value={Math.round((cur.margin||0)*100)} onChange={e=>upMat(String(m.id),"margin",(parseFloat(e.target.value)||0)/100)} style={inp}/>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Holiday Items */}
      {section==="holiday"&&(
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          <div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace",marginBottom:4}}>All-in price charged to customer (install labor included)</div>
          {HOLIDAY_ITEMS.map(item=>{
            const cur=local.holidayItems[item.id]||{};
            const def=DEFAULT_RATE_SETTINGS.holidayItems[item.id];
            return(
              <div key={item.id} style={{display:"flex",alignItems:"center",gap:10,background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:10,padding:"11px 13px"}}>
                <div style={{flex:1}}>
                  <div style={{color:"#fff",fontSize:12,fontFamily:"monospace",fontWeight:700}}>{item.label}</div>
                  <div style={{color:"rgba(255,255,255,0.3)",fontSize:9,fontFamily:"monospace"}}>per {item.unit}{recBadge(cur.pricePerUnit,def.pricePerUnit)}</div>
                </div>
                <div style={{display:"flex",alignItems:"center",gap:6}}>
                  <span style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace"}}>$</span>
                  <input type="number" min="0" step="0.01" value={cur.pricePerUnit||0} onChange={e=>upHlItem(item.id,e.target.value)} style={{...inp,width:70,textAlign:"right"}}/>
                  <span style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace"}}>/{item.unit}</span>
                </div>
                <button title="Reset" onClick={()=>setLocal(l=>({...l,holidayItems:{...l.holidayItems,[item.id]:{...def}}}))} style={{background:"none",border:"1px solid rgba(255,255,255,0.1)",borderRadius:6,padding:"4px 7px",color:"rgba(255,255,255,0.3)",fontSize:10,cursor:"pointer",fontFamily:"monospace"}}>↺</button>
              </div>
            );
          })}
        </div>
      )}

      <div style={{display:"flex",gap:8}}>
        <button onClick={resetSection} style={{flex:1,background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:10,padding:"12px",color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",cursor:"pointer"}}>↺ RESET SECTION</button>
        <button onClick={handleSave} disabled={saving} style={{flex:2,background:saved?"rgba(124,252,0,0.2)":"#7CFC00",color:saved?"#7CFC00":"#000",border:saved?"1px solid rgba(124,252,0,0.4)":"none",borderRadius:10,padding:"12px",fontSize:12,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>{saving?"SAVING…":saved?"✓ SAVED":"SAVE RATES"}</button>
      </div>
    </div>
  );
}

function AccountScreen({profile,session,onSignOut,onProfileUpdate,initialTab="profile",onClearRecurring,onUpgrade,onDeleteAccount,quotes=[],customers=[],invoices=[],chemLogs=[],rateSettings=null,onRateSave}){
  const [tab,setTab]=useState(initialTab);
  useEffect(()=>{setTab(initialTab);},[initialTab]);
  const [form,setForm]=useState({name:profile?.name||"",company:profile?.company||"",phone:profile?.phone||"",website:profile?.website||"",address:profile?.address||""});
  const [pwForm,setPwForm]=useState({current:"",next:"",confirm:""});
  const [saving,setSaving]=useState(false);
  const [logoUrl,setLogoUrl]=useState(profile?.logo_url||null);
  const [logoUploading,setLogoUploading]=useState(false);
  const [toast,showToast]=useToast();
  const [cancelConfirm,setCancelConfirm]=useState(false);
  const logoInputRef=useRef(null);

  const daysLeft=profile?.trial_start?Math.max(0,14-daysSince(profile.trial_start)):14;
  const plan=profile?.plan||"trial";

  const handleLogoUpload=async(e)=>{
    const file=e.target.files[0];
    if(!file) return;
    if(file.size>2*1024*1024){showToast("Logo must be under 2MB","error");return;}
    setLogoUploading(true);
    // Convert to base64 and store in profile (avoids needing Storage bucket setup)
    const reader=new FileReader();
    reader.onload=async(ev)=>{
      const dataUrl=ev.target.result;
      setLogoUrl(dataUrl);
      if(session)await supabase.from("profiles").update({logo_url:dataUrl}).eq("id",session.user.id);
      onProfileUpdate({...profile,logo_url:dataUrl});
      setLogoUploading(false);
      showToast("Logo saved");
    };
    reader.readAsDataURL(file);
  };

  const removeLogo=async()=>{
    setLogoUrl(null);
    if(session)await supabase.from("profiles").update({logo_url:null}).eq("id",session.user.id);
    onProfileUpdate({...profile,logo_url:null});
    showToast("Logo removed");
  };

  const saveProfile=async()=>{
    setSaving(true);
    const{error}=await supabase.from("profiles").update({
      name:form.name, company:form.company,
      phone:form.phone||null, website:form.website||null, address:form.address||null,
    }).eq("id",session.user.id);
    setSaving(false);
    if(error){showToast("Failed to save","error");return;}
    onProfileUpdate({...profile,...form,logo_url:logoUrl});
    showToast("Profile saved");
  };

  const savePassword=async()=>{
    if(pwForm.next.length<6){showToast("Password too short","error");return;}
    if(pwForm.next!==pwForm.confirm){showToast("Passwords don't match","error");return;}
    setSaving(true);
    const{error}=await supabase.auth.updateUser({password:pwForm.next});
    setSaving(false);
    if(error){showToast(error.message,"error");return;}
    setPwForm({current:"",next:"",confirm:""});
    showToast("Password updated");
  };

  const handleCancel=async()=>{
    if(session)await supabase.from("profiles").update({plan:"cancelled"}).eq("id",session.user.id);
    onProfileUpdate({...profile,plan:"cancelled"});
    setCancelConfirm(false);
    showToast("Subscription cancelled");
  };

  return(
    <div style={{display:"flex",flexDirection:"column",gap:16}}>
      {toast&&<Toast message={toast.message} type={toast.type}/>}
      {cancelConfirm&&<ConfirmModal message="Cancel your subscription? You'll lose access at the end of your billing period." onConfirm={handleCancel} onCancel={()=>setCancelConfirm(false)} confirmLabel="YES, CANCEL" danger/>}

      <div><p style={S.label}>Settings</p><h2 style={S.heading}>Account</h2></div>

      <div style={{display:"flex",background:"rgba(255,255,255,0.05)",borderRadius:10,padding:3,gap:2,flexWrap:"wrap"}}>
        {[["profile","Profile"],["subscription","Plan"],["password","Password"],["rates","Rates"],["export","Export"]].map(([v,l])=>(
          <button key={v} onClick={()=>setTab(v)} style={{flex:1,padding:"7px 4px",background:tab===v?"#7CFC00":"none",color:tab===v?"#000":"rgba(255,255,255,0.45)",border:"none",borderRadius:8,cursor:"pointer",fontSize:10,fontWeight:700,fontFamily:"monospace",transition:"all 0.2s",minWidth:0}}>{l.toUpperCase()}</button>
        ))}
      </div>

      {/* Profile Tab */}
      {tab==="profile"&&(
        <div style={{display:"flex",flexDirection:"column",gap:14}}>

          {/* Logo upload */}
          <div style={{...S.card}}>
            <div style={{...S.label,marginBottom:12}}>Company Logo</div>
            <div style={{display:"flex",alignItems:"center",gap:14}}>
              <div style={{width:88,height:88,borderRadius:10,border:`2px dashed ${logoUrl?"rgba(124,252,0,0.4)":"rgba(255,255,255,0.15)"}`,background:"rgba(255,255,255,0.04)",display:"flex",alignItems:"center",justifyContent:"center",overflow:"hidden",flexShrink:0}}>
                {logoUrl
                  ? <img src={logoUrl} alt="logo" style={{width:"100%",height:"100%",objectFit:"contain"}}/>
                  : <div style={{textAlign:"center"}}><div style={{fontSize:24}}>🖼</div><div style={{color:"rgba(255,255,255,0.25)",fontSize:9,fontFamily:"monospace",marginTop:4}}>NO LOGO</div></div>
                }
              </div>
              <div style={{flex:1,display:"flex",flexDirection:"column",gap:8}}>
                <div style={{color:"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace",lineHeight:1.5}}>
                  Appears on printed invoices. PNG or JPG, max 2MB.
                </div>
                <input ref={logoInputRef} type="file" accept="image/png,image/jpeg,image/jpg,image/svg+xml" onChange={handleLogoUpload} style={{display:"none"}}/>
                <button onClick={()=>logoInputRef.current.click()} disabled={logoUploading} style={{background:"rgba(124,252,0,0.1)",border:"1px solid rgba(124,252,0,0.3)",borderRadius:8,padding:"8px 12px",color:"#7CFC00",fontSize:11,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>
                  {logoUploading?"UPLOADING…":"📁 UPLOAD LOGO"}
                </button>
                {logoUrl&&<button onClick={removeLogo} style={{background:"rgba(255,68,68,0.08)",border:"1px solid rgba(255,68,68,0.2)",borderRadius:8,padding:"6px 12px",color:"#ff6b6b",fontSize:11,fontFamily:"monospace",cursor:"pointer"}}>✕ REMOVE</button>}
              </div>
            </div>
          </div>

          {/* Company info */}
          <div style={{...S.card,display:"flex",flexDirection:"column",gap:12}}>
            <div style={{...S.label,marginBottom:0}}>Company Info</div>
            <Field label="Your Name" value={form.name} onChange={v=>setForm(f=>({...f,name:v}))} placeholder="Jane Smith"/>
            <Field label="Company Name" value={form.company} onChange={v=>setForm(f=>({...f,company:v}))} placeholder="ABC Lawn Care"/>
            <Field label="Phone Number" value={form.phone} onChange={v=>setForm(f=>({...f,phone:v}))} placeholder="(555) 867-5309"/>
            <Field label="Business Address" value={form.address} onChange={v=>setForm(f=>({...f,address:v}))} placeholder="123 Main St, Nashville TN 37205"/>
            <Field label="Website (optional)" value={form.website} onChange={v=>setForm(f=>({...f,website:v}))} placeholder="www.yourbusiness.com"/>
            <div style={{paddingTop:10,borderTop:"1px solid rgba(255,255,255,0.06)"}}>
              <div style={S.label}>Email Address</div>
              <div style={{color:"rgba(255,255,255,0.5)",fontSize:13,fontFamily:"monospace"}}>{session?.user?.email||"demo@example.com"}</div>
              <div style={{color:"rgba(255,255,255,0.25)",fontSize:11,fontFamily:"monospace",marginTop:3}}>Contact support to change your email</div>
            </div>
          </div>

          <button onClick={saveProfile} disabled={saving} style={{...btn(true),background:"#7CFC00",color:"#000",border:"none"}}>{saving?"SAVING…":"SAVE PROFILE"}</button>
          <button onClick={onSignOut} style={{...btn(true,"danger")}}>SIGN OUT</button>
        </div>
      )}

      {/* Subscription Tab */}
      {tab==="subscription"&&(
        <div style={{display:"flex",flexDirection:"column",gap:14}}>

          {/* Plan status card */}
          {profile?.plan==="pro"?(
            <div style={{background:"rgba(0,207,255,0.08)",border:"1px solid rgba(0,207,255,0.3)",borderRadius:12,padding:"18px 16px",textAlign:"center"}}>
              <div style={{fontSize:28,marginBottom:8}}>✅</div>
              <div style={{color:"var(--lq-blue)",fontFamily:"monospace",fontSize:16,fontWeight:700,marginBottom:4}}>PRO PLAN — ACTIVE</div>
              <div style={{color:"rgba(255,255,255,0.45)",fontSize:12,fontFamily:"monospace"}}>$10/mo · All features included · Cancel anytime</div>

            </div>
          ):(
            <>
              {/* Trial status */}
              {(()=>{
                const daysLeft=profile?.trial_start?Math.max(0,14-daysSince(profile.trial_start)):14;
                const expired=daysLeft===0;
                const urgent=daysLeft<=3&&!expired;
                return(
                  <div style={{background:expired?"rgba(255,68,68,0.08)":urgent?"rgba(255,170,0,0.08)":"rgba(124,252,0,0.07)",border:"1px solid "+(expired?"rgba(255,68,68,0.3)":urgent?"rgba(255,170,0,0.3)":"rgba(124,252,0,0.25)"),borderRadius:12,padding:"18px 16px",textAlign:"center"}}>
                    <div style={{fontSize:28,marginBottom:8}}>{expired?"⏰":urgent?"⚠️":"🎉"}</div>
                    <div style={{color:expired?"#ff6b6b":urgent?"#ffaa00":"#7CFC00",fontFamily:"monospace",fontSize:15,fontWeight:700,marginBottom:4}}>
                      {expired?"TRIAL EXPIRED":daysLeft+" DAY"+(daysLeft!==1?"S":"")+  " LEFT IN TRIAL"}
                    </div>
                    <div style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",marginBottom:expired?16:8}}>
                      {expired?"Upgrade to keep access to all your data":"14-day free trial · $10/mo after · cancel anytime"}
                    </div>
                    {!expired&&(
                      <div style={{height:4,background:"rgba(255,255,255,0.08)",borderRadius:99,overflow:"hidden",marginBottom:12}}>
                        <div style={{height:"100%",background:urgent?"#ffaa00":"#7CFC00",width:Math.round(((14-daysLeft)/14)*100)+"%",borderRadius:99,transition:"width 0.5s"}}/>
                      </div>
                    )}
                    <button onClick={onUpgrade} style={{width:"100%",background:expired?"#ff6b6b":"#7CFC00",color:"#000",border:"none",borderRadius:9,padding:"12px",fontSize:13,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>
                      🚀 {expired?"UPGRADE NOW — $10/MO":"UPGRADE TO PRO — $10/MO"}
                    </button>
                  </div>
                );
              })()}
            </>
          )}

          {/* Stripe Connect */}
          <div style={{background:"rgba(99,102,241,0.07)",border:"1px solid rgba(99,102,241,0.25)",borderRadius:12,padding:"16px"}}>
            <div style={{color:"#a5b4fc",fontSize:10,fontFamily:"monospace",letterSpacing:"0.1em",marginBottom:8}}>STRIPE PAYMENTS</div>
            {profile?.stripe_account_id?(
              <>
                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
                  <span style={{color:"#00ff99",fontSize:14}}>✅</span>
                  <div>
                    <div style={{color:"#fff",fontSize:13,fontFamily:"monospace",fontWeight:700}}>Stripe Connected</div>
                    <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace",marginTop:2}}>Clients can pay invoices directly to your Stripe account</div>
                  </div>
                </div>
                <button onClick={async()=>{
                  if(!window.confirm("Disconnect your Stripe account?")) return;
                  if(session)await supabase.from('profiles').update({stripe_account_id:null}).eq('id',session.user.id);
                  setProfile(p=>({...p,stripe_account_id:null}));
                }} style={{...btn(true,"danger"),width:"auto",padding:"8px 14px",fontSize:11}}>Disconnect</button>
              </>
            ):(
              <>
                <div style={{color:"rgba(255,255,255,0.45)",fontSize:12,fontFamily:"monospace",marginBottom:12,lineHeight:1.6}}>Connect your Stripe account so clients can pay invoices online. Money goes directly to you.</div>
                <button onClick={()=>{
                  if(session)window.location.href=`/api/connect-stripe?userId=${session.user.id}`;
                }} style={{...btn(true),background:"rgba(99,102,241,0.2)",color:"#a5b4fc",borderColor:"rgba(99,102,241,0.4)"}}>⚡ CONNECT STRIPE ACCOUNT</button>
              </>
            )}
          </div>

          {/* Feature list */}
          <div style={{...S.card}}>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:10,fontFamily:"monospace",letterSpacing:"0.1em",marginBottom:12}}>{profile?.plan==="pro"?"YOUR PRO PLAN INCLUDES":"EVERYTHING INCLUDED"}</div>
            {[
              "Unlimited quotes & clients",
              "Satellite lawn measurement",
              "Landscaping bed quoting",
              "Upsell engine & property scan",
              "Schedule & route optimization",
              "Recurring client scheduling",
              "Invoicing & payment tracking",
              "Seasonal upsell campaigns",
              "Chemical application log",
              "Before/after photos",
              "Door hanger quick quotes",
              "Data synced across devices",
            ].map(feat=>(
              <div key={feat} style={{display:"flex",justifyContent:"space-between",padding:"7px 0",borderBottom:"1px solid rgba(255,255,255,0.04)"}}>
                <span style={{color:"rgba(255,255,255,0.6)",fontSize:13,fontFamily:"monospace"}}>{feat}</span>
                <span style={{color:"#7CFC00",fontSize:13,fontWeight:700}}>✓</span>
              </div>
            ))}
          </div>

          {/* Feedback */}
          <FeedbackWidget profile={profile} session={session}/>

          <div style={{color:"rgba(255,255,255,0.2)",fontSize:11,fontFamily:"monospace",textAlign:"center",lineHeight:1.6}}>
            $10/mo after your trial · cancel anytime · no contracts
          </div>

          {/* Danger zone */}
          <div style={{background:"rgba(255,68,68,0.05)",border:"1px solid rgba(255,68,68,0.2)",borderRadius:12,padding:"14px 16px",display:"flex",flexDirection:"column",gap:10}}>
            {/* Cancel subscription */}
            {(profile?.plan==="pro"||profile?.plan==="trial"||profile?.plan)&&(
              <div style={{background:"rgba(255,170,0,0.05)",border:"1px solid rgba(255,170,0,0.2)",borderRadius:12,padding:"14px 16px",marginBottom:10}}>
                <div style={{color:"#ffaa00",fontSize:11,fontFamily:"monospace",fontWeight:700,letterSpacing:"0.08em",marginBottom:8}}>SUBSCRIPTION</div>
                <div style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",marginBottom:12,lineHeight:1.6}}>
                  Cancel your subscription — you'll keep access until the end of your current billing period.
                </div>
                <button onClick={async()=>{
                  if(!window.confirm("Cancel your subscription? You'll keep access until the end of your billing period.")) return;
                  const{data:{session:sess}}=await supabase.auth.getSession();
                  if(!sess) return;
                  // Try Stripe portal if customer ID exists
                  const{data:prof}=await supabase.from('profiles').select('stripe_customer_id').eq('id',sess.user.id).single();
                  if(prof?.stripe_customer_id){
                    try{
                      const res=await fetch('/api/customer-portal',{
                        method:'POST',
                        headers:{'Content-Type':'application/json'},
                        body:JSON.stringify({userId:sess.user.id})
                      });
                      const data=await res.json();
                      if(data.url){ window.location.href=data.url; return; }
                    }catch(e){}
                  }
                  // No Stripe customer — cancel directly in DB
                  await supabase.from('profiles').update({plan:'cancelled'}).eq('id',sess.user.id);
                  onProfileUpdate(p=>({...p,plan:'cancelled'}));
                  alert("Subscription cancelled. You'll keep access until your billing period ends.");
                }} style={{width:"100%",background:"rgba(255,170,0,0.08)",border:"1px solid rgba(255,170,0,0.3)",borderRadius:9,padding:"11px",color:"#ffaa00",fontSize:12,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>
                  CANCEL SUBSCRIPTION
                </button>
              </div>
            )}

            <div style={{color:"#ff6b6b",fontSize:11,fontFamily:"monospace",fontWeight:700,letterSpacing:"0.08em"}}>DANGER ZONE</div>
            <div>
              <div style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",marginBottom:8,lineHeight:1.6}}>Clear all future recurring scheduled jobs from your calendar.</div>
              <button onClick={onClearRecurring} style={{width:"100%",background:"rgba(255,68,68,0.08)",border:"1px solid rgba(255,68,68,0.3)",borderRadius:9,padding:"11px",color:"#ff6b6b",fontSize:12,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>🗑 CLEAR ALL RECURRING JOBS</button>
            </div>
            <div style={{borderTop:"1px solid rgba(255,68,68,0.15)",paddingTop:10}}>
              <div style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",marginBottom:8,lineHeight:1.6}}>Permanently delete your account and all data. This cannot be undone.</div>
              <button onClick={()=>{
                if(window.confirm("Are you sure? This permanently deletes your account and ALL data.")){
                  if(window.confirm("Last chance — are you absolutely sure?")){
                    onDeleteAccount();
                  }
                }
              }} style={{width:"100%",background:"rgba(255,0,0,0.15)",border:"2px solid rgba(255,68,68,0.5)",borderRadius:9,padding:"11px",color:"#ff4444",fontSize:12,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>
                ⚠ DELETE MY ACCOUNT PERMANENTLY
              </button>
            </div>
          </div>
        </div>
      )}

      {tab==="rates"&&(
        <RatesSettingsTab rateSettings={rateSettings} onSave={async(r)=>{if(onRateSave)await onRateSave(r);showToast("Rates saved");}}/>
      )}

      {tab==="export"&&(
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <div style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",lineHeight:1.6}}>
            Export your data as CSV files you can open in Excel or Google Sheets.
          </div>

          {/* Clients */}
          <div style={{...S.card}}>
            <div style={{color:"#7CFC00",fontSize:11,fontFamily:"monospace",fontWeight:700,marginBottom:10,letterSpacing:"0.08em"}}>👥 CLIENT DATA</div>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",marginBottom:12}}>
              {customers.length} clients · includes name, phone, email, address, recurring schedule
            </div>
            <button onClick={()=>{
              const headers=["Name","Phone","Email","Address","Property Type","Notes","Recurring","Frequency","Day","Start Date","End Date","Services"];
              const rows=customers.map(c=>[
                c.name||"",c.phone||"",c.email||"",c.address||"",c.propertyType||"",
                (c.notes||"").replace(/,/g,";"),
                c.recurringActive?"Yes":"No",c.recurringFrequency||"",
                ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"][parseInt(c.recurringDay||"1")]||"",
                c.recurringStart||"",c.recurringEnd||"",c.recurringServices||""
              ]);
              const csv=[headers,...rows].map(r=>r.map(v=>`"${String(v).replace(/"/g,'""')}"`).join(",")).join("\n");
              const a=document.createElement("a");
              a.href="data:text/csv;charset=utf-8,"+encodeURIComponent(csv);
              a.download="lawnquote-clients-"+todayStr()+".csv";
              a.click();
            }} style={{...btn(true),background:"rgba(124,252,0,0.1)",color:"#7CFC00",borderColor:"rgba(124,252,0,0.25)"}}>
              ⬇ EXPORT CLIENTS CSV
            </button>
          </div>

          {/* Quotes */}
          <div style={{...S.card}}>
            <div style={{color:"var(--lq-blue)",fontSize:11,fontFamily:"monospace",fontWeight:700,marginBottom:10,letterSpacing:"0.08em"}}>✦ QUOTE DATA</div>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",marginBottom:12}}>
              {quotes.length} quotes · includes quote number, client, total, stage, date
            </div>
            <button onClick={()=>{
              const headers=["Quote #","Client","Address","Total","Stage","Services","Date","Recurring"];
              const rows=quotes.map(q=>[
                q.quoteNum||"",q.customerName||"",q.address||"",
                (q.total||0).toFixed(2),q.stage||"",
                (q.services||[]).map(s=>s.label||s.name||"").filter(Boolean).join("; "),
                q.createdAt||"",q.recurring||"once"
              ]);
              const csv=[headers,...rows].map(r=>r.map(v=>`"${String(v).replace(/"/g,'""')}"`).join(",")).join("\n");
              const a=document.createElement("a");
              a.href="data:text/csv;charset=utf-8,"+encodeURIComponent(csv);
              a.download="lawnquote-quotes-"+todayStr()+".csv";
              a.click();
            }} style={{...btn(true),background:"rgba(0,207,255,0.08)",color:"var(--lq-blue)",borderColor:"rgba(0,207,255,0.25)"}}>
              ⬇ EXPORT QUOTES CSV
            </button>
          </div>


          {/* Chemical logs */}
          <div style={{...S.card}}>
            <div style={{color:"#ffaa00",fontSize:11,fontFamily:"monospace",fontWeight:700,marginBottom:10,letterSpacing:"0.08em"}}>🧪 CHEMICAL APPLICATION LOG</div>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",marginBottom:12}}>
              {chemLogs.length} application records · EPA compliant format
            </div>
            <button onClick={()=>{
              const headers=["Date","Client","Address","Product","EPA Reg #","Target","Rate","Unit","Area (sqft)","Weather","Wind","Temp (F)","REI","REI Unit","Safe Re-Entry","Notes"];
              const rows=chemLogs.map(l=>[
                l.date||"",l.customerName||"",l.address||"",
                l.product||"",l.epaReg||"",l.target||"",
                l.rate||"",l.rateUnit||"",l.area||"",
                l.weather||"",l.wind||"",l.temp||"",
                l.rei||"",l.reiUnit||"",l.reiExpiry||"",
                (l.notes||"").replace(/,/g,";")
              ]);
              const csv=[headers,...rows].map(r=>r.map(v=>`"${String(v).replace(/"/g,'""')}"`).join(",")).join("\n");
              const a=document.createElement("a");
              a.href="data:text/csv;charset=utf-8,"+encodeURIComponent(csv);
              a.download="lawnquote-chemical-log-"+todayStr()+".csv";
              a.click();
            }} style={{...btn(true),background:"rgba(255,170,0,0.08)",color:"#ffaa00",borderColor:"rgba(255,170,0,0.25)"}}>
              ⬇ EXPORT CHEMICAL LOG CSV
            </button>
          </div>

          {/* Invoice & Tax Report — combined */}
          <div style={{...S.card,borderColor:"rgba(0,255,153,0.15)"}}>
            <div style={{color:"#00ff99",fontSize:11,fontFamily:"monospace",fontWeight:700,marginBottom:6,letterSpacing:"0.08em"}}>🧾 INVOICE & TAX REPORT</div>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",marginBottom:12}}>
              {invoices.length} invoices · filter by method & period · export CSV or print for your accountant
            </div>
            <TaxReportWidget invoices={invoices} quotes={quotes} profile={profile}/>
          </div>

          {/* Full data export */}
          <div style={{...S.card,borderColor:"rgba(124,252,0,0.15)"}}>
            <div style={{color:"#7CFC00",fontSize:11,fontFamily:"monospace",fontWeight:700,marginBottom:10,letterSpacing:"0.08em"}}>📦 FULL DATA EXPORT</div>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",marginBottom:12}}>
              Export everything as a single JSON file — useful as a full backup of your data.
            </div>
            <button onClick={()=>{
              const data={
                exportDate:new Date().toISOString(),
                profile:{name:profile?.name,company:profile?.company,phone:profile?.phone},
                clients:customers,
                quotes,
                invoices,
                chemLogs,
              };
              const a=document.createElement("a");
              a.href="data:application/json;charset=utf-8,"+encodeURIComponent(JSON.stringify(data,null,2));
              a.download="lawnquote-backup-"+todayStr()+".json";
              a.click();
            }} style={{...btn(true),background:"rgba(124,252,0,0.08)",color:"#7CFC00",borderColor:"rgba(124,252,0,0.2)"}}>
              ⬇ EXPORT FULL BACKUP JSON
            </button>
          </div>

        </div>
      )}

      {tab==="password"&&(
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <div style={{...S.card,display:"flex",flexDirection:"column",gap:14}}>
            <AuthInput label="NEW PASSWORD" type="password" value={pwForm.next} onChange={v=>setPwForm(f=>({...f,next:v}))} placeholder="Min. 6 characters"/>
            <AuthInput label="CONFIRM NEW PASSWORD" type="password" value={pwForm.confirm} onChange={v=>setPwForm(f=>({...f,confirm:v}))} placeholder="Re-enter new password"/>
          </div>
          <button onClick={savePassword} disabled={saving||pwForm.next.length<6} style={{...btn(pwForm.next.length>=6&&!saving),background:pwForm.next.length>=6&&!saving?"#7CFC00":"rgba(124,252,0,0.15)",color:pwForm.next.length>=6&&!saving?"#000":"rgba(255,255,255,0.3)",border:"none"}}>{saving?"UPDATING…":"UPDATE PASSWORD"}</button>
        </div>
      )}
    </div>
  );
}


// ─── Upsell Engine ────────────────────────────────────────────────────────────
const SEASON = (() => {
  const m = new Date().getMonth();
  if (m >= 2 && m <= 4) return "spring";
  if (m >= 5 && m <= 7) return "summer";
  if (m >= 8 && m <= 10) return "fall";
  return "winter";
})();

const SCAN_ITEMS = [
  { id:"bare",    label:"Bare / thin patches",     icon:"🟤", services:["seed","fert"],   seasons:["spring","fall"] },
  { id:"beds",    label:"Overgrown beds / shrubs",  icon:"🌿", services:["edge","trim"],   seasons:["spring","summer","fall"] },
  { id:"weeds",   label:"Weeds taking over",        icon:"🌱", services:["weed","fert"],   seasons:["spring","summer"] },
  { id:"stress",  label:"Lawn looks stressed / yellow", icon:"🟡", services:["fert","aerate"], seasons:["summer"] },
  { id:"debris",  label:"Leaves / debris buildup",  icon:"🍂", services:["leaf","aerate"], seasons:["fall","winter"] },
  { id:"dormant", label:"Preparing for dormancy",   icon:"❄️", services:["fert","seed"],   seasons:["fall","winter"] }];

// Given scan observations + already-selected services, return upsell suggestions
function getUpsells(scanIds, selSvc, sqft, rates) {
  const suggested = new Set();
  scanIds.forEach(id => {
    const item = SCAN_ITEMS.find(s => s.id === id);
    item?.services.forEach(svc => suggested.add(svc));
  });
  // Remove already selected
  selSvc.forEach(s => suggested.delete(s));
  return [...suggested].slice(0, 3).map(id => {
    const svc = SERVICES.find(s => s.id === id);
    if (!svc) return null;
    const r = rates[id] || { basePrice: svc.basePrice, perSqft: svc.perSqft };
    const price = r.basePrice + r.perSqft * sqft;
    return { ...svc, price, annualBiweekly: price * 26 };
  }).filter(Boolean);
}

function PropertyScan({ sqft, selSvc, rates, onAddService, onNext, onBack }) {
  const [checked, setChecked] = useState([]);
  const toggle = id => setChecked(c => c.includes(id) ? c.filter(x => x !== id) : [...c, id]);
  const upsells = getUpsells(checked, selSvc, sqft, rates);
  const seasonal = SCAN_ITEMS.filter(i => i.seasons.includes(SEASON));
  const other    = SCAN_ITEMS.filter(i => !i.seasons.includes(SEASON));

  return (
    <div style={{ display:"flex", flexDirection:"column", gap:16 }}>
      <div>
        <p style={S.label}>Property Scan · {SEASON.charAt(0).toUpperCase()+SEASON.slice(1)}</p>
        <h2 style={S.heading}>What do you see?</h2>
        <p style={S.sub}>Tap everything you notice on this property</p>
      </div>

      {/* Seasonal items */}
      <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
        <div style={{ color:"rgba(255,255,255,0.3)", fontSize:9, fontFamily:"monospace", letterSpacing:"0.1em", marginBottom:2 }}>COMMON THIS {SEASON.toUpperCase()}</div>
        {seasonal.map(item => {
          const on = checked.includes(item.id);
          return (
            <button key={item.id} onClick={() => toggle(item.id)} style={{ display:"flex", alignItems:"center", gap:12, background:on?"rgba(124,252,0,0.1)":"rgba(255,255,255,0.04)", border:`1px solid ${on?"rgba(124,252,0,0.35)":"rgba(255,255,255,0.08)"}`, borderRadius:12, padding:"13px 14px", cursor:"pointer", textAlign:"left", transition:"all 0.15s" }}>
              <span style={{ fontSize:20 }}>{item.icon}</span>
              <span style={{ flex:1, color:on?"#fff":"rgba(255,255,255,0.65)", fontSize:14, fontFamily:"monospace" }}>{item.label}</span>
              <div style={{ width:22, height:22, borderRadius:6, background:on?"#7CFC00":"rgba(255,255,255,0.08)", border:`2px solid ${on?"#7CFC00":"rgba(255,255,255,0.15)"}`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                {on && <span style={{ fontSize:12, color:"#000", fontWeight:900 }}>✓</span>}
              </div>
            </button>
          );
        })}
        {other.length > 0 && <>
          <div style={{ color:"rgba(255,255,255,0.2)", fontSize:9, fontFamily:"monospace", letterSpacing:"0.1em", marginTop:6, marginBottom:2 }}>OTHER</div>
          {other.map(item => {
            const on = checked.includes(item.id);
            return (
              <button key={item.id} onClick={() => toggle(item.id)} style={{ display:"flex", alignItems:"center", gap:12, background:on?"rgba(124,252,0,0.1)":"rgba(255,255,255,0.03)", border:`1px solid ${on?"rgba(124,252,0,0.35)":"rgba(255,255,255,0.06)"}`, borderRadius:12, padding:"12px 14px", cursor:"pointer", textAlign:"left", opacity: on?1:0.6, transition:"all 0.15s" }}>
                <span style={{ fontSize:18 }}>{item.icon}</span>
                <span style={{ flex:1, color:on?"#fff":"rgba(255,255,255,0.5)", fontSize:13, fontFamily:"monospace" }}>{item.label}</span>
                <div style={{ width:20, height:20, borderRadius:5, background:on?"#7CFC00":"rgba(255,255,255,0.08)", border:`2px solid ${on?"#7CFC00":"rgba(255,255,255,0.15)"}`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                  {on && <span style={{ fontSize:10, color:"#000", fontWeight:900 }}>✓</span>}
                </div>
              </button>
            );
          })}
        </>}
      </div>

      {/* Upsell suggestions */}
      {upsells.length > 0 && (
        <div style={{ background:"rgba(124,252,0,0.05)", border:"1px solid rgba(124,252,0,0.2)", borderRadius:14, padding:"14px 16px" }}>
          <div style={{ color:"#7CFC00", fontSize:11, fontFamily:"monospace", fontWeight:700, marginBottom:12 }}>💡 RECOMMENDED ADD-ONS</div>
          <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
            {upsells.map(u => (
              <div key={u.id} style={{ display:"flex", alignItems:"center", gap:12, background:"rgba(255,255,255,0.04)", borderRadius:10, padding:"11px 13px" }}>
                <div style={{ flex:1 }}>
                  <div style={{ color:"#fff", fontSize:13, fontFamily:"monospace", fontWeight:700 }}>{u.label}</div>
                  <div style={{ color:"rgba(255,255,255,0.35)", fontSize:11, fontFamily:"monospace", marginTop:2 }}>
                    +${u.price.toFixed(0)} this visit · +${u.annualBiweekly.toLocaleString()}/yr biweekly
                  </div>
                </div>
                <button onClick={() => { onAddService(u.id); }} style={{ background:"#7CFC00", color:"#000", border:"none", borderRadius:8, padding:"7px 12px", fontSize:12, fontWeight:700, fontFamily:"monospace", cursor:"pointer", whiteSpace:"nowrap" }}>+ ADD</button>
              </div>
            ))}
          </div>
        </div>
      )}

      {checked.length === 0 && (
        <div style={{ color:"rgba(255,255,255,0.25)", fontSize:12, fontFamily:"monospace", textAlign:"center", padding:"8px 0" }}>
          Nothing to flag? Tap Continue to build the quote.
        </div>
      )}

      <div style={{ display:"flex", gap:8 }}>
        <button onClick={onBack} style={{ ...btn(true,"ghost"), flex:"0 0 72px" }}>← BACK</button>
        <button onClick={() => onNext(checked)} style={{ ...btn(true), flex:1 }}>
          {checked.length > 0 ? `CONTINUE WITH ${upsells.length} SUGGESTION${upsells.length!==1?"S":""}` : "CONTINUE →"}
        </button>
      </div>
    </div>
  );
}

// ─── Quote Type Selector ──────────────────────────────────────────────────────
function QuoteTypeSelector({onSelect}){
  return(
    <div style={{padding:"8px 0 24px"}}>
      <div style={{color:"rgba(255,255,255,0.35)",fontFamily:"monospace",fontSize:10,letterSpacing:"0.1em",marginBottom:14,textTransform:"uppercase"}}>What type of quote?</div>
      {[
        {key:"lawn",    icon:"🌿", label:"Lawn & Landscaping", sub:"Mowing, fert, hardscape, etc."},
        {key:"holiday", icon:"🎄", label:"Holiday Lighting",   sub:"Christmas light install & takedown"},
      ].map(t=>(
        <button key={t.key} onClick={()=>onSelect(t.key)} style={{
          width:"100%",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.1)",
          borderRadius:12,padding:"16px 18px",marginBottom:10,display:"flex",gap:16,
          alignItems:"center",cursor:"pointer",textAlign:"left",transition:"border-color 0.2s"
        }}
        onMouseEnter={e=>e.currentTarget.style.borderColor="rgba(124,252,0,0.4)"}
        onMouseLeave={e=>e.currentTarget.style.borderColor="rgba(255,255,255,0.1)"}>
          <span style={{fontSize:28}}>{t.icon}</span>
          <div>
            <div style={{color:"#fff",fontFamily:"monospace",fontSize:13,fontWeight:700,marginBottom:2}}>{t.label}</div>
            <div style={{color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:11}}>{t.sub}</div>
          </div>
        </button>
      ))}
    </div>
  );
}

// ─── Holiday Quote Flow ───────────────────────────────────────────────────────
const HL_STEPS=["customer","address","measure","build"];

function HolidayQuoteFlow({googleReady,prefillCustomer,quickMode,onDone,rateSettings,onChangeType}){
  const anonCustomer = {id:genId(),name:"Door Hanger Lead",phone:"",email:"",createdAt:todayStr(),isAnon:true};
  const [step,setStep]           = useState(prefillCustomer?"address":quickMode?"address":"customer");
  const [customer,setCustomer]   = useState(prefillCustomer||(quickMode?anonCustomer:null));
  const [addressData,setAddressData] = useState(null);
  const [measurements,setMeasurements] = useState(null);

  const cur = HL_STEPS.indexOf(step);
  return(
    <div>
      {quickMode&&(
        <div style={{background:"rgba(255,107,53,0.08)",border:"1px solid rgba(255,107,53,0.25)",borderRadius:10,padding:"9px 14px",display:"flex",alignItems:"center",gap:8,marginBottom:16}}>
          <span style={{fontSize:16}}>🚪</span>
          <div>
            <div style={{color:"#ff6b35",fontSize:12,fontFamily:"monospace",fontWeight:700}}>QUICK HOLIDAY QUOTE</div>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace"}}>No customer info — save as door hanger lead</div>
          </div>
        </div>
      )}
      <div style={{display:"flex",gap:3,marginBottom:20}}>
        {HL_STEPS.map((s,i)=>(
          <div key={s} style={{flex:1,height:2,borderRadius:99,background:i<=cur?"#ff6b35":"rgba(255,255,255,0.1)",transition:"background 0.3s"}}/>
        ))}
      </div>
      <div key={step} style={{animation:"fadeIn 0.3s ease"}}>
        {step==="customer" && <CustomerIntake onNext={c=>{setCustomer(c);setStep("address");}} onQuickMode={()=>{setCustomer(anonCustomer);setStep("address");}} onBack={onChangeType}/>}
        {step==="address"  && <AddressCapture googleReady={googleReady} onNext={d=>{setAddressData(d);setStep("measure");}} onBack={()=>prefillCustomer?undefined:quickMode?onChangeType&&onChangeType():setStep("customer")} customer={customer}/>}
        {step==="measure"  && <HolidayMeasureStep addressData={addressData} googleReady={googleReady} onNext={m=>{setMeasurements(m);setStep("build");}} onBack={()=>setStep("address")}/>}
        {step==="build"    && customer && addressData && measurements &&
          <HolidayBuilder customer={customer} addressData={addressData} measurements={measurements} onDone={onDone} onBack={()=>setStep("measure")} rateSettings={rateSettings}/>}
      </div>
    </div>
  );
}

// ─── Holiday Measure Step ─────────────────────────────────────────────────────
// Google Maps polyline tracer: tap along the roofline/gutters to measure linear ft.
// Each path segment is labelled (Roofline, Gutters, etc.) and auto-sums.
const HL_PATH_TYPES = [
  { id:"roofline", label:"Roofline",      color:"#ff6b35" },
  { id:"gutters",  label:"Gutters/Fascia",color:"#ffaa00" },
  { id:"pathway",  label:"Pathway/Walkway",color:"#7CFC00"},
  { id:"garland",  label:"Garland Run",   color:"#4fc3f7" },
];

function HolidayMeasureStep({addressData,googleReady,onNext,onBack}){
  const mapDivRef  = useRef(null);
  const mapRef     = useRef(null);
  const pinsRef    = useRef([]);      // active working pins (Markers)
  const frozenRef  = useRef([]);      // all frozen polylines on the map
  const previewRef = useRef(null);    // live preview polyline

  const [mode,setMode]         = useState("idle");
  const [pathType,setPathType] = useState("roofline");
  const [placing,setPlacing]   = useState([]);   // current working lat/lngs
  const [paths,setPaths]       = useState([]);   // committed [{id,type,label,ft,color}]
  const [fullscreen,setFullscreen] = useState(false);
  const [m,setM] = useState({wreathCount:"",stakeCount:"",doorCount:"",roofPitch:"medium",outletAccess:"yes"});
  const upd=(k,v)=>setM(p=>({...p,[k]:v}));

  // Keep refs in sync for use inside event listeners
  const modeRef     = useRef(mode);
  const pathTypeRef = useRef(pathType);
  const placingRef  = useRef(placing);
  useEffect(()=>{ modeRef.current=mode; },[mode]);
  useEffect(()=>{ pathTypeRef.current=pathType; },[pathType]);
  useEffect(()=>{ placingRef.current=placing; },[placing]);

  // Init map
  useEffect(()=>{
    if(mapRef.current||!mapDivRef.current||!window.google?.maps) return;
    const center=addressData?.place?.geometry?.location||{lat:36.17,lng:-86.78};
    mapRef.current=new window.google.maps.Map(mapDivRef.current,{
      center,zoom:20,mapTypeId:"satellite",tilt:0,
      disableDefaultUI:true,zoomControl:true,gestureHandling:"greedy",
    });
  },[googleReady,addressData]);

  // Lock/unlock body+main scroll when fullscreen (fixes iOS fixed positioning)
  useEffect(()=>{
    const main=document.querySelector("main.scrl");
    if(fullscreen){
      document.body.style.overflow="hidden";
      if(main) main.style.overflow="hidden";
    }
    return ()=>{
      document.body.style.overflow="";
      if(main) main.style.overflow="auto";
    };
  },[fullscreen]);

  // Fullscreen resize
  useEffect(()=>{
    if(!mapRef.current||!window.google?.maps) return;
    const t=setTimeout(()=>{
      window.google.maps.event.trigger(mapRef.current,"resize");
      const c=mapRef.current.getCenter();
      if(c) mapRef.current.setCenter(c);
    },80);
    return ()=>clearTimeout(t);
  },[fullscreen]);

  // Cursor
  useEffect(()=>{
    if(mapDivRef.current)
      mapDivRef.current.setAttribute("style",`width:100%; height:${fullscreen?"100%":"300px"}; cursor:${mode==="placing"?"crosshair":"grab"} !important;`);
  },[mode,fullscreen]);

  // Redraw preview polyline whenever placing changes
  useEffect(()=>{
    if(!mapRef.current||!window.google?.maps) return;
    if(previewRef.current){ previewRef.current.setMap(null); previewRef.current=null; }
    if(placing.length<1) return;
    const pt=HL_PATH_TYPES.find(p=>p.id===pathTypeRef.current);
    const color=pt?.color||"#ff6b35";
    previewRef.current=new window.google.maps.Polyline({
      path:placing,strokeColor:color,strokeOpacity:0.9,strokeWeight:3,
      icons:[{icon:{path:window.google.maps.SymbolPath.FORWARD_OPEN_ARROW,scale:2},offset:"100%"}],
      map:mapRef.current,
    });
  },[placing]);

  // Map click listener — registered once
  useEffect(()=>{
    if(!mapRef.current||!window.google?.maps) return;
    const listener=mapRef.current.addListener("click",e=>{
      if(modeRef.current!=="placing") return;
      const ll={lat:e.latLng.lat(),lng:e.latLng.lng()};
      const pt=HL_PATH_TYPES.find(p=>p.id===pathTypeRef.current);
      const color=pt?.color||"#ff6b35";
      const idx=pinsRef.current.length;
      const marker=new window.google.maps.Marker({
        position:ll,map:mapRef.current,draggable:true,
        icon:{path:window.google.maps.SymbolPath.CIRCLE,scale:idx===0?10:7,
          fillColor:idx===0?"#fff":color,fillOpacity:1,strokeColor:color,strokeWeight:2},
        label:idx===0?{text:"START",color:idx===0?"#000":"#fff",fontSize:"8px",fontWeight:"bold"}:undefined,
        zIndex:idx+10,
      });
      marker.addListener("dragend",()=>{
        const newPos={lat:marker.getPosition().lat(),lng:marker.getPosition().lng()};
        setPlacing(pts=>{ const u=[...pts]; u[idx]=newPos; return u; });
      });
      pinsRef.current.push(marker);
      setPlacing(pts=>[...pts,ll]);
    });
    return ()=>window.google.maps.event.removeListener(listener);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  const computeFt=(latlngs)=>{
    if(latlngs.length<2) return 0;
    const gmPath=latlngs.map(p=>new window.google.maps.LatLng(p.lat,p.lng));
    return Math.round(window.google.maps.geometry.spherical.computeLength(gmPath)*3.28084);
  };

  const undoPin=()=>{
    if(!pinsRef.current.length) return;
    pinsRef.current.pop().setMap(null);
    setPlacing(pts=>pts.slice(0,-1));
  };

  const finishPath=()=>{
    if(placing.length<2){ cancelPath(); return; }
    const ft=computeFt(placing);
    const pt=HL_PATH_TYPES.find(p=>p.id===pathType);
    const color=pt?.color||"#ff6b35";
    const id=genId();
    // Freeze preview polyline
    if(previewRef.current){ previewRef.current.set("strokeOpacity",0.55); frozenRef.current.push(previewRef.current); previewRef.current=null; }
    pinsRef.current.forEach(p=>{ p.setDraggable(false); p.setMap(null); });
    pinsRef.current=[];
    setPaths(prev=>[...prev,{id,type:pathType,label:pt?.label||pathType,ft,color}]);
    setPlacing([]);
    setMode("idle");
  };

  const cancelPath=()=>{
    pinsRef.current.forEach(p=>p.setMap(null));
    pinsRef.current=[];
    if(previewRef.current){ previewRef.current.setMap(null); previewRef.current=null; }
    setPlacing([]);
    setMode("idle");
  };

  const removePath=(id)=>{
    setPaths(prev=>prev.filter(p=>p.id!==id));
  };

  const startPlacing=(type)=>{
    cancelPath();
    setPathType(type);
    setMode("placing");
  };

  const totalFt=paths.reduce((a,p)=>a+p.ft,0);
  const byType={};
  paths.forEach(p=>{ byType[p.type]=(byType[p.type]||0)+p.ft; });
  const nums={
    rooflineFt:byType.roofline||0,gutterFt:byType.gutters||0,garlandFt:byType.garland||0,
    wreathCount:Number(m.wreathCount)||0,stakeCount:Number(m.stakeCount)||0,
    doorCount:Number(m.doorCount)||0,windowCount:0,
  };
  const canNext=totalFt>0||nums.wreathCount>0;

  const hlColor="#ff6b35";
  const btnSm={background:"rgba(255,255,255,0.07)",border:"1px solid rgba(255,255,255,0.12)",borderRadius:10,padding:"13px",color:"rgba(255,255,255,0.8)",fontSize:12,fontFamily:"monospace",fontWeight:700,cursor:"pointer"};
  const inpSm=(label,key)=>(
    <div>
      <div style={{color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:10,letterSpacing:"0.06em",marginBottom:4,textTransform:"uppercase"}}>{label}</div>
      <input type="number" min="0" value={m[key]} onChange={e=>upd(key,e.target.value)} placeholder="0"
        style={{width:"100%",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.12)",borderRadius:8,padding:"9px 10px",color:"#fff",fontFamily:"monospace",fontSize:13,boxSizing:"border-box"}}/>
    </div>
  );

  const bottomControls=(
    <div style={{display:"flex",flexDirection:"column",gap:8}}>
      {mode==="idle"&&(
        <>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
            {HL_PATH_TYPES.map(pt=>(
              <button key={pt.id} onClick={()=>startPlacing(pt.id)} style={{
                padding:"10px 8px",borderRadius:9,border:`1px solid ${pt.color}44`,
                background:`${pt.color}18`,color:pt.color,
                fontFamily:"monospace",fontSize:10,fontWeight:700,cursor:"pointer",textTransform:"uppercase",letterSpacing:"0.06em"
              }}>+ {pt.label}</button>
            ))}
          </div>
          {paths.length>0&&(
            <div style={{display:"flex",flexDirection:"column",gap:5}}>
              {paths.map(p=>(
                <div key={p.id} style={{display:"flex",alignItems:"center",gap:8,padding:"7px 10px",borderRadius:8,background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.08)"}}>
                  <div style={{width:8,height:8,borderRadius:2,background:p.color,flexShrink:0}}/>
                  <div style={{flex:1,color:"rgba(255,255,255,0.7)",fontFamily:"monospace",fontSize:11}}>{p.label}</div>
                  <div style={{color:"#fff",fontFamily:"monospace",fontSize:12,fontWeight:700}}>{p.ft} ft</div>
                  <button onClick={()=>removePath(p.id)} style={{background:"none",border:"none",color:"rgba(255,255,255,0.25)",cursor:"pointer",fontSize:13,padding:"0 2px"}}>✕</button>
                </div>
              ))}
              <div style={{display:"flex",justifyContent:"space-between",padding:"7px 10px",background:"rgba(255,107,53,0.08)",borderRadius:8,border:"1px solid rgba(255,107,53,0.2)"}}>
                <span style={{color:"rgba(255,255,255,0.5)",fontFamily:"monospace",fontSize:11}}>TOTAL</span>
                <span style={{color:hlColor,fontFamily:"monospace",fontSize:13,fontWeight:700}}>{totalFt} ft</span>
              </div>
            </div>
          )}
        </>
      )}
      {mode==="placing"&&(
        <div style={{display:"flex",gap:8}}>
          <button onClick={undoPin} disabled={placing.length===0} style={{...btnSm,flex:1,color:placing.length>0?"rgba(255,255,255,0.8)":"rgba(255,255,255,0.2)",cursor:placing.length>0?"pointer":"default"}}>↩ UNDO</button>
          <button onClick={finishPath} disabled={placing.length<2} style={{...btnSm,flex:2,background:placing.length>=2?hlColor:"rgba(255,255,255,0.07)",color:placing.length>=2?"#fff":"rgba(255,255,255,0.2)",border:"none",cursor:placing.length>=2?"pointer":"default"}}>
            ✓ DONE {placing.length>=2?`(${computeFt(placing)} ft)`:"(need 2+ pts)"}
          </button>
          <button onClick={cancelPath} style={{...btnSm,color:"#ff6b6b",border:"1px solid rgba(255,68,68,0.3)",background:"rgba(255,68,68,0.07)"}}>✕</button>
        </div>
      )}
    </div>
  );

  return(
    <div>
      {onBack&&<button onClick={onBack} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12,cursor:"pointer",padding:"0 0 14px",display:"flex",alignItems:"center",gap:6}}>← Back</button>}
      <div style={{color:hlColor,fontFamily:"monospace",fontSize:11,letterSpacing:"0.1em",marginBottom:2,textTransform:"uppercase"}}>🎄 Holiday Lighting</div>
      <div style={{color:"#fff",fontFamily:"monospace",fontSize:16,fontWeight:700,marginBottom:2}}>Measure the Property</div>
      <div style={{color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:11,marginBottom:12}}>{addressData?.address||""}</div>

      {/* Fullscreen overlay */}
      {fullscreen&&(
        <div style={{position:"fixed",top:0,right:0,bottom:0,left:0,zIndex:9999,display:"flex",flexDirection:"column",pointerEvents:"none"}}>
          <div style={{position:"absolute",top:0,left:0,right:0,background:"linear-gradient(to bottom,rgba(0,0,0,0.82),transparent)",padding:"14px 14px 36px",display:"flex",justifyContent:"space-between",alignItems:"center",zIndex:2,pointerEvents:"all"}}>
            <div style={{color:"rgba(255,255,255,0.8)",fontSize:12,fontFamily:"monospace"}}>
              {mode==="placing"
                ? placing.length<2?"👆 Tap to place pins — drag to adjust":"✓ Done when ready"
                : paths.length>0?`${paths.length} path${paths.length!==1?"s":""} · ${totalFt} ft total`:"Tap a path type below to start tracing"}
            </div>
            <button onClick={()=>setFullscreen(false)} style={{background:"rgba(0,0,0,0.75)",border:"1px solid rgba(255,255,255,0.3)",borderRadius:8,padding:"8px 14px",color:"#fff",fontSize:12,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>✕ EXIT</button>
          </div>
          {mode==="placing"&&placing.length>0&&(
            <div style={{position:"absolute",top:"38%",left:"50%",transform:"translate(-50%,-50%)",background:"rgba(0,0,0,0.8)",borderRadius:8,padding:"7px 16px",color:hlColor,fontSize:12,fontFamily:"monospace",fontWeight:700,border:`1px solid ${hlColor}66`,whiteSpace:"nowrap",zIndex:2,pointerEvents:"none"}}>
              {placing.length} pin{placing.length!==1?"s":""}{placing.length>=2?` · ${computeFt(placing)} ft`:""}
            </div>
          )}
          {/* Side controls — compact panel docked in the top-left corner
              (was a full-width bottom bar). */}
          <div style={{position:"absolute",top:54,left:12,width:180,maxWidth:"52vw",maxHeight:"calc(100% - 140px)",overflowY:"auto",background:"rgba(5,14,5,0.95)",border:"1px solid rgba(255,107,53,0.2)",borderRadius:12,padding:10,zIndex:2,pointerEvents:"all",boxShadow:"0 8px 28px rgba(0,0,0,0.45)"}}>
            {bottomControls}
          </div>
        </div>
      )}

      {/* Map container — always mounted */}
      <div style={{position:fullscreen?"fixed":"relative",top:fullscreen?0:"auto",right:fullscreen?0:"auto",bottom:fullscreen?0:"auto",left:fullscreen?0:"auto",zIndex:fullscreen?9998:"auto",borderRadius:fullscreen?0:10,overflow:"hidden",border:fullscreen?"none":"1px solid rgba(255,255,255,0.1)"}}>
        <div ref={mapDivRef} style={{width:"100%",height:fullscreen?"100%":300}}/>
        {!fullscreen&&(
          <button onClick={()=>setFullscreen(true)} style={{position:"absolute",top:10,right:10,background:"rgba(0,0,0,0.72)",border:"1px solid rgba(255,255,255,0.25)",borderRadius:8,padding:"7px 11px",color:"#fff",fontSize:11,fontFamily:"monospace",fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",gap:5}}>
            ⛶ FULL
          </button>
        )}
      </div>

      {/* Normal-mode controls */}
      {!fullscreen&&(
        <div style={{marginTop:12,marginBottom:16}}>
          {bottomControls}
        </div>
      )}

      {/* Items, pitch, outlets */}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:12}}>
        {inpSm("Wreaths","wreathCount")}
        {inpSm("Path Stakes","stakeCount")}
        {inpSm("Door/Window","doorCount")}
      </div>
      <div style={{marginBottom:10}}>
        <div style={{color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:10,letterSpacing:"0.06em",marginBottom:5,textTransform:"uppercase"}}>Roof Pitch</div>
        <div style={{display:"flex",gap:6}}>
          {["low","medium","steep"].map(p=>(
            <button key={p} onClick={()=>upd("roofPitch",p)} style={{flex:1,padding:"8px 0",borderRadius:7,border:"1px solid",fontFamily:"monospace",fontSize:10,cursor:"pointer",textTransform:"uppercase",
              borderColor:m.roofPitch===p?hlColor:"rgba(255,255,255,0.1)",
              background:m.roofPitch===p?"rgba(255,107,53,0.15)":"rgba(255,255,255,0.04)",
              color:m.roofPitch===p?hlColor:"rgba(255,255,255,0.4)"}}>{p}</button>
          ))}
        </div>
      </div>
      <div style={{marginBottom:16}}>
        <div style={{color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:10,letterSpacing:"0.06em",marginBottom:5,textTransform:"uppercase"}}>Outdoor Outlets?</div>
        <div style={{display:"flex",gap:6}}>
          {["yes","no"].map(v=>(
            <button key={v} onClick={()=>upd("outletAccess",v)} style={{flex:1,padding:"8px 0",borderRadius:7,border:"1px solid",fontFamily:"monospace",fontSize:10,cursor:"pointer",textTransform:"uppercase",
              borderColor:m.outletAccess===v?"#7CFC00":"rgba(255,255,255,0.1)",
              background:m.outletAccess===v?"rgba(124,252,0,0.1)":"rgba(255,255,255,0.04)",
              color:m.outletAccess===v?"#7CFC00":"rgba(255,255,255,0.4)"}}>{v}</button>
          ))}
        </div>
      </div>

      <button onClick={()=>canNext&&onNext({...nums,roofPitch:m.roofPitch,outletAccess:m.outletAccess,paths})} style={{
        width:"100%",background:canNext?hlColor:"rgba(255,255,255,0.08)",color:canNext?"#fff":"rgba(255,255,255,0.25)",
        border:"none",borderRadius:10,padding:"14px",fontFamily:"monospace",fontSize:13,fontWeight:700,cursor:canNext?"pointer":"not-allowed"
      }}>Build Quote →</button>
      {!canNext&&<div style={{color:"rgba(255,255,255,0.3)",fontFamily:"monospace",fontSize:11,textAlign:"center",marginTop:7}}>Trace at least one path or add items to continue</div>}
    </div>
  );
}

// ─── Holiday Builder ──────────────────────────────────────────────────────────
function HolidayBuilder({customer,addressData,measurements,onDone,onBack,rateSettings}){
  const merged = mergeRateSettings(rateSettings);
  const [selSvc,setSelSvc] = useState("install_takedown");
  const [items,setItems] = useState(()=>
    HOLIDAY_ITEMS.map(item=>{
      const r = merged.holidayItems[item.id]||item;
      // Pre-fill qty from measurements
      let qty = 0;
      if(item.id==="hli_roofline") qty = Math.round((measurements?.rooflineFt||0)+(measurements?.gutterFt||0));
      if(item.id==="hli_garland")  qty = Math.round(measurements?.garlandFt||0);
      if(item.id==="hli_wreath")   qty = measurements?.wreathCount||0;
      if(item.id==="hli_stake")    qty = measurements?.stakeCount||0;
      return {...item, pricePerUnit:r.pricePerUnit, qty, on: qty>0};
    })
  );
  const [installDate,setInstallDate]=useState("");
  const [takedownDate,setTakedownDate]=useState("");
  const [taxRate,setTaxRate]=useState(0);
  const [discount,setDiscount]=useState(0);
  const [notes,setNotes]=useState("");
  const [saving,setSaving]=useState(false);

  const svcOpt = HOLIDAY_SVC_OPTIONS.find(o=>o.id===selSvc)||HOLIDAY_SVC_OPTIONS[0];
  const activeItems = items.filter(i=>i.on&&i.qty>0);
  const installTotal = activeItems.reduce((a,i)=>a+i.pricePerUnit*i.qty,0);
  const takedownAmt  = Math.round(installTotal*(svcOpt.takedownPct/100)*100)/100;
  const subtotal     = Math.round((installTotal + takedownAmt + svcOpt.storageFee)*100)/100;
  const discAmt      = Math.round(subtotal*(discount/100)*100)/100;
  const taxAmt       = Math.round((subtotal-discAmt)*(taxRate/100)*100)/100;
  const total        = subtotal - discAmt + taxAmt;
  const deposit      = Math.round(total*0.50*100)/100;

  const setQty=(id,val)=>setItems(it=>it.map(i=>i.id===id?{...i,qty:Math.max(0,Number(val)||0),on:(Number(val)||0)>0}:i));
  const toggleOn=(id)=>setItems(it=>it.map(i=>i.id===id?{...i,on:!i.on,qty:!i.on&&i.qty===0?1:i.qty}:i));

  const inpStyle={background:"rgba(255,255,255,0.08)",border:"1px solid rgba(255,255,255,0.15)",borderRadius:7,padding:"7px 10px",color:"#fff",fontFamily:"monospace",fontSize:13,textAlign:"right",width:72};

  const handleSave=async()=>{
    setSaving(true);
    const{data:{session}}=await supabase.auth.getSession();
    if(!session){setSaving(false);return;}
    const uid=session.user.id;
    const qId=genId(); const qNum2=qNum();
    const services=activeItems.map(i=>({id:i.id,label:`${i.label} (${i.qty}${i.unit})`,price:Math.round(i.pricePerUnit*i.qty*100)/100}));
    if(takedownAmt>0) services.push({id:"takedown",label:"Takedown",price:takedownAmt});
    if(svcOpt.storageFee>0) services.push({id:"storage",label:"Storage",price:svcOpt.storageFee});

    let custId=customer.id;
    if(customer.isAnon||!custId){
      custId=genId();
      await supabase.from("customers").insert({id:custId,user_id:uid,name:customer.name||"Holiday Lead",phone:customer.phone||"",email:customer.email||"",address:addressData?.address||""});
    }
    const row={
      id:qId,user_id:uid,customer_id:custId,
      quote_num:qNum2,stage:"Lead",
      customer_name:customer.name||"",customer_phone:customer.phone||"",
      address:addressData?.address||"",
      services,materials:[],
      subtotal:Math.round(subtotal*100)/100,
      disc_amt:discAmt,tax_amt:taxAmt,tax_rate:taxRate,
      discount,total:Math.round(total*100)/100,
      notes,share_token:genId(),
      quote_category:"holiday",
      holiday_measurements:measurements,
      deposit_amount:deposit,
      preferred_install_date:installDate||null,
      preferred_takedown_date:takedownDate||null,
      created_at:todayStr(),
    };
    await supabase.from("quotes").insert(row);
    setSaving(false);
    onDone&&onDone({...row,quoteNum:qNum2,customerId:custId,customerName:customer.name||"",customerPhone:customer.phone||"",createdAt:todayStr(),discAmt,taxAmt,taxRate,shareToken:row.share_token,quoteCategory:"holiday",holidayMeasurements:measurements,depositAmount:deposit,depositPaid:false,depositStripeLink:null,preferredInstallDate:installDate||null,preferredTakedownDate:takedownDate||null,photos:[],services,materials:[]});
  };

  return(
    <div>
      {onBack&&<button onClick={onBack} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12,cursor:"pointer",padding:"0 0 18px",display:"flex",alignItems:"center",gap:6}}>← Back</button>}
      <div style={{color:"#ff6b35",fontFamily:"monospace",fontSize:11,letterSpacing:"0.1em",marginBottom:2,textTransform:"uppercase"}}>🎄 Holiday Lighting</div>
      <div style={{color:"#fff",fontFamily:"monospace",fontSize:16,fontWeight:700,marginBottom:20}}>{customer.name||"Holiday Quote"}</div>

      {/* Service option */}
      <div style={{display:"flex",gap:6,marginBottom:20}}>
        {HOLIDAY_SVC_OPTIONS.map(o=>(
          <button key={o.id} onClick={()=>setSelSvc(o.id)} style={{flex:1,padding:"10px 6px",borderRadius:10,border:`1px solid ${selSvc===o.id?"#ff6b35":"rgba(255,255,255,0.1)"}`,background:selSvc===o.id?"rgba(255,107,53,0.12)":"rgba(255,255,255,0.03)",color:selSvc===o.id?"#ff6b35":"rgba(255,255,255,0.5)",fontFamily:"monospace",fontSize:10,fontWeight:700,cursor:"pointer",textAlign:"center",lineHeight:1.4}}>
            {o.label}
          </button>
        ))}
      </div>

      {/* Line items */}
      <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:20}}>
        {items.map(item=>(
          <div key={item.id} style={{display:"flex",alignItems:"center",gap:10,padding:"11px 13px",borderRadius:10,border:`1px solid ${item.on?"rgba(255,107,53,0.3)":"rgba(255,255,255,0.07)"}`,background:item.on?"rgba(255,107,53,0.06)":"rgba(255,255,255,0.02)"}}>
            <button onClick={()=>toggleOn(item.id)} style={{width:20,height:20,borderRadius:5,flexShrink:0,background:item.on?"#ff6b35":"rgba(255,255,255,0.08)",border:`2px solid ${item.on?"#ff6b35":"rgba(255,255,255,0.15)"}`,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
              {item.on&&<span style={{fontSize:10,color:"#fff",fontWeight:900}}>✓</span>}
            </button>
            <div style={{flex:1}}>
              <div style={{color:"#fff",fontSize:13,fontFamily:"monospace"}}>{item.label}</div>
              <div style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontFamily:"monospace"}}>${item.pricePerUnit.toFixed(2)}/{item.unit}</div>
            </div>
            <input type="number" min="0" value={item.qty||""} placeholder="0"
              onChange={e=>setQty(item.id,e.target.value)}
              style={inpStyle}/>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:10,fontFamily:"monospace",width:20}}>{item.unit}</div>
            <div style={{color:item.on&&item.qty>0?"#ff6b35":"rgba(255,255,255,0.2)",fontSize:13,fontWeight:700,fontFamily:"monospace",width:52,textAlign:"right"}}>
              {item.on&&item.qty>0?`$${(item.pricePerUnit*item.qty).toFixed(0)}`:"—"}
            </div>
          </div>
        ))}
      </div>

      {/* Takedown / storage adders */}
      {(takedownAmt>0||svcOpt.storageFee>0)&&(
        <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.07)",borderRadius:10,padding:"11px 13px",marginBottom:16}}>
          {takedownAmt>0&&<div style={{display:"flex",justifyContent:"space-between",fontFamily:"monospace",fontSize:12,color:"rgba(255,255,255,0.4)",marginBottom:svcOpt.storageFee>0?6:0}}>
            <span>Takedown ({svcOpt.takedownPct}% of install)</span><span>${takedownAmt.toFixed(0)}</span>
          </div>}
          {svcOpt.storageFee>0&&<div style={{display:"flex",justifyContent:"space-between",fontFamily:"monospace",fontSize:12,color:"rgba(255,255,255,0.4)"}}>
            <span>Storage fee</span><span>${svcOpt.storageFee}</span>
          </div>}
        </div>
      )}

      {/* Schedule & details */}
      <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:16}}>
        <div style={{display:"flex",gap:10}}>
          <div style={{flex:1}}>
            <div style={{color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:9,letterSpacing:"0.08em",marginBottom:5,textTransform:"uppercase"}}>Install Date</div>
            <input type="date" value={installDate} onChange={e=>setInstallDate(e.target.value)} style={{width:"100%",background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"9px 10px",color:"#fff",fontFamily:"monospace",fontSize:12,boxSizing:"border-box"}}/>
          </div>
          <div style={{flex:1}}>
            <div style={{color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:9,letterSpacing:"0.08em",marginBottom:5,textTransform:"uppercase"}}>Takedown Date</div>
            <input type="date" value={takedownDate} onChange={e=>setTakedownDate(e.target.value)} style={{width:"100%",background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"9px 10px",color:"#fff",fontFamily:"monospace",fontSize:12,boxSizing:"border-box"}}/>
          </div>
        </div>
        <div style={{display:"flex",gap:10}}>
          <div style={{flex:1}}>
            <div style={{color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:9,letterSpacing:"0.08em",marginBottom:5,textTransform:"uppercase"}}>Discount %</div>
            <input type="number" min="0" max="100" value={discount} onChange={e=>setDiscount(Number(e.target.value)||0)} style={{width:"100%",background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"9px 10px",color:"#fff",fontFamily:"monospace",fontSize:12,boxSizing:"border-box"}}/>
          </div>
          <div style={{flex:1}}>
            <div style={{color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:9,letterSpacing:"0.08em",marginBottom:5,textTransform:"uppercase"}}>Tax %</div>
            <input type="number" min="0" max="20" value={taxRate} onChange={e=>setTaxRate(Number(e.target.value)||0)} style={{width:"100%",background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"9px 10px",color:"#fff",fontFamily:"monospace",fontSize:12,boxSizing:"border-box"}}/>
          </div>
        </div>
        <div>
          <div style={{color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:9,letterSpacing:"0.08em",marginBottom:5,textTransform:"uppercase"}}>Notes</div>
          <textarea value={notes} onChange={e=>setNotes(e.target.value)} rows={2} style={{width:"100%",background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"9px 10px",color:"#fff",fontFamily:"monospace",fontSize:12,boxSizing:"border-box",resize:"vertical"}}/>
        </div>
      </div>

      {/* Totals */}
      <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:10,padding:"14px 16px",marginTop:4}}>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:6,fontFamily:"monospace",fontSize:12,color:"rgba(255,255,255,0.5)"}}>
          <span>Subtotal</span><span>${subtotal.toFixed(2)}</span>
        </div>
        {discAmt>0&&<div style={{display:"flex",justifyContent:"space-between",marginBottom:6,fontFamily:"monospace",fontSize:12,color:"rgba(255,255,255,0.5)"}}>
          <span>Discount</span><span>−${discAmt.toFixed(2)}</span>
        </div>}
        {taxAmt>0&&<div style={{display:"flex",justifyContent:"space-between",marginBottom:6,fontFamily:"monospace",fontSize:12,color:"rgba(255,255,255,0.5)"}}>
          <span>Tax</span><span>${taxAmt.toFixed(2)}</span>
        </div>}
        <div style={{display:"flex",justifyContent:"space-between",fontFamily:"monospace",fontSize:15,fontWeight:700,color:"#fff",borderTop:"1px solid rgba(255,255,255,0.08)",paddingTop:10,marginTop:6}}>
          <span>Total</span><span>${total.toFixed(2)}</span>
        </div>
        <div style={{display:"flex",justifyContent:"space-between",fontFamily:"monospace",fontSize:12,color:"#ff6b35",marginTop:6}}>
          <span>50% Deposit</span><span>${deposit.toFixed(2)}</span>
        </div>
      </div>

      <button onClick={handleSave} disabled={saving} style={{
        width:"100%",marginTop:16,background:saving?"rgba(255,255,255,0.1)":"#ff6b35",
        color:saving?"rgba(255,255,255,0.4)":"#fff",border:"none",borderRadius:10,
        padding:"15px",fontFamily:"monospace",fontSize:13,fontWeight:700,cursor:saving?"not-allowed":"pointer"
      }}>{saving?"Saving...":"Save Holiday Quote →"}</button>
    </div>
  );
}

// ─── Quote Flow ───────────────────────────────────────────────────────────────
const QSTEPS=["customer","address","boundary","scan","build"];

function QuoteFlow({googleReady,prefillCustomer,quickMode,onDone,onSaveTemplate,rateSettings,onChangeType}){
  // Quick mode starts at address and uses a placeholder customer
  const anonCustomer = {id:genId(), name:"Door Hanger Lead", phone:"", email:"", createdAt:todayStr(), isAnon:true};
  const [step,setStep]=useState(prefillCustomer?"address":quickMode?"address":"customer");
  const [customer,setCustomer]=useState(prefillCustomer||(quickMode?anonCustomer:null));
  const [addressData,setAddressData]=useState(null);
  const [sqft,setSqft]=useState(0);
  const [scanObs,setScanObs]=useState([]);
  const [extraSvcs,setExtraSvcs]=useState([]);
  const merged=mergeRateSettings(rateSettings);
  const defaultRates=merged.services;

  const activeSteps = quickMode
    ? ["address","boundary","scan","build"]
    : QSTEPS;

  return(
    <div>
      {quickMode&&(
        <div style={{background:"rgba(255,170,0,0.08)",border:"1px solid rgba(255,170,0,0.25)",borderRadius:10,padding:"9px 14px",display:"flex",alignItems:"center",gap:8,marginBottom:16}}>
          <span style={{fontSize:16}}>🚪</span>
          <div>
            <div style={{color:"#ffaa00",fontSize:12,fontFamily:"monospace",fontWeight:700}}>QUICK QUOTE MODE</div>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace"}}>No customer info needed — save as anonymous lead</div>
          </div>
        </div>
      )}
      <div style={{display:"flex",gap:3,marginBottom:20}}>
        {activeSteps.map((s,i)=>{const cur=activeSteps.indexOf(step);return <div key={s} style={{flex:1,height:2,borderRadius:99,background:i<=cur?"#7CFC00":"rgba(255,255,255,0.1)",transition:"background 0.3s"}}/>;  })}
      </div>
      <div key={step} style={{animation:"fadeIn 0.3s ease"}}>
        {step==="customer"&&<CustomerIntake onNext={c=>{setCustomer(c);setStep("address");}} onQuickMode={()=>{setCustomer({id:genId(),name:"Door Hanger Lead",phone:"",email:"",createdAt:todayStr(),isAnon:true});setStep("address");}} onBack={onChangeType}/>}
        {step==="address" &&<AddressCapture googleReady={googleReady} onNext={d=>{setAddressData(d);setStep("boundary");}} onBack={()=>prefillCustomer?undefined:quickMode?onChangeType&&onChangeType():setStep("customer")} customer={customer}/>}
        {step==="boundary"&&addressData&&<BoundaryCapture addressData={addressData} onNext={sf=>{setSqft(sf);setStep("scan");}} onBack={()=>setStep("address")}/>}
        {step==="scan"    &&<PropertyScan sqft={sqft} selSvc={["mow",...extraSvcs]} rates={defaultRates} onAddService={id=>setExtraSvcs(e=>e.includes(id)?e:[...e,id])} onNext={obs=>{setScanObs(obs);setStep("build");}} onBack={()=>setStep("boundary")}/>}
        {step==="build"   &&customer&&addressData&&<QuoteBuilder customer={customer} addressData={addressData} sqft={sqft} scanObs={scanObs} preselectSvcs={["mow",...extraSvcs]} onDone={onDone} onBack={()=>setStep("scan")} quickMode={quickMode} onSaveTemplate={onSaveTemplate} defaultRates={merged.services} defaultLsRates={merged.landscapeServices}/>}
      </div>
    </div>
  );
}

function CustomerIntake({onNext,onQuickMode,onBack}){
  const [name,setName]=useState(""); const [phone,setPhone]=useState(""); const [email,setEmail]=useState("");
  const hasName=name.trim().length>0;
  const hasPhone=phone.replace(/\D/g,"").length>=10;
  const valid=hasName&&hasPhone;
  const fmt=v=>{const d=v.replace(/\D/g,"").slice(0,10);if(d.length>=7)return`(${d.slice(0,3)}) ${d.slice(3,6)}-${d.slice(6)}`;if(d.length>=4)return`(${d.slice(0,3)}) ${d.slice(3)}`;if(d.length)return`(${d}`;return"";};
  return(
    <div style={{display:"flex",flexDirection:"column",gap:18}}>
      {onBack&&<button onClick={onBack} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12,cursor:"pointer",padding:"0 0 4px",display:"flex",alignItems:"center",gap:6,alignSelf:"flex-start"}}>← Change type</button>}
      <div><p style={S.label}>Step 1 — Customer</p><h2 style={S.heading}>Who's the job for?</h2></div>

      {/* Quick Quote shortcut — only shown when handler is provided */}
      {!!onQuickMode&&<button onClick={onQuickMode} style={{display:"flex",alignItems:"center",gap:12,background:"rgba(255,170,0,0.08)",border:"1px solid rgba(255,170,0,0.3)",borderRadius:12,padding:"14px 16px",cursor:"pointer",textAlign:"left",width:"100%",transition:"all 0.2s"}}>
        <span style={{fontSize:24}}>🚪</span>
        <div style={{flex:1}}>
          <div style={{color:"#ffaa00",fontSize:13,fontFamily:"monospace",fontWeight:700}}>QUICK QUOTE — DOOR HANGER</div>
          <div style={{color:"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace",marginTop:2}}>Skip customer info · go straight to the address · save as anonymous lead</div>
        </div>
        <span style={{color:"rgba(255,170,0,0.6)",fontSize:16}}>→</span>
      </button>}

      {!!onQuickMode&&<div style={{display:"flex",alignItems:"center",gap:10}}>
        <div style={{flex:1,height:1,background:"rgba(255,255,255,0.08)"}}/>
        <span style={{color:"rgba(255,255,255,0.25)",fontSize:11,fontFamily:"monospace"}}>OR ENTER CUSTOMER INFO</span>
        <div style={{flex:1,height:1,background:"rgba(255,255,255,0.08)"}}/>
      </div>}

      <Field label="Full Name" value={name} onChange={setName} placeholder="Jane Smith" required/>
      <Field label="Phone Number" value={phone} onChange={v=>setPhone(fmt(v))} placeholder="(555) 867-5309" required/>
      <Field label="Email (optional)" value={email} onChange={setEmail} placeholder="jane@email.com"/>
      <button onClick={()=>valid&&onNext({id:genId(),name,phone,email,createdAt:todayStr()})} disabled={!valid} style={btn(valid)}>NEXT: ADDRESS →</button>
    </div>
  );
}

function AddressCapture({googleReady,onNext,onBack,customer}){
  const inputRef=useRef(null);const acRef=useRef(null);const mapRef=useRef(null);const mapDivRef=useRef(null);const markerRef=useRef(null);
  const [address,setAddress]=useState("");const [place,setPlace]=useState(null);
  const [geoLoading,setGeoLoading]=useState(false);

  const placeMarker=(latLng)=>{
    if(!mapRef.current||!window.google?.maps) return;
    mapRef.current.setCenter(latLng);mapRef.current.setZoom(20);
    if(markerRef.current) markerRef.current.setMap(null);
    markerRef.current=new window.google.maps.Marker({
      position:latLng,map:mapRef.current,draggable:true,
      icon:{path:window.google.maps.SymbolPath.CIRCLE,scale:8,fillColor:"#7CFC00",fillOpacity:1,strokeColor:"#fff",strokeWeight:2}
    });
    markerRef.current.addListener("dragend",()=>{
      const p=markerRef.current.getPosition();
      doReverseGeocode({lat:p.lat(),lng:p.lng()});
    });
  };

  const doReverseGeocode=(latLng)=>{
    if(!window.google?.maps) return;
    new window.google.maps.Geocoder().geocode({location:latLng},(results,status)=>{
      if(status==="OK"&&results[0]){setAddress(results[0].formatted_address||"");setPlace(results[0]);placeMarker(latLng);}
    });
  };

  const handleGPS=()=>{
    if(!navigator.geolocation||!window.google?.maps) return;
    setGeoLoading(true);
    navigator.geolocation.getCurrentPosition(
      pos=>{setGeoLoading(false);doReverseGeocode({lat:pos.coords.latitude,lng:pos.coords.longitude});},
      ()=>setGeoLoading(false),{timeout:8000}
    );
  };

  useEffect(()=>{
    if(!googleReady||mapRef.current||!mapDivRef.current)return;
    mapRef.current=new window.google.maps.Map(mapDivRef.current,{center:{lat:36.17,lng:-86.78},zoom:17,mapTypeId:"satellite",tilt:0,disableDefaultUI:true,gestureHandling:"none"});
    mapRef.current.addListener("click",e=>doReverseGeocode({lat:e.latLng.lat(),lng:e.latLng.lng()}));
  },[googleReady]);

  useEffect(()=>{
    if(!googleReady||acRef.current||!inputRef.current)return;
    acRef.current=new window.google.maps.places.Autocomplete(inputRef.current,{types:["address"],componentRestrictions:{country:"us"}});
    acRef.current.addListener("place_changed",()=>{
      const p=acRef.current.getPlace();if(!p?.geometry)return;
      setAddress(p.formatted_address||"");setPlace(p);
      const loc=p.geometry.location;
      placeMarker({lat:loc.lat(),lng:loc.lng()});
    });
  },[googleReady]);

  return(
    <div style={{display:"flex",flexDirection:"column",gap:16}}>
      <div><p style={S.label}>Step 2 — Property</p><h2 style={S.heading}>Job address</h2>{customer&&<p style={S.sub}>For {customer.name}</p>}</div>
      <div style={{borderRadius:12,overflow:"hidden",height:170,border:"1px solid rgba(124,252,0,0.2)",position:"relative"}}>
        <div ref={mapDivRef} style={{width:"100%",height:"100%"}}/>
        {!googleReady&&<div style={{position:"absolute",inset:0,background:"#0d1f0d",display:"flex",alignItems:"center",justifyContent:"center"}}><span style={{color:"#7CFC00",fontFamily:"monospace",fontSize:12}}>LOADING…</span></div>}
        <div style={S.mapBadge}>SATELLITE</div>
        <div style={{position:"absolute",bottom:8,left:8,color:"rgba(255,255,255,0.5)",fontFamily:"monospace",fontSize:9,background:"rgba(0,0,0,0.6)",padding:"3px 6px",borderRadius:4}}>tap map · drag pin · or search below</div>
      </div>
      <button onClick={handleGPS} disabled={geoLoading||!googleReady} style={{display:"flex",alignItems:"center",justifyContent:"center",gap:8,background:"rgba(0,207,255,0.08)",border:"1px solid rgba(0,207,255,0.3)",borderRadius:10,padding:"11px 14px",color:geoLoading?"rgba(255,255,255,0.4)":"#00cfff",fontFamily:"monospace",fontSize:12,fontWeight:700,cursor:geoLoading?"default":"pointer",width:"100%"}}>
        <span>{geoLoading?"⏳":"📍"}</span>{geoLoading?"Detecting location…":"Use My Location"}
      </button>
      <div style={{background:"rgba(255,255,255,0.06)",border:"1px solid rgba(124,252,0,0.3)",borderRadius:10,padding:"11px 13px",display:"flex",gap:8,alignItems:"center"}}>
        <span style={{color:"#7CFC00"}}>📍</span>
        <input ref={inputRef} value={address} onChange={e=>setAddress(e.target.value)} placeholder="123 Main St…" disabled={!googleReady} style={{background:"none",border:"none",outline:"none",color:"#fff",fontSize:13,flex:1,fontFamily:"monospace"}}/>
      </div>
      {place&&<div style={{...S.card,borderColor:"rgba(124,252,0,0.15)"}}><div style={{color:"rgba(124,252,0,0.7)",fontSize:11,fontFamily:"monospace"}}>✓ {address}</div></div>}
      <div style={{display:"flex",gap:8}}>
        {onBack&&<button onClick={onBack} style={{...btn(true,"ghost"),flex:"0 0 72px"}}>← BACK</button>}
        <button onClick={()=>address.trim()&&onNext({address,place})} disabled={!address.trim()} style={{...btn(!!address.trim()),flex:1}}>NEXT: DRAW →</button>
      </div>
    </div>
  );
}

const ZONE_LABELS = ["Front Lawn","Backyard","Side Yard","Side Yard 2","Garden Bed","Other"];
const OBSTACLE_LABELS = ["House","Driveway","Pool","Patio","Shed","Garage","Other"];

function BoundaryCapture({addressData,onNext,onBack}){
  const mapDivRef  = useRef(null);
  const mapRef     = useRef(null);
  const pinsRef    = useRef([]);      // google.maps.Marker list
  const polyRef    = useRef(null);    // current preview polyline/polygon
  const [mode,       setMode]       = useState("idle");
  const [zoneType,   setZoneType]   = useState("zone");
  const [zones,      setZones]      = useState([]);
  const [pinLatLngs, setPinLatLngs] = useState([]);
  const [labelModal, setLabelModal] = useState(null);
  const [fullscreen, setFullscreen] = useState(false);

  const totalSqft = zones.reduce((a,z)=>z.type==="zone"?a+z.sqft:a-z.sqft,0);
  const netSqft   = Math.max(0,totalSqft);

  // ── Init map ──────────────────────────────────────────────────────────────
  useEffect(()=>{
    if(mapRef.current||!mapDivRef.current||!window.google?.maps) return;
    const center = addressData.place?.geometry?.location || {lat:36.17,lng:-86.78};
    mapRef.current = new window.google.maps.Map(mapDivRef.current,{
      center, zoom:20, mapTypeId:"satellite", tilt:0,
      disableDefaultUI:true, zoomControl:true,
      gestureHandling:"greedy",
    });
  },[addressData]);

  // Lock/unlock body+main scroll when fullscreen (fixes iOS fixed positioning)
  useEffect(()=>{
    const main=document.querySelector("main.scrl");
    if(fullscreen){
      document.body.style.overflow="hidden";
      if(main) main.style.overflow="hidden";
    }
    return ()=>{
      document.body.style.overflow="";
      if(main) main.style.overflow="auto";
    };
  },[fullscreen]);

  // When fullscreen changes, resize the map to fill the new container
  useEffect(()=>{
    if(!mapRef.current||!window.google?.maps) return;
    // Small delay so DOM has updated
    const t = setTimeout(()=>{
      window.google.maps.event.trigger(mapRef.current,"resize");
      const c = mapRef.current.getCenter();
      if(c) mapRef.current.setCenter(c);
    },80);
    return ()=>clearTimeout(t);
  },[fullscreen]);

  // Update cursor based on mode — use setAttribute to support !important
  useEffect(()=>{
    if(mapDivRef.current){
      const cursor = mode === "placing" ? "crosshair" : "grab";
      mapDivRef.current.setAttribute("style", `width:100%; height: ${fullscreen ? "100%" : "300px"}; cursor: ${cursor} !important;`);
    }
  },[mode, fullscreen]);

  // ── Redraw preview whenever pins change ───────────────────────────────────
  useEffect(()=>{
    if(!mapRef.current||!window.google?.maps) return;
    if(polyRef.current){ polyRef.current.setMap(null); polyRef.current=null; }
    if(pinLatLngs.length<2) return;
    const isZone = zoneTypeRef.current==="zone";
    const color  = isZone?"#7CFC00":"#ff4444";
    polyRef.current = new window.google.maps.Polyline({
      path:[...pinLatLngs, pinLatLngs[0]],
      strokeColor:color, strokeWeight:2.5, strokeOpacity:0.85,
      map:mapRef.current,
    });
  },[pinLatLngs]);

  // ── Handle map click to place a pin ───────────────────────────────────────
  // Use refs for mode and zoneType so the listener always reads fresh values
  const modeRef     = useRef(mode);
  const zoneTypeRef = useRef(zoneType);
  useEffect(()=>{ modeRef.current=mode; },[mode]);
  useEffect(()=>{ zoneTypeRef.current=zoneType; },[zoneType]);

  useEffect(()=>{
    if(!mapRef.current||!window.google?.maps) return;
    const listener = mapRef.current.addListener("click",e=>{
      if(modeRef.current!=="placing") return;
      const pos      = {lat:e.latLng.lat(),lng:e.latLng.lng()};
      const isZone   = zoneTypeRef.current==="zone";
      const color    = isZone?"#7CFC00":"#ff4444";
      const idx      = pinsRef.current.length;

      const marker = new window.google.maps.Marker({
        position:pos, map:mapRef.current, draggable:true,
        icon:{
          path:window.google.maps.SymbolPath.CIRCLE,
          scale:idx===0?14:10,
          fillColor:idx===0?"#fff":color, fillOpacity:1,
          strokeColor:color, strokeWeight:2,
        },
        label:idx===0?{text:"START",color:"#000",fontSize:"8px",fontWeight:"bold"}:undefined,
        zIndex:idx+10,
      });

      marker.addListener("dragend",()=>{
        const newPos={lat:marker.getPosition().lat(),lng:marker.getPosition().lng()};
        setPinLatLngs(pts=>{
          const updated=[...pts];
          updated[idx]=newPos;
          return updated;
        });
      });

      pinsRef.current.push(marker);
      setPinLatLngs(pts=>[...pts,pos]);
    });
    // Only register once on mount
    return ()=>window.google.maps.event.removeListener(listener);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  const startPlacing = (type) => {
    // Clear any previous working pins
    pinsRef.current.forEach(m=>m.setMap(null));
    pinsRef.current=[];
    if(polyRef.current){polyRef.current.setMap(null);polyRef.current=null;}
    setPinLatLngs([]);
    setZoneType(type);
    setMode("placing");
  };

  const undoLastPin = () => {
    if(pinsRef.current.length===0) return;
    const last=pinsRef.current.pop();
    last.setMap(null);
    setPinLatLngs(pts=>pts.slice(0,-1));
  };

  const cancelPlacing = () => {
    pinsRef.current.forEach(m=>m.setMap(null));
    pinsRef.current=[];
    if(polyRef.current){polyRef.current.setMap(null);polyRef.current=null;}
    setPinLatLngs([]);
    setMode("idle");
  };

  const closeShape = () => {
    if(pinLatLngs.length<3) return;
    // Remove working polyline
    if(polyRef.current){polyRef.current.setMap(null);polyRef.current=null;}
    const isZone = zoneType==="zone";
    const color  = isZone?"#7CFC00":"#ff4444";
    // Draw filled polygon — clickable:false so taps pass through to the map
    const poly = new window.google.maps.Polygon({
      paths:pinLatLngs,
      fillColor:color, fillOpacity:isZone?0.22:0.25,
      strokeColor:color, strokeWeight:2.5,
      clickable:false,
      map:mapRef.current,
    });
    const sqft = computeSqft(poly);
    // Keep the outline pins but make them non-draggable now
    pinsRef.current.forEach(m=>m.setDraggable(false));
    setLabelModal({poly, sqft, type:zoneType, pins:[...pinsRef.current]});
    pinsRef.current=[];
    setPinLatLngs([]);
    setMode("idle");
  };

  const confirmLabel = (label) => {
    if(!labelModal) return;
    // Make placed pins non-interactive so they don't block map taps
    (labelModal.pins||[]).forEach(m=>{
      m.setClickable(false);
      m.setDraggable(false);
    });
    setZones(zs=>[...zs,{id:genId(),label,poly:labelModal.poly,pins:labelModal.pins||[],sqft:labelModal.sqft,type:labelModal.type}]);
    setLabelModal(null);
  };

  const removeZone = (id) => {
    setZones(zs=>{
      const z=zs.find(z=>z.id===id);
      if(z){ z.poly.setMap(null); (z.pins||[]).forEach(m=>m.setMap(null)); }
      return zs.filter(z=>z.id!==id);
    });
  };

  const isZoneMode = zoneType==="zone";
  const color      = isZoneMode?"#7CFC00":"#ff4444";

  return(
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      <div>
        <p style={S.label}>Step 3 — Boundary</p>
        <h2 style={S.heading}>Measure lawn area</h2>
        <p style={S.sub}>{addressData.address}</p>
      </div>

      {/* Instruction banner */}
      <div style={{background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:10,padding:"10px 14px",display:"flex",gap:10,alignItems:"flex-start"}}>
        <span style={{fontSize:16,flexShrink:0}}>👆</span>
        <div style={{color:"rgba(255,255,255,0.5)",fontSize:12,fontFamily:"monospace",lineHeight:1.6}}>
          {mode==="placing"
            ? pinLatLngs.length<3
              ? "Tap the map to place pins around the edge of the area. Place at least 3 pins."
              : "Keep adding pins or tap CLOSE SHAPE when done."
            : "Tap + ADD ZONE to start measuring. Tap each corner of the lawn."}
        </div>
      </div>

      {/* Fullscreen overlay UI (map div stays mounted always below) */}
      {fullscreen&&(
        <div style={{position:"fixed",top:0,right:0,bottom:0,left:0,zIndex:9999,display:"flex",flexDirection:"column",pointerEvents:"none"}}>
          {/* Top gradient bar */}
          <div style={{position:"absolute",top:0,left:0,right:0,background:"linear-gradient(to bottom,rgba(0,0,0,0.8),transparent)",padding:"14px 14px 40px",display:"flex",justifyContent:"space-between",alignItems:"center",zIndex:2,pointerEvents:"all"}}>
            <div style={{color:"rgba(255,255,255,0.85)",fontSize:12,fontFamily:"monospace"}}>
              {mode==="placing"
                ? pinLatLngs.length<3?"👆 Tap corners to place pins":"✓ Ready — tap CLOSE SHAPE"
                : zones.length>0?"Zones drawn — add more or confirm":"Tap ＋ ADD ZONE to start"}
            </div>
            <button onClick={()=>setFullscreen(false)} style={{background:"rgba(0,0,0,0.75)",border:"1px solid rgba(255,255,255,0.3)",borderRadius:8,padding:"8px 14px",color:"#fff",fontSize:12,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>
              ✕ EXIT
            </button>
          </div>

          {/* Center badge */}
          {mode==="placing"&&pinLatLngs.length>0&&(
            <div style={{position:"absolute",top:"40%",left:"50%",transform:"translate(-50%,-50%)",background:"rgba(0,0,0,0.8)",borderRadius:8,padding:"7px 16px",color,fontSize:12,fontFamily:"monospace",fontWeight:700,border:"1px solid "+color+"66",whiteSpace:"nowrap",zIndex:2,pointerEvents:"none"}}>
              {pinLatLngs.length} pin{pinLatLngs.length!==1?"s":""}{pinLatLngs.length>=3?" — ready to close":""}
            </div>
          )}
          {netSqft>0&&mode==="idle"&&(
            <div style={{position:"absolute",top:"40%",left:"50%",transform:"translate(-50%,-50%)",background:"rgba(0,0,0,0.8)",borderRadius:8,padding:"7px 16px",color:"#7CFC00",fontSize:14,fontFamily:"monospace",fontWeight:700,border:"1px solid rgba(124,252,0,0.5)",whiteSpace:"nowrap",zIndex:2,pointerEvents:"none"}}>
              {netSqft.toLocaleString()} SQ FT NET
            </div>
          )}

          {/* Side controls — compact panel docked in the top-left corner
              (was a full-width bottom bar). */}
          <div style={{position:"absolute",top:54,left:12,background:"rgba(5,14,5,0.95)",border:"1px solid rgba(124,252,0,0.15)",borderRadius:12,padding:10,display:"flex",flexDirection:"column",gap:8,width:180,maxWidth:"52vw",maxHeight:"calc(100% - 140px)",overflowY:"auto",zIndex:2,pointerEvents:"all",boxShadow:"0 8px 28px rgba(0,0,0,0.45)"}}>
            {mode==="idle"&&(
              <>
                <button onClick={()=>startPlacing("zone")} style={{width:"100%",background:"rgba(124,252,0,0.12)",border:"1px solid rgba(124,252,0,0.4)",borderRadius:10,padding:"12px",color:"#7CFC00",fontSize:12,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>＋ ADD ZONE</button>
                <button onClick={()=>startPlacing("subtract")} style={{width:"100%",background:"rgba(255,68,68,0.08)",border:"1px solid rgba(255,68,68,0.3)",borderRadius:10,padding:"12px",color:"#ff6b6b",fontSize:12,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>－ SUBTRACT</button>
              </>
            )}
            {mode==="placing"&&(
              <>
                <button onClick={closeShape} disabled={pinLatLngs.length<3} style={{width:"100%",background:pinLatLngs.length>=3?color:"rgba(255,255,255,0.04)",border:"1px solid "+(pinLatLngs.length>=3?color+"88":"rgba(255,255,255,0.08)"),borderRadius:10,padding:"12px",color:pinLatLngs.length>=3?"#000":"rgba(255,255,255,0.2)",fontSize:12,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>
                  ✓ CLOSE {pinLatLngs.length>=3?"("+pinLatLngs.length+"pts)":"("+(3-pinLatLngs.length)+" more)"}
                </button>
                <button onClick={undoLastPin} disabled={pinLatLngs.length===0} style={{width:"100%",background:"rgba(255,255,255,0.07)",border:"1px solid rgba(255,255,255,0.12)",borderRadius:10,padding:"11px",color:pinLatLngs.length>0?"rgba(255,255,255,0.8)":"rgba(255,255,255,0.2)",fontSize:12,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>↩ UNDO</button>
                <button onClick={cancelPlacing} style={{width:"100%",background:"rgba(255,68,68,0.08)",border:"1px solid rgba(255,68,68,0.2)",borderRadius:10,padding:"11px",color:"#ff6b6b",fontSize:12,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>✕ CANCEL</button>
              </>
            )}
          </div>
        </div>
      )}

      {/* Map container — always mounted, just resized */}
      <div style={{
        position: fullscreen ? "fixed" : "relative",
        top: fullscreen ? 0 : "auto",
        right: fullscreen ? 0 : "auto",
        bottom: fullscreen ? 0 : "auto",
        left: fullscreen ? 0 : "auto",
        zIndex:    fullscreen ? 9998 : "auto",
        borderRadius: fullscreen ? 0 : 12,
        overflow: "hidden",
        border: fullscreen ? "none" : "1px solid rgba(124,252,0,0.2)",
      }}>
        <div ref={mapDivRef} style={{width:"100%", height: fullscreen ? "100%" : 300}}/>

        {/* Normal view overlays */}
        {!fullscreen&&(
          <>
            {mode==="placing"&&pinLatLngs.length>0&&(
              <div style={{position:"absolute",top:10,left:"50%",transform:"translateX(-50%)",background:"rgba(0,0,0,0.88)",borderRadius:8,padding:"6px 14px",color,fontSize:12,fontFamily:"monospace",fontWeight:700,border:"1px solid "+color+"66",whiteSpace:"nowrap"}}>
                {pinLatLngs.length} pin{pinLatLngs.length!==1?"s":""} {pinLatLngs.length>=3?"— ready to close":"— keep tapping"}
              </div>
            )}
            {netSqft>0&&mode==="idle"&&(
              <div style={{position:"absolute",bottom:36,left:"50%",transform:"translateX(-50%)",background:"rgba(0,0,0,0.88)",borderRadius:8,padding:"6px 14px",color:"#7CFC00",fontSize:13,fontFamily:"monospace",fontWeight:700,border:"1px solid rgba(124,252,0,0.4)",whiteSpace:"nowrap"}}>
                {netSqft.toLocaleString()} SQ FT NET
              </div>
            )}
            <button onClick={()=>setFullscreen(true)} style={{position:"absolute",top:10,right:10,background:"rgba(0,0,0,0.72)",border:"1px solid rgba(255,255,255,0.25)",borderRadius:8,padding:"7px 11px",color:"#fff",fontSize:11,fontFamily:"monospace",fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",gap:5}}>
              ⛶ FULLSCREEN
            </button>
            <div style={S.mapBadge}>TAP TO PLACE PINS</div>
          </>
        )}
      </div>

      {/* Mode buttons */}
      {mode==="idle"&&(
        <div style={{display:"flex",gap:8}}>
          <button onClick={()=>startPlacing("zone")} style={{flex:1,background:"rgba(124,252,0,0.1)",border:"1px solid rgba(124,252,0,0.35)",borderRadius:10,padding:"13px",color:"#7CFC00",fontSize:13,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>
            ＋ ADD ZONE
          </button>
          <button onClick={()=>startPlacing("subtract")} style={{flex:1,background:"rgba(255,68,68,0.08)",border:"1px solid rgba(255,68,68,0.3)",borderRadius:10,padding:"13px",color:"#ff6b6b",fontSize:13,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>
            － SUBTRACT
          </button>
        </div>
      )}

      {/* Placing controls */}
      {mode==="placing"&&(
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
            <button onClick={undoLastPin} disabled={pinLatLngs.length===0} style={{background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.12)",borderRadius:10,padding:"13px",color:pinLatLngs.length>0?"rgba(255,255,255,0.7)":"rgba(255,255,255,0.2)",fontSize:13,fontFamily:"monospace",fontWeight:700,cursor:pinLatLngs.length>0?"pointer":"default"}}>
              ↩ UNDO PIN
            </button>
            <button onClick={cancelPlacing} style={{background:"rgba(255,68,68,0.08)",border:"1px solid rgba(255,68,68,0.2)",borderRadius:10,padding:"13px",color:"#ff6b6b",fontSize:13,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>
              ✕ CANCEL
            </button>
          </div>
          <button onClick={closeShape} disabled={pinLatLngs.length<3} style={{background:pinLatLngs.length>=3?color:"rgba(255,255,255,0.05)",border:"1px solid "+(pinLatLngs.length>=3?color+"66":"rgba(255,255,255,0.1)"),borderRadius:10,padding:"16px",color:pinLatLngs.length>=3?"#000":"rgba(255,255,255,0.2)",fontSize:14,fontFamily:"monospace",fontWeight:700,cursor:pinLatLngs.length>=3?"pointer":"default",transition:"all 0.2s"}}>
            ✓ CLOSE SHAPE {pinLatLngs.length>=3?"("+pinLatLngs.length+" pins)":"— need "+(3-pinLatLngs.length)+" more"}
          </button>
        </div>
      )}

      {/* Zone list */}
      {zones.length>0&&(
        <div style={{display:"flex",flexDirection:"column",gap:6}}>
          <div style={{color:"rgba(255,255,255,0.3)",fontSize:9,fontFamily:"monospace",letterSpacing:"0.1em"}}>DRAWN AREAS</div>
          {zones.map(z=>(
            <div key={z.id} style={{display:"flex",alignItems:"center",gap:10,background:z.type==="zone"?"rgba(124,252,0,0.06)":"rgba(255,68,68,0.06)",border:"1px solid "+(z.type==="zone"?"rgba(124,252,0,0.2)":"rgba(255,68,68,0.2)"),borderRadius:10,padding:"9px 12px"}}>
              <span style={{fontSize:14}}>{z.type==="zone"?"🟢":"🔴"}</span>
              <div style={{flex:1}}>
                <div style={{color:"#fff",fontSize:13,fontFamily:"monospace"}}>{z.label}</div>
                <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace"}}>{z.type==="subtract"?"−":"+"} {z.sqft.toLocaleString()} sqft</div>
              </div>
              <button onClick={()=>removeZone(z.id)} style={{background:"none",border:"none",color:"rgba(255,255,255,0.25)",cursor:"pointer",fontSize:15,padding:"0 4px"}}>✕</button>
            </div>
          ))}
          <div style={{display:"flex",justifyContent:"space-between",padding:"8px 12px",background:"rgba(255,255,255,0.04)",borderRadius:10,border:"1px solid rgba(255,255,255,0.08)"}}>
            <span style={{color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12}}>NET LAWN AREA</span>
            <span style={{color:"#7CFC00",fontFamily:"monospace",fontSize:14,fontWeight:700}}>{netSqft.toLocaleString()} sqft</span>
          </div>
        </div>
      )}

      {/* Label modal */}
      {labelModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",zIndex:500,display:"flex",alignItems:"center",justifyContent:"center",padding:"20px"}}>
          <div style={{background:"#0f1f0f",border:"1px solid rgba(255,255,255,0.12)",borderRadius:16,padding:"24px",maxWidth:340,width:"100%"}}>
            <div style={{color:"#fff",fontSize:15,fontFamily:"monospace",fontWeight:700,marginBottom:4}}>
              {labelModal.type==="zone"?"Name this zone":"Name this obstacle"}
            </div>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",marginBottom:16}}>
              {labelModal.sqft.toLocaleString()} sqft · tap to select
            </div>
            <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:14}}>
              {(labelModal.type==="zone"?ZONE_LABELS:OBSTACLE_LABELS).map(l=>(
                <button key={l} onClick={()=>confirmLabel(l)} style={{padding:"10px 14px",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.12)",borderRadius:8,color:"rgba(255,255,255,0.7)",fontSize:13,fontFamily:"monospace",cursor:"pointer"}}>{l}</button>
              ))}
            </div>
            <div style={{display:"flex",gap:8}}>
              <input id="custom-label-bc" placeholder="Custom name…" style={{flex:1,background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.12)",borderRadius:8,padding:"10px 12px",color:"#fff",fontSize:13,fontFamily:"monospace",outline:"none"}} onKeyDown={e=>e.key==="Enter"&&e.target.value.trim()&&confirmLabel(e.target.value.trim())}/>
              <button onClick={()=>{const v=document.getElementById("custom-label-bc")?.value?.trim();if(v)confirmLabel(v);}} style={{background:"#7CFC00",color:"#000",border:"none",borderRadius:8,padding:"10px 14px",fontSize:12,fontWeight:700,fontFamily:"monospace",cursor:"pointer"}}>OK</button>
            </div>
            <button onClick={()=>{labelModal.poly.setMap(null);(labelModal.pins||[]).forEach(m=>m.setMap(null));setLabelModal(null);}} style={{marginTop:12,background:"none",border:"none",color:"rgba(255,255,255,0.25)",fontSize:12,fontFamily:"monospace",cursor:"pointer"}}>✕ Discard this area</button>
          </div>
        </div>
      )}

      {/* Nav buttons */}
      <div style={{display:"flex",gap:8}}>
        <button onClick={onBack} style={{...btn(true,"ghost"),flex:"0 0 72px"}}>← BACK</button>
        <button onClick={()=>netSqft>0&&onNext(netSqft)} disabled={!netSqft||mode==="placing"} style={{...btn(netSqft>0&&mode!=="placing"),flex:1}}>
          {mode==="placing"?"CLOSE SHAPE FIRST":netSqft>0?`CONFIRM ${netSqft.toLocaleString()} SQFT →`:"ADD A ZONE TO CONTINUE"}
        </button>
      </div>
    </div>
  );
}

function LandscapeTab({lsBeds,setLsBeds,lsRates,setLsRates,lsBedTotal}){
  const [editRates,setEditRates] = useState(false);
  const [addingBed,setAddingBed] = useState(false);
  const [newBed,setNewBed]       = useState({name:"",type:"rect",length:"",width:"",sqft:"",qty:"1"});

  const addBed = () => {
    if(!newBed.name.trim()) return;
    setLsBeds(b=>[...b,{...newBed,id:genId(),services:{}}]);
    setNewBed({name:"",type:"rect",length:"",width:"",sqft:"",qty:"1"});
    setAddingBed(false);
  };

  const bedSqft = bed => bed.type==="rect"
    ? (parseFloat(bed.length)||0)*(parseFloat(bed.width)||0)
    : (parseFloat(bed.sqft)||0);

  const toggleBedSvc = (bedId,svcId) => {
    setLsBeds(bs=>bs.map(b=>b.id===bedId?{...b,services:{...b.services,[svcId]:!b.services[svcId]}}:b));
  };

  const bedSvcPrice = (bed,svc) => {
    if(!svc) return 0;
    const r=lsRates[svc.id]||{};
    const sf=bedSqft(bed);
    if(svc.unit==="each") return ((r.laborEach||0)+(r.matEach||0))*(parseFloat(bed.qty)||1);
    return ((r.laborPerSqft||0)+(r.matPerSqft||0))*sf;
  };

  const updateLsRate = (id,field,val) => {
    const n=parseFloat(val); if(isNaN(n)||n<0) return;
    setLsRates(r=>({...r,[id]:{...r[id],[field]:n}}));
  };

  const inp={background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"9px 10px",color:"#fff",fontSize:12,fontFamily:"monospace",outline:"none"};

  return(
    <div style={{display:"flex",flexDirection:"column",gap:12}}>

      {/* Rate editor toggle */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace"}}>
          Total landscaping: <span style={{color:"#7CFC00",fontWeight:700}}>${lsBedTotal.toFixed(0)}</span>
        </div>
        <button onClick={()=>setEditRates(e=>!e)} style={{background:editRates?"rgba(0,207,255,0.1)":"rgba(255,255,255,0.04)",color:editRates?"var(--lq-blue)":"rgba(255,255,255,0.4)",border:"1px solid "+(editRates?"rgba(0,207,255,0.3)":"rgba(255,255,255,0.08)"),borderRadius:8,padding:"5px 11px",fontSize:10,cursor:"pointer",fontFamily:"monospace"}}>
          {editRates?"✓ CLOSE RATES":"⚙ EDIT RATES"}
        </button>
      </div>

      {/* Service rates editor */}
      {editRates&&(
        <div style={{background:"rgba(0,207,255,0.05)",border:"1px solid rgba(0,207,255,0.15)",borderRadius:12,padding:"12px 14px"}}>
          <div style={{color:"var(--lq-blue)",fontSize:10,fontFamily:"monospace",fontWeight:700,marginBottom:10,letterSpacing:"0.1em"}}>ADJUST LANDSCAPE SERVICE RATES</div>
          {LANDSCAPE_SERVICES.filter(s=>s&&s.id).map(s=>(
            <div key={s.id} style={{marginBottom:10,paddingBottom:10,borderBottom:"1px solid rgba(255,255,255,0.06)"}}>
              <div style={{color:"#fff",fontSize:12,fontFamily:"monospace",marginBottom:6}}>{s.label} <span style={{color:"rgba(255,255,255,0.3)",fontSize:10}}>({s.notes})</span></div>
              <div style={{display:"flex",gap:8}}>
                {s.unit==="each"?(
                  <>
                    <div style={{flex:1}}><div style={{color:"rgba(255,255,255,0.3)",fontSize:9,fontFamily:"monospace",marginBottom:3}}>LABOR/EA ($)</div><input type="number" min="0" step="0.5" value={lsRates[s.id]?.laborEach||0} onChange={e=>updateLsRate(s.id,"laborEach",e.target.value)} style={{...inp,width:"100%"}}/></div>
                    <div style={{flex:1}}><div style={{color:"rgba(255,255,255,0.3)",fontSize:9,fontFamily:"monospace",marginBottom:3}}>MAT/EA ($)</div><input type="number" min="0" step="0.5" value={lsRates[s.id]?.matEach||0} onChange={e=>updateLsRate(s.id,"matEach",e.target.value)} style={{...inp,width:"100%"}}/></div>
                  </>
                ):(
                  <>
                    <div style={{flex:1}}><div style={{color:"rgba(255,255,255,0.3)",fontSize:9,fontFamily:"monospace",marginBottom:3}}>LABOR/SQFT ($)</div><input type="number" min="0" step="0.01" value={lsRates[s.id]?.laborPerSqft||0} onChange={e=>updateLsRate(s.id,"laborPerSqft",e.target.value)} style={{...inp,width:"100%"}}/></div>
                    <div style={{flex:1}}><div style={{color:"rgba(255,255,255,0.3)",fontSize:9,fontFamily:"monospace",marginBottom:3}}>MAT/SQFT ($)</div><input type="number" min="0" step="0.01" value={lsRates[s.id]?.matPerSqft||0} onChange={e=>updateLsRate(s.id,"matPerSqft",e.target.value)} style={{...inp,width:"100%"}}/></div>
                  </>
                )}
                <div style={{flex:"0 0 50px",textAlign:"right",paddingTop:20}}>
                  <div style={{color:"#7CFC00",fontSize:11,fontFamily:"monospace",fontWeight:700}}>
                    {s.unit==="each"?"$/ea":"$/sf"}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Beds list */}
      {lsBeds.map(bed=>{
        const sf=bedSqft(bed);
        const bedTotal=Object.entries(bed.services||{}).filter(([on])=>on).reduce((a,[sid])=>{
          const svc=LANDSCAPE_SERVICES.find(s=>s&&s.id&&s.id===sid); if(!svc) return a;
          return a+bedSvcPrice(bed,svc);
        },0);
        return(
          <div key={bed.id} style={{background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:12,padding:"13px 14px"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
              <div>
                <div style={{color:"#fff",fontSize:14,fontFamily:"monospace",fontWeight:700}}>{bed.name}</div>
                <div style={{color:"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace",marginTop:1}}>
                  {bed.type==="rect"
                    ? (bed.length&&bed.width?bed.length+"ft × "+bed.width+"ft = "+sf.toFixed(0)+" sqft":"Enter dimensions below")
                    : (sf>0?sf.toFixed(0)+" sqft":"Enter sqft below")}
                  {bed.qty>1?" · "+bed.qty+" units":""}
                </div>
              </div>
              <div style={{display:"flex",gap:6,alignItems:"center"}}>
                {bedTotal>0&&<div style={{color:"#7CFC00",fontSize:14,fontWeight:700}}>${bedTotal.toFixed(0)}</div>}
                <button onClick={()=>setLsBeds(bs=>bs.filter(b=>b.id!==bed.id))} style={{background:"none",border:"none",color:"rgba(255,68,68,0.5)",cursor:"pointer",fontSize:15}}>✕</button>
              </div>
            </div>

            {/* Dimension inputs */}
            <div style={{display:"flex",gap:8,marginBottom:10}}>
              <div style={{display:"flex",background:"rgba(255,255,255,0.05)",borderRadius:8,padding:2,gap:1,flexShrink:0}}>
                {[["rect","L×W"],["free","SqFt"]].map(([v,l])=>(
                  <button key={v} onClick={()=>setLsBeds(bs=>bs.map(b=>b.id===bed.id?{...b,type:v}:b))} style={{padding:"5px 9px",background:bed.type===v?"#7CFC00":"none",color:bed.type===v?"#000":"rgba(255,255,255,0.4)",border:"none",borderRadius:6,cursor:"pointer",fontSize:10,fontFamily:"monospace",fontWeight:700}}>{l}</button>
                ))}
              </div>
              {bed.type==="rect"?(
                <>
                  <input type="number" min="0" placeholder="Length (ft)" value={bed.length} onChange={e=>setLsBeds(bs=>bs.map(b=>b.id===bed.id?{...b,length:e.target.value}:b))} style={{...inp,flex:1}}/>
                  <input type="number" min="0" placeholder="Width (ft)" value={bed.width} onChange={e=>setLsBeds(bs=>bs.map(b=>b.id===bed.id?{...b,width:e.target.value}:b))} style={{...inp,flex:1}}/>
                </>
              ):(
                <input type="number" min="0" placeholder="Total sqft" value={bed.sqft} onChange={e=>setLsBeds(bs=>bs.map(b=>b.id===bed.id?{...b,sqft:e.target.value}:b))} style={{...inp,flex:1}}/>
              )}
              {LANDSCAPE_SERVICES.filter(s=>s&&s.unit==="each").find(s=>Object.keys(bed.services||{}).find(id=>id===s.id&&bed.services[id]))&&(
                <input type="number" min="1" placeholder="Qty" value={bed.qty||1} onChange={e=>setLsBeds(bs=>bs.map(b=>b.id===bed.id?{...b,qty:e.target.value}:b))} style={{...inp,width:56}}/>
              )}
            </div>

            {/* Service checkboxes for this bed */}
            <div style={{display:"flex",flexDirection:"column",gap:6}}>
              <div style={{color:"rgba(255,255,255,0.3)",fontSize:9,fontFamily:"monospace",letterSpacing:"0.08em"}}>SELECT SERVICES FOR THIS BED</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
                {LANDSCAPE_SERVICES.filter(svc=>svc&&svc.id).map(svc=>{
                  const on=!!(bed.services||{})[svc.id];
                  const price=(svc&&(sf>0||svc.unit==="each"))?bedSvcPrice(bed,svc):0;
                  return(
                    <button key={svc.id} onClick={()=>toggleBedSvc(bed.id,svc.id)} style={{padding:"5px 9px",background:on?"rgba(0,207,255,0.12)":"rgba(255,255,255,0.04)",border:"1px solid "+(on?"rgba(0,207,255,0.35)":"rgba(255,255,255,0.08)"),borderRadius:7,cursor:"pointer",display:"flex",alignItems:"center",gap:5}}>
                      <span style={{color:on?"var(--lq-blue)":"rgba(255,255,255,0.45)",fontSize:11,fontFamily:"monospace"}}>{svc.label}</span>
                      {on&&price>0&&<span style={{color:"rgba(0,207,255,0.7)",fontSize:10,fontFamily:"monospace"}}>${price.toFixed(0)}</span>}
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Labor vs material breakdown */}
            {Object.entries(bed.services||{}).some(([on])=>on)&&sf>0&&(
              <div style={{marginTop:10,paddingTop:8,borderTop:"1px solid rgba(255,255,255,0.06)",display:"flex",gap:12}}>
                {Object.entries(bed.services||{}).filter(([on])=>on).map(([sid])=>{
                  const svc=LANDSCAPE_SERVICES.filter(s=>s&&s.id).find(s=>s.id===sid); if(!svc) return null;
                  const r=lsRates[sid]||{};
                  const labor=svc.unit==="each"?(r.laborEach||0)*(parseFloat(bed.qty)||1):(r.laborPerSqft||0)*sf;
                  const mat=svc.unit==="each"?(r.matEach||0)*(parseFloat(bed.qty)||1):(r.matPerSqft||0)*sf;
                  return(
                    <div key={sid} style={{flex:1,background:"rgba(255,255,255,0.03)",borderRadius:7,padding:"7px 9px"}}>
                      <div style={{color:"rgba(255,255,255,0.5)",fontSize:10,fontFamily:"monospace",marginBottom:3}}>{svc.label}</div>
                      <div style={{display:"flex",justifyContent:"space-between"}}><span style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontFamily:"monospace"}}>Labor</span><span style={{color:"#7CFC00",fontSize:10,fontFamily:"monospace"}}>${labor.toFixed(0)}</span></div>
                      {mat>0&&<div style={{display:"flex",justifyContent:"space-between"}}><span style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontFamily:"monospace"}}>Material</span><span style={{color:"rgba(124,252,0,0.6)",fontSize:10,fontFamily:"monospace"}}>${mat.toFixed(0)}</span></div>}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}

      {/* Add bed form */}
      {addingBed?(
        <div style={{background:"rgba(124,252,0,0.05)",border:"1px solid rgba(124,252,0,0.2)",borderRadius:12,padding:"14px"}}>
          <div style={{color:"#7CFC00",fontSize:11,fontFamily:"monospace",fontWeight:700,marginBottom:10}}>NEW BED / AREA</div>
          <div style={{display:"flex",gap:8,marginBottom:8}}>
            <input value={newBed.name} onChange={e=>setNewBed(b=>({...b,name:e.target.value}))} placeholder="Bed name (e.g. Front Beds)" style={{...inp,flex:1}}/>
          </div>
          <div style={{display:"flex",gap:8,marginBottom:10}}>
            <div style={{display:"flex",background:"rgba(255,255,255,0.05)",borderRadius:8,padding:2,gap:1}}>
              {[["rect","L×W"],["free","SqFt"]].map(([v,l])=>(
                <button key={v} onClick={()=>setNewBed(b=>({...b,type:v}))} style={{padding:"6px 10px",background:newBed.type===v?"#7CFC00":"none",color:newBed.type===v?"#000":"rgba(255,255,255,0.4)",border:"none",borderRadius:6,cursor:"pointer",fontSize:10,fontFamily:"monospace",fontWeight:700}}>{l}</button>
              ))}
            </div>
            {newBed.type==="rect"?(
              <>
                <input type="number" min="0" placeholder="Length ft" value={newBed.length} onChange={e=>setNewBed(b=>({...b,length:e.target.value}))} style={{...inp,flex:1}}/>
                <input type="number" min="0" placeholder="Width ft" value={newBed.width} onChange={e=>setNewBed(b=>({...b,width:e.target.value}))} style={{...inp,flex:1}}/>
              </>
            ):(
              <input type="number" min="0" placeholder="Total sqft" value={newBed.sqft} onChange={e=>setNewBed(b=>({...b,sqft:e.target.value}))} style={{...inp,flex:1}}/>
            )}
          </div>
          <div style={{display:"flex",gap:8}}>
            <button onClick={()=>setAddingBed(false)} style={{flex:1,background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:9,padding:"10px",color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",cursor:"pointer"}}>CANCEL</button>
            <button onClick={addBed} disabled={!newBed.name.trim()} style={{flex:2,background:newBed.name.trim()?"#7CFC00":"rgba(124,252,0,0.15)",color:newBed.name.trim()?"#000":"rgba(255,255,255,0.3)",border:"none",borderRadius:9,padding:"10px",fontSize:12,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>ADD BED →</button>
          </div>
        </div>
      ):(
        <button onClick={()=>setAddingBed(true)} style={{background:"rgba(255,255,255,0.04)",border:"1px dashed rgba(255,255,255,0.15)",borderRadius:12,padding:"14px",color:"rgba(255,255,255,0.45)",fontSize:13,fontFamily:"monospace",cursor:"pointer",width:"100%"}}>
          + ADD BED / AREA
        </button>
      )}
    </div>
  );
}

function QuoteBuilder({customer,addressData,sqft,onDone,onBack,scanObs=[],preselectSvcs=["mow"],quickMode=false,onSaveTemplate,defaultRates,defaultLsRates}){
  const [selSvc,setSelSvc]=useState(()=>[...new Set(preselectSvcs)]);const [selMat,_setSelMat]=useState([]);
  const [rates,setRates]=useState(()=>defaultRates||Object.fromEntries(SERVICES.filter(s=>s&&s.id).map(s=>[s.id,{basePrice:s.basePrice||0,perSqft:s.perSqft||0}])));
  const [recurring,setRecurring]=useState("once");const [payment,setPayment]=useState("Cash");
  const [notes,setNotes]=useState("");const [taxRate,setTaxRate]=useState(0);
  const [discount,setDiscount]=useState({type:"pct",value:0});
  const [tab,setTab]=useState("grass");const [editRates,setEditRates]=useState(false);
  const [lsBeds,setLsBeds]=useState([]);  // landscaping beds
  const [_lsSvcs,_setLsSvcs]=useState({}); // {serviceId: true/false} per bed
  const [customLines,setCustomLines]=useState([]); // free-form line items
  const [lsRates,setLsRates]=useState(()=>defaultLsRates||Object.fromEntries(LANDSCAPE_SERVICES.filter(s=>s&&s.id).map(s=>[s.id,{laborPerSqft:s.laborPerSqft||0,matPerSqft:s.matPerSqft||0,laborEach:s.laborEach||0,matEach:s.matEach||0}])));
  const [saving,setSaving]=useState(false);const [saved,setSaved]=useState(false);
  const [showSMS,setShowSMS]=useState(false);const [_copied,_setCopied]=useState(false);
  const [photos,setPhotos]=useState([]);
  const fileRef=useRef(null);
  const qn=useRef(qNum()).current;
  const handlePhoto=(e,photoType="before")=>{
    Array.from(e.target.files).forEach(file=>{
      const reader=new FileReader();
      reader.onload=ev=>setPhotos(p=>[...p,{url:ev.target.result,type:photoType,file}]);
      reader.readAsDataURL(file);
    });
  };
  const svcPrice=s=>(rates[s.id]?.basePrice||0)+(rates[s.id]?.perSqft||0)*sqft;
  const matPrice=m=>m.price*(1+m.margin);
  const customTotal = customLines.reduce((a,l)=>a+(parseFloat(l.price)||0),0);
  const lsBedTotal = lsBeds.reduce((bedTotal,bed)=>{
    const bSqft = bed.type==="rect" ? (parseFloat(bed.length)||0)*(parseFloat(bed.width)||0) : (parseFloat(bed.sqft)||0);
    return bedTotal + Object.entries(bed.services||{}).filter(([on])=>on).reduce((a,[svcId])=>{
      const r=lsRates[svcId]||{}; const svc=LANDSCAPE_SERVICES.filter(s=>s&&s.id).find(s=>s.id===svcId);
      if(!svc) return a;
      if(svc.unit==="each") return a+(r.laborEach||0)*(parseFloat(bed.qty)||1)+(r.matEach||0)*(parseFloat(bed.qty)||1);
      return a+(r.laborPerSqft||0)*bSqft+(r.matPerSqft||0)*bSqft;
    },0);
  },0);
  const subtotal=SERVICES.filter(s=>selSvc.includes(s.id)).reduce((a,s)=>a+svcPrice(s),0)+MATERIALS.filter(m=>selMat.includes(m.id)).reduce((a,m)=>a+matPrice(m),0)+lsBedTotal+customTotal;
  const discAmt=discount.type==="pct"?subtotal*(discount.value/100):Math.min(discount.value,subtotal);
  const taxAmt=(subtotal-discAmt)*(taxRate/100);
  const total=subtotal-discAmt+taxAmt;
  const recurInfo=RECURRING_OPTIONS.find(r=>r.id===recurring);
  const annualVal=recurring!=="once"?total*recurInfo.perYear:null;
  const updateRate=(id,field,val)=>{const n=parseFloat(val);if(!isNaN(n)&&n>=0)setRates(r=>({...r,[id]:{...r[id],[field]:n}}));};
  const smsText=`Hi ${customer.name.split(" ")[0]}! 🌿 Here's your lawn estimate:\n\n📍 ${addressData.address}\n📐 ${sqft.toLocaleString()} sqft\n\nServices:\n${SERVICES.filter(s=>selSvc.includes(s.id)).map(s=>`  • ${s.label} — $${svcPrice(s).toFixed(0)}`).join("\n")}${discount.value>0?`\n\n💚 Discount: -$${discAmt.toFixed(0)}`:""}${taxRate>0?`\n🧾 Tax (${taxRate}%): $${taxAmt.toFixed(0)}`:""}\n\n💰 Total: $${total.toFixed(0)}${recurring!=="once"?` (${recurInfo.label})`:""}${annualVal?`\n📅 Annual value: $${annualVal.toLocaleString()}`:""}\n\nQuote #${qn} · Valid 7 days\n\nReply YES to book! 📞`;
  const handleSave=async stage=>{
    setSaving(true);
    const newId=genId();

    // Get current user id from supabase session
    const { data:{ session:sess } } = await supabase.auth.getSession();
    const uid = sess?.user?.id;
    if(!uid){ setSaving(false); alert("Not signed in. Please sign out and back in."); return; }

    // Paywall check — fetch fresh profile
    const{data:freshProfile}=await supabase.from("profiles").select("plan,trial_start").eq("id",uid).single();
    if(!hasAccess(freshProfile||profile)){
      setSaving(false);
      setShowPaywall(true);
      return;
    }

    // Paywall check — fetch fresh profile
    const{data:freshProf2}=await supabase.from("profiles").select("plan,trial_start,created_at").eq("id",uid).single();
    const checkProfile = freshProf2||profile;
    console.log("[Paywall] checking:", checkProfile?.plan, checkProfile?.trial_start);
    if(checkProfile && !hasAccess(checkProfile)){
      setSaving(false);
      setShowPaywall(true);
      return;
    }

    // Upload photos to Supabase Storage; fall back to base64 if upload fails
    if(photos.some(p=>p.file)){
      await Promise.all(photos.map(async(p,i)=>{
        if(!p.file) return;
        const ext=p.file.type==='image/png'?'png':'jpg';
        const path=`${uid}/${newId}/${Date.now()}-${i}.${ext}`;
        const{error}=await supabase.storage.from('quote-photos').upload(path,p.file,{contentType:p.file.type||'image/jpeg',upsert:false});
        if(error){console.error('Photo upload error:',error);return;}
        const{data:{publicUrl}}=supabase.storage.from('quote-photos').getPublicUrl(path);
        p._publicUrl=publicUrl;
      }));
    }

    const quoteRow={
      id:newId, quote_num:qn, stage, created_at:todayStr(),
      user_id:uid,                          // ← required for RLS
      customer_id:customer.id,
      customer_name:customer.name,
      customer_phone:customer.phone||null,
      address:addressData.address, sqft,
      services:[...SERVICES.filter(s=>selSvc.includes(s.id)).map(s=>({...s,...rates[s.id]})),...lsBeds.flatMap(bed=>Object.entries(bed.services||{}).filter(([on])=>on).map(([sid])=>{const lsSvc=LANDSCAPE_SERVICES.find(s=>s&&s.id===sid);return lsSvc?{id:"ls-"+bed.id+"-"+sid,label:lsSvc.label+" ("+bed.name+")",bedName:bed.name,isLandscape:true}:null;}).filter(Boolean)),...customLines.filter(l=>l.label).map(l=>({id:l.id,label:l.label,basePrice:parseFloat(l.price)||0,perSqft:0,isCustom:true}))],
      materials:MATERIALS.filter(m=>selMat.includes(m.id)),
      subtotal, disc_amt:discAmt, tax_amt:taxAmt, total, tax_rate:taxRate,
      discount, recurring, payment, notes,
      photo_count:photos.length,
      photos:photos.map(p=>p._publicUrl||p.url),
      annual_val:annualVal,
    };
    try {
      // Always upsert customer first so the FK resolves
      await supabase.from("customers").upsert({
        id:          customer.id,
        user_id:     uid,
        name:        customer.name,
        phone:       customer.phone||null,
        email:       customer.email||null,
        created_at:  customer.createdAt||todayStr(),
        property_type: customer.propertyType||null,
        address:     customer.address||null,
        notes:       customer.notes||null,
      },{onConflict:"id"});
      const{error}=await supabase.from("quotes").insert(quoteRow);
      if(error){
        console.error("Quote insert error:", error.message, error.details, error.hint);
        throw error;
      }
      // Start the 14-day trial clock on first quote saved
      if(!checkProfile?.trial_start){
        await supabase.from("profiles").update({trial_start:todayStr()}).eq("id",uid);
      }
      setSaving(false); setSaved(true);
      onDone(rowToQuote(quoteRow));
    } catch(err) {
      console.error("Quote save error:", err);
      setSaving(false);
      alert("Failed to save quote: "+(err.message||"Unknown error")+". Check the browser console for details.");
    }
  };
  const rateInp={background:"rgba(255,255,255,0.07)",border:"1px solid rgba(124,252,0,0.25)",borderRadius:6,padding:"4px 7px",color:"#fff",fontSize:12,fontFamily:"monospace",width:70,textAlign:"right",outline:"none"};
  return(
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <div><p style={S.label}>Step 4 — Quote Builder</p><h2 style={S.heading}>{customer.name}</h2><p style={S.sub}>{sqft.toLocaleString()} sqft · {addressData.address}</p></div>
      <div style={{display:"flex",background:"rgba(255,255,255,0.05)",borderRadius:10,padding:3,gap:2}}>
        {[["grass","🌿 Grass"],["landscape","🌳 Landscaping"],["custom","✏ Custom"],["details","⚙ Details"]].map(([v,l])=>(
          <button key={v} onClick={()=>setTab(v)} style={{flex:1,padding:"8px",background:tab===v?"#7CFC00":"none",color:tab===v?"#000":"rgba(255,255,255,0.45)",border:"none",borderRadius:8,cursor:"pointer",fontSize:10,fontWeight:700,fontFamily:"monospace",transition:"all 0.2s"}}>{l}</button>
        ))}
      </div>
      {tab==="grass"&&(
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
            <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace"}}>Lawn area: {sqft.toLocaleString()} sqft</div>
            <button onClick={()=>setEditRates(e=>!e)} style={{background:editRates?"rgba(124,252,0,0.1)":"rgba(255,255,255,0.04)",color:editRates?"#7CFC00":"rgba(255,255,255,0.4)",border:"1px solid "+(editRates?"rgba(124,252,0,0.25)":"rgba(255,255,255,0.08)"),borderRadius:8,padding:"5px 11px",fontSize:10,cursor:"pointer",fontFamily:"monospace"}}>{editRates?"✓ DONE":"⚙ RATES"}</button>
          </div>
          {SERVICES.map(s=>{const on=selSvc.includes(s.id);return(
            <div key={s.id} style={{background:on?"rgba(124,252,0,0.07)":"rgba(255,255,255,0.03)",border:"1px solid "+(on?"rgba(124,252,0,0.25)":"rgba(255,255,255,0.06)"),borderRadius:12,padding:"11px 13px"}}>
              <div style={{display:"flex",alignItems:"center",gap:10}}>
                <button onClick={()=>setSelSvc(p=>p.includes(s.id)?p.filter(x=>x!==s.id):[...p,s.id])} style={{width:20,height:20,borderRadius:5,flexShrink:0,background:on?"#7CFC00":"rgba(255,255,255,0.08)",border:"2px solid "+(on?"#7CFC00":"rgba(255,255,255,0.15)"),display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>{on&&<span style={{fontSize:10,color:"#000",fontWeight:900}}>✓</span>}</button>
                <div style={{flex:1}}>
                  <div style={{color:"#fff",fontSize:13,fontFamily:"monospace"}}>{s.label}</div>
                  {editRates&&<div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace"}}>{s.notes||""}</div>}
                </div>
                <div style={{color:on?"#7CFC00":"rgba(255,255,255,0.3)",fontSize:14,fontWeight:700}}>${svcPrice(s).toFixed(0)}</div>
              </div>
              {editRates&&<div style={{marginTop:8,paddingTop:8,borderTop:"1px solid rgba(255,255,255,0.05)",display:"flex",gap:8,alignItems:"flex-end"}}>
                <div style={{flex:1}}><div style={{color:"rgba(255,255,255,0.3)",fontSize:9,fontFamily:"monospace",marginBottom:3}}>BASE ($)</div><input type="number" min="0" value={rates[s.id].basePrice} onChange={e=>updateRate(s.id,"basePrice",e.target.value)} style={rateInp}/></div>
                <div style={{flex:1}}><div style={{color:"rgba(255,255,255,0.3)",fontSize:9,fontFamily:"monospace",marginBottom:3}}>/SQFT ($)</div><input type="number" min="0" step="0.001" value={rates[s.id].perSqft} onChange={e=>updateRate(s.id,"perSqft",e.target.value)} style={rateInp}/></div>
                <div style={{color:"#7CFC00",fontSize:12,fontWeight:700,fontFamily:"monospace",paddingBottom:2}}>${svcPrice(s).toFixed(0)}</div>
              </div>}
            </div>
          );})}
        </div>
      )}

      {tab==="landscape"&&(
        <LandscapeTab lsBeds={lsBeds} setLsBeds={setLsBeds} lsRates={lsRates} setLsRates={setLsRates} lsBedTotal={lsBedTotal}/>
      )}

      {tab==="custom"&&(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace"}}>
              Custom total: <span style={{color:"#7CFC00",fontWeight:700}}>${customTotal.toFixed(0)}</span>
            </div>
          </div>

          {/* Line items */}
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {customLines.map((line,i)=>(
              <div key={line.id} style={{display:"flex",gap:8,alignItems:"center",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.09)",borderRadius:10,padding:"10px 12px"}}>
                <div style={{flex:1,display:"flex",flexDirection:"column",gap:6}}>
                  <input
                    value={line.label}
                    onChange={e=>setCustomLines(ls=>ls.map(l=>l.id===line.id?{...l,label:e.target.value}:l))}
                    placeholder={"Line item "+(i+1)+" description…"}
                    style={{background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:7,padding:"8px 10px",color:"#fff",fontSize:13,fontFamily:"monospace",outline:"none",width:"100%"}}
                  />
                  <input
                    value={line.description}
                    onChange={e=>setCustomLines(ls=>ls.map(l=>l.id===line.id?{...l,description:e.target.value}:l))}
                    placeholder="Details / scope of work (optional)"
                    style={{background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.07)",borderRadius:7,padding:"6px 10px",color:"rgba(255,255,255,0.6)",fontSize:11,fontFamily:"monospace",outline:"none",width:"100%"}}
                  />
                </div>
                <div style={{display:"flex",alignItems:"center",background:"rgba(255,255,255,0.07)",border:"1px solid rgba(124,252,0,0.2)",borderRadius:8,padding:"8px 10px",gap:3,flexShrink:0,width:90}}>
                  <span style={{color:"rgba(255,255,255,0.4)",fontSize:13}}>$</span>
                  <input
                    type="number" min="0" step="1"
                    value={line.price}
                    onChange={e=>setCustomLines(ls=>ls.map(l=>l.id===line.id?{...l,price:e.target.value}:l))}
                    placeholder="0"
                    style={{background:"none",border:"none",color:"#7CFC00",fontSize:14,fontFamily:"monospace",fontWeight:700,outline:"none",textAlign:"right",width:"100%"}}
                  />
                </div>
                <button onClick={()=>setCustomLines(ls=>ls.filter(l=>l.id!==line.id))} style={{background:"none",border:"none",color:"rgba(255,68,68,0.5)",cursor:"pointer",fontSize:16,padding:"0 2px",flexShrink:0}}>✕</button>
              </div>
            ))}
          </div>

          {/* Add line button */}
          <button onClick={()=>setCustomLines(ls=>[...ls,{id:genId(),label:"",description:"",price:""}])} style={{background:"rgba(255,255,255,0.04)",border:"1px dashed rgba(255,255,255,0.15)",borderRadius:10,padding:"13px",color:"rgba(255,255,255,0.45)",fontSize:13,fontFamily:"monospace",cursor:"pointer",width:"100%"}}>
            + ADD LINE ITEM
          </button>

          {customLines.length===0&&(
            <div style={{...S.card,textAlign:"center",padding:"24px 16px"}}>
              <div style={{fontSize:28,marginBottom:8}}>✏️</div>
              <div style={{color:"rgba(255,255,255,0.35)",fontFamily:"monospace",fontSize:12,marginBottom:4}}>Build a custom quote</div>
              <div style={{color:"rgba(255,255,255,0.2)",fontFamily:"monospace",fontSize:11}}>Add any service, description, and price you agreed on — no sqft math needed</div>
            </div>
          )}

          {customLines.length>0&&(
            <div style={{background:"rgba(124,252,0,0.05)",border:"1px solid rgba(124,252,0,0.15)",borderRadius:10,padding:"11px 14px"}}>
              <div style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontFamily:"monospace",marginBottom:6,letterSpacing:"0.08em"}}>CUSTOM LINE ITEMS SUMMARY</div>
              {customLines.filter(l=>l.label).map(l=>(
                <div key={l.id} style={{display:"flex",justifyContent:"space-between",padding:"4px 0",borderBottom:"1px solid rgba(255,255,255,0.04)"}}>
                  <div>
                    <span style={{color:"rgba(255,255,255,0.7)",fontSize:12,fontFamily:"monospace"}}>{l.label}</span>
                    {l.description&&<div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace",marginTop:1}}>{l.description}</div>}
                  </div>
                  <span style={{color:"#7CFC00",fontSize:13,fontFamily:"monospace",fontWeight:700,flexShrink:0,marginLeft:10}}>${(parseFloat(l.price)||0).toFixed(0)}</span>
                </div>
              ))}
              <div style={{display:"flex",justifyContent:"space-between",marginTop:8,paddingTop:6,borderTop:"1px solid rgba(124,252,0,0.2)"}}>
                <span style={{color:"rgba(255,255,255,0.5)",fontFamily:"monospace",fontSize:12}}>Custom subtotal</span>
                <span style={{color:"#7CFC00",fontSize:14,fontWeight:700,fontFamily:"monospace"}}>${customTotal.toFixed(0)}</span>
              </div>
            </div>
          )}
        </div>
      )}

      {tab==="details"&&(
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <div style={{...S.card}}>
            <div style={{...S.label,marginBottom:12}}>Tax & Discount</div>
            <div style={{display:"flex",gap:10}}>
              <div style={{flex:1}}><div style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontFamily:"monospace",marginBottom:5}}>TAX RATE (%)</div><input type="number" min="0" max="20" step="0.1" value={taxRate} onChange={e=>setTaxRate(parseFloat(e.target.value)||0)} style={{background:"rgba(255,255,255,0.07)",border:"1px solid rgba(255,255,255,0.12)",borderRadius:8,padding:"9px 12px",color:"#fff",fontSize:13,fontFamily:"monospace",width:"100%",outline:"none"}}/></div>
              <div style={{flex:1}}><div style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontFamily:"monospace",marginBottom:5}}>DISCOUNT</div><div style={{display:"flex",background:"rgba(255,255,255,0.05)",borderRadius:8,padding:2}}>{[["pct","%"],["flat","$"]].map(([v,l])=><button key={v} onClick={()=>setDiscount(d=>({...d,type:v}))} style={{flex:1,padding:"7px",background:discount.type===v?"#7CFC00":"none",color:discount.type===v?"#000":"rgba(255,255,255,0.5)",border:"none",borderRadius:6,cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"monospace"}}>{l}</button>)}</div></div>
              <div style={{flex:1}}><div style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontFamily:"monospace",marginBottom:5}}>AMOUNT</div><input type="number" min="0" value={discount.value} onChange={e=>setDiscount(d=>({...d,value:parseFloat(e.target.value)||0}))} style={{background:"rgba(255,255,255,0.07)",border:"1px solid rgba(255,255,255,0.12)",borderRadius:8,padding:"9px 12px",color:"#fff",fontSize:13,fontFamily:"monospace",width:"100%",outline:"none"}}/></div>
            </div>
          </div>
          <div><div style={S.label}>Schedule</div><div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>{RECURRING_OPTIONS.map(r=><button key={r.id} onClick={()=>setRecurring(r.id)} style={{padding:"10px",background:recurring===r.id?"rgba(124,252,0,0.1)":"rgba(255,255,255,0.03)",border:`1px solid ${recurring===r.id?"rgba(124,252,0,0.35)":"rgba(255,255,255,0.07)"}`,borderRadius:10,cursor:"pointer"}}><div style={{color:recurring===r.id?"#7CFC00":"rgba(255,255,255,0.6)",fontSize:12,fontFamily:"monospace",fontWeight:recurring===r.id?700:400}}>{r.label}</div>{r.id!=="once"&&<div style={{color:"rgba(255,255,255,0.25)",fontSize:10,fontFamily:"monospace",marginTop:2}}>{r.perYear}x / yr</div>}</button>)}</div></div>
          <div><div style={S.label}>Payment Method</div><div style={{display:"flex",flexWrap:"wrap",gap:6}}>{PAYMENT_METHODS.map(p=><button key={p} onClick={()=>setPayment(p)} style={{padding:"7px 13px",background:payment===p?"rgba(124,252,0,0.1)":"rgba(255,255,255,0.03)",border:`1px solid ${payment===p?"rgba(124,252,0,0.3)":"rgba(255,255,255,0.07)"}`,borderRadius:8,cursor:"pointer",color:payment===p?"#7CFC00":"rgba(255,255,255,0.5)",fontSize:12,fontFamily:"monospace"}}>{p}</button>)}</div></div>
          <Field label="Property Notes & Hazards" value={notes} onChange={setNotes} placeholder="Gate code, dog in yard, steep slope…" rows={3}/>

          {/* Site photos — Before / After */}
          <div>
            <div style={S.label}>Site Photos</div>
            <input ref={fileRef} type="file" accept="image/*" multiple capture="environment" onChange={e=>handlePhoto(e,"before")} style={{display:"none"}}/>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:8}}>
              <button onClick={()=>fileRef.current.click()} style={{background:"rgba(255,170,0,0.08)",border:"1px solid rgba(255,170,0,0.25)",borderRadius:10,padding:"11px 6px",color:"#ffaa00",fontSize:11,fontFamily:"monospace",cursor:"pointer",fontWeight:700}}>📷 BEFORE</button>
              <button onClick={()=>{const inp=document.createElement("input");inp.type="file";inp.accept="image/*";inp.multiple=true;inp.onchange=e=>handlePhoto(e,"after");inp.click();}} style={{background:"rgba(0,255,153,0.07)",border:"1px solid rgba(0,255,153,0.25)",borderRadius:10,padding:"11px 6px",color:"#00ff99",fontSize:11,fontFamily:"monospace",cursor:"pointer",fontWeight:700}}>📷 AFTER</button>
            </div>
            {photos.length>0?(
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                {["before","after"].map(type=>{
                  const typed=photos.filter(p=>p.type===type);
                  if(typed.length===0) return null;
                  return(
                    <div key={type}>
                      <div style={{color:type==="before"?"#ffaa00":"#00ff99",fontSize:10,fontFamily:"monospace",fontWeight:700,marginBottom:6,letterSpacing:"0.08em"}}>{type.toUpperCase()} ({typed.length})</div>
                      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
                        {typed.map((p,i)=>(
                          <div key={i} style={{position:"relative",aspectRatio:"4/3",borderRadius:10,overflow:"hidden",border:"1px solid "+(type==="before"?"rgba(255,170,0,0.3)":"rgba(0,255,153,0.3)")}}>
                            <img src={p.url} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>
                            <button onClick={()=>setPhotos(ps=>ps.filter(x=>x!==p))} style={{position:"absolute",top:4,right:4,background:"rgba(0,0,0,0.75)",border:"none",color:"#fff",borderRadius:"50%",width:20,height:20,cursor:"pointer",fontSize:11}}>✕</button>
                            <div style={{position:"absolute",bottom:4,left:6,background:type==="before"?"rgba(255,170,0,0.9)":"rgba(0,255,153,0.9)",borderRadius:4,padding:"2px 6px",color:"#000",fontSize:9,fontFamily:"monospace",fontWeight:700}}>{type.toUpperCase()}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            ):(
              <div style={{background:"rgba(255,255,255,0.03)",border:"1px dashed rgba(255,255,255,0.1)",borderRadius:10,padding:"18px",textAlign:"center",color:"rgba(255,255,255,0.25)",fontSize:12,fontFamily:"monospace"}}>
                Take before photos now · after photos when done
              </div>
            )}
          </div>
        </div>
      )}
      <div style={{background:"rgba(124,252,0,0.05)",border:"1px solid rgba(124,252,0,0.18)",borderRadius:12,padding:"14px 16px"}}>
        {[{label:"Subtotal",value:`$${subtotal.toFixed(0)}`,show:true},{label:`Discount${discount.type==="pct"?` (${discount.value}%)`:""} `,value:`-$${discAmt.toFixed(0)}`,show:discAmt>0,color:"var(--lq-blue)"},{label:`Tax (${taxRate}%)`,value:`$${taxAmt.toFixed(0)}`,show:taxAmt>0}].filter(r=>r.show).map(r=>(
          <div key={r.label} style={{display:"flex",justifyContent:"space-between",marginBottom:6}}><span style={{color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12}}>{r.label}</span><span style={{color:r.color||"rgba(255,255,255,0.6)",fontFamily:"monospace",fontSize:12}}>{r.value}</span></div>
        ))}
        <div style={S.divider}/>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:8}}><span style={{color:"rgba(255,255,255,0.6)",fontFamily:"monospace",fontSize:13}}>TOTAL</span><span style={{color:"#7CFC00",fontSize:22,fontWeight:700}}>${total.toFixed(0)}</span></div>
        {annualVal&&<div style={{display:"flex",justifyContent:"space-between",marginTop:6}}><span style={{color:"rgba(255,255,255,0.3)",fontFamily:"monospace",fontSize:11}}>{recurInfo.label} · annual</span><span style={{color:"rgba(124,252,0,0.6)",fontFamily:"monospace",fontSize:11}}>${annualVal.toLocaleString()}/yr</span></div>}
      </div>

      {/* ── While I'm here banner ── */}
      {(() => {
        const allSvcs = SERVICES.filter(s => !selSvc.includes(s.id));
        const season = SEASON;
        const priority = { spring:["seed","fert","edge"], summer:["weed","aerate","trim"], fall:["leaf","aerate","seed"], winter:["leaf","trim","fert"] };
        const suggestion = (priority[season]||[]).map(id=>allSvcs.find(s=>s.id===id)).find(Boolean);
        if(!suggestion) return null;
        const price = rates[suggestion.id]?.basePrice + rates[suggestion.id]?.perSqft * sqft || suggestion.basePrice + suggestion.perSqft * sqft;
        const annualVal26 = price * 26;
        return (
          <div style={{ background:"rgba(255,170,0,0.07)", border:"1px solid rgba(255,170,0,0.3)", borderRadius:12, padding:"13px 15px", display:"flex", alignItems:"center", gap:12 }}>
            <span style={{ fontSize:20 }}>💡</span>
            <div style={{ flex:1 }}>
              <div style={{ color:"#ffaa00", fontSize:12, fontFamily:"monospace", fontWeight:700 }}>WHILE YOU'RE HERE</div>
              <div style={{ color:"rgba(255,255,255,0.7)", fontSize:13, fontFamily:"monospace", marginTop:2 }}>{suggestion.label} — +${price.toFixed(0)}</div>
              <div style={{ color:"rgba(255,255,255,0.3)", fontSize:11, fontFamily:"monospace", marginTop:1 }}>Biweekly adds ${annualVal26.toLocaleString()}/yr to this account</div>
            </div>
            <button onClick={() => setSelSvc(s => [...new Set([...s, suggestion.id])])} style={{ background:"#ffaa00", color:"#000", border:"none", borderRadius:8, padding:"7px 12px", fontSize:12, fontWeight:700, fontFamily:"monospace", cursor:"pointer", whiteSpace:"nowrap" }}>+ ADD</button>
          </div>
        );
      })()}

      {showSMS&&(
        <div style={{background:"#0a180a",border:"1px solid rgba(124,252,0,0.2)",borderRadius:12,padding:"14px 16px"}}>
          <div style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontFamily:"monospace",marginBottom:8}}>SMS PREVIEW</div>
          <div style={{color:"rgba(255,255,255,0.8)",fontSize:12,fontFamily:"monospace",lineHeight:1.7,whiteSpace:"pre-line"}}>{smsText}</div>
          <button onClick={()=>{try{navigator.clipboard?.writeText(smsText);}catch(e){}setCopied(true);setTimeout(()=>setCopied(false),2000);}} style={{marginTop:10,background:copied?"rgba(124,252,0,0.2)":"#7CFC00",color:copied?"#7CFC00":"#000",border:"none",borderRadius:8,padding:"9px 16px",fontSize:12,fontWeight:700,fontFamily:"monospace",cursor:"pointer"}}>{copied?"✓ COPIED!":"📋 COPY TEXT"}</button>
        </div>
      )}
      {!saved?(
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          <button onClick={()=>{setShowSMS(s=>!s);if(!showSMS)handleSave("Quoted");}} style={{...btn(true),background:"#7CFC00",color:"#000",border:"none"}}>📱 {showSMS?"HIDE SMS QUOTE":"GENERATE SMS QUOTE"}</button>
          <div style={{display:"flex",gap:8}}>
            <button onClick={()=>handleSave("Lead")} disabled={saving} style={{flex:1,background:"rgba(255,255,255,0.05)",color:"rgba(255,255,255,0.55)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:10,padding:"12px",fontSize:12,cursor:"pointer",fontFamily:"monospace"}}>{saving?"SAVING…":"💾 SAVE DRAFT"}</button>
            <button onClick={()=>{const name=prompt("Template name?");if(name){onSaveTemplate?.({id:genId(),name,services:SERVICES.filter(s=>selSvc.includes(s.id)).map(s=>({...s,...rates[s.id]})),customLines,total,recurring,payment});}}} style={{flex:1,background:"rgba(255,170,0,0.07)",color:"#ffaa00",border:"1px solid rgba(255,170,0,0.2)",borderRadius:10,padding:"12px",fontSize:12,cursor:"pointer",fontFamily:"monospace"}}>📋 SAVE TEMPLATE</button>
            <button onClick={()=>handleSave("Accepted")} disabled={saving} style={{flex:1,background:"rgba(0,207,255,0.1)",color:"var(--lq-blue)",border:"1px solid rgba(0,207,255,0.25)",borderRadius:10,padding:"12px",fontSize:12,cursor:"pointer",fontFamily:"monospace"}}>✅ ACCEPTED</button>
          </div>
          <button onClick={onBack} style={{background:"none",color:"rgba(255,255,255,0.25)",border:"none",cursor:"pointer",fontSize:11,fontFamily:"monospace"}}>← BACK</button>
        </div>
      ):(
        <div style={{background:"rgba(124,252,0,0.07)",border:"1px solid rgba(124,252,0,0.25)",borderRadius:12,padding:"16px",textAlign:"center"}}>
          <div style={{fontSize:24,marginBottom:6}}>✅</div>
          <div style={{color:"#7CFC00",fontSize:15,fontWeight:700,fontFamily:"monospace"}}>Quote #{qn} Saved{quickMode?" as Lead":""}</div>
          <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace",marginTop:3}}>{customer.isAnon?addressData.address:customer.name} · ${total.toFixed(0)}</div>
          {quickMode&&<div style={{color:"rgba(255,170,0,0.7)",fontSize:11,fontFamily:"monospace",marginTop:6}}>🚪 Add customer info from the Pipeline when they call back</div>}
        </div>
      )}
    </div>
  );
}


// ─── Invoices ─────────────────────────────────────────────────────────────────
function InvoiceDetail({invoice,profile,session,customers,onBack,onMarkPaid,onDelete,onUpdate}){
  const [editing,    setEditing]    = useState(false);
  const [lineItems,  setLineItems]  = useState(invoice.lineItems||[]);
  const [terms,      setTerms]      = useState(invoice.terms||"due_receipt");
  const [customDate, setCustomDate] = useState(invoice.dueDate||todayStr());
  const [notes,      setNotes]      = useState(invoice.notes||"");
  const [saving,     setSaving]     = useState(false);
  const [payModal,   setPayModal]   = useState(false);
  const [payMethod,  setPayMethod]  = useState("Cash");
  const [confirm,    setConfirm]    = useState(false);
  const [copied,        setCopied]        = useState(false);
  const [payLinkLoading,setPayLinkLoading]= useState(false);
  const [payLinkCopied, setPayLinkCopied] = useState(false);
  const [toast,         showToast]        = useToast();

  const dueDate = terms==="custom" ? customDate : calcDueDate(terms);
  const total   = lineItems.reduce((a,li)=>a+(parseFloat(li.price)||0)*(parseFloat(li.qty)||1),0);
  const addLine = ()=>setLineItems(l=>[...l,{id:genId(),label:"",qty:1,price:0}]);
  const updateLine=(id,f,v)=>setLineItems(l=>l.map(li=>li.id===id?{...li,[f]:v}:li));
  const removeLine=id=>setLineItems(l=>l.filter(li=>li.id!==id));

  const statusColor = INV_STATUS_COLORS[isOverdue(invoice)?"Overdue":invoice.status]||"#888";
  const daysUntilDue = invoice.dueDate ? -daysSince(invoice.dueDate) : null;

  const handleSaveEdit=async()=>{
    setSaving(true);
    await onUpdate(invoice.id,{lineItems,terms,dueDate,notes,total});
    setSaving(false);
    setEditing(false);
    showToast("Invoice updated");
  };

  const buildSMS=()=>{
    const co=profile?.company?"From "+profile.company+". ":"";
    const items=(invoice.lineItems||[]).filter(l=>l.label).map(l=>"  "+l.label+": $"+((parseFloat(l.price)||0)*(parseFloat(l.qty)||1)).toFixed(0)).join("\n");
    return co+"Invoice #"+invoice.invoiceNum+"\n"
      +(items?"\n"+items+"\n":"")
      +"\nTotal: $"+invoice.total?.toFixed(0)
      +" | Due: "+fmtDate(invoice.dueDate||todayStr())
      +(invoice.notes?"\n"+invoice.notes:"")
      +"\n\nReply PAID when sent. Thanks!";
  };

  const buildEmailLink=()=>{
    const co=profile?.company||"Your Lawn Service";
    const subj=encodeURIComponent("Invoice #"+invoice.invoiceNum+" from "+co+" - $"+invoice.total?.toFixed(0));
    const nl="%0A";
    const items=(invoice.lineItems||[]).filter(l=>l.label).map(l=>"  - "+l.label+": $"+(parseFloat(l.price)||0).toFixed(2)).join(nl);
    const body="Hi "+invoice.customerName?.split(" ")[0]+","+nl+nl
      +"Invoice #"+invoice.invoiceNum+" from "+co+nl
      +"Due: "+fmtDate(invoice.dueDate||todayStr())+nl+nl
      +items+nl+nl
      +"Total: $"+invoice.total?.toFixed(2)+nl+nl
      +(invoice.notes?invoice.notes+nl+nl:"")
      +"Thank you!";
    return "mailto:"+invoice.customerEmail+"?subject="+subj+"&body="+body;
  };

  const handleSendPaymentLink=async()=>{
    setPayLinkLoading(true);
    try{
      const r=await fetch('/api/create-payment-link',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({invoiceId:invoice.id,invoiceNum:invoice.invoiceNum,total:invoice.total,customerName:invoice.customerName,stripeAccountId:profile?.stripe_account_id||null})});
      const{url,error:err}=await r.json();
      if(err||!url) throw new Error(err||'Failed');
      try{await navigator.clipboard.writeText(url);}catch(e){}
      const msg=`Hi ${invoice.customerName?.split(' ')[0]||'there'}! Here's your payment link for Invoice #${invoice.invoiceNum} ($${invoice.total?.toFixed(0)}): ${url}`;
      window.location.href=`sms:${invoice.customerPhone||''}?body=${encodeURIComponent(msg)}`;
      setPayLinkCopied(true);
      setTimeout(()=>setPayLinkCopied(false),3000);
      showToast('Payment link copied & SMS opened');
    }catch(e){
      showToast('Failed to create payment link','error');
    }
    setPayLinkLoading(false);
  };

  const inputSt={background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"9px 11px",color:"#fff",fontSize:13,fontFamily:"monospace",outline:"none"};

  return(
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      {toast&&<Toast message={toast.message} type={toast.type||"success"}/>}
      {confirm&&<ConfirmModal message={"Delete invoice #"+invoice.invoiceNum+"? This cannot be undone."} onConfirm={async()=>{await onDelete(invoice.id);onBack();}} onCancel={()=>setConfirm(false)}/>}

      {/* Pay modal */}
      {payModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.88)",zIndex:500,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
          <div style={{background:"#0a180a",border:"1px solid rgba(0,255,153,0.2)",borderRadius:"16px 16px 0 0",width:"100%",maxWidth:430,padding:"24px 20px 36px",animation:"fadeUp 0.2s ease"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:16}}>
              <div>
                <div style={{color:"#fff",fontSize:15,fontFamily:"monospace",fontWeight:700}}>✓ Mark as Paid</div>
                <div style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",marginTop:3}}>{invoice.customerName}</div>
              </div>
              <div style={{textAlign:"right"}}>
                <div style={{color:"#7CFC00",fontSize:22,fontWeight:700,fontFamily:"monospace"}}>${invoice.total?.toFixed(0)}</div>
                <div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace"}}>#{invoice.invoiceNum}</div>
              </div>
            </div>
            <div style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontFamily:"monospace",letterSpacing:"0.08em",marginBottom:10}}>HOW DID THEY PAY?</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:7,marginBottom:20}}>
              {PAYMENT_METHODS.map(p=>(
                <button key={p} onClick={()=>setPayMethod(p)} style={{padding:"10px 6px",background:payMethod===p?"rgba(0,255,153,0.12)":"rgba(255,255,255,0.04)",border:"1px solid "+(payMethod===p?"rgba(0,255,153,0.4)":"rgba(255,255,255,0.08)"),borderRadius:9,cursor:"pointer",textAlign:"center"}}>
                  <div style={{color:payMethod===p?"#00ff99":"rgba(255,255,255,0.55)",fontSize:12,fontFamily:"monospace",fontWeight:payMethod===p?700:400}}>{p}</div>
                </button>
              ))}
            </div>
            <div style={{display:"flex",gap:10}}>
              <button onClick={()=>setPayModal(false)} style={{...btn(true,"ghost"),flex:1}}>CANCEL</button>
              <button onClick={async()=>{await onMarkPaid(invoice.id,payMethod);setPayModal(false);showToast("Invoice marked paid");}} style={{flex:2,background:"#00ff99",color:"#000",border:"none",borderRadius:10,padding:"14px",fontSize:14,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>
                MARK PAID — {payMethod}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <button onClick={onBack} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12,cursor:"pointer",padding:0}}>← INVOICES</button>
        <div style={{display:"flex",gap:6}}>
          {invoice.status!=="Paid"&&<button onClick={()=>setEditing(e=>!e)} style={{background:editing?"rgba(124,252,0,0.12)":"rgba(255,255,255,0.05)",border:`1px solid ${editing?"rgba(124,252,0,0.3)":"rgba(255,255,255,0.1)"}`,borderRadius:8,padding:"6px 10px",color:editing?"#7CFC00":"rgba(255,255,255,0.5)",fontSize:11,fontFamily:"monospace",cursor:"pointer"}}>{editing?"✕ CANCEL":"✎ EDIT"}</button>}
          <button onClick={()=>setConfirm(true)} style={{background:"rgba(255,68,68,0.08)",border:"1px solid rgba(255,68,68,0.2)",borderRadius:8,padding:"6px 10px",color:"#ff6b6b",fontSize:11,fontFamily:"monospace",cursor:"pointer"}}>🗑</button>
        </div>
      </div>

      {/* Invoice header */}
      <div style={{...S.card,borderColor:"rgba(124,252,0,0.2)"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
          <div>
            <div style={{color:"#fff",fontSize:16,fontWeight:700,fontFamily:"monospace"}}>{invoice.customerName}</div>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",marginTop:2}}>#{invoice.invoiceNum} · {fmtDate(invoice.createdAt)}</div>
          </div>
          <div style={{textAlign:"right"}}>
            <div style={{color:"#7CFC00",fontSize:22,fontWeight:700}}>${invoice.total?.toFixed(0)}</div>
            <span style={{background:`${statusColor}18`,border:`1px solid ${statusColor}44`,borderRadius:6,padding:"2px 8px",color:statusColor,fontSize:10,fontFamily:"monospace"}}>{isOverdue(invoice)?"Overdue":invoice.status}</span>
          </div>
        </div>
        <div style={{height:1,background:"rgba(255,255,255,0.06)",marginBottom:10}}/>
        <div style={{display:"flex",justifyContent:"space-between"}}>
          <div>
            <div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace",marginBottom:2}}>DUE DATE</div>
            <div style={{color:isOverdue(invoice)?"#ff6b6b":"#fff",fontSize:13,fontFamily:"monospace",fontWeight:700}}>
              {invoice.dueDate?fmtDate(invoice.dueDate):"—"}
              {daysUntilDue!==null&&invoice.status!=="Paid"&&<span style={{color:"rgba(255,255,255,0.35)",fontSize:11,marginLeft:6}}>{daysUntilDue<=0?"("+Math.abs(daysUntilDue)+"d overdue)":"(in "+daysUntilDue+"d)"}</span>}
            </div>
          </div>
          {invoice.status==="Paid"&&<div style={{textAlign:"right"}}>
            <div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace",marginBottom:2}}>PAID ON</div>
            <div style={{color:"#00ff99",fontSize:13,fontFamily:"monospace",fontWeight:700}}>{invoice.paidDate?fmtDate(invoice.paidDate):"—"} · {invoice.paymentMethod}</div>
          </div>}
        </div>
      </div>

      {/* Edit mode */}
      {editing?(
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          <div style={{...S.label}}>Line Items</div>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {lineItems.map((li,i)=>(
              <div key={li.id} style={{display:"flex",gap:8,alignItems:"center"}}>
                <input value={li.label} onChange={e=>updateLine(li.id,"label",e.target.value)} placeholder={"Service "+(i+1)} style={{...inputSt,flex:1}}/>
                <div style={{display:"flex",alignItems:"center",...inputSt,width:90,gap:2}}>
                  <span style={{color:"rgba(255,255,255,0.3)"}}>$</span>
                  <input type="number" min="0" value={li.price} onChange={e=>updateLine(li.id,"price",e.target.value)} style={{background:"none",border:"none",color:"#7CFC00",fontSize:13,fontFamily:"monospace",outline:"none",textAlign:"right",flex:1}}/>
                </div>
                {lineItems.length>1&&<button onClick={()=>removeLine(li.id)} style={{background:"none",border:"none",color:"rgba(255,68,68,0.5)",cursor:"pointer",fontSize:15}}>✕</button>}
              </div>
            ))}
            <button onClick={addLine} style={{background:"rgba(255,255,255,0.04)",border:"1px dashed rgba(255,255,255,0.1)",borderRadius:8,padding:"9px",color:"rgba(255,255,255,0.35)",fontSize:12,fontFamily:"monospace",cursor:"pointer"}}>+ ADD LINE</button>
          </div>
          <div>
            <div style={S.label}>Payment Terms</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
              {TERMS_OPTIONS.map(t=><button key={t.id} onClick={()=>setTerms(t.id)} style={{padding:"9px",background:terms===t.id?"rgba(124,252,0,0.1)":"rgba(255,255,255,0.03)",border:`1px solid ${terms===t.id?"rgba(124,252,0,0.35)":"rgba(255,255,255,0.07)"}`,borderRadius:10,cursor:"pointer"}}><div style={{color:terms===t.id?"#7CFC00":"rgba(255,255,255,0.6)",fontSize:12,fontFamily:"monospace",fontWeight:terms===t.id?700:400}}>{t.label}</div></button>)}
            </div>
            {terms==="custom"&&<input type="date" value={customDate} onChange={e=>setCustomDate(e.target.value)} style={{marginTop:8,...inputSt,width:"100%"}}/>}
          </div>
          <Field label="Notes" value={notes} onChange={setNotes} placeholder="Payment instructions…" rows={2}/>
          <div style={{display:"flex",justifyContent:"space-between",padding:"12px 14px",background:"rgba(124,252,0,0.05)",border:"1px solid rgba(124,252,0,0.15)",borderRadius:10}}>
            <span style={{color:"rgba(255,255,255,0.5)",fontFamily:"monospace",fontSize:12}}>NEW TOTAL</span>
            <span style={{color:"#7CFC00",fontSize:18,fontWeight:700}}>${total.toFixed(0)}</span>
          </div>
          <button onClick={handleSaveEdit} disabled={saving} style={{...btn(true),background:"#7CFC00",color:"#000",border:"none"}}>{saving?"SAVING…":"SAVE CHANGES"}</button>
        </div>
      ):(
        /* View mode */
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          <div style={{...S.card}}>
            <div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace",marginBottom:8}}>LINE ITEMS</div>
            {(invoice.lineItems||[]).filter(li=>li.label).map((li,i)=>(
              <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:"1px solid rgba(255,255,255,0.04)"}}>
                <span style={{color:"rgba(255,255,255,0.75)",fontSize:13,fontFamily:"monospace"}}>{li.label}{(parseFloat(li.qty)||1)>1?" x"+(parseFloat(li.qty)||1):""}</span>
                <span style={{color:"#7CFC00",fontSize:13}}>${((parseFloat(li.price)||0)*(parseFloat(li.qty)||1)).toFixed(0)}</span>
              </div>
            ))}
            <div style={{display:"flex",justifyContent:"space-between",marginTop:8,paddingTop:8,borderTop:"1px solid rgba(124,252,0,0.15)"}}>
              <span style={{color:"rgba(255,255,255,0.55)",fontFamily:"monospace",fontSize:13}}>TOTAL</span>
              <span style={{color:"#7CFC00",fontSize:18,fontWeight:700}}>${invoice.total?.toFixed(0)}</span>
            </div>
          </div>
          {invoice.notes&&<div style={{...S.card}}><div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace",marginBottom:4}}>NOTES</div><div style={{color:"rgba(255,255,255,0.55)",fontSize:13,fontFamily:"monospace",lineHeight:1.5}}>{invoice.notes}</div></div>}
        </div>
      )}

      {/* Actions */}
      {!editing&&(
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {invoice.status!=="Paid"&&<button onClick={()=>setPayModal(true)} style={{...btn(true),background:"rgba(0,255,153,0.12)",color:"#00ff99",borderColor:"rgba(0,255,153,0.3)"}}>✓ MARK PAID</button>}
          {invoice.status!=="Paid"&&<button onClick={handleSendPaymentLink} disabled={payLinkLoading} style={{...btn(true),background:payLinkCopied?"rgba(124,252,0,0.15)":"rgba(99,102,241,0.12)",color:payLinkCopied?"#7CFC00":"#a5b4fc",borderColor:payLinkCopied?"rgba(124,252,0,0.3)":"rgba(99,102,241,0.35)"}}>{payLinkLoading?"CREATING LINK…":payLinkCopied?"✓ LINK COPIED!":"💳 SEND PAYMENT LINK"}</button>}
          {invoice.status!=="Paid"&&(()=>{const hasPhone=invoice.customerPhone&&invoice.customerPhone.replace(/\D/g,"").length>=7&&!invoice.customerPhone.includes("000-0000");return(<div style={{display:"flex",gap:8}}>
              {hasPhone?(<button onClick={()=>{const t=buildSMS();try{navigator.clipboard?.writeText(t);}catch(e){}window.location.href="sms:"+(invoice.customerPhone||"");showToast("Invoice text copied");}} style={{flex:1,...btn(true,"ghost")}}>📱 {invoice.status==="Draft"?"SEND INVOICE TEXT":"RESEND INVOICE TEXT"}</button>):(<div style={{flex:1,background:"rgba(255,170,0,0.07)",border:"1px solid rgba(255,170,0,0.2)",borderRadius:10,padding:"10px 12px",color:"#ffaa00",fontSize:11,fontFamily:"monospace",textAlign:"center"}}>⚠️ No phone</div>)}
              {invoice.customerEmail&&<button onClick={()=>window.open(buildEmailLink())} style={{flex:1,...btn(true,"ghost")}}>✉️ {invoice.status==="Draft"?"SEND EMAIL":"RESEND EMAIL"}</button>}
            </div>);})()}
          <div style={{display:"flex",gap:8}}>
            <a href={"tel:"+(invoice.customerPhone||"")} style={{flex:1,...btn(true,"ghost"),textDecoration:"none",textAlign:"center"}}>📞 CALL</a>
            <a href={"sms:"+(invoice.customerPhone||"")} style={{flex:1,...btn(true,"ghost"),textDecoration:"none",textAlign:"center",color:"#7CFC00",borderColor:"rgba(124,252,0,0.3)"}}>💬 TEXT</a>
          </div>
          <button onClick={()=>{
            const co=profile?.company||"LAWN.Quote";
            const addr=profile?.address||"";
            const phone=profile?.phone||"";
            const logo=profile?.logo_url||"";
            const subtotal=(invoice.lineItems||[]).filter(l=>l.label).reduce((a,l)=>a+(parseFloat(l.price)||0)*(parseFloat(l.qty)||1),0);
            const items=(invoice.lineItems||[]).filter(l=>l.label).map((l,i)=>`
              <tr style="background:${i%2===0?'#fff':'#f9f9f9'};">
                <td style="padding:10px 12px;font-size:13px;border-bottom:1px solid #eee;">${l.label}</td>
                <td style="padding:10px 12px;font-size:13px;text-align:center;border-bottom:1px solid #eee;">${parseFloat(l.qty)||1}</td>
                <td style="padding:10px 12px;font-size:13px;text-align:right;border-bottom:1px solid #eee;">$${(parseFloat(l.price)||0).toFixed(2)}</td>
                <td style="padding:10px 12px;font-size:13px;text-align:right;border-bottom:1px solid #eee;font-weight:600;">$${((parseFloat(l.price)||0)*(parseFloat(l.qty)||1)).toFixed(2)}</td>
              </tr>`).join('');
            const html=`<!DOCTYPE html><html><head><title>Invoice #${invoice.invoiceNum}</title>
            <style>
              *{box-sizing:border-box;margin:0;padding:0;}
              body{font-family:Arial,sans-serif;color:#222;background:#fff;padding:32px;}
              .accent{background:#1a5c2a;height:8px;width:100%;margin-bottom:24px;}
              .header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:24px;}
              .logo-area{display:flex;align-items:center;gap:16px;}
              .logo-circle{width:64px;height:64px;border-radius:50%;background:#dde8dd;display:flex;align-items:center;justify-content:center;font-size:11px;color:#888;font-weight:600;overflow:hidden;flex-shrink:0;}
              .logo-circle img{width:100%;height:100%;object-fit:cover;}
              .company-name{font-size:18px;font-weight:700;color:#1a5c2a;}
              .company-detail{font-size:12px;color:#666;margin-top:2px;}
              .invoice-title{text-align:right;}
              .invoice-title h1{font-size:28px;color:#888;letter-spacing:0.05em;}
              .invoice-meta{font-size:12px;color:#666;margin-top:6px;}
              .invoice-meta span{font-weight:700;color:#222;}
              .bill-row{display:flex;gap:32px;margin:20px 0;padding:16px;background:#f5f5f5;border-radius:4px;}
              .bill-col{flex:1;}
              .bill-label{font-size:10px;font-weight:700;color:#1a5c2a;letter-spacing:0.1em;text-transform:uppercase;border-bottom:1px solid #1a5c2a;padding-bottom:4px;margin-bottom:8px;}
              .bill-val{font-size:13px;color:#333;margin-bottom:2px;}
              .items-table{width:100%;border-collapse:collapse;margin:20px 0;}
              .items-table thead tr{background:#1a5c2a;color:white;}
              .items-table thead td{padding:10px 12px;font-size:11px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;}
              .items-table thead td:not(:first-child){text-align:right;}
              .totals{width:300px;margin-left:auto;margin-top:8px;}
              .totals-row{display:flex;justify-content:space-between;padding:6px 0;font-size:13px;border-bottom:1px solid #eee;}
              .totals-row.total{border-bottom:none;padding-top:10px;font-weight:700;font-size:16px;color:#1a5c2a;}
              .balance-due{background:#fde8e8;border-radius:4px;padding:10px 12px;display:flex;justify-content:space-between;align-items:center;margin-top:4px;}
              .balance-due span:first-child{font-weight:700;font-size:14px;}
              .balance-due span:last-child{font-weight:700;font-size:18px;color:#1a5c2a;}
              .footer-bar{background:#1a5c2a;height:8px;width:100%;margin-top:32px;}
              .notes{font-size:12px;color:#666;margin-top:16px;padding:12px;background:#f9f9f9;border-radius:4px;}
              .payment-terms{font-size:12px;color:#888;margin-top:8px;}
              @media print{body{padding:16px;}.accent{margin-bottom:16px;}}
            </style></head><body>
            <div class="accent"></div>
            <div class="header">
              <div class="logo-area">
                <div class="logo-circle">${logo?`<img src="${logo}" alt="logo"/>`:'LOGO'}</div>
                <div>
                  <div class="company-name">${co}</div>
                  ${addr?`<div class="company-detail">${addr}</div>`:''}
                  ${phone?`<div class="company-detail">${phone}</div>`:''}
                </div>
              </div>
              <div class="invoice-title">
                <h1>INVOICE</h1>
                <div class="invoice-meta">DATE &nbsp;&nbsp; <span>${new Date().toLocaleDateString()}</span></div>
                <div class="invoice-meta">INVOICE NO. &nbsp;&nbsp; <span>#${invoice.invoiceNum}</span></div>
              </div>
            </div>

            <div class="payment-terms" style="text-align:right;margin-bottom:8px;font-style:italic;">
              Due: ${invoice.dueDate?new Date(invoice.dueDate+'T12:00:00').toLocaleDateString():'Upon Receipt'}
            </div>

            <div class="bill-row">
              <div class="bill-col">
                <div class="bill-label">Bill To</div>
                <div class="bill-val" style="font-weight:600;">${invoice.customerName||''}</div>
                ${invoice.customerPhone?`<div class="bill-val">${invoice.customerPhone}</div>`:''}
                ${invoice.customerEmail?`<div class="bill-val">${invoice.customerEmail}</div>`:''}
              </div>
              <div class="bill-col">
                <div class="bill-label">Service Address</div>
                <div class="bill-val">${invoice.customerName||''}</div>
              </div>
            </div>

            <table class="items-table">
              <thead>
                <tr>
                  <td style="width:50%">Description</td>
                  <td style="text-align:center;width:10%">Qty</td>
                  <td style="text-align:right;width:20%">Unit Price</td>
                  <td style="text-align:right;width:20%">Total</td>
                </tr>
              </thead>
              <tbody>${items}</tbody>
            </table>

            <div style="display:flex;justify-content:space-between;align-items:flex-start;">
              <div style="max-width:300px;">
                ${invoice.notes?`<div class="notes"><strong>Remarks / Payment Instructions:</strong><br/>${invoice.notes}</div>`:'<div class="notes">Remarks / Payment Instructions:</div>'}
              </div>
              <div class="totals">
                <div class="totals-row"><span>SUBTOTAL</span><span>$${subtotal.toFixed(2)}</span></div>
                <div class="totals-row"><span>DISCOUNT</span><span>$${(invoice.discAmt||0).toFixed(2)}</span></div>
                <div class="totals-row"><span>SUBTOTAL LESS DISCOUNT</span><span>$${(subtotal-(invoice.discAmt||0)).toFixed(2)}</span></div>
                <div class="totals-row"><span>TAX RATE</span><span>${((invoice.taxRate||0)*100).toFixed(2)}%</span></div>
                <div class="totals-row"><span>TOTAL TAX</span><span>$${(invoice.taxAmt||0).toFixed(2)}</span></div>
                <div class="balance-due" style="margin-top:8px;">
                  <span>Balance Due</span>
                  <span>$ ${invoice.status==="Paid"?'PAID':invoice.total?.toFixed(2)}</span>
                </div>
              </div>
            </div>

            <div class="footer-bar"></div>
            <script>window.print();</script>
            </body></html>`;
            const win=window.open('','_blank');
            if(win){win.document.write(html);win.document.close();}
          }} style={{...btn(true,"ghost"),width:"100%"}}>🖨 PRINT INVOICE</button>
        </div>
      )}
    </div>
  );
}


const INV_STATUS_COLORS = { Draft:"#888", Sent:"#7CFC00", Overdue:"#ff4444", Paid:"#00ff99" };
const TERMS_OPTIONS = [
  { id:"due_receipt", label:"Due on Receipt", days:0 },
  { id:"net7",        label:"Net 7",          days:7 },
  { id:"net30",       label:"Net 30",         days:30 },
  { id:"custom",      label:"Custom Date",    days:null }];

function InvoiceList({ invoices, quotes, customers, onMarkPaid, onDelete, onCreateFromQuote, onNewInvoice, onSelectInvoice }) {
  const [filter, setFilter] = useState("All");
  const [quoteSearch, setQuoteSearch] = useState("");
  const [selectedQuotes, setSelectedQuotes] = useState(new Set());
  const [showQuoteLookup, setShowQuoteLookup] = useState(false);

  // All uninvoiced completed quotes
  const uninvoicedQuotes = quotes.filter(q=>
    q.stage==="Completed" &&
    q.customerName!=="Door Hanger Lead" &&
    !invoices.find(i=>i.quoteId===q.id)
  ).sort((a,b)=>b.createdAt.localeCompare(a.createdAt));

  // Filtered by search
  const searchLower = quoteSearch.toLowerCase();
  const filteredQuotes = quoteSearch
    ? uninvoicedQuotes.filter(q=>
        q.customerName?.toLowerCase().includes(searchLower) ||
        q.quoteNum?.toLowerCase().includes(searchLower) ||
        q.createdAt?.includes(quoteSearch)
      )
    : uninvoicedQuotes;

  const toggleQuote = (id) => setSelectedQuotes(s=>{ const n=new Set(s); n.has(id)?n.delete(id):n.add(id); return n; });
  const selectedList = uninvoicedQuotes.filter(q=>selectedQuotes.has(q.id));
  const selectedTotal = selectedList.reduce((a,q)=>a+(q.total||0),0);

  const [confirm, setConfirm] = useState(null);
  const [toast, showToast] = useToast();
  const [payModal, setPayModal] = useState(null);
  const [payMethod, setPayMethod] = useState("Cash");
  const [showQuotePicker, setShowQuotePicker] = useState(false);

  const withStatus = invoices.map(inv => ({
    ...inv,
    status: inv.status === "Paid" ? "Paid" : isOverdue(inv) ? "Overdue" : inv.status,
  }));
  const filtered = filter === "All" ? withStatus : withStatus.filter(i => i.status === filter);

  const totalOwed = withStatus.filter(i=>i.status==="Sent"||i.status==="Overdue").reduce((a,i)=>a+(i.total||0),0);
  const totalPaid = withStatus.filter(i=>i.status==="Paid").reduce((a,i)=>a+(i.total||0),0);

  const handlePaid = async () => {
    await onMarkPaid(payModal.id, payMethod);
    setPayModal(null);
    showToast("Invoice marked paid");
  };

  const acceptedQuotes = quotes.filter(q => ["Accepted","Quoted","Scheduled","Completed"].includes(q.stage) && !invoices.find(i => i.quoteId === q.id));

  return (
    <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
      {toast && <Toast message={toast.message} type={toast.type}/>}
      {confirm && <ConfirmModal message={`Delete invoice ${confirm.invoiceNum}? This cannot be undone.`} onConfirm={async()=>{ await onDelete(confirm.id); setConfirm(null); showToast("Invoice deleted"); }} onCancel={()=>setConfirm(null)}/>}

      {/* Quote Lookup */}
      <div style={{background:"rgba(124,252,0,0.05)",border:"1px solid rgba(124,252,0,0.2)",borderRadius:14,overflow:"hidden"}}>
        {/* Header */}
        <div onClick={()=>setShowQuoteLookup(s=>!s)} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"14px 16px",cursor:"pointer"}}>
          <div>
            <div style={{color:"#7CFC00",fontSize:12,fontFamily:"monospace",fontWeight:700}}>✦ QUOTE LOOKUP</div>
            <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace",marginTop:2}}>
              {uninvoicedQuotes.length} completed job{uninvoicedQuotes.length!==1?"s":""} ready to invoice
            </div>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            {selectedList.length>0&&(
              <button onClick={e=>{
                e.stopPropagation();
                if(onCreateFromQuote&&selectedList.length===1) onCreateFromQuote(selectedList[0]);
                else if(selectedList.length>1) onCreateFromQuote(selectedList);
                setSelectedQuotes(new Set());
              }} style={{background:"#7CFC00",color:"#000",border:"none",borderRadius:8,padding:"7px 12px",fontSize:11,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>
                🧾 {selectedList.length>1?"INVOICE "+selectedList.length+" — $"+selectedTotal.toFixed(0):"INVOICE $"+selectedTotal.toFixed(0)}
              </button>
            )}
            <span style={{color:"rgba(255,255,255,0.3)",fontSize:14}}>{showQuoteLookup?"▲":"▼"}</span>
          </div>
        </div>

        {/* Expanded lookup */}
        {showQuoteLookup&&(
          <div style={{borderTop:"1px solid rgba(124,252,0,0.15)",padding:"12px 16px",display:"flex",flexDirection:"column",gap:10}}>
            {/* Search bar */}
            <div style={{position:"relative"}}>
              <input
                value={quoteSearch}
                onChange={e=>setQuoteSearch(e.target.value)}
                placeholder="Search by client, quote #, or date (YYYY-MM-DD)…"
                style={{width:"100%",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(124,252,0,0.2)",borderRadius:9,padding:"10px 36px 10px 12px",color:"#fff",fontSize:12,fontFamily:"monospace",outline:"none"}}
              />
              {quoteSearch&&<button onClick={()=>setQuoteSearch("")} style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:"rgba(255,255,255,0.3)",cursor:"pointer",fontSize:14}}>✕</button>}
            </div>

            {/* Select all / clear */}
            {filteredQuotes.length>0&&(
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <button onClick={()=>setSelectedQuotes(new Set(filteredQuotes.map(q=>q.id)))} style={{background:"none",border:"none",color:"rgba(124,252,0,0.6)",fontSize:11,fontFamily:"monospace",cursor:"pointer"}}>SELECT ALL ({filteredQuotes.length})</button>
                {selectedList.length>0&&<button onClick={()=>setSelectedQuotes(new Set())} style={{background:"none",border:"none",color:"rgba(255,255,255,0.3)",fontSize:11,fontFamily:"monospace",cursor:"pointer"}}>CLEAR</button>}
              </div>
            )}

            {/* Quote list */}
            <div style={{display:"flex",flexDirection:"column",gap:6,maxHeight:320,overflowY:"auto"}}>
              {filteredQuotes.length===0?(
                <div style={{color:"rgba(255,255,255,0.25)",fontSize:12,fontFamily:"monospace",textAlign:"center",padding:"16px 0"}}>
                  {quoteSearch?"No quotes match your search":"No completed quotes ready to invoice"}
                </div>
              ):filteredQuotes.map(q=>(
                <div key={q.id} onClick={()=>toggleQuote(q.id)} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 12px",background:selectedQuotes.has(q.id)?"rgba(124,252,0,0.08)":"rgba(255,255,255,0.03)",border:`1px solid ${selectedQuotes.has(q.id)?"rgba(124,252,0,0.3)":"rgba(255,255,255,0.07)"}`,borderRadius:9,cursor:"pointer",transition:"all 0.15s"}}>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <div style={{width:18,height:18,borderRadius:4,border:`2px solid ${selectedQuotes.has(q.id)?"#7CFC00":"rgba(255,255,255,0.2)"}`,background:selectedQuotes.has(q.id)?"#7CFC00":"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                      {selectedQuotes.has(q.id)&&<span style={{color:"#000",fontSize:11,fontWeight:700}}>✓</span>}
                    </div>
                    <div>
                      <div style={{color:"#fff",fontSize:13,fontFamily:"monospace",fontWeight:600}}>{q.customerName}</div>
                      <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace"}}>#{q.quoteNum} · {fmtDate(q.createdAt)}</div>
                    </div>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <div style={{color:"#7CFC00",fontSize:14,fontWeight:700}}>${(q.total||0).toFixed(0)}</div>
                    {(q.total||0)===0&&<div style={{color:"#ff6b6b",fontSize:9,fontFamily:"monospace"}}>NO PRICE</div>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Pay modal */}
      {payModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.88)",zIndex:500,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
          <div style={{background:"#0a180a",border:"1px solid rgba(0,255,153,0.2)",borderRadius:"16px 16px 0 0",width:"100%",maxWidth:430,padding:"24px 20px 36px",animation:"fadeUp 0.2s ease"}}>
            {/* Header */}
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:16}}>
              <div>
                <div style={{color:"#fff",fontSize:15,fontFamily:"monospace",fontWeight:700}}>✓ Mark as Paid</div>
                <div style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",marginTop:3}}>{payModal.customerName}</div>
              </div>
              <div style={{textAlign:"right"}}>
                <div style={{color:"#7CFC00",fontSize:22,fontWeight:700,fontFamily:"monospace"}}>${payModal.total?.toFixed(0)}</div>
                <div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace"}}>#{payModal.invoiceNum}</div>
              </div>
            </div>
            {/* Payment method */}
            <div style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontFamily:"monospace",letterSpacing:"0.08em",marginBottom:10}}>HOW DID THEY PAY?</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:7,marginBottom:20}}>
              {PAYMENT_METHODS.map(p=>(
                <button key={p} onClick={()=>setPayMethod(p)} style={{padding:"10px 6px",background:payMethod===p?"rgba(0,255,153,0.12)":"rgba(255,255,255,0.04)",border:"1px solid "+(payMethod===p?"rgba(0,255,153,0.4)":"rgba(255,255,255,0.08)"),borderRadius:9,cursor:"pointer",textAlign:"center",transition:"all 0.15s"}}>
                  <div style={{color:payMethod===p?"#00ff99":"rgba(255,255,255,0.55)",fontSize:12,fontFamily:"monospace",fontWeight:payMethod===p?700:400}}>{p}</div>
                </button>
              ))}
            </div>
            <div style={{display:"flex",gap:10}}>
              <button onClick={()=>setPayModal(null)} style={{...btn(true,"ghost"),flex:1}}>CANCEL</button>
              <button onClick={handlePaid} style={{flex:2,background:"#00ff99",color:"#000",border:"none",borderRadius:10,padding:"14px",fontSize:14,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>
                MARK PAID — {payMethod}
              </button>
            </div>
          </div>
        </div>
      )}

      <div>
        <p style={S.label}>Invoices</p>
        <h2 style={S.heading}>Invoices</h2>
        <p style={S.sub}>${totalOwed.toFixed(0)} outstanding · ${totalPaid.toFixed(0)} collected</p>
      </div>

      {/* Quick actions */}
      <div style={{display:"flex",gap:8}}>
        <button onClick={onNewInvoice} style={{flex:1,background:"rgba(124,252,0,0.08)",border:"1px solid rgba(124,252,0,0.25)",borderRadius:10,padding:"11px",color:"#7CFC00",fontSize:12,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>+ NEW INVOICE</button>
        {acceptedQuotes.length > 0 && (
          <button onClick={()=>setShowQuotePicker(true)} style={{flex:1,background:"rgba(0,207,255,0.08)",border:"1px solid rgba(0,207,255,0.25)",borderRadius:10,padding:"11px",color:"var(--lq-blue)",fontSize:12,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>⚡ FROM QUOTE ({acceptedQuotes.length})</button>
        )}
      </div>

      {/* Quote picker modal */}
      {showQuotePicker&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.88)",zIndex:500,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
          <div style={{background:"#0a180a",border:"1px solid rgba(0,207,255,0.2)",borderRadius:"16px 16px 0 0",width:"100%",maxWidth:430,maxHeight:"80vh",display:"flex",flexDirection:"column",animation:"fadeUp 0.25s ease"}}>
            {/* Header */}
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"18px 20px 14px",borderBottom:"1px solid rgba(255,255,255,0.07)",flexShrink:0}}>
              <div>
                <div style={{color:"#fff",fontSize:15,fontFamily:"monospace",fontWeight:700}}>⚡ Convert Quote to Invoice</div>
                <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace",marginTop:2}}>{acceptedQuotes.length} accepted quote{acceptedQuotes.length!==1?"s":""} ready to invoice</div>
              </div>
              <button onClick={()=>setShowQuotePicker(false)} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",cursor:"pointer",fontSize:18}}>✕</button>
            </div>
            {/* Quote list */}
            <div style={{overflowY:"auto",padding:"12px 16px 32px",flex:1,display:"flex",flexDirection:"column",gap:8}}>
              {acceptedQuotes.map(q=>(
                <button key={q.id} onClick={()=>{setShowQuotePicker(false);onCreateFromQuote(q);}} style={{display:"flex",alignItems:"center",gap:12,background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:12,padding:"14px",cursor:"pointer",textAlign:"left",width:"100%",transition:"all 0.15s"}}>
                  {/* Avatar */}
                  <div style={{width:38,height:38,borderRadius:"50%",background:"rgba(0,207,255,0.12)",border:"1px solid rgba(0,207,255,0.25)",display:"flex",alignItems:"center",justifyContent:"center",color:"var(--lq-blue)",fontSize:15,fontWeight:700,flexShrink:0,fontFamily:"monospace"}}>
                    {(q.customerName||"?").charAt(0).toUpperCase()}
                  </div>
                  {/* Details */}
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:3}}>
                      <div style={{color:"#fff",fontSize:13,fontFamily:"monospace",fontWeight:700}}>{q.customerName}</div>
                      <div style={{color:"#7CFC00",fontSize:14,fontWeight:700,fontFamily:"monospace",flexShrink:0,marginLeft:8}}>${q.total?.toFixed(0)}</div>
                    </div>
                    <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace",marginBottom:3}}>#{q.quoteNum} · {fmtDate(q.createdAt)}</div>
                    {q.address&&<div style={{color:"rgba(255,255,255,0.25)",fontSize:10,fontFamily:"monospace",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>📍 {q.address}</div>}
                    <div style={{display:"flex",gap:4,marginTop:5,flexWrap:"wrap"}}>
                      {(q.services||[]).slice(0,3).map(s=>s&&s.label&&(
                        <span key={s.id} style={{background:"rgba(0,207,255,0.08)",border:"1px solid rgba(0,207,255,0.2)",borderRadius:4,padding:"2px 6px",color:"rgba(0,207,255,0.7)",fontSize:9,fontFamily:"monospace"}}>{s.label}</span>
                      ))}
                    </div>
                  </div>
                  <span style={{color:"rgba(255,255,255,0.2)",fontSize:14,flexShrink:0}}>→</span>
                </button>
              ))}
              {acceptedQuotes.length===0&&(
                <div style={{textAlign:"center",padding:"32px 0"}}>
                  <div style={{fontSize:28,marginBottom:8}}>📋</div>
                  <div style={{color:"rgba(255,255,255,0.35)",fontFamily:"monospace",fontSize:12}}>No accepted quotes without invoices</div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Filters */}
      <div style={{display:"flex",gap:6,overflowX:"auto",paddingBottom:4}}>
        {["All","Draft","Sent","Overdue","Paid"].map(s=>(
          <button key={s} onClick={()=>setFilter(s)} style={{flexShrink:0,padding:"6px 11px",background:filter===s?`${INV_STATUS_COLORS[s]||"#7CFC00"}18`:"rgba(255,255,255,0.04)",border:`1px solid ${filter===s?(INV_STATUS_COLORS[s]||"#7CFC00")+"44":"rgba(255,255,255,0.08)"}`,borderRadius:8,color:filter===s?(INV_STATUS_COLORS[s]||"#7CFC00"):"rgba(255,255,255,0.4)",fontSize:10,fontFamily:"monospace",cursor:"pointer",whiteSpace:"nowrap"}}>
            {s.toUpperCase()} <span style={{opacity:0.6}}>({(s==="All"?withStatus:withStatus.filter(i=>i.status===s)).length})</span>
          </button>
        ))}
      </div>

      {filtered.length===0 ? (
        <div style={{...S.card,textAlign:"center",padding:"32px 16px"}}><div style={{fontSize:28,marginBottom:8}}>🧾</div><div style={{color:"rgba(255,255,255,0.35)",fontFamily:"monospace",fontSize:12}}>No invoices yet</div></div>
      ) : (
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {filtered.map(inv => {
            const color = INV_STATUS_COLORS[inv.status]||"#888";
            const daysUntilDue = inv.dueDate ? -daysSince(inv.dueDate) : null;
            const smsReminder = `Hi ${inv.customerName?.split(" ")[0]}! Just a reminder that invoice ${inv.invoiceNum} for $${inv.total?.toFixed(0)} is due ${inv.dueDate ? "on " + fmtDate(inv.dueDate) : "now"}. Reply PAID if you've already sent payment. Thanks!`;
            return (
              <div key={inv.id} onClick={()=>onSelectInvoice(inv)} style={{...S.card,borderColor:inv.status==="Overdue"?"rgba(255,68,68,0.35)":inv.status==="Paid"?"rgba(0,255,153,0.2)":"rgba(255,255,255,0.08)",cursor:"pointer"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
                  <div style={{flex:1,marginRight:10}}>
                    <div style={{color:"#fff",fontSize:14,fontFamily:"monospace",fontWeight:700}}>{inv.customerName}</div>
                    <div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace",marginTop:2}}>#{inv.invoiceNum} · {fmtDate(inv.createdAt)}</div>
                    {inv.dueDate && inv.status !== "Paid" && (
                      <div style={{color:inv.status==="Overdue"?"#ff6b6b":"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace",marginTop:2}}>
                        {inv.status==="Overdue" ? `⚠ ${Math.abs(daysUntilDue)}d overdue` : daysUntilDue===0 ? "Due today" : `Due in ${daysUntilDue}d · ${fmtDate(inv.dueDate)}`}
                      </div>
                    )}
                    {inv.status==="Paid" && inv.paidDate && (
                      <div style={{color:"rgba(0,255,153,0.6)",fontSize:11,fontFamily:"monospace",marginTop:2}}>✓ Paid {fmtDate(inv.paidDate)} · {inv.paymentMethod}</div>
                    )}
                  </div>
                  <div style={{textAlign:"right"}}>
                    <div style={{color:inv.status==="Paid"?"#00ff99":"#7CFC00",fontSize:16,fontWeight:700}}>${inv.total?.toFixed(0)}</div>
                    <span style={{background:`${color}18`,border:`1px solid ${color}44`,borderRadius:6,padding:"2px 7px",color,fontSize:10,fontFamily:"monospace"}}>{inv.status}</span>
                  </div>
                </div>

                {/* Line items preview */}
                <div style={{display:"flex",flexWrap:"wrap",gap:4,marginBottom:10}}>
                  {(inv.lineItems||[]).slice(0,3).map((li,i)=><Tag key={i} label={li.label||li.name} color="#888"/>)}
                  {(inv.lineItems||[]).length>3&&<Tag label={`+${inv.lineItems.length-3} more`} color="#888"/>}
                </div>

                {/* Actions */}
                <div style={{display:"flex",gap:6,justifyContent:"flex-end",flexWrap:"wrap"}}>
                  {inv.status!=="Paid" && (
                    <button onClick={()=>setPayModal(inv)} style={{background:"rgba(0,255,153,0.1)",border:"1px solid rgba(0,255,153,0.3)",borderRadius:7,padding:"5px 10px",color:"#00ff99",fontSize:10,fontFamily:"monospace",cursor:"pointer",whiteSpace:"nowrap"}}>✓ MARK PAID</button>
                  )}
                  {(inv.status==="Sent"||inv.status==="Overdue") && (
                    <button onClick={()=>{try{navigator.clipboard?.writeText(smsReminder);}catch(e){}showToast("Reminder copied");}} style={{background:"rgba(255,170,0,0.08)",border:"1px solid rgba(255,170,0,0.25)",borderRadius:7,padding:"5px 10px",color:"#ffaa00",fontSize:10,fontFamily:"monospace",cursor:"pointer",whiteSpace:"nowrap"}}>💬 REMIND</button>
                  )}
                  {inv.status==="Draft"&&<button onClick={async()=>{ await onMarkPaid(inv.id,null,"Sent"); showToast("Invoice sent"); }} style={{background:"rgba(124,252,0,0.08)",border:"1px solid rgba(124,252,0,0.2)",borderRadius:7,padding:"5px 10px",color:"#7CFC00",fontSize:10,fontFamily:"monospace",cursor:"pointer",whiteSpace:"nowrap"}}>📤 MARK SENT</button>}
                  {inv.status!=="Paid"&&<button onClick={e=>{e.stopPropagation();setPayModal(inv);setPayMethod("Cash");}} style={{background:"rgba(0,255,153,0.08)",border:"1px solid rgba(0,255,153,0.2)",borderRadius:7,padding:"5px 10px",color:"#00ff99",fontSize:10,fontFamily:"monospace",cursor:"pointer",whiteSpace:"nowrap"}}>✓ PAID</button>}
                  <button onClick={()=>setConfirm(inv)} style={{background:"rgba(255,68,68,0.08)",border:"1px solid rgba(255,68,68,0.2)",borderRadius:7,padding:"5px 10px",color:"#ff6b6b",fontSize:10,fontFamily:"monospace",cursor:"pointer"}}>🗑</button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}


// ─── Quote → Invoice Review Modal ────────────────────────────────────────────
function QuoteToInvoiceModal({quote, onSave, onClose}){
  // Pre-fill line items from quote services
  const initLines = [
    ...(quote.services||[]).filter(s=>s&&s.label).map(s=>({
      id:s.id||genId(),
      label:s.label,
      qty:1,
      price:((s.basePrice||0)+(s.perSqft||0)*(quote.sqft||0)),
    })),
    ...(quote.materials||[]).filter(m=>m&&m.name).map(m=>({
      id:m.id||genId(),
      label:m.name,
      qty:1,
      price:m.price*(1+(m.margin||0)),
    }))];

  const [lines,   setLines]   = useState(initLines.length>0 ? initLines : [{id:genId(),label:"",qty:1,price:0}]);
  const [terms,   setTerms]   = useState("due_receipt");
  const [custDate,setCustDate]= useState(todayStr());
  const [notes,   setNotes]   = useState(quote.notes||"");
  const [saving,  setSaving]  = useState(false);

  const total   = lines.reduce((a,l)=>a+(parseFloat(l.price)||0)*(parseFloat(l.qty)||1),0);
  const dueDate = terms==="custom" ? custDate : calcDueDate(terms);

  const addLine    = ()=>setLines(l=>[...l,{id:genId(),label:"",qty:1,price:0}]);
  const removeLine = id=>setLines(l=>l.filter(li=>li.id!==id));
  const updateLine = (id,field,val)=>setLines(l=>l.map(li=>li.id===id?{...li,[field]:val}:li));

  const handle = async()=>{
    setSaving(true);
    await onSave({
      customerId:   quote.customerId,
      customerName: quote.customerName,
      customerPhone:quote.customerPhone,
      customerEmail:null,
      lineItems:    lines.filter(l=>l.label),
      subtotal:     total,
      discAmt:      0,
      taxAmt:       0,
      total,
      terms,
      dueDate,
      notes,
      status:"Draft",
    }, quote.id);
    setSaving(false);
    onClose();
  };

  const inp={background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"9px 11px",color:"#fff",fontSize:13,fontFamily:"monospace",outline:"none"};

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.88)",zIndex:500,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
      <div style={{background:"#0a180a",border:"1px solid rgba(124,252,0,0.2)",borderRadius:"16px 16px 0 0",width:"100%",maxWidth:430,maxHeight:"92vh",display:"flex",flexDirection:"column",animation:"fadeUp 0.25s ease"}}>

        {/* Header */}
        <div style={{padding:"18px 20px 0",flexShrink:0}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:14}}>
            <div>
              <div style={{color:"#fff",fontSize:15,fontFamily:"monospace",fontWeight:700}}>🧾 Create Invoice</div>
              <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace",marginTop:2}}>Review and edit before saving</div>
            </div>
            <button onClick={onClose} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",cursor:"pointer",fontSize:18}}>✕</button>
          </div>
          {/* Quote summary card */}
          <div style={{background:"rgba(124,252,0,0.06)",border:"1px solid rgba(124,252,0,0.2)",borderRadius:12,padding:"12px 14px",marginBottom:14}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
              <div>
                <div style={{color:"#fff",fontSize:14,fontFamily:"monospace",fontWeight:700}}>{quote.customerName}</div>
                <div style={{color:"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace",marginTop:2}}>Quote #{quote.quoteNum} · {fmtDate(quote.createdAt)}</div>
                {quote.address&&<div style={{color:"rgba(255,255,255,0.3)",fontSize:11,fontFamily:"monospace",marginTop:1}}>📍 {quote.address}</div>}
              </div>
              <div style={{textAlign:"right",flexShrink:0}}>
                <div style={{color:"#7CFC00",fontSize:20,fontWeight:700,fontFamily:"monospace"}}>${quote.total?.toFixed(0)}</div>
                <div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace"}}>{quote.sqft?.toLocaleString()} sqft</div>
              </div>
            </div>
          </div>
          <div style={{borderBottom:"1px solid rgba(255,255,255,0.07)",marginBottom:0}}/>
        </div>

        {/* Scrollable body */}
        <div style={{overflowY:"auto",padding:"16px 20px 8px",flex:1,display:"flex",flexDirection:"column",gap:14}}>

          {/* Line items */}
          <div>
            <div style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontFamily:"monospace",letterSpacing:"0.08em",marginBottom:8}}>LINE ITEMS — tap to edit</div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {lines.map((li,i)=>(
                <div key={li.id} style={{background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:10,padding:"10px 12px"}}>
                  <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:6}}>
                    <input
                      value={li.label}
                      onChange={e=>updateLine(li.id,"label",e.target.value)}
                      placeholder={"Service "+(i+1)}
                      style={{...inp,flex:1}}
                    />
                    {lines.length>1&&(
                      <button onClick={()=>removeLine(li.id)} style={{background:"none",border:"none",color:"rgba(255,68,68,0.5)",cursor:"pointer",fontSize:15,flexShrink:0}}>✕</button>
                    )}
                  </div>
                  <div style={{display:"flex",gap:8,alignItems:"center"}}>
                    <div style={{display:"flex",alignItems:"center",gap:4,...inp,width:64,flexShrink:0}}>
                      <span style={{color:"rgba(255,255,255,0.3)",fontSize:11}}>Qty</span>
                      <input
                        type="number" min="1"
                        value={li.qty}
                        onChange={e=>updateLine(li.id,"qty",e.target.value)}
                        style={{background:"none",border:"none",color:"#fff",fontSize:13,fontFamily:"monospace",outline:"none",width:"100%",textAlign:"right"}}
                      />
                    </div>
                    <div style={{display:"flex",alignItems:"center",gap:3,...inp,flex:1}}>
                      <span style={{color:"rgba(255,255,255,0.35)"}}>$</span>
                      <input
                        type="number" min="0" step="0.01"
                        value={parseFloat(li.price)||0}
                        onChange={e=>updateLine(li.id,"price",e.target.value)}
                        style={{background:"none",border:"none",color:"#7CFC00",fontSize:14,fontFamily:"monospace",fontWeight:700,outline:"none",textAlign:"right",flex:1}}
                      />
                    </div>
                    <div style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",flexShrink:0,width:52,textAlign:"right"}}>
                      =${((parseFloat(li.price)||0)*(parseFloat(li.qty)||1)).toFixed(0)}
                    </div>
                  </div>
                </div>
              ))}
              <button onClick={addLine} style={{background:"rgba(255,255,255,0.03)",border:"1px dashed rgba(255,255,255,0.12)",borderRadius:9,padding:"10px",color:"rgba(255,255,255,0.35)",fontSize:12,fontFamily:"monospace",cursor:"pointer"}}>
                + ADD LINE
              </button>
            </div>
          </div>

          {/* Total */}
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",background:"rgba(124,252,0,0.05)",border:"1px solid rgba(124,252,0,0.15)",borderRadius:10,padding:"12px 14px"}}>
            <span style={{color:"rgba(255,255,255,0.5)",fontFamily:"monospace",fontSize:13}}>TOTAL</span>
            <span style={{color:"#7CFC00",fontSize:22,fontWeight:700,fontFamily:"monospace"}}>${total.toFixed(2)}</span>
          </div>

          {/* Payment terms */}
          <div>
            <div style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontFamily:"monospace",letterSpacing:"0.08em",marginBottom:8}}>PAYMENT TERMS</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
              {TERMS_OPTIONS.map(t=>(
                <button key={t.id} onClick={()=>setTerms(t.id)} style={{padding:"10px 8px",background:terms===t.id?"rgba(124,252,0,0.1)":"rgba(255,255,255,0.03)",border:"1px solid "+(terms===t.id?"rgba(124,252,0,0.35)":"rgba(255,255,255,0.07)"),borderRadius:9,cursor:"pointer",textAlign:"center"}}>
                  <div style={{color:terms===t.id?"#7CFC00":"rgba(255,255,255,0.55)",fontSize:12,fontFamily:"monospace",fontWeight:terms===t.id?700:400}}>{t.label}</div>
                </button>
              ))}
            </div>
            {terms==="custom"&&(
              <input type="date" value={custDate} onChange={e=>setCustDate(e.target.value)} style={{...inp,width:"100%",marginTop:8}}/>
            )}
            {terms!=="custom"&&(
              <div style={{color:"rgba(255,255,255,0.3)",fontSize:11,fontFamily:"monospace",marginTop:6}}>Due date: {fmtDate(dueDate)}</div>
            )}
          </div>

          {/* Notes */}
          <Field label="Notes" value={notes} onChange={setNotes} placeholder="Payment instructions, thank you note…" rows={2}/>

        </div>

        {/* Footer actions */}
        <div style={{padding:"12px 20px 32px",borderTop:"1px solid rgba(255,255,255,0.07)",display:"flex",gap:8,flexShrink:0}}>
          <button onClick={()=>{handle();}} disabled={saving} style={{flex:2,background:saving?"rgba(124,252,0,0.2)":"#7CFC00",color:saving?"rgba(255,255,255,0.4)":"#000",border:"none",borderRadius:10,padding:"14px",fontSize:14,fontFamily:"monospace",fontWeight:700,cursor:saving?"default":"pointer"}}>
            {saving?"SAVING…":"SAVE AS DRAFT"}
          </button>
          <button onClick={onClose} style={{flex:1,background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:10,padding:"14px",color:"rgba(255,255,255,0.5)",fontSize:13,fontFamily:"monospace",cursor:"pointer"}}>
            CANCEL
          </button>
        </div>
      </div>
    </div>
  );
}

function NewInvoiceForm({ customers, profile, session, onSave, onBack }) {
  const [custId,      setCustId]      = useState("");
  const [custSearch,  setCustSearch]  = useState("");
  const [lineItems,   setLineItems]   = useState([{ id:genId(), label:"", qty:1, price:0 }]);
  const [terms,       setTerms]       = useState("due_receipt");
  const [customDate,  setCustomDate]  = useState(todayStr());
  const [taxRate,     setTaxRate]     = useState(0);
  const [discountAmt, setDiscountAmt] = useState(0);
  const [notes,       setNotes]       = useState("");
  const [saving,      setSaving]      = useState(false);
  const [invoiceNum]                  = useState(iNum());

  const selCust   = customers.find(c=>c.id===custId);
  const filtCusts = customers.filter(c=>
    c.name.toLowerCase().includes(custSearch.toLowerCase()) ||
    c.phone?.includes(custSearch) ||
    c.email?.toLowerCase().includes(custSearch.toLowerCase())
  );

  const dueDate  = terms==="custom" ? customDate : calcDueDate(terms);
  const subtotal = lineItems.reduce((a,li)=>a+(parseFloat(li.price)||0)*(parseFloat(li.qty)||1),0);
  const taxAmt   = (subtotal - discountAmt) * (taxRate / 100);
  const total    = subtotal - discountAmt + taxAmt;

  const addLine    = ()    => setLineItems(l=>[...l,{id:genId(),label:"",qty:1,price:0}]);
  const updateLine = (id,f,v) => setLineItems(l=>l.map(li=>li.id===id?{...li,[f]:v}:li));
  const removeLine = id   => setLineItems(l=>l.filter(li=>li.id!==id));

  // Build a complete invoice data object shared across all delivery methods
  const buildInvoiceData = (status) => ({
    customerId:    selCust.id,
    customerName:  selCust.name,
    customerPhone: selCust.phone,
    customerEmail: selCust.email||null,
    lineItems:     lineItems.filter(li=>li.label),
    subtotal, discAmt:discountAmt, taxAmt, total,
    taxRate, terms, dueDate, status, notes,
    invoiceNum,
    companyName:    profile?.company || "",
    companyEmail:   session?.user?.email || "",
    companyPhone:   profile?.phone   || "",
    companyAddress: profile?.address || "",
    companyWebsite: profile?.website || "",
    logoUrl:        profile?.logo_url || null,
  });

  // ── Print HTML ──
  const buildPrintHTML = () => {
    const co      = profile?.company  || "Your Company";
    const coPhone = profile?.phone    || "";
    const coAddr  = profile?.address  || "";
    const coEmail = session?.user?.email || "";
    const coWeb   = profile?.website  || "";
    const logo    = profile?.logo_url || null;

    const itemRows = lineItems.filter(li=>li.label).map(li=>{
      const qty   = parseFloat(li.qty)||1;
      const price = parseFloat(li.price)||0;
      const amt   = qty*price;
      return "<tr>"
        +"<td class='td-desc'>"+li.label+"</td>"
        +"<td class='td-amt'>$"+amt.toFixed(2)+"</td>"
        +"</tr>";
    }).join("");

    const summaryRows = [
      ...(subtotal!==total ? [["Subtotal","$"+subtotal.toFixed(2)]] : []),
      ...(discountAmt>0    ? [["Discount","-$"+discountAmt.toFixed(2)]] : []),
      ...(taxRate>0        ? [["Tax ("+taxRate+"%)","$"+taxAmt.toFixed(2)]] : [])].map(([l,v])=>"<tr><td style='padding:4px 0;font-size:13px;color:#555'>"+l+"</td><td style='padding:4px 0;text-align:right;font-size:13px'>"+v+"</td></tr>").join("");

    const logoHtml = logo
      ? "<img src='"+logo+"' style='max-width:160px;max-height:80px;object-fit:contain'/>"
      : "<span style='font-size:28px;font-weight:bold;color:#bbb;letter-spacing:-1px'>YOUR LOGO</span>";

    return "<!DOCTYPE html><html><head><meta charset='utf-8'><title>Invoice "+invoiceNum+"</title>"
      +"<style>"
      +"*{box-sizing:border-box;margin:0;padding:0}"
      +"body{font-family:Helvetica,Arial,sans-serif;color:#333;background:#fff;font-size:13px}"
      +"@media print{body{padding:0}.no-print{display:none}}"
      +".page{max-width:680px;margin:0 auto;padding:48px 40px}"
      +".top{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:32px}"
      +".logo{margin-bottom:4px}"
      +".co-info{font-size:12px;color:#555;line-height:1.7;margin-top:8px}"
      +".inv-label{font-size:28px;font-weight:300;letter-spacing:2px;color:#888;text-align:right}"
      +".meta-table{width:100%;border-collapse:collapse;margin-bottom:28px}"
      +".meta-table td{padding:5px 0;font-size:12px;border-bottom:1px solid #e0e0e0;vertical-align:top}"
      +".meta-table .lbl{font-weight:bold;font-size:10px;letter-spacing:.1em;text-transform:uppercase;color:#888;width:120px}"
      +".meta-table .val{color:#333}"
      +".cust-section{margin-bottom:28px}"
      +".cust-label{font-size:10px;font-weight:bold;letter-spacing:.1em;text-transform:uppercase;color:#888;border-bottom:1px solid #ddd;padding-bottom:4px;margin-bottom:8px}"
      +".cust-name{font-size:14px;font-weight:bold;margin-bottom:3px}"
      +".cust-detail{font-size:12px;color:#555;line-height:1.6}"
      +"table.items{width:100%;border-collapse:collapse;margin-bottom:4px}"
      +"table.items thead tr{border-top:1px solid #222;border-bottom:1px solid #222}"
      +"table.items th{font-size:10px;font-weight:bold;letter-spacing:.1em;text-transform:uppercase;padding:8px 0;color:#333}"
      +"table.items th.th-amt{text-align:right}"
      +".td-desc{padding:10px 0;border-bottom:1px solid #eee;font-size:13px}"
      +".td-amt{padding:10px 0;border-bottom:1px solid #eee;text-align:right;font-size:13px}"
      +".totals{width:220px;margin-left:auto;margin-top:4px}"
      +".totals td{padding:4px 0;font-size:13px}"
      +".total-final{font-size:15px;font-weight:bold;border-top:2px solid #222;padding-top:6px!important}"
      +".total-final td{padding-top:8px!important}"
      +".footer{margin-top:40px;text-align:center;border-top:1px solid #ddd;padding-top:20px}"
      +".thankyou{font-size:18px;font-weight:bold;letter-spacing:2px;margin:8px 0}"
      +".footer-note{font-size:11px;color:#888;line-height:1.8;font-style:italic}"
      +"</style></head><body><div class='page'>"

      // ── Top: logo left, INVOICE right ──
      +"<div class='top'>"
      +"<div><div class='logo'>"+logoHtml+"</div>"
      +"<div class='co-info'>"
      +co+"<br>"
      +(coAddr?coAddr+"<br>":"")
      +(coPhone?coPhone+"<br>":"")
      +(coEmail?coEmail+"<br>":"")
      +(coWeb?coWeb:"")
      +"</div></div>"
      +"<div class='inv-label'>INVOICE</div>"
      +"</div>"

      // ── Meta: date, invoice no, due date, amount ──
      +"<table class='meta-table'><tbody>"
      +"<tr><td class='lbl'>Date of Invoice</td><td class='val'>"+fmtDate(todayStr())+"</td>"
      +"<td class='lbl' style='padding-left:24px'>Invoice No.</td><td class='val' style='text-align:right'>#"+invoiceNum+"</td></tr>"
      +"<tr><td class='lbl'>Date Due</td><td class='val'>"+fmtDate(dueDate)+"</td>"
      +"<td class='lbl' style='padding-left:24px'>Amount Due</td><td class='val' style='text-align:right;font-weight:bold'>$"+total.toFixed(2)+"</td></tr>"
      +"</tbody></table>"

      // ── Bill To ──
      +"<div class='cust-section'>"
      +"<div class='cust-label'>Customer Name</div>"
      +"<div class='cust-name'>"+selCust.name+"</div>"
      +"<div class='cust-detail'>"
      +(selCust.address?selCust.address+"<br>":"")
      +(selCust.phone?selCust.phone+"<br>":"")
      +(selCust.email?selCust.email:"")
      +"</div></div>"

      // ── Line items ──
      +"<table class='items'><thead><tr>"
      +"<th style='text-align:left'>Description</th>"
      +"<th class='th-amt'>Amount</th>"
      +"</tr></thead><tbody>"
      +itemRows
      +"</tbody></table>"

      // ── Totals ──
      +"<table class='totals'><tbody>"
      +summaryRows
      +"<tr class='total-final'><td style='font-weight:bold'>TOTAL</td><td style='text-align:right;font-weight:bold'>$"+total.toFixed(2)+"</td></tr>"
      +"</tbody></table>"

      // ── Footer ──
      +"<div class='footer'>"
      +"<div class='footer-note'>Please make check payable to "+co+".</div>"
      +"<div class='thankyou'>THANK YOU</div>"
      +(notes?"<div class='footer-note'>"+notes+"</div>":"")
      +"<div class='footer-note' style='margin-top:8px'>"
      +(coPhone?coPhone+" &bull; ":"")
      +(coEmail?coEmail+" &bull; ":"")
      +(coWeb?coWeb:"")
      +"</div>"
      +"</div>"
      +"</div></body></html>";
  };

  // ── SMS text ──
  const buildSMS = () => {
    const co      = profile?.company ? profile.company+" - " : "";
    const items   = lineItems.filter(li=>li.label).map(li=>li.label).join(", ");
    const disc    = discountAmt>0 ? " Discount: -$"+discountAmt.toFixed(0)+"." : "";
    const tax     = taxRate>0     ? " Tax ("+taxRate+"%): $"+taxAmt.toFixed(0)+"." : "";
    return "Hi "+(selCust.isAnon?"there":selCust.name.split(" ")[0])+"! "+co+"Invoice #"+invoiceNum+" for $"+total.toFixed(0)
      +" is ready. Services: "+items+"."+disc+tax
      +" Due: "+fmtDate(dueDate)+". "
      +(notes ? "Note: "+notes+" " : "")
      +"Reply PAID when sent. Thanks!";
  };

  // ── Email body (URL-encoded) ──
  const buildEmail = () => {
    const co    = profile?.company || "Your Lawn Service";
    const nl    = "%0A";
    const items = lineItems.filter(li=>li.label).map(li=>{
      const qty = parseFloat(li.qty)||1;
      const p   = parseFloat(li.price)||0;
      return "  "+li.label+(qty>1?" (x"+qty+")":"")+" .............. $"+(qty*p).toFixed(2);
    }).join(nl);
    const subj = encodeURIComponent("Invoice #"+invoiceNum+" from "+co+" - $"+total.toFixed(2)+" due "+fmtDate(dueDate));
    let body = "Hi "+selCust.name.split(" ")[0]+","+nl+nl
      +"Please find your invoice below from "+co+"."+nl+nl
      +"Invoice #: "+invoiceNum+nl
      +"Date: "+fmtDate(todayStr())+nl
      +"Due Date: "+fmtDate(dueDate)+nl+nl
      +"SERVICES:"+nl+items+nl+nl
      +(discountAmt>0 ? "Discount: -$"+discountAmt.toFixed(2)+nl : "")
      +(taxRate>0     ? "Tax ("+taxRate+"%): $"+taxAmt.toFixed(2)+nl : "")
      +"-----------------------------"+nl
      +"TOTAL DUE: $"+total.toFixed(2)+nl+nl
      +(notes ? "Note: "+notes+nl+nl : "")
      +"Thank you for your business!"+nl
      +co+(profile?.email ? nl+profile.email : "");
    return "mailto:"+selCust.email+"?subject="+subj+"&body="+body;
  };

  const handleSave = async (status="Draft", delivery=null) => {
    if(!selCust) return;
    setSaving(true);
    await onSave(buildInvoiceData(status));
    setSaving(false);

    if(delivery==="sms" && selCust.phone){
      const txt = buildSMS();
      try { navigator.clipboard?.writeText(txt); } catch(e){}
      window.location.href = "sms:"+selCust.phone;
    }
    if(delivery==="email" && selCust.email){
      window.open(buildEmail());
    }
    if(delivery==="print"){
      const win = window.open("","_blank");
      if(win){ win.document.write(buildPrintHTML()); win.document.close(); setTimeout(()=>win.print(),400); }
    }
  };

  const inputSt = {background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"10px 12px",color:"#fff",fontSize:13,fontFamily:"monospace",outline:"none"};

  return (
    <div style={{display:"flex",flexDirection:"column",gap:16}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div><p style={S.label}>New Invoice</p><h2 style={S.heading}>Create Invoice</h2><p style={S.sub}>#{invoiceNum}</p></div>
        <button onClick={onBack} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12,cursor:"pointer"}}>✕ CANCEL</button>
      </div>

      {/* Company info banner */}
      {(!profile?.company) && (
        <div style={{background:"rgba(255,170,0,0.07)",border:"1px solid rgba(255,170,0,0.25)",borderRadius:10,padding:"10px 14px",color:"#ffaa00",fontSize:12,fontFamily:"monospace"}}>
          ⚠ Add your company name in Account → Profile so it appears on invoices
        </div>
      )}
      {profile?.company && (
        <div style={{...S.card,borderColor:"rgba(124,252,0,0.15)",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{color:"rgba(255,255,255,0.35)",fontSize:9,fontFamily:"monospace",letterSpacing:"0.1em",marginBottom:2}}>FROM</div>
            <div style={{color:"#fff",fontSize:14,fontFamily:"monospace",fontWeight:700}}>{profile.company}</div>
            {profile.email&&<div style={{color:"rgba(255,255,255,0.4)",fontSize:11,fontFamily:"monospace"}}>{profile.email}</div>}
          </div>
          <span style={{fontSize:22}}>🌿</span>
        </div>
      )}

      {/* Client picker */}
      <div>
        <div style={S.label}>Bill To *</div>
        {!selCust ? (
          <div>
            <div style={{background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:10,padding:"10px 13px",display:"flex",gap:8,alignItems:"center",marginBottom:8}}>
              <span style={{color:"rgba(255,255,255,0.3)"}}>🔍</span>
              <input value={custSearch} onChange={e=>setCustSearch(e.target.value)} placeholder="Search clients…" style={{background:"none",border:"none",outline:"none",color:"#fff",fontSize:13,flex:1,fontFamily:"monospace"}}/>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:6,maxHeight:180,overflowY:"auto"}}>
              {filtCusts.slice(0,6).map(c=>(
                <button key={c.id} onClick={()=>{setCustId(c.id);setCustSearch("");}} style={{display:"flex",alignItems:"center",gap:10,background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:10,padding:"10px 12px",cursor:"pointer",textAlign:"left"}}>
                  <div style={{width:30,height:30,borderRadius:"50%",background:"rgba(124,252,0,0.12)",display:"flex",alignItems:"center",justifyContent:"center",color:"#7CFC00",fontSize:13,fontWeight:700,flexShrink:0}}>{c.name.charAt(0)}</div>
                  <div><div style={{color:"#fff",fontSize:13,fontFamily:"monospace"}}>{c.name}</div><div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace"}}>{[c.phone,c.email].filter(Boolean).join(" · ")}</div></div>
                </button>
              ))}
            </div>
          </div>
        ) : (
          <div style={{...S.card,borderColor:"rgba(124,252,0,0.2)"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
              <div>
                <div style={{color:"#fff",fontSize:14,fontFamily:"monospace",fontWeight:700}}>{selCust.name}</div>
                {selCust.phone&&<div style={{color:"rgba(255,255,255,0.4)",fontSize:12,fontFamily:"monospace",marginTop:2}}>{selCust.phone}</div>}
                {selCust.email&&<div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace",marginTop:1}}>{selCust.email}</div>}
                {selCust.address&&<div style={{color:"rgba(255,255,255,0.3)",fontSize:11,fontFamily:"monospace",marginTop:1}}>📍 {selCust.address}</div>}
              </div>
              <button onClick={()=>setCustId("")} style={{background:"none",border:"none",color:"rgba(255,255,255,0.3)",cursor:"pointer",fontSize:14}}>✕</button>
            </div>
          </div>
        )}
      </div>

      {/* Line items */}
      <div>
        <div style={S.label}>Line Items</div>
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {/* Header */}
          <div style={{display:"flex",gap:8,paddingBottom:4,borderBottom:"1px solid rgba(255,255,255,0.07)"}}>
            <div style={{flex:1,color:"rgba(255,255,255,0.3)",fontSize:9,fontFamily:"monospace",letterSpacing:"0.08em"}}>DESCRIPTION</div>
            <div style={{width:50,color:"rgba(255,255,255,0.3)",fontSize:9,fontFamily:"monospace",letterSpacing:"0.08em",textAlign:"center"}}>QTY</div>
            <div style={{width:80,color:"rgba(255,255,255,0.3)",fontSize:9,fontFamily:"monospace",letterSpacing:"0.08em",textAlign:"right"}}>PRICE</div>
            <div style={{width:24}}/>
          </div>
          {lineItems.map((li,i)=>(
            <div key={li.id} style={{display:"flex",gap:8,alignItems:"center"}}>
              <input value={li.label} onChange={e=>updateLine(li.id,"label",e.target.value)} placeholder={"Service "+(i+1)} style={{...inputSt,flex:1}}/>
              <input type="number" min="1" value={li.qty} onChange={e=>updateLine(li.id,"qty",e.target.value)} style={{...inputSt,width:50,textAlign:"center"}}/>
              <div style={{display:"flex",alignItems:"center",...inputSt,width:90,gap:2}}>
                <span style={{color:"rgba(255,255,255,0.3)"}}>$</span>
                <input type="number" min="0" value={li.price} onChange={e=>updateLine(li.id,"price",e.target.value)} style={{background:"none",border:"none",color:"#7CFC00",fontSize:13,fontFamily:"monospace",outline:"none",textAlign:"right",flex:1}}/>
              </div>
              {lineItems.length>1&&<button onClick={()=>removeLine(li.id)} style={{background:"none",border:"none",color:"rgba(255,68,68,0.5)",cursor:"pointer",fontSize:15,padding:"0 2px",flexShrink:0}}>✕</button>}
            </div>
          ))}
          <button onClick={addLine} style={{background:"rgba(255,255,255,0.04)",border:"1px dashed rgba(255,255,255,0.12)",borderRadius:8,padding:"10px",color:"rgba(255,255,255,0.35)",fontSize:12,fontFamily:"monospace",cursor:"pointer"}}>+ ADD LINE ITEM</button>
        </div>
      </div>

      {/* Tax & Discount */}
      <div style={{...S.card}}>
        <div style={{...S.label,marginBottom:12}}>Tax & Discount</div>
        <div style={{display:"flex",gap:10}}>
          <div style={{flex:1}}>
            <div style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontFamily:"monospace",marginBottom:5}}>TAX RATE (%)</div>
            <input type="number" min="0" max="25" step="0.1" value={taxRate} onChange={e=>setTaxRate(parseFloat(e.target.value)||0)} style={{...inputSt,width:"100%"}}/>
          </div>
          <div style={{flex:1}}>
            <div style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontFamily:"monospace",marginBottom:5}}>DISCOUNT ($)</div>
            <input type="number" min="0" value={discountAmt} onChange={e=>setDiscountAmt(parseFloat(e.target.value)||0)} style={{...inputSt,width:"100%"}}/>
          </div>
        </div>
      </div>

      {/* Payment Terms */}
      <div>
        <div style={S.label}>Payment Terms</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
          {TERMS_OPTIONS.map(t=>(
            <button key={t.id} onClick={()=>setTerms(t.id)} style={{padding:"10px",background:terms===t.id?"rgba(124,252,0,0.1)":"rgba(255,255,255,0.03)",border:`1px solid ${terms===t.id?"rgba(124,252,0,0.35)":"rgba(255,255,255,0.07)"}`,borderRadius:10,cursor:"pointer",textAlign:"center",transition:"all 0.15s"}}>
              <div style={{color:terms===t.id?"#7CFC00":"rgba(255,255,255,0.6)",fontSize:12,fontFamily:"monospace",fontWeight:terms===t.id?700:400}}>{t.label}</div>
              {t.days!==null&&<div style={{color:"rgba(255,255,255,0.25)",fontSize:10,fontFamily:"monospace",marginTop:2}}>Due {t.days===0?"today":"in "+t.days+"d"}</div>}
            </button>
          ))}
        </div>
        {terms==="custom"&&(
          <input type="date" value={customDate} onChange={e=>setCustomDate(e.target.value)} style={{marginTop:8,...inputSt,width:"100%"}}/>
        )}
      </div>

      {/* Totals breakdown */}
      <div style={{background:"rgba(124,252,0,0.05)",border:"1px solid rgba(124,252,0,0.18)",borderRadius:12,padding:"14px 16px",display:"flex",flexDirection:"column",gap:6}}>
        <div style={{display:"flex",justifyContent:"space-between"}}><span style={{color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12}}>Subtotal</span><span style={{color:"rgba(255,255,255,0.6)",fontFamily:"monospace",fontSize:12}}>${subtotal.toFixed(2)}</span></div>
        {discountAmt>0&&<div style={{display:"flex",justifyContent:"space-between"}}><span style={{color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12}}>Discount</span><span style={{color:"var(--lq-blue)",fontFamily:"monospace",fontSize:12}}>-${discountAmt.toFixed(2)}</span></div>}
        {taxRate>0&&<div style={{display:"flex",justifyContent:"space-between"}}><span style={{color:"rgba(255,255,255,0.4)",fontFamily:"monospace",fontSize:12}}>Tax ({taxRate}%)</span><span style={{color:"rgba(255,255,255,0.5)",fontFamily:"monospace",fontSize:12}}>${taxAmt.toFixed(2)}</span></div>}
        <div style={{height:1,background:"rgba(124,252,0,0.2)",margin:"2px 0"}}/>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}><span style={{color:"rgba(255,255,255,0.6)",fontFamily:"monospace",fontSize:13,fontWeight:700}}>TOTAL DUE</span><span style={{color:"#7CFC00",fontSize:22,fontWeight:700}}>${total.toFixed(2)}</span></div>
        <div style={{display:"flex",justifyContent:"space-between"}}><span style={{color:"rgba(255,255,255,0.3)",fontFamily:"monospace",fontSize:11}}>Due Date</span><span style={{color:"rgba(255,255,255,0.5)",fontFamily:"monospace",fontSize:11}}>{fmtDate(dueDate)}</span></div>
      </div>

      <Field label="Notes / Payment Instructions" value={notes} onChange={setNotes} placeholder="Venmo @username, make checks payable to…" rows={2}/>

      {/* Delivery buttons */}
      <div style={{display:"flex",flexDirection:"column",gap:8}}>
        <button onClick={()=>handleSave("Sent","sms")} disabled={!selCust||saving} style={{...btn(!!selCust&&!saving),background:!!selCust&&!saving?"#7CFC00":"rgba(124,252,0,0.15)",color:!!selCust&&!saving?"#000":"rgba(255,255,255,0.3)",border:"none",padding:"14px",fontSize:14}}>
          {saving?"SAVING…":"📱 SAVE & SEND SMS"}
        </button>
        <button onClick={()=>handleSave("Sent","email")} disabled={!selCust||saving} style={{background:"rgba(0,207,255,0.1)",color:selCust?"var(--lq-blue)":"rgba(255,255,255,0.25)",border:"1px solid "+(selCust?"rgba(0,207,255,0.3)":"rgba(255,255,255,0.08)"),borderRadius:10,padding:"13px",fontSize:13,cursor:selCust?"pointer":"default",fontFamily:"monospace",fontWeight:700,width:"100%"}}>
          {saving?"SAVING…":"✉️ SAVE & SEND EMAIL"}
        </button>
        <div style={{display:"flex",gap:8}}>
          <button onClick={()=>handleSave("Draft","print")} disabled={!selCust||saving} style={{flex:1,background:"rgba(255,255,255,0.06)",color:selCust?"rgba(255,255,255,0.7)":"rgba(255,255,255,0.25)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:10,padding:"12px",fontSize:12,cursor:selCust?"pointer":"default",fontFamily:"monospace",fontWeight:700}}>
            {saving?"SAVING…":"🖨️ PRINT / PDF"}
          </button>
          <button onClick={()=>handleSave("Draft")} disabled={!selCust||saving} style={{flex:1,background:"rgba(255,255,255,0.04)",color:"rgba(255,255,255,0.45)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:10,padding:"12px",fontSize:12,cursor:selCust?"pointer":"default",fontFamily:"monospace"}}>
            {saving?"SAVING…":"💾 DRAFT"}
          </button>
        </div>
      </div>
    </div>
  );
}


// ─── Estimate Templates ───────────────────────────────────────────────────────
function useTemplates(){
  const [templates,setTemplates] = useState(()=>{
    try{ return JSON.parse(localStorage.getItem("lq_templates")||"[]"); }catch{ return []; }
  });
  const save = (t) => {
    const updated = [...templates, t];
    setTemplates(updated);
    localStorage.setItem("lq_templates", JSON.stringify(updated));
  };
  const remove = (id) => {
    const updated = templates.filter(t=>t.id!==id);
    setTemplates(updated);
    localStorage.setItem("lq_templates", JSON.stringify(updated));
  };
  return {templates, save, remove};
}

// eslint-disable-next-line no-unused-vars
function TemplatePickerModal({templates, onSelect, onClose}){
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",zIndex:500,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
      <div style={{background:"#0a180a",border:"1px solid rgba(124,252,0,0.2)",borderRadius:"16px 16px 0 0",width:"100%",maxWidth:430,maxHeight:"70vh",display:"flex",flexDirection:"column",animation:"fadeUp 0.25s ease"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"18px 20px 12px",borderBottom:"1px solid rgba(255,255,255,0.07)",flexShrink:0}}>
          <div style={{color:"#fff",fontSize:15,fontFamily:"monospace",fontWeight:700}}>📋 Load Template</div>
          <button onClick={onClose} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",cursor:"pointer",fontSize:18}}>✕</button>
        </div>
        <div style={{overflowY:"auto",padding:"12px 16px 32px",flex:1}}>
          {templates.length===0?(
            <div style={{textAlign:"center",padding:"32px 0"}}>
              <div style={{fontSize:28,marginBottom:8}}>📋</div>
              <div style={{color:"rgba(255,255,255,0.35)",fontFamily:"monospace",fontSize:12}}>No templates yet</div>
              <div style={{color:"rgba(255,255,255,0.2)",fontFamily:"monospace",fontSize:11,marginTop:4}}>Save a quote as a template to reuse it</div>
            </div>
          ):(
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {templates.map(t=>(
                <button key={t.id} onClick={()=>onSelect(t)} style={{display:"flex",alignItems:"center",gap:12,background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:12,padding:"13px 14px",cursor:"pointer",textAlign:"left",width:"100%"}}>
                  <span style={{fontSize:20}}>📋</span>
                  <div style={{flex:1}}>
                    <div style={{color:"#fff",fontSize:13,fontFamily:"monospace",fontWeight:700}}>{t.name}</div>
                    <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace",marginTop:2}}>
                      {(t.services||[]).slice(0,3).map(s=>s.label).join(", ")}
                    </div>
                    <div style={{color:"#7CFC00",fontSize:12,fontFamily:"monospace",marginTop:2}}>${t.total?.toFixed(0)} est.</div>
                  </div>
                  <span style={{color:"rgba(255,255,255,0.3)",fontSize:14}}>→</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}


// ─── Seasonal Campaigns ───────────────────────────────────────────────────────
const CAMPAIGN_TEMPLATES = [
  { id:"spring_cleanup", season:"spring", service:"Spring Cleanup",   emoji:"🌱",
    text:(name,co)=>"Hi "+name+"! "+co+"Spring cleanup season is here. We'd love to get your property looking great — beds edged, debris cleared, and lawn ready to grow. Reply YES to schedule or call us for a quick quote!" },
  { id:"aeration_fall",  season:"fall",   service:"Fall Aeration",    emoji:"🍂",
    text:(name,co)=>"Hi "+name+"! "+co+"Fall is the best time to aerate your lawn and get it ready for spring. We have openings this month — want us to add you to the schedule?" },
  { id:"leaf_removal",   season:"fall",   service:"Leaf Removal",     emoji:"🍁",
    text:(name,co)=>"Hi "+name+"! "+co+"Leaf season is here. Don't let leaves smother your lawn over winter — we're scheduling leaf removal now. Want to get on the list?" },
  { id:"fert_spring",    season:"spring", service:"Spring Fertilization", emoji:"💚",
    text:(name,co)=>"Hi "+name+"! "+co+"Spring fertilization is key to a thick, green lawn all season. We're scheduling applications now — reply YES to book yours!" },
  { id:"mulch",          season:"spring", service:"Mulch Install",    emoji:"🪵",
    text:(name,co)=>"Hi "+name+"! "+co+"Fresh mulch makes a huge difference — keeps weeds down, retains moisture, and looks sharp. We're installing this week. Want a quick quote?" },
  { id:"winter_prep",    season:"winter", service:"Winter Prep",      emoji:"❄️",
    text:(name,co)=>"Hi "+name+"! "+co+"Before the cold hits — want us to do a final cleanup, final mow, and get your property buttoned up for winter? Slots filling fast!" }];

function CampaignScreen({quotes,customers,profile,onClose}){
  const [selCampaign, setSelCampaign] = useState(null);
  const [sentIds,     setSentIds]     = useState(new Set());
  const [copied,      setCopied]      = useState(null);
  const co = profile?.company ? profile.company+" — " : "";

  const getCampaignClients = (campaign) => {
    // Find clients who had this service last year but not this year
    const thisYear  = new Date().getFullYear().toString();
    const lastYear  = (new Date().getFullYear()-1).toString();
    const hadLastYear = new Set(
      quotes.filter(q=>(q.stage==="Accepted"||q.stage==="Completed")&&(q.createdAt||"").startsWith(lastYear)&&
        (q.services||[]).some(s=>s.label?.toLowerCase().includes(campaign.service.toLowerCase().split(" ")[0])))
      .map(q=>q.customerName)
    );
    const hadThisYear = new Set(
      quotes.filter(q=>(q.createdAt||"").startsWith(thisYear)&&
        (q.services||[]).some(s=>s.label?.toLowerCase().includes(campaign.service.toLowerCase().split(" ")[0])))
      .map(q=>q.customerName)
    );
    // Also include active clients who haven't had this service at all
    const allActive = new Set(quotes.filter(q=>q.stage==="Accepted"||q.stage==="Completed").map(q=>q.customerName));
    const targets = new Set([...hadLastYear, ...allActive]);
    hadThisYear.forEach(n=>targets.delete(n));
    return customers.filter(c=>targets.has(c.name)&&c.phone);
  };

  const copyText = (client, campaign) => {
    const txt = campaign.text(client.name.split(" ")[0], co);
    try{ navigator.clipboard?.writeText(txt); }catch(e){}
    setCopied(client.id);
    setTimeout(()=>setCopied(null),2000);
  };

  if(selCampaign){
    const clients = getCampaignClients(selCampaign);
    return(
      <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.9)",zIndex:500,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
        <div style={{background:"#0a180a",border:"1px solid rgba(124,252,0,0.2)",borderRadius:"16px 16px 0 0",width:"100%",maxWidth:430,maxHeight:"85vh",display:"flex",flexDirection:"column",animation:"fadeUp 0.25s ease"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"16px 18px 12px",borderBottom:"1px solid rgba(255,255,255,0.07)",flexShrink:0}}>
            <div>
              <div style={{color:"#fff",fontSize:14,fontFamily:"monospace",fontWeight:700}}>{selCampaign.emoji} {selCampaign.service}</div>
              <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace",marginTop:2}}>{clients.length} client{clients.length!==1?"s":""} to reach</div>
            </div>
            <button onClick={()=>setSelCampaign(null)} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",cursor:"pointer",fontSize:18}}>✕</button>
          </div>

          {/* Message preview */}
          <div style={{margin:"12px 16px",background:"rgba(124,252,0,0.05)",border:"1px solid rgba(124,252,0,0.15)",borderRadius:10,padding:"11px 13px"}}>
            <div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace",marginBottom:4}}>MESSAGE PREVIEW</div>
            <div style={{color:"rgba(255,255,255,0.65)",fontSize:12,fontFamily:"monospace",lineHeight:1.6}}>{selCampaign.text("Client",co)}</div>
          </div>

          <div style={{overflowY:"auto",padding:"0 16px 32px",flex:1}}>
            {clients.length===0?(
              <div style={{textAlign:"center",padding:"24px 0"}}>
                <div style={{fontSize:28,marginBottom:8}}>✅</div>
                <div style={{color:"rgba(255,255,255,0.35)",fontFamily:"monospace",fontSize:12}}>All clients have already booked this service this year</div>
              </div>
            ):(
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
                {clients.map(client=>{
                  const sent = sentIds.has(client.id);
                  return(
                    <div key={client.id} style={{background:sent?"rgba(0,255,153,0.05)":"rgba(255,255,255,0.03)",border:"1px solid "+(sent?"rgba(0,255,153,0.2)":"rgba(255,255,255,0.07)"),borderRadius:10,padding:"11px 13px",display:"flex",alignItems:"center",gap:10}}>
                      <div style={{width:32,height:32,borderRadius:"50%",background:"rgba(124,252,0,0.12)",display:"flex",alignItems:"center",justifyContent:"center",color:"#7CFC00",fontSize:14,fontWeight:700,flexShrink:0}}>{client.name.charAt(0)}</div>
                      <div style={{flex:1}}>
                        <div style={{color:"#fff",fontSize:13,fontFamily:"monospace",fontWeight:700}}>{client.name}</div>
                        <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace"}}>{client.phone}</div>
                      </div>
                      <div style={{display:"flex",gap:6}}>
                        <button onClick={()=>copyText(client,selCampaign)} style={{background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"6px 10px",color:copied===client.id?"#7CFC00":"rgba(255,255,255,0.5)",fontSize:10,fontFamily:"monospace",cursor:"pointer",whiteSpace:"nowrap"}}>
                          {copied===client.id?"✓ COPIED":"📋 COPY"}
                        </button>
                        <a href={"sms:"+client.phone} onClick={()=>setSentIds(s=>new Set([...s,client.id]))} style={{background:sent?"rgba(0,255,153,0.1)":"rgba(124,252,0,0.1)",border:"1px solid "+(sent?"rgba(0,255,153,0.3)":"rgba(124,252,0,0.25)"),borderRadius:8,padding:"6px 10px",color:sent?"#00ff99":"#7CFC00",fontSize:10,fontFamily:"monospace",cursor:"pointer",textDecoration:"none",whiteSpace:"nowrap"}}>
                          {sent?"✓ SENT":"💬 TEXT"}
                        </a>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",zIndex:500,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
      <div style={{background:"#0a180a",border:"1px solid rgba(124,252,0,0.2)",borderRadius:"16px 16px 0 0",width:"100%",maxWidth:430,maxHeight:"80vh",display:"flex",flexDirection:"column",animation:"fadeUp 0.25s ease"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"18px 20px 12px",borderBottom:"1px solid rgba(255,255,255,0.07)",flexShrink:0}}>
          <div>
            <div style={{color:"#fff",fontSize:15,fontFamily:"monospace",fontWeight:700}}>📣 Campaigns</div>
            <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace",marginTop:2}}>Reach clients who need your services</div>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",cursor:"pointer",fontSize:18}}>✕</button>
        </div>
        <div style={{overflowY:"auto",padding:"12px 16px 32px",flex:1}}>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {CAMPAIGN_TEMPLATES.map(c=>{
              const count = getCampaignClients(c).length;
              return(
                <button key={c.id} onClick={()=>setSelCampaign(c)} style={{display:"flex",alignItems:"center",gap:12,background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:12,padding:"14px",cursor:"pointer",textAlign:"left",width:"100%",transition:"all 0.15s"}}>
                  <span style={{fontSize:24}}>{c.emoji}</span>
                  <div style={{flex:1}}>
                    <div style={{color:"#fff",fontSize:13,fontFamily:"monospace",fontWeight:700}}>{c.service}</div>
                    <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace",marginTop:2,textTransform:"capitalize"}}>{c.season} campaign</div>
                  </div>
                  <div style={{textAlign:"right",flexShrink:0}}>
                    <div style={{color:count>0?"#7CFC00":"rgba(255,255,255,0.25)",fontSize:14,fontWeight:700,fontFamily:"monospace"}}>{count}</div>
                    <div style={{color:"rgba(255,255,255,0.25)",fontSize:9,fontFamily:"monospace"}}>TO REACH</div>
                  </div>
                  <span style={{color:"rgba(255,255,255,0.2)",fontSize:14}}>→</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}


// ─── Chemical Application Log ─────────────────────────────────────────────────
const WEATHER_CONDITIONS = ["Sunny","Cloudy","Overcast","Partly Cloudy"];
const WIND_CONDITIONS    = ["Calm (<5mph)","Light (5-10mph)","Moderate (10-15mph)"];

function ChemLogModal({quote,job,customers=[],onSave,onClose}){
  const [product,   setProduct]   = useState("");
  const [epaReg,    setEpaReg]    = useState("");
  const [target,    setTarget]    = useState("");
  const [rate,      setRate]      = useState("");
  const [rateUnit,  setRateUnit]  = useState("oz/1000sqft");
  const [area,      setArea]      = useState(quote?.sqft?.toString()||"");
  const [weather,   setWeather]   = useState("Sunny");
  const [wind,      setWind]      = useState("Calm (<5mph)");
  const [temp,      setTemp]      = useState("");
  const [rei,       setRei]       = useState("");
  const [reiUnit,   setReiUnit]   = useState("hours");
  const [notes,     setNotes]     = useState("");
  const [saving,    setSaving]    = useState(false);
  const [selCustomerId, setSelCustomerId] = useState(quote?.customerId||job?.customerId||"");
  const valid = product.trim()&&rate.trim();

  const selectedCustomer = customers.find(c=>c.id===selCustomerId);
  const customerName = selectedCustomer?.name || quote?.customerName || job?.customerName || "";
  const address = selectedCustomer?.address || quote?.address || job?.address || "";

  // REI expiry calculation
  const reiExpiry = rei ? (()=>{
    const now = new Date();
    const mins = reiUnit==="hours" ? parseFloat(rei)*60 : reiUnit==="days" ? parseFloat(rei)*60*24 : parseFloat(rei);
    now.setMinutes(now.getMinutes() + mins);
    return now.toLocaleString('en-US',{month:'short',day:'numeric',hour:'numeric',minute:'2-digit'});
  })() : null;

  const handle = async() => {
    setSaving(true);
    const log = {
      id:genId(), date:todayStr(),
      product, epaReg, target, rate, rateUnit,
      area, weather, wind, temp, rei, reiUnit,
      reiExpiry: reiExpiry||"",
      notes,
      address,
      customerName,
      customerId: selCustomerId||"",
    };
    await onSave(log);
    setSaving(false);
    onClose();
  };

  const buildPDF = () => {
    const html = `<!DOCTYPE html><html><head><title>Chemical Application Log</title>
    <style>
      *{box-sizing:border-box;margin:0;padding:0;}
      body{font-family:Arial,sans-serif;color:#222;padding:32px;max-width:700px;}
      h1{color:#1a5c2a;font-size:22px;margin-bottom:4px;}
      .subtitle{color:#666;font-size:13px;margin-bottom:24px;}
      .accent{background:#1a5c2a;height:4px;width:100%;margin-bottom:20px;}
      .grid{display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:20px;}
      .field{background:#f9f9f9;border-radius:6px;padding:12px;}
      .field-label{font-size:10px;font-weight:700;color:#1a5c2a;text-transform:uppercase;letter-spacing:0.08em;margin-bottom:4px;}
      .field-val{font-size:14px;color:#222;}
      .rei-box{background:#fff3cd;border:1px solid #ffc107;border-radius:8px;padding:14px;margin-bottom:20px;}
      .rei-title{font-weight:700;color:#856404;font-size:13px;margin-bottom:4px;}
      .rei-val{font-size:16px;font-weight:700;color:#1a5c2a;}
      .footer{margin-top:32px;padding-top:16px;border-top:1px solid #eee;font-size:11px;color:#999;display:flex;justify-content:space-between;}
      @media print{body{padding:16px;}}
    </style></head><body>
    <div class="accent"></div>
    <h1>🧪 Chemical Application Log</h1>
    <div class="subtitle">Date: ${todayStr()} &nbsp;|&nbsp; Operator: ${customerName||'—'}</div>
    <div class="grid">
      <div class="field"><div class="field-label">Product Name</div><div class="field-val">${product||'—'}</div></div>
      <div class="field"><div class="field-label">EPA Reg. Number</div><div class="field-val">${epaReg||'—'}</div></div>
      <div class="field"><div class="field-label">Target Pest / Weed</div><div class="field-val">${target||'—'}</div></div>
      <div class="field"><div class="field-label">Rate Applied</div><div class="field-val">${rate||'—'} ${rateUnit}</div></div>
      <div class="field"><div class="field-label">Area Treated</div><div class="field-val">${area||'—'} sqft</div></div>
      <div class="field"><div class="field-label">Property Address</div><div class="field-val">${address||'—'}</div></div>
      <div class="field"><div class="field-label">Weather</div><div class="field-val">${weather}</div></div>
      <div class="field"><div class="field-label">Wind Speed</div><div class="field-val">${wind}</div></div>
      <div class="field"><div class="field-label">Temperature</div><div class="field-val">${temp||'—'}°F</div></div>
      <div class="field"><div class="field-label">Client</div><div class="field-val">${customerName||'—'}</div></div>
    </div>
    ${rei?`<div class="rei-box"><div class="rei-title">⚠️ Re-Entry Interval (REI)</div><div class="rei-val">Safe to re-enter after: ${reiExpiry}</div><div style="font-size:12px;color:#666;margin-top:4px;">REI: ${rei} ${reiUnit} from time of application</div></div>`:''}
    ${notes?`<div class="field" style="margin-bottom:20px;"><div class="field-label">Notes</div><div class="field-val">${notes}</div></div>`:''}
    <div class="footer"><span>LAWN.Quote Chemical Application Log</span><span>Generated: ${new Date().toLocaleString()}</span></div>
    <script>window.print();</script>
    </body></html>`;
    const win = window.open('','_blank');
    if(win){ win.document.write(html); win.document.close(); }
  };

  const inp={background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"10px 12px",color:"#fff",fontSize:13,fontFamily:"monospace",outline:"none",width:"100%"};

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.9)",zIndex:500,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
      <div style={{background:"#0a180a",border:"1px solid rgba(0,207,255,0.2)",borderRadius:"16px 16px 0 0",width:"100%",maxWidth:430,maxHeight:"90vh",display:"flex",flexDirection:"column",animation:"fadeUp 0.25s ease"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"16px 18px 12px",borderBottom:"1px solid rgba(255,255,255,0.07)",flexShrink:0}}>
          <div>
            <div style={{color:"#fff",fontSize:14,fontFamily:"monospace",fontWeight:700}}>🧪 Application Log</div>
            <div style={{color:"rgba(255,255,255,0.35)",fontSize:11,fontFamily:"monospace",marginTop:2}}>{customerName||"Select a client"} · {todayStr()}</div>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",color:"rgba(255,255,255,0.4)",cursor:"pointer",fontSize:18}}>✕</button>
        </div>
        <div style={{overflowY:"auto",padding:"14px 16px 32px",flex:1,display:"flex",flexDirection:"column",gap:12}}>

          {/* Client dropdown */}
          <div>
            <div style={S.label}>Client</div>
            <select value={selCustomerId} onChange={e=>setSelCustomerId(e.target.value)} style={{...inp,color:selCustomerId?"#fff":"rgba(255,255,255,0.4)"}}>
              <option value="">— Select a client —</option>
              {customers.sort((a,b)=>a.name.localeCompare(b.name)).map(c=>(
                <option key={c.id} value={c.id}>{c.name}{c.address?" · "+c.address.split(',')[0]:""}</option>
              ))}
            </select>
          </div>

          <Field label="Product Name *" value={product} onChange={setProduct} placeholder="Roundup Pro Concentrate"/>
          <Field label="EPA Reg. Number" value={epaReg} onChange={setEpaReg} placeholder="228-xxx"/>
          <Field label="Target Pest / Weed" value={target} onChange={setTarget} placeholder="Broadleaf weeds, crabgrass…"/>
          <div style={{display:"flex",gap:8}}>
            <div style={{flex:1}}><Field label="Rate *" value={rate} onChange={setRate} placeholder="2.5"/></div>
            <div style={{flex:1}}>
              <div style={S.label}>Unit</div>
              <select value={rateUnit} onChange={e=>setRateUnit(e.target.value)} style={{...inp}}>
                {["oz/1000sqft","oz/acre","lbs/1000sqft","lbs/acre","gal/acre","fl oz/gal"].map(u=><option key={u} value={u}>{u}</option>)}
              </select>
            </div>
          </div>
          <Field label="Area Treated (sqft)" value={area} onChange={setArea} placeholder="2400"/>

          {/* REI */}
          <div>
            <div style={S.label}>Re-Entry Interval (REI) <span style={{color:"rgba(255,255,255,0.25)",fontSize:9}}>(optional)</span></div>
            <div style={{display:"flex",gap:8}}>
              <input type="text" inputMode="decimal" value={rei} onChange={e=>setRei(e.target.value)} placeholder="24" style={{...inp,flex:1}}/>
              <select value={reiUnit} onChange={e=>setReiUnit(e.target.value)} style={{...inp,flex:1}}>
                {["hours","days","minutes"].map(u=><option key={u} value={u}>{u}</option>)}
              </select>
            </div>
            {reiExpiry&&(
              <div style={{marginTop:6,background:"rgba(255,170,0,0.08)",border:"1px solid rgba(255,170,0,0.25)",borderRadius:8,padding:"8px 12px"}}>
                <div style={{color:"#ffaa00",fontSize:10,fontFamily:"monospace",fontWeight:700,marginBottom:2}}>⚠️ SAFE TO RE-ENTER AFTER</div>
                <div style={{color:"#fff",fontSize:13,fontFamily:"monospace",fontWeight:700}}>{reiExpiry}</div>
              </div>
            )}
          </div>

          <div>
            <div style={S.label}>Weather Conditions</div>
            <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
              {WEATHER_CONDITIONS.map(w=><button key={w} onClick={()=>setWeather(w)} style={{padding:"6px 11px",background:weather===w?"rgba(0,207,255,0.12)":"rgba(255,255,255,0.04)",border:"1px solid "+(weather===w?"rgba(0,207,255,0.35)":"rgba(255,255,255,0.08)"),borderRadius:8,color:weather===w?"var(--lq-blue)":"rgba(255,255,255,0.5)",fontSize:11,fontFamily:"monospace",cursor:"pointer"}}>{w}</button>)}
            </div>
          </div>
          <div>
            <div style={S.label}>Wind Speed</div>
            <div style={{display:"flex",flexDirection:"column",gap:5}}>
              {WIND_CONDITIONS.map(w=><button key={w} onClick={()=>setWind(w)} style={{padding:"8px 11px",background:wind===w?"rgba(0,207,255,0.12)":"rgba(255,255,255,0.04)",border:"1px solid "+(wind===w?"rgba(0,207,255,0.35)":"rgba(255,255,255,0.08)"),borderRadius:8,color:wind===w?"var(--lq-blue)":"rgba(255,255,255,0.5)",fontSize:12,fontFamily:"monospace",cursor:"pointer",textAlign:"left"}}>{w}</button>)}
            </div>
          </div>
          <Field label="Temp (°F)" value={temp} onChange={setTemp} placeholder="74"/>
          <Field label="Notes" value={notes} onChange={setNotes} placeholder="Special instructions…" rows={2}/>
          
          <div style={{display:"flex",gap:8,marginTop:4}}>
            <button onClick={handle} disabled={!valid||saving} style={{flex:2,...btn(valid&&!saving),background:valid&&!saving?"var(--lq-blue)":"rgba(0,207,255,0.15)",color:valid&&!saving?"#000":"rgba(255,255,255,0.3)",border:"none"}}>
              {saving?"SAVING…":"SAVE LOG"}
            </button>
            <button onClick={buildPDF} disabled={!valid} style={{flex:1,...btn(valid),background:"rgba(124,252,0,0.1)",color:valid?"#7CFC00":"rgba(255,255,255,0.2)",borderColor:"rgba(124,252,0,0.25)"}}>
              🖨 PDF
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Demo data ────────────────────────────────────────────────────────────────
const DEMO_PROFILE={id:"demo",name:"Demo User",company:"Green Pro Lawn Care",plan:"trial",trial_start:null,logo_url:null};
const DEMO_CUSTOMERS=[
  {id:"dc1",name:"John Smith",phone:"(812) 555-0142",email:"john@example.com",address:"4521 Oak Street, Evansville, IN",propertyType:"Residential",createdAt:"2026-04-01",notes:"Gate code 1234",recurringTemplateQuoteId:null},
  {id:"dc2",name:"Maria Garcia",phone:"(812) 555-0287",email:"maria@example.com",address:"892 Maple Ave, Evansville, IN",propertyType:"Residential",createdAt:"2026-04-15",notes:"",recurringTemplateQuoteId:null},
  {id:"dc3",name:"Riverside Commons HOA",phone:"(812) 555-0399",email:"hoa@riverside.com",address:"1200 Commerce Blvd, Evansville, IN",propertyType:"Commercial",createdAt:"2026-03-10",notes:"Needs invoice by end of month",recurringTemplateQuoteId:null},
];
const DEMO_QUOTES=[
  {id:"dq1",quoteNum:"LQ-D001",stage:"Accepted",createdAt:"2026-05-10",customerId:"dc1",customerName:"John Smith",customerPhone:"(812) 555-0142",address:"4521 Oak Street, Evansville, IN",sqft:8200,services:[{id:"mow",label:"Mow",basePrice:45,perSqft:0},{id:"edge",label:"Edge & Trim",basePrice:25,perSqft:0}],total:70,discAmt:0,taxAmt:0,subtotal:70,recurring:"biweekly",payment:"any",notes:"Prefers mornings",photos:[]},
  {id:"dq2",quoteNum:"LQ-D002",stage:"Quoted",createdAt:"2026-05-20",customerId:"dc2",customerName:"Maria Garcia",customerPhone:"(812) 555-0287",address:"892 Maple Ave, Evansville, IN",sqft:11500,services:[{id:"mow",label:"Mow",basePrice:55,perSqft:0},{id:"edge",label:"Edge & Trim",basePrice:30,perSqft:0},{id:"weed",label:"Weed Control",basePrice:40,perSqft:0}],total:125,discAmt:0,taxAmt:0,subtotal:125,recurring:"monthly",payment:"any",notes:"",photos:[]},
  {id:"dq3",quoteNum:"LQ-D003",stage:"Completed",createdAt:"2026-05-01",customerId:"dc3",customerName:"Riverside Commons HOA",customerPhone:"(812) 555-0399",address:"1200 Commerce Blvd, Evansville, IN",sqft:32000,services:[{id:"mow",label:"Commercial Mow",basePrice:280,perSqft:0},{id:"edge",label:"Edge & Blow",basePrice:95,perSqft:0}],total:375,discAmt:0,taxAmt:0,subtotal:375,recurring:"weekly",payment:"check",notes:"Invoice to HOA board",photos:[]},
  {id:"dq4",quoteNum:"LQ-D004",stage:"Lead",createdAt:"2026-05-27",customerId:"dc2",customerName:"Maria Garcia",customerPhone:"(812) 555-0287",address:"892 Maple Ave, Evansville, IN",sqft:null,services:[{id:"leaf",label:"Leaf Removal",basePrice:85,perSqft:0}],total:85,discAmt:0,taxAmt:0,subtotal:85,recurring:"once",payment:"any",notes:"Called about fall cleanup",photos:[]},
];
const DEMO_INVOICES=[
  {id:"di1",invoiceNum:"INV-D001",customerId:"dc1",customerName:"John Smith",customerPhone:"(812) 555-0142",customerEmail:"john@example.com",status:"Sent",createdAt:"2026-05-10",dueDate:"2026-05-24",total:70,lineItems:[{id:"l1",label:"Mow, Edge & Trim — May 10",qty:1,price:70}],terms:"net14",notes:"",paymentMethod:null,paidDate:null},
  {id:"di2",invoiceNum:"INV-D002",customerId:"dc3",customerName:"Riverside Commons HOA",customerPhone:"(812) 555-0399",customerEmail:"hoa@riverside.com",status:"Paid",createdAt:"2026-05-01",dueDate:"2026-05-15",total:375,lineItems:[{id:"l2",label:"Commercial Mow & Edge — May 1",qty:1,price:375}],terms:"net14",notes:"",paymentMethod:"Check",paidDate:"2026-05-13"},
];

// ─── App ──────────────────────────────────────────────────────────────────────
export default function App() {
  const googleReady  = useGoogleReady();
  const [colorMode,setColorMode] = useState(()=>localStorage.getItem('lq_theme')||'dark');
  const isDark = colorMode==='dark';
  const toggleTheme=()=>{const n=isDark?'light':'dark';setColorMode(n);localStorage.setItem('lq_theme',n);};
  useEffect(()=>{
    document.documentElement.classList.toggle('lq-light',!isDark);
  },[isDark]);
  const [authScreen,setAuthScreen]   = useState("login");
  const [session,setSession]         = useState(null);
  const [isDemoMode,setIsDemoMode]   = useState(false);
  const [profile,setProfile]         = useState(null);
  const [rateSettings,setRateSettings] = useState(()=>mergeRateSettings(null));
  const [loading,setLoading]         = useState(true);
  const [screen,setScreen]           = useState("pipeline");
  const [redesignOn]                 = useState(()=>{ try{const u=new URLSearchParams(window.location.search); if(u.get('redesign')==='1'){localStorage.setItem('lq_redesign','1');return true;} if(u.get('redesign')==='0'){localStorage.setItem('lq_redesign','0');return false;} return localStorage.getItem('lq_redesign')!=='0';}catch(e){return true;} });
  const [quotes,setQuotes]           = useState([]);
  const [jobs,setJobs]               = useState([]);
  const [showAccountMenu,setShowAccountMenu] = useState(false);
  const [showGlobalSearch,setShowGlobalSearch] = useState(false);
  const [globalQuery,setGlobalQuery] = useState('');
  const [showPaywall,setShowPaywall]     = useState(false);
  const [accountTab,setAccountTab]   = useState("profile");
  const [showCampaigns,setShowCampaigns] = useState(false);
  const [invoicePromptJob,setInvoicePromptJob] = useState(null);
  const [invoiceFromQuote,setInvoiceFromQuote]   = useState(null);
  const [chemLogTarget,setChemLogTarget] = useState(null); // {quote} or {job}
  const [_chemLogs,setChemLogs]       = useState([]);
  const {templates:_templates,save:saveTemplate,remove:_removeTemplate} = useTemplates();
  const [_showTemplatePicker,_setShowTemplatePicker] = useState(false);
  const [_templatePreload,_setTemplatePreload] = useState(null);
  const [customers,setCustomers]     = useState([]);
  const [invoices,setInvoices]       = useState([]);
  const [selCustomer,setSelCustomer] = useState(null);
  const [selQuote,setSelQuote]       = useState(null);
  const [editingQuote,setEditingQuote] = useState(null);
  const [prefillCust,setPrefillCust] = useState(null);
  const [quoteFlowKey,setQuoteFlowKey] = useState(1);
  const [quickQuote,setQuickQuote]   = useState(false);
  const [quoteCategory,setQuoteCategory] = useState(null); // null | 'lawn' | 'holiday'
  const [newInvoice,setNewInvoice]   = useState(false);
  const [selInvoice,setSelInvoice]   = useState(null);
  const [addingCustomer,setAddingCustomer]   = useState(false);
  const [importingCustomers,setImportingCustomers] = useState(false);
  const [showPWAModal,setShowPWAModal]       = useState(false);
  const [showPasswordReset,setShowPasswordReset] = useState(false);
  // eslint-disable-next-line no-unused-vars

  useEffect(()=>{
    const params=new URLSearchParams(window.location.search);
    if(params.has('stripe_connected')){
      window.history.replaceState({},'',window.location.pathname);
      setAccountTab('subscription');
      setScreen('account');
    }
    if(params.has('stripe_connect_error')){
      window.history.replaceState({},'',window.location.pathname);
      alert('Stripe Connect error: '+params.get('stripe_connect_error'));
    }
  },[]);// eslint-disable-line react-hooks/exhaustive-deps

  useEffect(()=>{
    // Demo mode: ?demo in URL skips auth entirely
    if(new URLSearchParams(window.location.search).has('demo')){
      setIsDemoMode(true);
      setProfile(DEMO_PROFILE);
      setCustomers(DEMO_CUSTOMERS);
      setQuotes(DEMO_QUOTES);
      setInvoices(DEMO_INVOICES);
      setJobs([]);
      setLoading(false);
      return;
    }
    supabase.auth.getSession().then(({data:{session}})=>{
      setSession(session);
      if(session)fetchAll(session.user.id);
      else setLoading(false);
    });
    const{data:{subscription}}=supabase.auth.onAuthStateChange((event,session)=>{
      if(event==='PASSWORD_RECOVERY'){
        setSession(session);
        setShowPasswordReset(true);
        setLoading(false);
        return;
      }
      setSession(session);
      if(session){fetchAll(session.user.id);}
      else{setLoading(false);setQuotes([]);setCustomers([]);setProfile(null);}
    });
    return()=>subscription.unsubscribe();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  // Show PWA install prompt once on mobile if not already installed
  useEffect(()=>{
    const isStandalone=window.matchMedia('(display-mode: standalone)').matches||window.navigator.standalone;
    const seen=localStorage.getItem('pwa_prompt_seen');
    if(!isStandalone && !seen){
      const timer=setTimeout(()=>setShowPWAModal(true),2500);
      return()=>clearTimeout(timer);
    }
  },[]);

  const fetchAll=useCallback(async uid=>{
    setLoading(true);
    const[{data:prof},{data:cust},{data:quot},{data:inv},{data:sched},{data:managed}]=await Promise.all([
      supabase.from("profiles").select("*").eq("id",uid).single(),
      supabase.from("customers").select("*").eq("user_id",uid).order("created_at",{ascending:false}),
      supabase.from("quotes").select("*").eq("user_id",uid).order("created_at",{ascending:false}),
      supabase.from("invoices").select("*").eq("user_id",uid).order("created_at",{ascending:false}),
      supabase.from("scheduled_jobs").select("*").eq("user_id",uid).order("scheduled_date",{ascending:true}),
      supabase.from("managed_accounts").select("account_id").eq("admin_id",uid)
    ]);
    setProfile(prof||null);
    setRateSettings(mergeRateSettings(prof?.rate_settings||null));
    // Show paywall if trial expired
    if(prof && !hasAccess(prof)) setShowPaywall(true);

    // If user is an admin, also fetch from managed accounts
    let allCust=cust||[];
    let allQuot=quot||[];
    let allInv=inv||[];
    let allSched=sched||[];

    if(managed && managed.length>0){
      const accountIds=managed.map(m=>m.account_id);
      const[{data:custMgd},{data:quotMgd},{data:invMgd},{data:schedMgd}]=await Promise.all([
        supabase.from("customers").select("*").in("user_id",accountIds).order("created_at",{ascending:false}),
        supabase.from("quotes").select("*").in("user_id",accountIds).order("created_at",{ascending:false}),
        supabase.from("invoices").select("*").in("user_id",accountIds).order("created_at",{ascending:false}),
        supabase.from("scheduled_jobs").select("*").in("user_id",accountIds).order("scheduled_date",{ascending:true})
      ]);
      allCust=[...allCust,...(custMgd||[])];
      allQuot=[...allQuot,...(quotMgd||[])];
      allInv=[...allInv,...(invMgd||[])];
      allSched=[...allSched,...(schedMgd||[])];
    }

    const mappedCust=allCust.map(rowToCustomer);
    const mappedQuotes=allQuot.map(rowToQuote);
    // Backfill $0 completed recurring quotes so historical ones don't show as $0.
    // Display-only (in-memory) — uses the customer's recurring price, or the
    // highest non-zero recurring quote for that customer as a fallback. DB untouched.
    const _custById={},_custByName={};
    mappedCust.forEach(c=>{_custById[c.id]=c;if(c.name)_custByName[c.name]=c;});
    const _fbByCust={};
    mappedQuotes.forEach(q=>{
      if(q.recurring&&q.recurring!=="once"&&q.total>0){
        const cid=q.customerId||(_custByName[q.customerName]&&_custByName[q.customerName].id)||q.customerName;
        if(cid) _fbByCust[cid]=Math.max(_fbByCust[cid]||0,q.total);
      }
    });
    const normQuotes=mappedQuotes.map(q=>{
      if(q.stage==="Completed"&&q.recurring&&q.recurring!=="once"&&(!q.total||q.total===0)){
        const c=_custById[q.customerId]||_custByName[q.customerName];
        const cid=q.customerId||(c&&c.id)||q.customerName;
        const price=(c&&c.recurringPrice?Number(c.recurringPrice):0)||_fbByCust[cid]||_fbByCust[q.customerName]||0;
        if(price>0) return {...q,total:price,subtotal:q.subtotal||price,_estimated:true};
      }
      return q;
    });
    setCustomers(mappedCust);
    setQuotes(normQuotes);
    setInvoices(allInv.map(rowToInvoice));
    setJobs(allSched.map(r=>({
      id:r.id, customerId:r.customer_id, quoteId:r.quote_id,
      customerName:r.customer_name, address:r.address,
      lat:r.lat, lng:r.lng,
      scheduledDate:r.scheduled_date, scheduledTime:r.scheduled_time,
      duration:r.duration_mins, status:r.status,
      notes:r.notes, services:r.services, jobType:r.job_type,
    })));
    setLoading(false);
  },[]);

  const enterDemoMode=()=>{
    setIsDemoMode(true);
    setProfile(DEMO_PROFILE);
    setCustomers(DEMO_CUSTOMERS);
    setQuotes(DEMO_QUOTES);
    setInvoices(DEMO_INVOICES);
    setJobs([]);
    setLoading(false);
  };

  const exitDemoMode=()=>{
    setIsDemoMode(false);
    setProfile(null);
    setCustomers([]);
    setQuotes([]);
    setInvoices([]);
    setJobs([]);
    setAuthScreen("signup");
  };

  const handleUpdateStage=async(id,stage)=>{
    setQuotes(qs=>qs.map(q=>q.id===id?{...q,stage}:q));
    if(selQuote?.id===id) setSelQuote(q=>({...q,stage}));
    if(isDemoMode) return;
    await supabase.from("quotes").update({stage}).eq("id",id);
  };

  const handleDeleteQuote=async id=>{
    setQuotes(qs=>qs.filter(q=>q.id!==id));
    if(selQuote?.id===id) setSelQuote(null);
    await supabase.from("quotes").delete().eq("id",id);
  };

  const handleDuplicateQuote=async q=>{
    const newId=genId(); const newQn=qNum();
    const dupe={...q,id:newId,quoteNum:newQn,stage:"Lead",createdAt:todayStr()};
    setQuotes(qs=>[dupe,...qs]);
    await supabase.from("quotes").insert({
      id:newId,quote_num:newQn,stage:"Lead",created_at:todayStr(),
      customer_id:q.customerId,customer_name:q.customerName,customer_phone:q.customerPhone,
      address:q.address,sqft:q.sqft,services:q.services,materials:q.materials,
      subtotal:q.subtotal,disc_amt:q.discAmt,tax_amt:q.taxAmt,total:q.total,
      tax_rate:q.taxRate,discount:q.discount,recurring:q.recurring,
      payment:q.payment,notes:q.notes,photo_count:0,annual_val:q.annualVal,
    });
  };

  const handleUpdateCustomer=async(id,form)=>{
    setCustomers(cs=>cs.map(c=>c.id===id?{...c,...form}:c));
    if(selCustomer?.id===id) setSelCustomer(c=>({...c,...form}));
    await supabase.from("customers").update({
      name:form.name, phone:form.phone, email:form.email||null,
      address:form.address||null, property_type:form.propertyType||null, notes:form.notes||null,
      recurring_active:      form.recurringActive!=null ? Boolean(form.recurringActive) : null,
      recurring_frequency:   form.recurringFrequency   ?? null,
      recurring_day:         form.recurringDay         ?? null,
      recurring_start:       form.recurringStart       ?? null,
      recurring_services:    form.recurringServices    ?? null,
      recurring_duration:    form.recurringDuration    ?? null,
      recurring_custom_days: form.recurringCustomDays  ?? null,
      recurring_end:         form.recurringEnd         ?? null,
      recurring_price:       form.recurringPrice       ?? null,
      recurring_template_quote_id: form.recurringTemplateQuoteId ?? null,
    }).eq("id",id);
  };

  const handleDeleteCustomer=async id=>{
    setCustomers(cs=>cs.filter(c=>c.id!==id));
    setQuotes(qs=>qs.filter(q=>q.customerId!==id));
    setJobs(js=>js.filter(j=>j.customerId!==id));
    setInvoices(is=>is.filter(i=>i.customerId!==id));
    setSelCustomer(null);
    setScreen("customers");
    await supabase.from("scheduled_jobs").delete().eq("customer_id",id);
    await supabase.from("invoices").delete().eq("customer_id",id);
    await supabase.from("quotes").delete().eq("customer_id",id);
    await supabase.from("customers").delete().eq("id",id);
  };


  const handleCreateMultiInvoice=async(selectedQuotes)=>{
    if(!selectedQuotes||selectedQuotes.length===0) return;
    const first = selectedQuotes[0];
    // One line item per quote using exact quoted total
    const finalLineItems = selectedQuotes.map(q=>({
      id:genId(),
      label:(q.services&&q.services[0]?(q.services[0].label||q.services[0].name||'Lawn Service'):'Lawn Service')
            +(selectedQuotes.length>1?' — '+fmtDate(q.createdAt):''),
      qty:1,
      price:parseFloat(q.total)||0,
    }));
    const total = selectedQuotes.reduce((a,q)=>a+(parseFloat(q.total)||0),0);
    const data = {
      customerId:    first.customerId,
      customerName:  first.customerName,
      customerPhone: first.customerPhone,
      customerEmail: null,
      lineItems:finalLineItems,
      subtotal: total, discAmt:0, taxAmt:0, total,
      terms:'due_receipt', dueDate:todayStr(),
      status:'Draft',
      notes:'Combined invoice for '+selectedQuotes.length+' jobs: '+selectedQuotes.map(q=>'#'+q.quoteNum).join(', '),
    };
    await handleSaveInvoice(data, selectedQuotes.length===1?selectedQuotes[0].id:null);
    setSelCustomer(null);
    setScreen("invoices");
  };

  const handleSaveInvoice=async(data,quoteId=null)=>{
    const invNum = "INV-"+String(invoices.length+1).padStart(4,"0");
    const newInv = {
      id:genId(), invoiceNum:invNum, createdAt:todayStr(),
      quoteId:quoteId||null,
      ...data,
    };
    // Optimistic add
    setInvoices(is=>[newInv,...is]);
    // If linked to a quote, mark quote as Completed in state
    if(quoteId){
      setQuotes(qs=>qs.map(q=>q.id===quoteId?{...q,stage:"Completed"}:q));
    }
    if(isDemoMode) return;
    const uid = session?.user?.id;
    if(!uid) return;
    // Fresh profile check
    const{data:freshProf}=await supabase.from("profiles").select("plan,trial_start").eq("id",uid).single();
    if(!hasAccess(freshProf||profile)){
      setShowPaywall(true);
      setInvoices(is=>is.filter(i=>i.id!==newInv.id));
      return;
    }
    const row={
      id:newInv.id, user_id:uid,
      customer_id:data.customerId||null,
      quote_id:quoteId||null,
      invoice_num:invNum,
      status:data.status||"Draft",
      line_items:data.lineItems||[],
      subtotal:data.subtotal||0,
      disc_amt:data.discAmt||0,
      tax_amt:data.taxAmt||0,
      tax_rate:data.taxRate||0,
      total:data.total||0,
      terms:data.terms||"due_receipt",
      due_date:data.dueDate||null,
      notes:data.notes||null,
      customer_name:data.customerName||null,
      customer_phone:data.customerPhone||null,
      customer_email:data.customerEmail||null,
      created_at:todayStr(),
    };
    const{error}=await supabase.from("invoices").insert(row);
    if(error){
      console.error("Save invoice error:",error.message);
      setInvoices(is=>is.filter(i=>i.id!==newInv.id));
      alert("Failed to save invoice: "+error.message);
    }
    if(quoteId&&!error){
      await supabase.from("quotes").update({stage:"Completed"}).eq("id",quoteId);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const handleCreateFromQuote=async(q)=>{
    const lineItems=[...(q.services||[]).map(s=>({id:s.id,label:s.label,price:s.basePrice+(s.perSqft||0)*q.sqft})),...(q.materials||[]).map(m=>({id:m.id,label:m.name,price:m.price*(1+(m.margin||0))}))];
    const dueDate=calcDueDate("net7");
    await handleSaveInvoice({customerId:q.customerId,customerName:q.customerName,customerPhone:q.customerPhone,lineItems,subtotal:q.subtotal,discAmt:q.discAmt,taxAmt:q.taxAmt,total:q.total,terms:"net7",dueDate,status:"Sent"},q.id);
  };

  const handleUpdateInvoice=async(id,updates)=>{
    setInvoices(is=>is.map(i=>i.id===id?{...i,...updates}:i));
    if(selInvoice?.id===id) setSelInvoice(i=>({...i,...updates}));
    const{error}=await supabase.from("invoices").update({
      line_items:updates.lineItems,
      terms:updates.terms,
      due_date:updates.dueDate,
      notes:updates.notes,
      total:updates.total,
    }).eq("id",id);
    if(error) console.error("Invoice update error:",error.message);
  };

    const handleMarkPaid=async(id,method,newStatus="Paid")=>{
    const paid=newStatus==="Paid"?todayStr():null;
    const updates={status:newStatus,paidDate:paid,paymentMethod:method};
    // Sync everywhere
    setInvoices(is=>is.map(i=>i.id===id?{...i,...updates}:i));
    if(selInvoice?.id===id) setSelInvoice(i=>({...i,...updates}));
    const{error}=await supabase.from("invoices").update({status:newStatus,paid_date:paid,payment_method:method}).eq("id",id);
    if(error) console.error("Mark paid error:",error.message);
  };

  const handleDeleteInvoice=async id=>{
    setInvoices(is=>is.filter(i=>i.id!==id));
    if(selInvoice?.id===id) setSelInvoice(null);
    await supabase.from("invoices").delete().eq("id",id);
  };



  const handleBulkImport=async(batch)=>{
    // Optimistic update
    setCustomers(cs=>[...batch.map(c=>({...c})),...cs]);
    // Batch insert to Supabase
    const rows=batch.map(c=>({
      id:c.id, name:c.name, phone:c.phone||null, email:c.email||null,
      address:c.address||null, property_type:c.propertyType||"Residential",
      notes:c.notes||null, created_at:c.createdAt,
    }));
    const{error}=await supabase.from("customers").insert(rows);
    if(error) throw error;
  };

  const handleUpgrade=async()=>{
    try{
      const{data:{session:sess}}=await supabase.auth.getSession();
      if(!sess){ alert("Please sign in first."); return; }
      const res=await fetch("/api/create-checkout",{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({
          email:sess.user.email,
          priceId:"price_1TXn5FFOsREr3krA0wgTAXmV",
        }),
      });
      const{url,error}=await res.json();
      if(error) throw new Error(error);
      window.location.href=url;
    }catch(err){
      console.error("Checkout error:",err);
      alert("Could not start checkout: "+err.message);
    }
  };

  const handleDeleteAccount=async()=>{
    const{data:{session:sess}}=await supabase.auth.getSession();
    if(!sess) return;
    const uid=sess.user.id;
    const email=sess.user.email;
    try{
      // Delete all user data
      await supabase.from("scheduled_jobs").delete().eq("user_id",uid);
      await supabase.from("invoices").delete().eq("user_id",uid);
      await supabase.from("quotes").delete().eq("user_id",uid);
      await supabase.from("customers").delete().eq("user_id",uid);
      await supabase.from("profiles").delete().eq("id",uid);

      // Delete the auth user so they can't log back in
      await fetch('/api/delete-user',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({userId:uid})
      });

      // Sign out
      await supabase.auth.signOut();
      alert("Your account and all data have been permanently deleted.");
    }catch(err){
      console.error("Delete account error:",err);
      alert("Error deleting account: "+err.message);
    }
  };

  const handleClearRecurring=async()=>{
    if(!window.confirm("Remove all future recurring jobs from your schedule? This cannot be undone.")) return;
    const today=todayStr();
    const toRemove=jobs.filter(j=>j.jobType==="Recurring"&&j.scheduledDate>=today);
    setJobs(js=>js.filter(j=>!(j.jobType==="Recurring"&&j.scheduledDate>=today)));
    await Promise.all(toRemove.map(j=>supabase.from("scheduled_jobs").delete().eq("id",j.id)));
    alert("Cleared "+toRemove.length+" recurring job"+(toRemove.length!==1?"s":"")+" from schedule.");
  };

  const handleBillingPortal=async()=>{
    const{data:{session:sess}}=await supabase.auth.getSession();
    if(!sess){ alert("Please sign in first."); return; }
    try{
      const res=await fetch('/api/customer-portal',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({userId:sess.user.id})});
      const data=await res.json();
      if(data.url){ window.location.href=data.url; return; }
      alert(data.error||"No billing portal is available for this account yet.");
    }catch(e){ alert("Could not open the billing portal. Please try again."); }
  };

  const handleCancelSub=async()=>{
    if(!window.confirm("Cancel your subscription? You'll keep access until the end of your billing period.")) return;
    const{data:{session:sess}}=await supabase.auth.getSession();
    if(!sess) return;
    const{data:prof}=await supabase.from('profiles').select('stripe_customer_id').eq('id',sess.user.id).single();
    if(prof?.stripe_customer_id){
      try{
        const res=await fetch('/api/customer-portal',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({userId:sess.user.id})});
        const data=await res.json();
        if(data.url){ window.location.href=data.url; return; }
      }catch(e){}
    }
    await supabase.from('profiles').update({plan:'cancelled'}).eq('id',sess.user.id);
    setProfile(p=>({...p,plan:'cancelled'}));
    alert("Subscription cancelled. You'll keep access until your billing period ends.");
  };

  const handleScheduleRecurring=async(customerId, jobsToCreate)=>{
    const uid=session.user.id;
    // Remove any existing future scheduled jobs for this customer first
    const today=todayStr();
    const existing=jobs.filter(j=>j.customerId===customerId&&j.scheduledDate>=today);
    if(existing.length>0){
      setJobs(js=>js.filter(j=>!(j.customerId===customerId&&j.scheduledDate>=today)));
      await Promise.all(existing.map(j=>supabase.from("scheduled_jobs").delete().eq("id",j.id)));
    }
    // Create new scheduled jobs
    const newJobs=jobsToCreate.map(j=>({...j,id:genId(),customerId,customerName:j.customerName,address:j.address,jobType:"Recurring"}));
    setJobs(js=>[...js,...newJobs]);
    const rows=newJobs.map(j=>({
      id:j.id, user_id:uid, customer_id:customerId,
      customer_name:j.customerName, address:j.address,
      lat:null, lng:null,
      scheduled_date:j.scheduledDate, scheduled_time:null,
      duration_mins:j.duration||60, status:"Scheduled",
      notes:null, services:j.services||null, job_type:"Recurring",
    }));
    const {error:schedErr} = await supabase.from("scheduled_jobs").insert(rows);
    if(schedErr) console.error("Schedule insert error:", schedErr.message, schedErr.details);
    else console.log("[Recurring] inserted", rows.length, "jobs");
  };

  const handleSaveNewCustomer=async(cust,navigate=true)=>{
    const uid = session?.user?.id;
    if(!uid){ alert("Not signed in"); return; }
    // Optimistic add
    setCustomers(cs=>[cust,...cs]);
    const{error}=await supabase.from("customers").insert({
      id:cust.id, user_id:uid,
      name:cust.name, phone:cust.phone||null,
      email:cust.email||null, address:cust.address||null,
      property_type:cust.propertyType||null,
      notes:cust.notes||null, created_at:cust.createdAt,
    });
    if(error){
      console.error("Save customer error:",error.message);
      setCustomers(cs=>cs.filter(c=>c.id!==cust.id));
      alert("Failed to save client: "+error.message);
      return;
    }
    setAddingCustomer(false);
    // Navigate straight to the new client's profile (legacy flow only;
    // the redesign shell handles its own post-save navigation)
    if(navigate){
      setSelCustomer(cust);
      setScreen("customers");
    }
  };

  const handleEditQuote=async(quoteId,updates)=>{
    setQuotes(qs=>qs.map(q=>q.id===quoteId?{...q,...updates}:q));
    if(selQuote?.id===quoteId) setSelQuote(q=>({...q,...updates}));
    setEditingQuote(null);
    const{error}=await supabase.from("quotes").update({
      services:updates.services,
      subtotal:updates.subtotal,
      total:updates.total,
      notes:updates.notes,
    }).eq("id",quoteId);
    if(error) console.error("Quote edit error:",error.message);
  };

  
  const handleCompleteJob=async(job)=>{
    const updates={status:"Completed"};
    if(job.actualDuration) updates.duration=job.actualDuration;
    await handleUpdateJob(job.id,updates);

    // ── Sync quote stage to Completed if job has a linked quote ──
    if(job.quoteId){
      // Update in state
      setQuotes(qs=>qs.map(q=>q.id===job.quoteId?{...q,stage:"Completed"}:q));
      // Update in Supabase
      await supabase.from("quotes").update({stage:"Completed"}).eq("id",job.quoteId);
    } else if(job.customerName&&job.customerName!=="Door Hanger Lead"){
      // No quoteId — try to match by customer name + address (best effort)
      const matched=quotes.find(q=>
        q.customerName===job.customerName&&
        (q.stage==="Accepted"||q.stage==="Scheduled")&&
        (!job.address||q.address===job.address)
      );
      if(matched){
        setQuotes(qs=>qs.map(q=>q.id===matched.id?{...q,stage:"Completed"}:q));
        await supabase.from("quotes").update({stage:"Completed"}).eq("id",matched.id);
      }
    }

    // ── Auto-create quote for recurring jobs with no quoteId ──
    if(!job.quoteId && job.jobType==="Recurring" && job.customerName && job.customerName!=="Door Hanger Lead"){
      const uid=session.user.id;
      const customer=customers.find(c=>c.name===job.customerName);
      if(customer){
        const newQuoteId=genId();
        const templateQuote=customer.recurringTemplateQuoteId
          ? quotes.find(q=>q.id===customer.recurringTemplateQuoteId)
          : null;
        const svcList=templateQuote
          ? (templateQuote.services||[]).map(s=>({...s,id:genId()}))
          : (()=>{
              const svcString=job.services||customer.recurringServices||"";
              return typeof svcString==="string"
                ? svcString.split(",").map(s=>s.trim()).filter(Boolean).map(s=>({id:genId(),name:s,price:0,qty:1}))
                : (Array.isArray(svcString)?svcString:[]).map(s=>({...s,id:genId()}));
            })();
        const total=customer.recurringPrice!=null
          ? Number(customer.recurringPrice)
          : templateQuote
            ? (templateQuote.total||0)
            : svcList.reduce((a,s)=>a+(parseFloat(s.price)||0),0)||0;
        const qNum="LQ-R"+Date.now().toString().slice(-4);
        const jobDate=job.scheduledDate||job.date||todayStr();
        const newQuote={
          id:newQuoteId,userId:uid,customerId:customer.id,
          customerName:job.customerName,customerPhone:customer.phone||"",
          address:job.address||customer.address||"",
          stage:"Completed",services:svcList,subtotal:total,total,
          recurring:"recurring",quoteNum:qNum,createdAt:jobDate,
          notes:"Recurring service — "+jobDate,
        };
        setQuotes(qs=>[...qs,newQuote]);
        await supabase.from("quotes").insert({
          id:newQuoteId,user_id:uid,customer_id:customer.id,
          customer_name:job.customerName,customer_phone:customer.phone||"",
          address:job.address||customer.address||"",
          stage:"Completed",services:svcList,subtotal:total,total,
          recurring:"recurring",quote_num:qNum,created_at:jobDate,
          notes:"Recurring service — "+jobDate,
        });
        await supabase.from("scheduled_jobs").update({quote_id:newQuoteId}).eq("id",job.id);
        job={...job,quoteId:newQuoteId};
      }
    }

    // Job complete — user can invoice from the Invoices tab
  };

  const handleAddJob=async(job)=>{
    const uid=session.user.id;
    const row={id:job.id,user_id:uid,customer_name:job.customerName,address:job.address,lat:job.lat||null,lng:job.lng||null,scheduled_date:job.scheduledDate,scheduled_time:job.scheduledTime||null,duration_mins:job.duration||60,status:job.status||"Scheduled",notes:job.notes||null,services:job.services||null,job_type:"Service",created_at:todayStr()};
    setJobs(js=>[...js,job]);
    const{error}=await supabase.from("scheduled_jobs").insert(row);
    if(error){console.error("Add job error:",error.message);setJobs(js=>js.filter(j=>j.id!==job.id));}
  };

  const handleUpdateJob=async(id,updates)=>{
    setJobs(js=>js.map(j=>j.id===id?{...j,...updates}:j));
    const dbUpdates={};
    if(updates.status)        dbUpdates.status=updates.status;
    if(updates.scheduledDate) dbUpdates.scheduled_date=updates.scheduledDate;
    if(updates.scheduledTime) dbUpdates.scheduled_time=updates.scheduledTime;
    if(updates.duration)      dbUpdates.duration_mins=updates.duration;
    await supabase.from("scheduled_jobs").update(dbUpdates).eq("id",id);

    // ── If undoing complete, set linked quote back to Accepted ──
    if(updates.status==="Scheduled"){
      const job=jobs.find(j=>j.id===id);
      if(job?.quoteId){
        setQuotes(qs=>qs.map(q=>q.id===job.quoteId?{...q,stage:"Accepted"}:q));
        await supabase.from("quotes").update({stage:"Accepted"}).eq("id",job.quoteId);
      }
    }
  };

  const handleDeleteJob=async(id)=>{
    setJobs(js=>js.filter(j=>j.id!==id));
    await supabase.from("scheduled_jobs").delete().eq("id",id);
  };

  const handleQuoteDone=(newQuote)=>{
    // Optimistically add to state immediately — don't wait for fetchAll
    if(newQuote){
      setQuotes(qs=>[newQuote,...qs]);
      // Also ensure customer is in list
      if(newQuote.customerId){
        setCustomers(cs=>cs.find(c=>c.id===newQuote.customerId)?cs:[{id:newQuote.customerId,name:newQuote.customerName,phone:newQuote.customerPhone,email:"",createdAt:todayStr()},...cs]);
      }
    }
    setPrefillCust(null);
    setQuoteCategory(null);
    setQuoteFlowKey(k=>k+1); // reset QuoteFlow for next fresh quote
    setScreen("pipeline");
    // Background refresh to sync any other changes
    if(session) setTimeout(()=>fetchAll(session.user.id), 1500);
  };
  const handleSignOut=async()=>{ await supabase.auth.signOut(); setAuthScreen("login"); };
  const handleSaveRates=async(rates)=>{
    if(!session) return;
    const{error}=await supabase.from("profiles").update({rate_settings:rates}).eq("id",session.user.id);
    if(!error){ setRateSettings(mergeRateSettings(rates)); setProfile(p=>({...p,rate_settings:rates})); }
  };
  const nav=s=>{console.log('Navigation to screen:', s); setSelCustomer(null);setSelQuote(null);setEditingQuote(null);setNewInvoice(false);setSelInvoice(null);setAddingCustomer(false);setImportingCustomers(false);setShowAccountMenu(false);setShowCampaigns(false);setScreen(s);};

  const [rebookToast,showRebookToast]=useToast();
  const [rebookTarget,setRebookTarget]=useState(null);
  const handleRebook=(q)=>setRebookTarget(q);
  const confirmRebook=(date)=>{
    const q=rebookTarget;
    setRebookTarget(null);
    const svcString=(q.services||[]).map(s=>s.label||s.name||"").filter(Boolean).join(", ");
    const job={id:genId(),customerName:q.customerName,customerId:q.customerId||null,address:q.address||"",scheduledDate:date,duration:60,services:svcString,status:"Scheduled",quoteId:null,jobType:"Service"};
    setJobs(js=>[...js,job]);
    setSelCustomer(null);
    nav('schedule');
    showRebookToast('Job rebooked for '+new Date(date+"T12:00:00").toLocaleDateString("en-US",{month:"short",day:"numeric"}));
    if(session?.user?.id){
      const uid=session.user.id;
      supabase.from("scheduled_jobs").insert({id:job.id,user_id:uid,customer_id:job.customerId,customer_name:job.customerName,address:job.address,scheduled_date:date,duration_mins:60,status:"Scheduled",notes:svcString,job_type:"Service",created_at:todayStr()}).then(({error})=>{
        if(error){console.error("Rebook job error:",error.message);setJobs(js=>js.filter(j=>j.id!==job.id));}
      });
    }
  };

  // ── Also run SQL migration for new customer columns ──
  // Run this once in Supabase SQL Editor:
  // alter table customers add column if not exists address text;
  // alter table customers add column if not exists property_type text;
  // alter table customers add column if not exists notes text;

  if(loading) return(
    <div className={"lqr"+(isDark?"":" theme-light")} style={{minHeight:"100vh",background:"var(--bg)",color:"var(--text)",display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:20}}>
      <style>{REDESIGN_TOKENS}</style>
      <div style={{position:"relative",width:64,height:64,display:"flex",alignItems:"center",justifyContent:"center"}}>
        <div style={{position:"absolute",inset:0,borderRadius:"50%",border:"3px solid var(--surface-3)",borderTopColor:"var(--accent)",animation:"lqrSpin 0.85s linear infinite"}}/>
        <div style={{width:44,height:44,borderRadius:14,background:"var(--accent-soft)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22}}>🌿</div>
      </div>
      <div style={{fontWeight:800,fontSize:18,letterSpacing:"-0.02em"}}>LAWN<span style={{color:"var(--accent)"}}>.</span>Quote</div>
      <div style={{color:"var(--text-faint)",fontSize:12,letterSpacing:"0.14em",fontWeight:700,textTransform:"uppercase",animation:"lqrLoadPulse 1.5s ease infinite"}}>Loading…</div>
      <style>{`@keyframes lqrSpin{to{transform:rotate(360deg)}}@keyframes lqrLoadPulse{0%,100%{opacity:1}50%{opacity:0.35}}`}</style>
    </div>
  );

  // Flag-gated redesign (beta): new shell for the list screens; detail/edit,
  // Schedule, New Quote and Account fall through to the existing UI below.
  const _redesignList = screen==="pipeline"||screen==="invoices"||screen==="customers";
  const _noOverlay = !selQuote&&!editingQuote&&!selInvoice&&!newInvoice&&!selCustomer&&!addingCustomer&&!importingCustomers&&!showCampaigns&&!showGlobalSearch&&!chemLogTarget;
  if(redesignOn&&(session||isDemoMode)&&_redesignList&&_noOverlay){
    return <RedesignApp
      quotes={quotes} invoices={invoices} customers={customers} jobs={jobs} profile={profile} email={session?.user?.email||''}
      isDark={isDark} isDemoMode={isDemoMode}
      onToggleTheme={toggleTheme}
      onLegacy={s=>nav(s)}
      renderNewQuote={back=>{
        if(!quoteCategory&&!quickQuote) return <QuoteTypeSelector onSelect={c=>{setQuoteCategory(c);}}/>;
        const changeType=()=>{setQuoteCategory(null);setQuoteFlowKey(k=>k+1);};
        if(quoteCategory==="holiday") return <HolidayQuoteFlow key={quoteFlowKey} googleReady={googleReady} prefillCustomer={prefillCust} quickMode={quickQuote} onDone={q=>{setQuickQuote(false);setPrefillCust(null);handleQuoteDone(q);back&&back();}} rateSettings={rateSettings} onChangeType={changeType}/>;
        return <QuoteFlow key={quoteFlowKey} googleReady={googleReady} prefillCustomer={prefillCust} quickMode={quickQuote} onDone={q=>{setQuickQuote(false);setPrefillCust(null);handleQuoteDone(q);back&&back();}} onSaveTemplate={saveTemplate} rateSettings={rateSettings} onChangeType={changeType}/>;
      }}
      renderSchedule={()=><ScheduleScreen quotes={quotes} jobs={jobs} customers={customers} onAddJob={handleAddJob} onUpdateJob={handleUpdateJob} onDeleteJob={handleDeleteJob} onCompleteJob={handleCompleteJob} googleReady={googleReady}/>}
      renderCustomer={(customer,back)=><CustomerProfile customer={customer} quotes={quotes} invoices={invoices} onBack={back} onNewQuote={c=>{setPrefillCust(c);setQuoteFlowKey(k=>k+1);if(back)back();setScreen('newquote');}} onUpdate={handleUpdateCustomer} onDelete={async id=>{await handleDeleteCustomer(id);if(back)back();}} onScheduleRecurring={handleScheduleRecurring} onSelectInvoice={inv=>{setSelInvoice(inv);setScreen('invoices');}} onUpdateStage={handleUpdateStage} onDeleteQuote={handleDeleteQuote} onDuplicateQuote={handleDuplicateQuote} onCreateInvoice={q=>setInvoiceFromQuote(q)} onMarkPaid={handleMarkPaid} onDeleteInvoice={handleDeleteInvoice} onUpdateInvoice={handleUpdateInvoice} onCreateMultiInvoice={handleCreateMultiInvoice} onRebook={handleRebook}/>}
      renderQuoteDetail={(quote,back)=><QuoteDetail quote={quote} onBack={back} onUpdateStage={handleUpdateStage} onDelete={async id=>{await handleDeleteQuote(id);if(back)back();}} onDuplicate={handleDuplicateQuote} onCreateInvoice={q=>setInvoiceFromQuote(q)} onEditQuote={q=>{setEditingQuote(q);setSelQuote(q);setScreen('pipeline');}} onLogApplication={q=>setChemLogTarget({quote:q})}/>}
      renderInvoiceDetail={(invoice,back)=><InvoiceDetail invoice={invoice} profile={profile} session={session} customers={customers} onBack={back} onMarkPaid={async(id,method)=>{await handleMarkPaid(id,method);if(back)back();}} onDelete={async id=>{await handleDeleteInvoice(id);if(back)back();}} onUpdate={handleUpdateInvoice}/>}
      onExitDemo={exitDemoMode}
      onMoreQuote={q=>{setSelQuote(q);setScreen('pipeline');}}
      onMoreInvoice={i=>{setSelInvoice(i);setScreen('invoices');}}
      onSelectCustomer={c=>{setSelCustomer(c);setScreen('customers');}}
      onUpdateStage={handleUpdateStage}
      onDeleteQuote={handleDeleteQuote}
      onDuplicateQuote={handleDuplicateQuote}
      onMarkPaid={handleMarkPaid}
      onDeleteInvoice={handleDeleteInvoice}
      onSearch={()=>setShowGlobalSearch(true)}
      onCampaigns={()=>setShowCampaigns(true)}
      onLogApplication={()=>setChemLogTarget({manual:true})}
      renderNewInvoice={back=><NewInvoiceForm customers={customers} profile={profile} session={session} onSave={data=>handleSaveInvoice(data)} onBack={back}/>}
      renderAddClient={back=><AddCustomerForm onSave={async c=>{await handleSaveNewCustomer(c,false);back();}} onBack={back}/>}
      renderImportClients={back=><ImportCustomers existingCount={customers.length} onImport={handleBulkImport} onBack={back}/>}
      onSignOut={handleSignOut}
      onUpgrade={handleUpgrade}
      onManageSub={()=>{setAccountTab('subscription');setScreen('account');}}
      onBillingPortal={handleBillingPortal}
      onCancelSub={handleCancelSub}
      onClearRecurring={handleClearRecurring}
      onDeleteAccount={handleDeleteAccount}
      onAccountTab={t=>{setAccountTab(t);setScreen('account');}}
      onSaveProfile={async(u)=>{ if(session){ await supabase.from('profiles').update({name:u.name,company:u.company,phone:u.phone||null,website:u.website||null,address:u.address||null}).eq('id',session.user.id); } setProfile(p=>({...p,...u})); }}
      onChangePassword={async(pw)=>{ const{error}=await supabase.auth.updateUser({password:pw}); return error?error.message:null; }}
      onSaveLogo={async(dataUrl)=>{ if(session){ await supabase.from('profiles').update({logo_url:dataUrl}).eq('id',session.user.id); } setProfile(p=>({...p,logo_url:dataUrl})); }}
      onRemoveLogo={async()=>{ if(session){ await supabase.from('profiles').update({logo_url:null}).eq('id',session.user.id); } setProfile(p=>({...p,logo_url:null})); }}
      renderRates={back=><div style={{padding:'2px 14px 24px',animation:'lqrFade .3s ease both'}}><button onClick={back} style={{display:'flex',alignItems:'center',gap:8,background:'none',border:'none',color:'var(--text-dim)',fontSize:14,cursor:'pointer',marginBottom:16,padding:'4px 0'}}>← Back</button><RatesSettingsTab rateSettings={rateSettings} onSave={async r=>{await handleSaveRates(r);}}/></div>}
    />;
  }

  return(
    <>
      <style>{`
        :root{
          --lq-accent:#7CFC00;--lq-blue:#00cfff;--lq-text:#ffffff;
          --lq-text2:rgba(255,255,255,0.6);--lq-text3:rgba(255,255,255,0.4);
          --lq-card:rgba(255,255,255,0.04);--lq-card-border:rgba(255,255,255,0.08);
          --lq-divider:rgba(255,255,255,0.06);--lq-bg:#050e05;--lq-bg2:#0c1f0c;
          --lq-nav:rgba(5,14,5,0.97);--lq-nav-border:rgba(124,252,0,0.1);
          --lq-input:rgba(255,255,255,0.06);--lq-input-border:rgba(255,255,255,0.1);
          --lq-inactive:rgba(255,255,255,0.3);
        }
        html.lq-light{
          --lq-accent:#1e6b32;--lq-blue:#1a1a1a;--lq-text:#1a1a1a;
          --lq-text2:#444444;--lq-text3:#666666;
          --lq-card:#ffffff;--lq-card-border:#e0e0e0;
          --lq-divider:#e8e8e8;--lq-bg:#f5f5f5;--lq-bg2:#ffffff;
          --lq-nav:#ffffff;--lq-nav-border:#e0e0e0;
          --lq-input:#ffffff;--lq-input-border:#dddddd;
          --lq-inactive:#666666;
        }
        *{box-sizing:border-box;margin:0;padding:0;}
        body{background:var(--lq-bg);}

        /* ── Light mode overrides ── */
        /* All white/near-white text → dark charcoal (solid AND translucent white) */
        html.lq-light *[style*="rgb(255, 255, 255"]{color:#333!important;}
        html.lq-light *[style*="color: rgba(255, 255, 255"]{color:#333!important;}
        /* Blue-tinted backgrounds → neutral grey */
        html.lq-light *[style*="rgba(0, 207, 255"]{background:rgba(0,0,0,0.04)!important;border-color:#e0e0e0!important;}
        /* Green-tinted backgrounds → pale green */
        html.lq-light *[style*="rgba(124, 252, 0"]{background:rgba(45,138,66,0.07)!important;border-color:rgba(45,138,66,0.2)!important;}
        /* Orange-tinted backgrounds → warm cream */
        html.lq-light *[style*="rgba(255, 170, 0"]{background:#fff8e8!important;border-color:#e8a000!important;}
        /* Red-tinted backgrounds → light red */
        html.lq-light *[style*="rgba(255, 68, 68"]{background:#fff0f0!important;border-color:#e57373!important;}
        /* Solid dark panels (modals, dropdowns, bottom sheets) → white cards.
           Must come after the tint rules above: those match the panels' tinted
           borders and would otherwise wipe the panel background to transparent */
        html.lq-light *[style*="background: rgb(10, 24, 10"],
        html.lq-light *[style*="background: rgb(13, 31, 13"],
        html.lq-light *[style*="background: rgb(15, 31, 15"]{background:#ffffff!important;border-color:#d4d4d4!important;}
        /* Every button gets a visible fill or outline: bare text buttons and
           translucent-white fills disappear against the light background */
        html.lq-light button[style*="background: none"]{background:#ffffff!important;border:1px solid #c8c8c8!important;}
        html.lq-light button[style*="background: rgba(255, 255, 255"]{background:#ffffff!important;border:1px solid #c8c8c8!important;}
        /* Dark-fill buttons keep readable text (--lq-blue is near-black in light) */
        html.lq-light *[style*="background: var(--lq-blue)"]{color:#ffffff!important;}
        /* Exception: bottom nav tabs stay plain icon+label */
        html.lq-light [style*="position: fixed"][style*="bottom: 0"] button{background:none!important;border:none!important;}
        /* Preserve explicit colored text (accent, green money, etc.) — AA-safe shades */
        html.lq-light *[style*="color: rgb(124, 252, 0"]{color:#1e6b32!important;}
        html.lq-light *[style*="color: rgba(124, 252, 0"]{color:#1e6b32!important;}
        html.lq-light *[style*="color: rgb(0, 255, 153"]{color:#0e7a3c!important;}
        html.lq-light *[style*="color: rgba(0, 255, 153"]{color:#0e7a3c!important;}
        html.lq-light *[style*="color: rgb(102, 255, 194"]{color:#0e7a3c!important;}
        html.lq-light *[style*="color: rgb(0, 207, 255"]{color:#1a1a1a!important;}
        html.lq-light *[style*="color: rgb(255, 170, 0"]{color:#8a5f00!important;}
        html.lq-light *[style*="color: rgba(255, 170, 0"]{color:#8a5f00!important;}
        html.lq-light *[style*="color: rgb(136, 136, 136"]{color:#666666!important;}
        html.lq-light *[style*="color: rgb(165, 180, 252"]{color:#4338ca!important;}
        /* Filter-chip count badges use opacity for emphasis — too faint on light bg */
        html.lq-light *[style*="opacity: 0.6"]{opacity:1!important;}
        html.lq-light *[style*="color: rgb(255, 107, 107"]{color:#c0392b!important;}
        html.lq-light *[style*="color: rgb(255, 68, 68"]{color:#c0392b!important;}
        /* Nav shadow */
        html.lq-light [style*="position: fixed"][style*="bottom: 0"]{box-shadow:0 -2px 12px rgba(0,0,0,0.08)!important;}

        @keyframes fadeUp{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
        @keyframes fadeIn{from{opacity:0}to{opacity:1}}
        @keyframes pulse{0%,100%{opacity:1}50%{opacity:0.35}}
        textarea{resize:vertical;}
        ::-webkit-scrollbar{width:3px;height:3px;}
        ::-webkit-scrollbar-thumb{background:rgba(124,252,0,0.15);border-radius:99px;}
        html.lq-light ::-webkit-scrollbar-thumb{background:rgba(0,0,0,0.15);}
        .pac-container{background:var(--lq-bg2)!important;border:1px solid var(--lq-card-border)!important;border-radius:10px!important;overflow:hidden;margin-top:4px;z-index:9999!important;}
        .pac-item{background:var(--lq-bg2)!important;color:var(--lq-text2)!important;border-top:1px solid var(--lq-divider)!important;padding:10px 14px!important;cursor:pointer!important;font-size:13px!important;font-family:monospace!important;}
        .pac-item:hover,.pac-item-selected{background:var(--lq-card)!important;}
        .pac-item-query{color:var(--lq-text)!important;}
        .pac-matched{color:var(--lq-accent)!important;font-weight:700;}
        .pac-icon{display:none!important;}
      `}</style>

      {!session&&!isDemoMode&&(
        <div style={{minHeight:"100vh",background:isDark?"radial-gradient(ellipse at top left,#0c1f0c,#050e05 60%)":"#f5faf5",display:"flex",justifyContent:"center",alignItems:"flex-start",padding:"40px 20px 60px"}}>
          <div style={{width:"100%",maxWidth:400,animation:"fadeUp 0.4s ease"}}>
            {authScreen==="login"  &&<LoginScreen onNav={setAuthScreen} onDemo={enterDemoMode}/>}
            {authScreen==="signup" &&<SignupScreen onNav={setAuthScreen}/>}
            {authScreen==="forgot" &&<ForgotScreen onNav={setAuthScreen}/>}
          </div>
        </div>
      )}

      {(session||isDemoMode)&&(
        <>
          <div style={{minHeight:"100vh",background:isDark?"radial-gradient(ellipse at top left,#0c1f0c,#050e05 55%)":"#f5faf5",display:"flex",justifyContent:"center"}}>
            <div style={{width:"100%",maxWidth:430,padding:"20px 16px 90px"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,paddingBottom:14,borderBottom:"1px solid var(--lq-divider)"}}>
                <div style={{display:"flex",flexDirection:"column",gap:4}}>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <div style={{width:8,height:8,borderRadius:"50%",background:"var(--lq-accent)",boxShadow:isDark?"0 0 8px #7CFC00":"none"}}/>
                    <span style={{color:"var(--lq-accent)",fontFamily:"monospace",fontSize:13,fontWeight:700,letterSpacing:"0.1em"}}>LAWN·QUOTE</span>
                  </div>
                  <button onClick={toggleTheme} style={{display:"flex",alignItems:"center",gap:5,background:"none",border:"none",cursor:"pointer",padding:0,width:"fit-content"}}>
                    <div style={{width:28,height:15,borderRadius:99,background:isDark?"rgba(124,252,0,0.2)":"rgba(0,80,0,0.15)",position:"relative",transition:"background 0.2s",flexShrink:0}}>
                      <div style={{width:11,height:11,borderRadius:"50%",background:isDark?"#7CFC00":"#1e6b1e",position:"absolute",top:2,left:isDark?2:15,transition:"left 0.2s"}}/>
                    </div>
                    <span style={{color:isDark?"rgba(255,255,255,0.3)":"rgba(0,0,0,0.6)",fontSize:9,fontFamily:"monospace",letterSpacing:"0.06em"}}>{isDark?"DARK":"LIGHT"}</span>
                  </button>
                </div>
                <div style={{position:"relative"}}>
                  <button onClick={()=>setShowGlobalSearch(s=>!s)} style={{background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:10,padding:"6px 10px",color:"rgba(255,255,255,0.4)",fontSize:13,cursor:"pointer"}}>🔍</button>
                  <button onClick={()=>setShowAccountMenu(m=>!m)} style={{display:"flex",alignItems:"center",gap:7,background:showAccountMenu?"rgba(124,252,0,0.08)":"rgba(255,255,255,0.05)",border:`1px solid ${showAccountMenu?"rgba(124,252,0,0.3)":"rgba(255,255,255,0.1)"}`,borderRadius:10,padding:"6px 10px",cursor:"pointer",transition:"all 0.2s"}}>
                    <div style={{width:26,height:26,borderRadius:"50%",background:"rgba(124,252,0,0.15)",border:"1px solid rgba(124,252,0,0.3)",display:"flex",alignItems:"center",justifyContent:"center",color:"#7CFC00",fontSize:12,fontWeight:700,flexShrink:0}}>{(profile?.name||session.user.email||"?").charAt(0).toUpperCase()}</div>
                    <div style={{textAlign:"left"}}>
                      <div style={{color:"rgba(255,255,255,0.7)",fontSize:11,fontFamily:"monospace",fontWeight:700,lineHeight:1}}>{profile?.name||session.user.email?.split("@")[0]}</div>
                      {profile?.company&&<div style={{color:"rgba(255,255,255,0.3)",fontSize:9,fontFamily:"monospace",marginTop:1}}>{profile.company}</div>}
                    </div>
                    <span style={{color:"rgba(255,255,255,0.3)",fontSize:10}}>{showAccountMenu?"▲":"▼"}</span>
                  </button>
                  {showAccountMenu&&<AccountDropdown profile={profile} session={session} onNavigate={tab=>{setAccountTab(tab);setScreen("account");}} onSignOut={handleSignOut} onClose={()=>setShowAccountMenu(false)}/>}
                </div>
              </div>

              {isDemoMode&&(
                <div style={{background:"rgba(124,252,0,0.08)",border:"1px solid rgba(124,252,0,0.3)",borderRadius:12,padding:"12px 16px",marginBottom:12,display:"flex",alignItems:"center",justifyContent:"space-between",gap:10}}>
                  <div>
                    <div style={{color:"#7CFC00",fontFamily:"monospace",fontSize:11,fontWeight:700,letterSpacing:"0.08em"}}>🎭 DEMO MODE</div>
                    <div style={{color:"rgba(255,255,255,0.45)",fontFamily:"monospace",fontSize:11,marginTop:2}}>Explore the app · your data won't be saved</div>
                  </div>
                  <button onClick={exitDemoMode} style={{background:"#7CFC00",color:"#000",border:"none",borderRadius:8,padding:"8px 14px",fontSize:12,fontWeight:700,fontFamily:"monospace",cursor:"pointer",whiteSpace:"nowrap"}}>Sign Up Free →</button>
                </div>
              )}
              {!isDemoMode&&<TrialBanner profile={profile} onUpgrade={handleUpgrade}/>}
              <DashboardStrip quotes={quotes} customers={customers} invoices={invoices} jobs={jobs}/>
              <div style={{display:"flex",gap:6,marginBottom:10}}>
                <button onClick={()=>setShowCampaigns(true)} style={{flex:1,background:isDark?"rgba(124,252,0,0.07)":"#f0faf0",border:`1px solid ${isDark?"rgba(124,252,0,0.2)":"#c8e6c9"}`,borderRadius:9,padding:"8px 10px",color:"var(--lq-accent)",fontSize:11,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>📣 CAMPAIGNS</button>
                <button onClick={()=>setChemLogTarget({manual:true})} style={{flex:1,background:isDark?"rgba(0,207,255,0.07)":"#f5f5f5",border:`1px solid ${isDark?"rgba(0,207,255,0.2)":"#ddd"}`,borderRadius:9,padding:"8px 10px",color:isDark?"var(--lq-blue)":"#333",fontSize:11,fontFamily:"monospace",fontWeight:700,cursor:"pointer"}}>🧪 LOG APPLICATION</button>
              </div>

              <div style={{animation:"fadeUp 0.3s ease"}}>
                {screen==="pipeline"  &&!selQuote&&!editingQuote&&<OnboardingChecklist profile={profile} customers={customers} quotes={quotes} onNavigate={(s,tab)=>{if(tab){setAccountTab(tab);}nav(s);}}/>}
                {screen==="pipeline"  &&!selQuote&&!editingQuote&&<Pipeline quotes={quotes} onUpdateStage={handleUpdateStage} onDeleteQuote={handleDeleteQuote} onDuplicateQuote={handleDuplicateQuote} onSelectQuote={q=>setSelQuote(q)} onScheduleFromQuote={q=>{handleUpdateStage(q.id,'Scheduled');nav('schedule');}}/>}
                {screen==="pipeline"  &&selQuote&&!editingQuote&&<QuoteDetail quote={selQuote} onBack={()=>setSelQuote(null)} onUpdateStage={async(id,s)=>{await handleUpdateStage(id,s);setSelQuote(q=>({...q,stage:s}));}} onDelete={async id=>{await handleDeleteQuote(id);setSelQuote(null);}} onDuplicate={handleDuplicateQuote} onCreateInvoice={q=>setInvoiceFromQuote(q)} onEditQuote={q=>{setEditingQuote(q);setSelQuote(null);}} onLogApplication={q=>setChemLogTarget({quote:q})}/>}
                {screen==="pipeline"  &&editingQuote&&<QuoteEditForm quote={editingQuote} onSave={handleEditQuote} onBack={()=>{setEditingQuote(null);setSelQuote(editingQuote);}}/>}
                {screen==="customers" &&!selCustomer&&!addingCustomer&&!importingCustomers&&<Customers customers={customers} quotes={quotes} onSelect={c=>setSelCustomer(c)} onAdd={()=>setAddingCustomer(true)} onImport={()=>setImportingCustomers(true)}/>}
                {screen==="customers" &&addingCustomer&&<AddCustomerForm onSave={handleSaveNewCustomer} onBack={()=>setAddingCustomer(false)}/>}
                {screen==="customers" &&importingCustomers&&<ImportCustomers existingCount={customers.length} onImport={handleBulkImport} onBack={()=>setImportingCustomers(false)}/>}
                {screen==="customers" &&selCustomer&&<CustomerProfile customer={selCustomer} quotes={quotes} invoices={invoices} onBack={()=>setSelCustomer(null)} onNewQuote={c=>{setPrefillCust(c);setQuoteFlowKey(k=>k+1);setSelCustomer(null);setScreen("newquote");}} onUpdate={handleUpdateCustomer} onDelete={handleDeleteCustomer} onScheduleRecurring={handleScheduleRecurring} onSelectInvoice={inv=>{setSelInvoice(inv);setScreen("invoices");}} onUpdateStage={handleUpdateStage} onDeleteQuote={handleDeleteQuote} onDuplicateQuote={handleDuplicateQuote} onCreateInvoice={q=>setInvoiceFromQuote(q)} onMarkPaid={handleMarkPaid} onDeleteInvoice={handleDeleteInvoice} onUpdateInvoice={handleUpdateInvoice} onCreateMultiInvoice={handleCreateMultiInvoice} onRebook={handleRebook}/>}
                <div style={{display:screen==="newquote"?"block":"none"}}>
                  {(!quoteCategory&&!quickQuote)
                    ? <QuoteTypeSelector onSelect={c=>setQuoteCategory(c)}/>
                    : (()=>{const ct=()=>{setQuoteCategory(null);setQuoteFlowKey(k=>k+1);};return quoteCategory==="holiday"
                      ? <HolidayQuoteFlow key={quoteFlowKey} googleReady={googleReady} prefillCustomer={prefillCust} quickMode={quickQuote} onDone={q=>{setQuickQuote(false);setPrefillCust(null);handleQuoteDone(q);}} rateSettings={rateSettings} onChangeType={ct}/>
                      : <QuoteFlow key={quoteFlowKey} googleReady={googleReady} prefillCustomer={prefillCust} quickMode={quickQuote} onDone={q=>{setQuickQuote(false);setPrefillCust(null);handleQuoteDone(q);}} onSaveTemplate={saveTemplate} rateSettings={rateSettings} onChangeType={ct}/>;})()
                  }
                </div>
                {screen==="invoices"  &&!newInvoice&&!selInvoice&&<InvoiceList invoices={invoices} quotes={quotes} customers={customers} onMarkPaid={handleMarkPaid} onDelete={handleDeleteInvoice} onCreateFromQuote={q=>{ if(Array.isArray(q)){handleCreateMultiInvoice(q);}else{setInvoiceFromQuote(q);} setScreen('invoices'); }} onNewInvoice={()=>setNewInvoice(true)} onSelectInvoice={i=>setSelInvoice(i)}/>}
                {screen==="invoices"  &&newInvoice&&!selInvoice&&<NewInvoiceForm customers={customers} profile={profile} session={session} onSave={data=>handleSaveInvoice(data)} onBack={()=>setNewInvoice(false)}/>}
                {screen==="invoices"  &&selInvoice&&<InvoiceDetail invoice={selInvoice} profile={profile} session={session} customers={customers} onBack={()=>setSelInvoice(null)} onMarkPaid={async(id,method)=>{await handleMarkPaid(id,method);setSelInvoice(i=>({...i,status:"Paid",paidDate:todayStr(),paymentMethod:method}));}} onDelete={handleDeleteInvoice} onUpdate={handleUpdateInvoice}/>}
                {screen==="schedule"  &&<ScheduleScreen quotes={quotes} jobs={jobs} customers={customers} onAddJob={handleAddJob} onUpdateJob={handleUpdateJob} onDeleteJob={handleDeleteJob} onCompleteJob={handleCompleteJob} googleReady={googleReady}/>}
                {screen==="account"   &&<AccountScreen profile={profile} session={session} onSignOut={handleSignOut} onProfileUpdate={setProfile} initialTab={accountTab} onClearRecurring={handleClearRecurring} onUpgrade={handleUpgrade} onDeleteAccount={handleDeleteAccount} quotes={quotes} customers={customers} invoices={invoices} chemLogs={_chemLogs} rateSettings={rateSettings} onRateSave={handleSaveRates}/>}
              </div>
            </div>
          </div>
          {/* Paywall modal — blocks expired trial users */}
          {showPaywall&&<PaywallModal onUpgrade={()=>{setShowPaywall(false);handleUpgrade();}} onSignOut={handleSignOut}/>}

          {/* Campaigns modal */}
          {showCampaigns&&<CampaignScreen quotes={quotes} customers={customers} profile={profile} onClose={()=>setShowCampaigns(false)}/>}

          {/* Global Search */}
          {showGlobalSearch&&(
            <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.9)",zIndex:600,display:"flex",flexDirection:"column",padding:"16px"}}>
              <div style={{display:"flex",gap:10,marginBottom:16}}>
                <input autoFocus value={globalQuery} onChange={e=>setGlobalQuery(e.target.value)} placeholder="Search clients, quotes, invoices…" style={{flex:1,background:"rgba(255,255,255,0.08)",border:"1px solid rgba(124,252,0,0.3)",borderRadius:10,padding:"12px 16px",color:"#fff",fontSize:14,fontFamily:"monospace",outline:"none"}}/>
                <button onClick={()=>{setShowGlobalSearch(false);setGlobalQuery('');}} style={{background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:10,padding:"12px 16px",color:"rgba(255,255,255,0.5)",fontSize:13,cursor:"pointer"}}>✕</button>
              </div>
              {globalQuery.length>1&&(()=>{
                const q=globalQuery.toLowerCase();
                const matchClients=customers.filter(c=>c.name?.toLowerCase().includes(q)||c.phone?.includes(q)||c.address?.toLowerCase().includes(q)).slice(0,4);
                const matchQuotes=quotes.filter(qt=>qt.customerName?.toLowerCase().includes(q)||qt.quoteNum?.toLowerCase().includes(q)||qt.address?.toLowerCase().includes(q)).slice(0,4);
                const matchInvoices=invoices.filter(i=>i.customerName?.toLowerCase().includes(q)||i.invoiceNum?.toLowerCase().includes(q)).slice(0,4);
                const Section=({title,items,render})=>items.length>0?(<div style={{marginBottom:16}}><div style={{color:"rgba(255,255,255,0.3)",fontSize:10,fontFamily:"monospace",letterSpacing:"0.1em",marginBottom:8}}>{title}</div><div style={{display:"flex",flexDirection:"column",gap:6}}>{items.map(render)}</div></div>):null;
                return(
                  <div style={{overflowY:"auto",flex:1}}>
                    <Section title="CLIENTS" items={matchClients} render={c=>(
                      <div key={c.id} onClick={()=>{setSelCustomer(c);setShowGlobalSearch(false);setGlobalQuery('');nav('customers');}} style={{display:"flex",justifyContent:"space-between",padding:"10px 14px",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:9,cursor:"pointer"}}>
                        <span style={{color:"#fff",fontFamily:"monospace",fontSize:13}}>{c.name}</span>
                        <span style={{color:"rgba(255,255,255,0.35)",fontFamily:"monospace",fontSize:11}}>{c.phone}</span>
                      </div>
                    )}/>
                    <Section title="QUOTES" items={matchQuotes} render={qt=>(
                      <div key={qt.id} onClick={()=>{setSelQuote(qt);setShowGlobalSearch(false);setGlobalQuery('');nav('pipeline');}} style={{display:"flex",justifyContent:"space-between",padding:"10px 14px",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:9,cursor:"pointer"}}>
                        <div><div style={{color:"#fff",fontFamily:"monospace",fontSize:13}}>{qt.customerName}</div><div style={{color:"rgba(255,255,255,0.35)",fontFamily:"monospace",fontSize:10}}>#{qt.quoteNum}</div></div>
                        <span style={{color:"#7CFC00",fontFamily:"monospace",fontSize:13}}>${qt.total?.toFixed(0)}</span>
                      </div>
                    )}/>
                    <Section title="INVOICES" items={matchInvoices} render={i=>(
                      <div key={i.id} onClick={()=>{setSelInvoice(i);setShowGlobalSearch(false);setGlobalQuery('');nav('invoices');}} style={{display:"flex",justifyContent:"space-between",padding:"10px 14px",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:9,cursor:"pointer"}}>
                        <div><div style={{color:"#fff",fontFamily:"monospace",fontSize:13}}>{i.customerName}</div><div style={{color:"rgba(255,255,255,0.35)",fontFamily:"monospace",fontSize:10}}>#{i.invoiceNum}</div></div>
                        <span style={{color:i.status==="Paid"?"#00ff99":"#7CFC00",fontFamily:"monospace",fontSize:13}}>${i.total?.toFixed(0)}</span>
                      </div>
                    )}/>
                    {matchClients.length===0&&matchQuotes.length===0&&matchInvoices.length===0&&(
                      <div style={{color:"rgba(255,255,255,0.3)",fontFamily:"monospace",fontSize:13,textAlign:"center",marginTop:40}}>No results for "{globalQuery}"</div>
                    )}
                  </div>
                );
              })()}
            </div>
          )}

          {/* Chemical log modal */}
          {chemLogTarget&&<ChemLogModal quote={chemLogTarget.quote||null} job={chemLogTarget.job||null} customers={customers} onSave={async log=>{setChemLogs(l=>[log,...l]);setChemLogTarget(null);}} onClose={()=>setChemLogTarget(null)}/>}

          {/* Quote → Invoice review modal */}
          {invoiceFromQuote&&<QuoteToInvoiceModal
            quote={invoiceFromQuote}
            onSave={async(data,quoteId)=>{await handleSaveInvoice(data,quoteId);setInvoiceFromQuote(null);nav("invoices");}}
            onClose={()=>setInvoiceFromQuote(null)}
          />}

          {/* Invoice prompt after job complete */}


          <NavBar screen={screen} setScreen={screen} onNav={nav}/>
        </>
      )}

      {rebookToast&&<Toast message={rebookToast.message} type={rebookToast.type||"success"}/>}
      {rebookTarget&&<RebookModal quote={rebookTarget} onConfirm={confirmRebook} onClose={()=>setRebookTarget(null)}/>}

      {/* PWA install instructions — shown regardless of auth state */}
      {showPWAModal&&<PWAInstallModal onClose={()=>{setShowPWAModal(false);localStorage.setItem('pwa_prompt_seen','1');}}/>}

      {/* Password reset modal — shown after clicking email reset link */}
      {showPasswordReset&&<PasswordResetModal onDone={()=>{setShowPasswordReset(false);if(session)fetchAll(session.user.id);}}/>}
    </>
  );
}